import * as i0 from '@angular/core';
import { InjectionToken, Injectable, Inject, Component, Input, Directive, EventEmitter, ViewChild, HostListener, Output, HostBinding, NgModule } from '@angular/core';
import { Observable, expand, EMPTY, map, BehaviorSubject } from 'rxjs';
import * as i1 from '@angular/common/http';
import { HttpErrorResponse, HttpHeaders, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { timeout } from 'rxjs/operators';
import * as i1$1 from '@angular/common';
import { CommonModule } from '@angular/common';
import * as i4$1 from '@angular/material/checkbox';
import { MatCheckbox, MatCheckboxModule } from '@angular/material/checkbox';
import * as i2 from '@angular/material/icon';
import { MatIconModule } from '@angular/material/icon';
import * as i4 from '@angular/material/tooltip';
import { MatTooltipModule } from '@angular/material/tooltip';
import * as i1$2 from '@angular/cdk/layout';
import { Breakpoints } from '@angular/cdk/layout';
import * as i1$3 from '@angular/material/dialog';
import { MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';
import * as i3 from '@angular/material/button';
import { MatButtonModule } from '@angular/material/button';
import { __decorate, __param } from 'tslib';
import * as i3$1 from '@angular/material/progress-spinner';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import * as i7 from '@angular/material/progress-bar';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import * as i4$2 from '@angular/router';
import { RouterModule } from '@angular/router';
import * as i3$2 from '@angular/material/card';
import { MatCardModule } from '@angular/material/card';
import { MatDividerModule } from '@angular/material/divider';
import { MatGridListModule } from '@angular/material/grid-list';
import * as i6 from '@angular/material/snack-bar';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import * as i4$3 from '@angular/material/table';
import { MatTableDataSource, MatTableModule } from '@angular/material/table';
import { MatSelectModule } from '@angular/material/select';
import { MatInputModule } from '@angular/material/input';
import { MatMenuModule } from '@angular/material/menu';

class ActionEvent {
    get value() {
        return this._value;
    }
    constructor(_value = null) {
        this._value = _value;
    }
}
class Action {
    get value() {
        return this._value;
    }
    constructor(name, value = null) {
        this._disabled = true;
        this._onAction = null;
        this._name = name;
        this._value = value;
        this.listeners = new Array();
        this.controls = [];
    }
    get name() {
        return this._name;
    }
    get onAction() {
        return this._onAction;
    }
    set onAction(value) {
        this._onAction = value;
    }
    createActionEvent(value = null) {
        // default:
        return new ActionEvent(value);
    }
    perform(value = null) {
        this._value = value;
        if (!this.disabled && this._onAction) {
            let ae = this.createActionEvent(value);
            this._onAction(ae);
        }
    }
    set disabled(disabled) {
        //console.debug("Action: "+this._name+" disabled: "+disabled)
        this._disabled = disabled;
        for (let c of this.controls) {
            c.disabled = this._disabled;
        }
        //let disStr=this.disabled?"disabled":"enabled";
        //console.log(this._name+": "+disStr);
    }
    get disabled() {
        return this._disabled;
    }
    addControl(ctrl, actionEventName) {
        if (ctrl) {
            if (this.controls.indexOf(ctrl) < 0) {
                ctrl.disabled = this.disabled;
                this.controls.push(ctrl);
                if (actionEventName) {
                    ctrl.addEventListener(actionEventName, () => {
                        this.perform();
                    });
                }
            }
        }
    }
    removeControl(ctrl) {
        const i = this.controls.indexOf(ctrl);
        if (i >= 0) {
            this.controls = this.controls.splice(i, 1);
        }
    }
}

class BasicAudioSource {
    constructor() {
        this._ready = false;
        this.onReadyListeners = new Array();
    }
    addOnReadyListener(onReady) {
        // let alreadyAdded=false;
        // for(let or of this.onReadyListeners){
        //   if(or===onReady){
        //     alreadyAdded=true;
        //     break;
        //   }
        // }
        // if(!alreadyAdded) {
        //   this.onReadyListeners.push(onReady);
        // }
        if (!(this.onReadyListeners.find((or) => or === onReady))) {
            this.onReadyListeners.push(onReady);
        }
        if (this._ready) {
            onReady();
        }
    }
    removeOnReadyListener(onReady) {
        this.onReadyListeners = this.onReadyListeners.filter((or) => or !== onReady);
    }
    ready() {
        this._ready = true;
        for (let onReady of this.onReadyListeners) {
            onReady.call(this);
        }
    }
}
class AudioBufferSource extends BasicAudioSource {
    constructor(_audioBuffer) {
        super();
        this._audioBuffer = _audioBuffer;
        this._duration = this._audioBuffer.length / this._audioBuffer.sampleRate;
        this.ready();
    }
    get audioBuffer() {
        return this._audioBuffer;
    }
    get duration() {
        return this._duration;
    }
    get sampleRate() {
        return this._audioBuffer.sampleRate;
    }
    get numberOfChannels() {
        return this._audioBuffer.numberOfChannels;
    }
    get frameLen() {
        return this._audioBuffer.length;
    }
    sampleCounts() {
        return this._audioBuffer.numberOfChannels * this._audioBuffer.length;
    }
    audioInputStream() {
        return new AudioBufferInputStream(this._audioBuffer);
    }
    asyncAudioInputStream() {
        return null;
    }
    releaseAudioData() {
        return new Observable(subscriber => {
            subscriber.next();
            subscriber.complete();
        });
    }
    randomAccessAudioStream() {
        return new RandomAccessAudioBufferStream(this._audioBuffer);
    }
}
class AudioDataHolder {
    get audioSource() {
        return this._audioSource;
    }
    get duration() {
        return this._duration;
    }
    constructor(_audioSource) {
        this._audioSource = _audioSource;
        this._numberOfChannels = 0;
        this._sampleRate = 0;
        this._frameLen = 0;
        this._duration = 0;
        if (this._audioSource) {
            this._numberOfChannels = this._audioSource.numberOfChannels;
            this._sampleRate = this._audioSource.sampleRate;
            this._frameLen = this._audioSource.frameLen;
            this._duration = this._frameLen / this._sampleRate;
        }
    }
    addOnReadyListener(onReady) {
        this._audioSource?.addOnReadyListener(onReady);
    }
    get sampleRate() {
        return this._sampleRate;
    }
    get numberOfChannels() {
        return this._numberOfChannels;
    }
    get frameLen() {
        return this._frameLen;
    }
    sampleCounts() {
        return this._numberOfChannels * this._frameLen;
    }
    randomAccessAudioStream() {
        if (this._audioSource) {
            return this._audioSource.randomAccessAudioStream();
        }
        else {
            throw Error('No audio source set');
        }
    }
    // private frames(framePos:number,frameLen:number,bufs:Float32Array[]):number{
    //   let read=0;
    //   if(this._buffer){
    //     let toRead=frameLen;
    //     if(this._buffer.length<framePos+frameLen){
    //       toRead=this._buffer.length-framePos;
    //     }
    //     for(let ch=0;ch<bufs.length;ch++){
    //       let chData=this._buffer.getChannelData(ch);
    //       for(let i=0;i<toRead;i++){
    //         bufs[ch][i]=chData[framePos+i];
    //       }
    //     }
    //     read=toRead;
    //   }else if(this._arrayBuffer){
    //     read=this._arrayBuffer.frames(framePos,frameLen,bufs);
    //   }
    //   return read;
    // }
    audioInputStream() {
        // if(this._buffer){
        //   return new AudioBufferInputStream(this._buffer);
        // }
        // if(this._arrayBuffer){
        //   return new ArrayAudioBufferInputStream(this._arrayBuffer);
        // }
        // return null;
        if (this._audioSource) {
            return this._audioSource.audioInputStream();
        }
        else {
            return null;
        }
    }
    asyncAudioInputStream() {
        // if(this._inddbAudioBuffer){
        //   return new IndexedDbAudioInputStream(this._inddbAudioBuffer);
        // }else if(this._netAudioBuffer){
        //   return new NetAudioInputStream(this._netAudioBuffer);
        // }
        // return null;
        if (this._audioSource) {
            return this._audioSource.asyncAudioInputStream();
        }
        else {
            return null;
        }
    }
    // get buffer(): AudioBuffer | null {
    //   return this._buffer;
    // }
    //
    // get arrayBuffer(): ArrayAudioBuffer | null {
    //   return this._arrayBuffer;
    // }
    //
    // get inddbBuffer():IndexedDbAudioBuffer|null{
    //   return this._inddbAudioBuffer;
    // }
    //
    // get netBuffer():NetAudioBuffer|null{
    //   return this._netAudioBuffer;
    // }
    releaseAudioData() {
        return new Observable(subscriber => {
            //if (this._audioSource instanceof  IndexedDbAudioBuffer) {
            if (this._audioSource) {
                this._audioSource.releaseAudioData().subscribe({
                    next: () => {
                        subscriber.next();
                    },
                    complete: () => {
                        this._audioSource = null;
                        subscriber.complete();
                    }, error: (err) => {
                        subscriber.error(err);
                    }
                });
            }
            else {
                subscriber.next();
                subscriber.complete();
            }
            // }else{
            //   // Others have no persistent respectively async deletable storage, they should be finally removed by the GC
            //   //this._buffer=null;
            //   //this._arrayBuffer=null;
            //   this._audioSource=null;
            //   subscriber.next();
            //   subscriber.complete();
            // }
        });
    }
}
class RandomAccessAudioBufferStream {
    constructor(_buffer) {
        this._buffer = _buffer;
    }
    close() {
    }
    framesObs(framePos, frameLen, bufs) {
        return new Observable(subscriber => {
            let read = 0;
            let toRead = frameLen;
            if (this._buffer.length < framePos + frameLen) {
                toRead = this._buffer.length - framePos;
            }
            for (let ch = 0; ch < bufs.length; ch++) {
                let chData = this._buffer.getChannelData(ch);
                for (let i = 0; i < toRead; i++) {
                    bufs[ch][i] = chData[framePos + i];
                }
            }
            read = toRead;
            subscriber.next(read);
            subscriber.complete();
        });
    }
}
class AudioBufferInputStream {
    constructor(audioBuffer) {
        this.audioBuffer = audioBuffer;
        this.framePos = 0;
    }
    close() {
    }
    skipFrames(n) {
        this.framePos += n;
    }
    read(buffers) {
        let read = 0;
        let toRead = buffers[0].length;
        if (this.framePos + toRead > this.audioBuffer.length) {
            toRead = this.audioBuffer.length - this.framePos;
        }
        for (let ch = 0; ch < buffers.length; ch++) {
            for (let i = 0; i < toRead; i++) {
                buffers[ch][i] = this.audioBuffer.getChannelData(ch)[this.framePos + i];
            }
        }
        read = toRead;
        this.framePos += toRead;
        return read;
    }
}

class ArrayAudioBufferRandomAccessStream {
    constructor(_arrayBuffer) {
        this._arrayBuffer = _arrayBuffer;
    }
    close() {
    }
    framesObs(framePos, frameLen, bufs) {
        return new Observable(subscriber => {
            let read = this._arrayBuffer.frames(framePos, frameLen, bufs);
            subscriber.next(read);
            subscriber.complete();
        });
    }
}

class ArrayAudioBufferInputStream {
    constructor(arrayAudioBuffer) {
        this.arrayAudioBuffer = arrayAudioBuffer;
        this._framePos = 0;
        this.chunkFramePos = 0;
        this.chunkIdx = 0;
        this.eod = false;
        //console.debug("Array audio input stream array audio buffer frames: "+arrayAudioBuffer.frameLen);
    }
    close() {
    }
    skipFrames(n) {
        let toSkip = n;
        if (this.chunkIdx >= this.arrayAudioBuffer.chunkCount) {
            this.eod = true;
            if (toSkip > 0) {
                throw Error('Skip out of bounds: Cannot skip ' + toSkip + ' frames.');
            }
        }
        else {
            let chunkBuf0 = this.arrayAudioBuffer.data[0][this.chunkIdx];
            let chunkBufsLen = chunkBuf0.length;
            let currBufSkippable = chunkBufsLen - this.chunkFramePos;
            if (n >= currBufSkippable) {
                this._framePos += currBufSkippable;
                toSkip -= currBufSkippable;
                this.chunkIdx++;
                this.chunkFramePos = 0;
                if (this.chunkIdx < this.arrayAudioBuffer.chunkCount) {
                    this.skipFrames(toSkip);
                }
                else {
                    if (toSkip > 0) {
                        throw Error('Skip out of bounds: Cannot skip ' + toSkip + ' frames.');
                    }
                }
            }
            else {
                toSkip -= n;
                this.chunkFramePos += n;
            }
        }
    }
    read(buffers) {
        let read = 0;
        let toRead = buffers[0].length;
        while (read < toRead && !this.eod) {
            //console.debug("Chunk "+this.chunkIdx+" of "+this.arrayAudioBuffer.chunkCount+" chunks.")
            if (this.chunkIdx >= this.arrayAudioBuffer.chunkCount) {
                this.eod = true;
                //console.debug("Array audio input stream end of data read frames: "+this.framePos);
            }
            else {
                let chunkBuf0 = this.arrayAudioBuffer.data[0][this.chunkIdx];
                let chunkBufsLen = chunkBuf0.length;
                const chunkBufAvail = chunkBufsLen - this.chunkFramePos;
                let r = chunkBufAvail;
                if (r > toRead - read) {
                    r = toRead - read;
                }
                for (let ch = 0; ch < buffers.length; ch++) {
                    let chChunkBuf = this.arrayAudioBuffer.data[ch][this.chunkIdx];
                    for (let bi = 0; bi < r; bi++) {
                        buffers[ch][read + bi] = chChunkBuf[this.chunkFramePos + bi];
                    }
                }
                read += r;
                this.chunkFramePos += r;
                if (this.chunkFramePos >= chunkBufsLen) {
                    this.chunkIdx++;
                    this.chunkFramePos = 0;
                }
            }
        }
        this._framePos += read;
        //console.debug("Read: "+read+", frame pos: "+this.framePos)
        if (this._framePos > this.arrayAudioBuffer.frameLen) {
            console.error("Array audio input stream frame pos: " + this._framePos + " greater then frame length: " + this.arrayAudioBuffer.frameLen);
        }
        return read;
    }
    get framePos() {
        return this._framePos;
    }
}

class ArrayAudioBuffer extends BasicAudioSource {
    constructor(_channelCount, _sampleRate, _data) {
        super();
        this._channelCount = _channelCount;
        this._sampleRate = _sampleRate;
        this._data = _data;
        this._chunkCount = 0;
        this._frameLen = 0;
        this._duration = 0;
        this._sealed = false;
        this.updateFrameLen();
        this.ready();
    }
    updateFrameLen() {
        this._frameLen = 0;
        this._chunkCount = 0;
        if (this._data.length > 0) {
            let ch0Data = this.data[0];
            for (let ch0Chk of ch0Data) {
                this._chunkCount++;
                this._frameLen += ch0Chk.length;
            }
        }
        this._duration = this._frameLen / this._sampleRate;
    }
    seal() {
        this._sealed = true;
    }
    sealed() {
        return this._sealed;
    }
    static fromAudioBuffer(audioBuffer, chunkFrameSize = 8192) {
        let aab;
        let chs = audioBuffer.numberOfChannels;
        let frameLength = audioBuffer.length;
        //let chunksSize=Math.ceil(frameLength/chunkFrameSize);
        let framePos = 0;
        let data = new Array(chs);
        for (let ch = 0; ch < chs; ch++) {
            data[ch] = new Array();
        }
        let toCopy = frameLength - framePos;
        while (toCopy > 0) {
            let toCopyChunk = chunkFrameSize;
            if (toCopyChunk > toCopy) {
                // last chunk, the rest
                toCopyChunk = toCopy;
            }
            for (let ch = 0; ch < chs; ch++) {
                data[ch].push(audioBuffer.getChannelData(ch).slice(framePos, framePos + toCopyChunk));
            }
            framePos += toCopyChunk;
            toCopy -= toCopyChunk;
        }
        aab = new ArrayAudioBuffer(chs, audioBuffer.sampleRate, data);
        return aab;
    }
    appendAudioBuffer(audioBuffer) {
        let chs = audioBuffer.numberOfChannels;
        if (this._channelCount !== chs) {
            throw new Error('Cannot append audio buffer with ' + chs + ' channels to this array audio buffer with ' + this._channelCount + ' channels. Number of channels must match.');
        }
        let sr = audioBuffer.sampleRate;
        if (sr !== this._sampleRate) {
            throw new Error('Cannot append audio buffer with samplerate ' + sr + ' to this array audio buffer with samplerate ' + this._sampleRate + '. Samplerates must match.');
        }
        for (let ch = 0; ch < chs; ch++) {
            let chAbSlice = audioBuffer.getChannelData(ch).slice();
            //console.debug("Append audio buffer ch: "+ch+": "+chAbSlice.length);
            this._data[ch].push(chAbSlice);
        }
        this.updateFrameLen();
    }
    get channelCount() {
        return this._channelCount;
    }
    frames(framePos, frameLen, bufs) {
        let ccFramePos = 0;
        let trgFramePos = framePos;
        let ch0Data = this.data[0];
        let cPos = 0;
        let filled = 0;
        let ci = 0;
        while (filled < frameLen && ci < this._chunkCount) {
            // Current chunk
            let cc0 = ch0Data[ci];
            let ccLen = cc0.length;
            let ccFrameEndPos = ccFramePos + ccLen;
            if (trgFramePos >= ccFramePos && trgFramePos < ccFrameEndPos) {
                let toCp = frameLen - filled;
                cPos = trgFramePos - ccFramePos;
                if (cPos + toCp > ccLen) {
                    toCp = ccLen - cPos;
                }
                for (let ch = 0; ch < bufs.length; ch++) {
                    let cc = this.data[ch][ci];
                    for (let i = 0; i < toCp; i++) {
                        bufs[ch][filled + i] = cc[cPos + i];
                    }
                }
                filled += toCp;
                trgFramePos += toCp;
                cPos += toCp;
                ccFramePos += toCp;
                if (cPos >= ccLen) {
                    ccFramePos = ccFrameEndPos;
                    cPos = 0;
                    ci++;
                }
            }
            else {
                // next chunk
                ccFramePos = ccFrameEndPos;
                cPos = 0;
                ci++;
            }
        }
        return filled;
    }
    get sampleRate() {
        return this._sampleRate;
    }
    get frameLen() {
        return this._frameLen;
    }
    get chunkCount() {
        return this._chunkCount;
    }
    get data() {
        return this._data;
    }
    asyncAudioInputStream() {
        return null;
    }
    audioInputStream() {
        return new ArrayAudioBufferInputStream(this);
    }
    get duration() {
        return this._duration;
    }
    get numberOfChannels() {
        return this._channelCount;
    }
    releaseAudioData() {
        return new Observable(subscriber => {
            // No persistent respectively async deletable storage, they should be finally removed by the GC
            //this._audioBuffer=null;
            //this._arrayBuffer=null;
            subscriber.next();
            subscriber.complete();
        });
    }
    sampleCounts() {
        return this._channelCount * this._frameLen;
    }
    randomAccessAudioStream() {
        return new ArrayAudioBufferRandomAccessStream(this);
    }
}

class EditFloat32ArrayInputStream {
    constructor(_srcInputStream, offset = 0, length) {
        this._srcInputStream = _srcInputStream;
        this.offset = offset;
        this.length = length;
        this.framePos = 0;
        this.readFrames = 0;
        if (this.offset < 0) {
            throw Error('Parameter offset must be undefined or greater or equal zero.');
        }
        if (this.length !== undefined && this.length < 0) {
            throw Error('Parameter length must be undefined or greater or equal zero.');
        }
    }
    skipToOffset() {
        if (this.framePos == 0 && this.offset > 0) {
            this._srcInputStream.skipFrames(this.offset);
            this.framePos += this.offset;
        }
    }
    read(buffers) {
        this.skipToOffset();
        let read = 0;
        if (this.length === undefined) {
            read = this._srcInputStream.read(buffers);
        }
        else {
            if (buffers.length > 0) {
                let bufsCh0 = buffers[0];
                let bufsLen = bufsCh0.length;
                let avail = this.length - this.readFrames;
                if (avail > 0) {
                    if (avail > bufsLen) {
                        read = this._srcInputStream.read(buffers);
                    }
                    else {
                        // temporary buffers required
                        let tmpBufs = new Array(buffers.length);
                        for (let ch = 0; ch < buffers.length; ch++) {
                            tmpBufs[ch] = new Float32Array(avail);
                        }
                        read = this._srcInputStream.read(tmpBufs);
                        for (let ch = 0; ch < buffers.length; ch++) {
                            buffers[ch].set(tmpBufs[ch]);
                        }
                    }
                }
            }
        }
        this.readFrames += read;
        this.framePos += read;
        return read;
    }
    skipFrames(n) {
        this.skipToOffset();
        if (this.length === undefined) {
            this._srcInputStream.skipFrames(n);
        }
        else {
            let avail = this.length - this.readFrames;
            if (avail > 0) {
                if (avail >= n) {
                    this._srcInputStream.skipFrames(n);
                    this.readFrames += n;
                    this.framePos += n;
                }
                else {
                    throw Error('Tried to skip out of bounds.');
                }
            }
        }
    }
    close() {
        this._srcInputStream.close();
    }
}
class AsyncEditFloat32ArrayInputStream {
    constructor(_srcInputStream, offset = 0, length) {
        this._srcInputStream = _srcInputStream;
        this.offset = offset;
        this.length = length;
        this.framePos = 0;
        this.readFrames = 0;
        if (this.offset < 0) {
            throw Error('Parameter offset must be undefined or greater or equal zero.');
        }
        if (this.length !== undefined && this.length < 0) {
            throw Error('Parameter length must be undefined or greater or equal zero.');
        }
    }
    skipToOffset() {
        if (this.framePos == 0 && this.offset > 0) {
            this._srcInputStream.skipFrames(this.offset);
            this.framePos += this.offset;
        }
    }
    readObs(buffers) {
        return new Observable(subscriber => {
            this.skipToOffset();
            if (this.length === undefined) {
                this._srcInputStream.readObs(buffers).subscribe(subscriber);
            }
            else {
                if (buffers.length > 0) {
                    let bufsCh0 = buffers[0];
                    let bufsLen = bufsCh0.length;
                    let avail = this.length - this.readFrames;
                    if (avail > 0) {
                        if (avail > bufsLen) {
                            this._srcInputStream.readObs(buffers).subscribe({
                                next: (read) => {
                                    this.readFrames += read;
                                    this.framePos += read;
                                    subscriber.next(read);
                                }, complete: () => {
                                    subscriber.complete();
                                }
                            });
                        }
                        else {
                            // temporary buffers required
                            let tmpBufs = new Array(buffers.length);
                            for (let ch = 0; ch < buffers.length; ch++) {
                                tmpBufs[ch] = new Float32Array(avail);
                            }
                            this._srcInputStream.readObs(tmpBufs).subscribe({
                                next: (read) => {
                                    for (let ch = 0; ch < buffers.length; ch++) {
                                        buffers[ch].set(tmpBufs[ch]);
                                    }
                                    this.readFrames += read;
                                    this.framePos += read;
                                    subscriber.next(read);
                                }, complete: () => {
                                    subscriber.complete();
                                }
                            });
                        }
                    }
                    else {
                        // end of stream
                        subscriber.next(0);
                        subscriber.complete();
                    }
                }
                else {
                    subscriber.next(0);
                    subscriber.complete();
                }
            }
        });
    }
    skipFrames(n) {
        this.skipToOffset();
        if (this.length === undefined) {
            this._srcInputStream.skipFrames(n);
        }
        else {
            let avail = this.length - this.readFrames;
            if (avail > 0) {
                if (avail >= n) {
                    this._srcInputStream.skipFrames(n);
                    this.readFrames += n;
                    this.framePos += n;
                }
                else {
                    throw Error('Tried to skip out of bounds.');
                }
            }
        }
    }
    close() {
        this._srcInputStream.close();
    }
}
class Float32ArrayChunkerOutStream {
    constructor(outStream) {
        this.outStream = outStream;
        this.bufs = new Array();
        this._channels = 0;
        this._chunkSize = 0;
        this.filled = 0;
        this.receivedFrames = 0;
        this.sentFrames = 0;
    }
    createBuffers() {
        this.bufs = new Array(this._channels);
        for (let ch = 0; ch < this._channels; ch++) {
            this.bufs[ch] = new Float32Array(this._chunkSize);
        }
    }
    set chunkSize(chunkSize) {
        this._chunkSize = chunkSize;
        this.createBuffers();
    }
    get chunkSize() {
        return this._chunkSize;
    }
    set channels(channels) {
        this._channels = channels;
        this.createBuffers();
    }
    get channels() {
        return this._channels;
    }
    available() {
        return this._chunkSize - this.filled;
    }
    write(buffers) {
        let copied = 0;
        if (buffers.length > 0) {
            let buffersLen = buffers[0].length;
            this.receivedFrames += buffersLen;
            let avail = buffersLen;
            // Fill out buffers until all values copied
            while (avail > 0) {
                let toFill = this._chunkSize - this.filled;
                if (toFill > avail) {
                    toFill = avail;
                }
                let sliceEnd = copied + toFill;
                // Firefox on Android sends only the first channel
                for (let ch = 0; ch < buffersLen; ch++) {
                    if (buffers[ch]) {
                        let cpPrt = buffers[ch].slice(copied, sliceEnd);
                        let buf = this.bufs[ch];
                        buf.set(cpPrt, this.filled);
                    }
                }
                copied += toFill;
                avail -= toFill;
                this.filled += toFill;
                if (this.filled == this._chunkSize) {
                    this.outStream.write(this.bufs);
                    this.sentFrames += this.filled;
                    this.filled = 0;
                }
            }
        }
        return copied;
    }
    flush() {
        if (this.filled > 0) {
            let restBufs = new Array(this._channels);
            for (let ch = 0; ch < this._channels; ch++) {
                restBufs[ch] = this.bufs[ch].slice(0, this.filled);
            }
            this.outStream.write(restBufs);
            this.outStream.flush();
            this.sentFrames += this.filled;
            this.filled = 0;
        }
    }
    close() {
        this.outStream.close();
    }
}

class AudioSourceNode extends AudioWorkletNode {
    constructor() {
        super(...arguments);
        this._playStartTime = null;
        this.onended = null;
    }
    static { this.DEFAULT_BUFFER_FILL_SECONDS = 10; }
    static { this.DEFAULT_STREAM_READ_FRAME_LEN = 1024; }
    static { this.QUANTUM_FRAME_LEN = 128; }
    get playPositionTime() {
        let ppt = null;
        if (this._playStartTime !== null) {
            ppt = this.context.currentTime - this._playStartTime;
        }
        return ppt;
    }
}

class ArrayAudioBufferSourceNode extends AudioSourceNode {
    constructor(context) {
        super(context, 'audio-source-worklet');
        this._bufferFillSeconds = AudioSourceNode.DEFAULT_BUFFER_FILL_SECONDS;
        this.bufferFillFrames = 0;
        this._arrayAudioBuffer = null;
        this._audioInputStream = null;
        this._aisBufs = null;
        this.filledFrames = 0;
        this.channelCountMode = 'explicit';
        this.port.onmessage = (msgEv) => {
            if (msgEv.data) {
                let evType = msgEv.data.eventType;
                if (evType) {
                    if ('bufferNotification' === evType) {
                        this.filledFrames = msgEv.data.filledFrames;
                        //console.debug("Buffer notification: filled frames: " + this.filledFrames);
                        this.fillBuffer();
                    }
                    else if ('ended' === evType) {
                        let drainTime = 0;
                        if (this._arrayAudioBuffer?.sampleRate) {
                            drainTime = ArrayAudioBufferSourceNode.QUANTUM_FRAME_LEN / this._arrayAudioBuffer.sampleRate;
                        }
                        //let dstAny:any=this.context.destination;
                        //console.debug('Destination node tail-time: '+dstAny['tail-time']);
                        window.setTimeout(() => {
                            this.onended?.call(this);
                        }, drainTime * 1000);
                    }
                }
            }
        };
    }
    fillBuffer() {
        if (this._arrayAudioBuffer && this._audioInputStream && this._aisBufs) {
            let filled = this.filledFrames;
            let bufLen = 0;
            while (filled < this.bufferFillFrames) {
                let read = this._audioInputStream.read(this._aisBufs);
                //console.log("ArrayAudioBufferSourceNode: read: "+read)
                if (read) {
                    let trBuffers = new Array(this.channelCount);
                    for (let ch = 0; ch < this.channelCount; ch++) {
                        let adCh = this._aisBufs[ch];
                        let adChCopy = new Float32Array(adCh.length);
                        bufLen = adChCopy.length;
                        adChCopy.set(adCh);
                        trBuffers[ch] = adChCopy.buffer;
                    }
                    this.port.postMessage({
                        cmd: 'data',
                        chs: this.channelCount,
                        audioData: trBuffers
                    }, trBuffers);
                    filled += read;
                }
                else {
                    this.port.postMessage({
                        cmd: 'endOfStream'
                    });
                    break;
                }
            }
        }
    }
    get arrayAudioBuffer() {
        return this._arrayAudioBuffer;
    }
    set arrayAudioBuffer(value) {
        this._arrayAudioBuffer = value;
        if (this._arrayAudioBuffer?.channelCount) {
            this.channelCount = this._arrayAudioBuffer?.channelCount;
            this.bufferFillFrames = this._arrayAudioBuffer.sampleRate * this._bufferFillSeconds;
        }
    }
    get bufferFillSeconds() {
        return this._bufferFillSeconds;
    }
    set bufferFillSeconds(value) {
        this._bufferFillSeconds = value;
    }
    start(when, offset, duration) {
        if (when) {
            throw Error("when parameter currently not supported by ArrayAudioBufferSourceNode class");
        }
        if (this._arrayAudioBuffer) {
            let arrAis = new ArrayAudioBufferInputStream(this._arrayAudioBuffer);
            if (offset === undefined && duration === undefined) {
                this._audioInputStream = arrAis;
            }
            else {
                let offsetFrames = 0;
                let durationFrames = undefined;
                if (offset !== undefined) {
                    offsetFrames = Math.floor(offset * this._arrayAudioBuffer.sampleRate);
                }
                if (duration !== undefined) {
                    durationFrames = Math.floor(duration * this._arrayAudioBuffer.sampleRate);
                }
                this._audioInputStream = new EditFloat32ArrayInputStream(arrAis, offsetFrames, durationFrames);
            }
            let chs = this._arrayAudioBuffer.channelCount;
            this._aisBufs = new Array(chs);
            for (let ch = 0; ch < chs; ch++) {
                this._aisBufs[ch] = new Float32Array(ArrayAudioBufferSourceNode.DEFAULT_STREAM_READ_FRAME_LEN);
            }
            this.fillBuffer();
            this.port.postMessage({ cmd: 'start' });
            if (offset) {
                this._playStartTime = this.context.currentTime - offset;
            }
            else {
                this._playStartTime = this.context.currentTime;
            }
        }
    }
    stop() {
        this.port.postMessage({ cmd: 'stop' });
        this.onended?.call(this);
    }
}

class UUID {
    static generate() {
        return UUID.s4() + UUID.s4() + '-' + UUID.s4() + '-' + UUID.s4() + '-' +
            UUID.s4() + '-' + UUID.s4() + UUID.s4() + UUID.s4();
    }
    static s4() {
        return Math.floor((1 + Math.random()) * 0x10000)
            .toString(16)
            .substring(1);
    }
}
class DataSize {
    static { this.BINARY_UNITS = ['B', 'KiB', 'MiB', 'GiB', 'TiB', 'PiB', 'EiB', 'ZiB', 'YiB', 'RiB', 'QiB']; }
    static { this.BINARY_UNIT_FACTOR = 1024; }
    static { this.BINARY_UNIT_FACTOR_LOG = Math.log(DataSize.BINARY_UNIT_FACTOR); }
    static formatBytesToBinaryUnits(bytes, decimals = 2) {
        let binaryUnitIdx = 0;
        let divisor = 1;
        if (bytes > 0) {
            const bytesLog = Math.log(bytes);
            binaryUnitIdx = Math.floor(bytesLog / this.BINARY_UNIT_FACTOR_LOG);
            if (binaryUnitIdx >= this.BINARY_UNITS.length) {
                // fallback to bytes
                binaryUnitIdx = 0;
            }
            divisor = Math.pow(this.BINARY_UNIT_FACTOR, binaryUnitIdx);
        }
        let decimalsUnitValue;
        if (binaryUnitIdx === 0) {
            decimalsUnitValue = bytes.toString();
        }
        else {
            const unitValue = bytes / divisor;
            decimalsUnitValue = unitValue.toFixed(decimals);
        }
        const binaryUnitStr = decimalsUnitValue + ' ' + this.BINARY_UNITS[binaryUnitIdx];
        return binaryUnitStr;
    }
}
class Arrays {
    static cloneNumberArray(numberArray) {
        let len = numberArray.length;
        let cloneArr = new Array(len);
        for (let c = 0; c < numberArray.length; c++) {
            cloneArr[c] = numberArray[c];
        }
        return cloneArr;
    }
    static swap(items, i, j) {
        let tmp = items[i];
        items[i] = items[j];
        items[j] = tmp;
    }
    static shuffleArray(orgArray) {
        let shuffledArray = [...orgArray];
        for (let i = shuffledArray.length; i > 1; i--) {
            let rnd = Math.random();
            let rndArrIdx = Math.floor(rnd * i);
            Arrays.swap(shuffledArray, i - 1, rndArrIdx);
        }
        return shuffledArray;
    }
}
class WorkerHelper {
    static { this.DEBUG = false; }
    static buildWorkerBlobURL(workerFct) {
        if (!(workerFct instanceof Function)) {
            throw new Error('Parameter workerFct is not a function! (XSS attack?).');
        }
        let woFctNm = workerFct.name;
        if (WorkerHelper.DEBUG) {
            console.info("Worker method name: " + woFctNm);
        }
        let woFctStr = workerFct.toString();
        if (WorkerHelper.DEBUG) {
            console.info("Worker method string:");
            console.info(woFctStr);
        }
        // Make sure code starts with "function()"
        // Chrome, Firefox: "[wofctNm](){...}", Safari: "function [wofctNm](){...}"
        // we need an anonymous function: "function() {...}"
        let piWoFctStr = woFctStr.replace(/^function +/, '');
        if (WorkerHelper.DEBUG) {
            console.info("Worker platform independent function string:");
            console.info(piWoFctStr);
        }
        // Convert to anonymous function
        let anonWoFctStr = piWoFctStr.replace(woFctNm + '()', 'function()');
        if (WorkerHelper.DEBUG) {
            console.info("Worker anonymous function string:");
            console.info(piWoFctStr);
        }
        // Self executing
        let ws = '(' + anonWoFctStr + ')();';
        if (WorkerHelper.DEBUG) {
            console.info("Worker self executing anonymous function string:");
            console.info(anonWoFctStr);
        }
        // Build the worker blob
        let wb = new Blob([ws], { type: 'text/javascript' });
        let workerBlobUrl = window.URL.createObjectURL(wb);
        return workerBlobUrl;
    }
}
class ErrorHelper {
    static messageFromError(error) {
        let msg = null;
        if (error instanceof Error) {
            msg = error.message;
        }
        return msg;
    }
    static messageFromErrorNonNull(error) {
        let msg = '';
        const msgNullable = ErrorHelper.messageFromError(error);
        if (msgNullable != null) {
            msg = msgNullable;
        }
        return msg;
    }
    static message(baseMessage, error) {
        let msg = baseMessage;
        if (error instanceof Error) {
            msg = baseMessage + ': ' + error.message;
        }
        else {
            msg = baseMessage + '.';
        }
        return msg;
    }
}

class PersistentAudioStorageTarget {
    get indexedDb() {
        return this._indexedDb;
    }
    get storeName() {
        return this._storeName;
    }
    constructor(_indexedDb, _storeName) {
        this._indexedDb = _indexedDb;
        this._storeName = _storeName;
    }
    transaction(mode) {
        return this._indexedDb.transaction(this.storeName, mode);
    }
    objectStore(mode) {
        let tr = this.transaction(mode);
        return tr.objectStore(this._storeName);
    }
    deleteAll() {
        return new Observable(subscriber => {
            let os = this.objectStore('readwrite');
            let clearReq = os.clear();
            clearReq.onsuccess = () => {
                console.debug("Cleared audio storage object store.");
                os.transaction.commit();
            };
            clearReq.onerror = () => {
                os.transaction.abort();
                console.error("Could not clear object store: " + clearReq.error);
            };
            os.transaction.oncomplete = () => {
                console.debug("Transaction complete: Clear audio storage object store.");
                subscriber.complete();
            };
            os.transaction.onerror = (err) => {
                subscriber.error(err);
            };
        });
    }
}
class IndexedDbAudioBuffer extends BasicAudioSource {
    get chunkFrameLen() {
        return this._chunkFrameLen;
    }
    get persistentAudioStorageTarget() {
        return this._persistentAudioStorageTarget;
    }
    get uuid() {
        return this._uuid;
    }
    constructor(_persistentAudioStorageTarget, _channelCount, _sampleRate, _chunkFrameLen, _frameLen, _uuid) {
        super();
        this._persistentAudioStorageTarget = _persistentAudioStorageTarget;
        this._channelCount = _channelCount;
        this._sampleRate = _sampleRate;
        this._chunkFrameLen = _chunkFrameLen;
        this._frameLen = _frameLen;
        this._uuid = _uuid;
        this._chunkCount = 0;
        this.indDbChkIdx = 0;
        this._sealed = false;
        this._storeError = null;
        this.ready();
    }
    get channelCount() {
        return this._channelCount;
    }
    sealed() {
        return this._sealed;
    }
    seal() {
        this._sealed = true;
    }
    deleteChunk(os, ci, cb, errCb) {
        // Build bounds for channels
        let lIdx = [this._uuid, ci, 0];
        let hIdx = [this._uuid, ci, this._channelCount];
        let chsKr = IDBKeyRange.bound(lIdx, hIdx);
        let exRq = os.getAllKeys(chsKr);
        exRq.onsuccess = () => {
            let cc = exRq.result;
            if (cc && cc.length > 0) {
                let rq = os.delete(chsKr);
                rq.onerror = (errEv) => {
                    errCb(new Error(errEv.toString()));
                };
                os.transaction.oncomplete = () => {
                    cb(cc);
                };
                os.transaction.commit();
            }
        };
        exRq.onerror = (errEv) => {
            errCb(new Error(errEv.toString()));
        };
    }
    deleteAllBufs(os, ci, cbEnd, cbErr) {
        //console.debug('IndexedDbAudioBuffer::fillBufs: framePos:'+framePos+', frameLen: '+frameLen+', filled: '+filled+', srcFramePos: '+srcFramePos+',ci: '+ci+', ccPos: '+ccPos);
        this.deleteChunk(os, ci, (ccKeys) => {
            if (ccKeys && ccKeys.length > 0) {
                //console.debug('IndexedDbAudioBuffer::fillBufs frameLen: '+frameLen);
                ci++;
                this.deleteAllBufs(os, ci, cbEnd, cbErr);
            }
            else {
                //console.debug('IndexedDbAudioBuffer::fillBufs (chunk not found) call: cbend '+filled);
                cbEnd();
            }
        }, (err) => {
            cbErr(err);
        });
    }
    get sampleRate() {
        return this._sampleRate;
    }
    get frameLen() {
        return this._frameLen;
    }
    get chunkCount() {
        return this._chunkCount;
    }
    appendRawAudioData(data) {
        return new Observable(subscriber => {
            if (this._persistentAudioStorageTarget && this._uuid) {
                let tr = this._persistentAudioStorageTarget.indexedDb.transaction(this._persistentAudioStorageTarget.storeName, 'readwrite');
                let recFileObjStore = tr.objectStore(this._persistentAudioStorageTarget.storeName);
                try {
                    let ch0Data = data[0];
                    let dataChkCnt = ch0Data.length;
                    let pos = 0;
                    for (let chCkIdx = 0; chCkIdx < dataChkCnt; chCkIdx++) {
                        let bufLen = 0;
                        for (let ch = 0; ch < this.channelCount; ch++) {
                            let chChk = data[ch][chCkIdx];
                            bufLen = chChk.length;
                            //let cacheId = uuid + '_' + ch + '_' + chCkIdx;
                            let chkDbId = [this._uuid, this.indDbChkIdx + chCkIdx, ch];
                            let cr = recFileObjStore.add(chChk, chkDbId);
                            //console.debug("Added: "+ch+" "+(this.indDbChkIdx+chCkIdx));
                            cr.onsuccess = () => {
                                //console.debug("Stored audio data to indexed db");
                                // if(chCkIdx>= dataChkCnt-1 && ch>=this.channelCount-1){
                                //   tr.commit();
                                // }
                            };
                            cr.onerror = () => {
                                if (!this._storeError) {
                                    // Only log the first error
                                    console.error("Error storing audio data of " + chChk.byteLength + " bytes to indexed db: " + cr.error);
                                }
                            };
                        }
                        pos += bufLen;
                        this._frameLen += bufLen;
                    }
                    this.indDbChkIdx += dataChkCnt;
                    tr.onerror = (ev) => {
                        if (!this._storeError) {
                            // Only log the first error
                            console.error("Failed to store audio data to indexed db, transaction error: " + tr.error);
                            this._storeError = tr.error;
                        }
                        subscriber.error(tr.error);
                    };
                    tr.onabort = (ev) => {
                        // If Chrome reaches quota it aborts the transaction
                        if (!this._storeError) {
                            // Only log the first error
                            console.error("Failed to store audio data to indexed db, transaction aborted: " + tr.error);
                            this._storeError = tr.error;
                        }
                        subscriber.error(tr.error);
                    };
                    tr.oncomplete = (ev) => {
                        subscriber.complete();
                    };
                    tr.commit();
                }
                catch (err) {
                    subscriber.error(new Error('Transfer audio data error: ' + err));
                }
            }
        });
    }
    static fromChunkAudioBuffer(persistentAudioStorageTarget, audioBuffer) {
        return new Observable(subscriber => {
            let chs = audioBuffer.numberOfChannels;
            let sr = audioBuffer.sampleRate;
            let chkFrameLength = audioBuffer.length;
            let iab = new IndexedDbAudioBuffer(persistentAudioStorageTarget, chs, sr, chkFrameLength, 0, UUID.generate());
            iab.appendChunkAudioBuffer(audioBuffer).subscribe({
                next: () => {
                    subscriber.next(iab);
                },
                complete: () => {
                    subscriber.complete();
                },
                error: (err) => {
                    subscriber.error(err);
                }
            });
        });
    }
    appendChunkAudioBuffer(audioBuffer) {
        if (this._sealed) {
            throw new Error('Cannot append audio buffer to already sealed audio buffer.');
        }
        let chs = audioBuffer.numberOfChannels;
        if (this._channelCount !== chs) {
            throw new Error('Cannot append audio buffer with ' + chs + ' channels to this array audio buffer with ' + this._channelCount + ' channels. Number of channels must match.');
        }
        let sr = audioBuffer.sampleRate;
        if (sr !== this._sampleRate) {
            throw new Error('Cannot append audio buffer with samplerate ' + sr + ' to this array audio buffer with samplerate ' + this._sampleRate + '. Samplerates must match.');
        }
        let abFl = audioBuffer.length;
        if (abFl > this._chunkFrameLen) {
            throw new Error('Cannot append audio buffer with frame length ' + abFl + ' to this array audio buffer with chunk frame length ' + this._chunkFrameLen + '. Chunk length must be equal or less if last chunk.');
        }
        return new Observable(subscriber => {
            if (this._persistentAudioStorageTarget && this._uuid) {
                let tr = this._persistentAudioStorageTarget.transaction('readwrite');
                let recFileObjStore = tr.objectStore(this._persistentAudioStorageTarget.storeName);
                try {
                    for (let ch = 0; ch < this.channelCount; ch++) {
                        let chChk = audioBuffer.getChannelData(ch);
                        let chkDbId = [this._uuid, this.indDbChkIdx++, ch];
                        try {
                            let cr = recFileObjStore.add(chChk, chkDbId);
                            cr.onsuccess = (ev) => { };
                            cr.onerror = (ev) => {
                                // iPad may throw QuotaExceededError here
                                // iPad asks for more storage and if denied, the error is thrown here
                                if (!this._storeError) {
                                    // Only log the first error
                                    console.error("Error storing audio data of " + chChk.byteLength + " bytes to indexed db: " + cr.error);
                                }
                                //subscriber.error(cr.error);
                            };
                        }
                        catch (err1) {
                            if (!this._storeError) {
                                console.error("Error adding audio data to indexed db store: " + err1);
                                this._storeError = (err1 instanceof Error) ? err1 : new Error(err1);
                            }
                            subscriber.error(err1);
                        }
                    }
                    this._frameLen += abFl;
                    tr.onerror = (ev) => {
                        if (!this._storeError) {
                            // Only log the first error
                            console.error("Failed to store audio data to indexed db, transaction error: " + tr.error);
                            this._storeError = tr.error;
                        }
                        subscriber.error(tr.error);
                    };
                    tr.onabort = (ev) => {
                        // If Chrome reaches quota it aborts the transaction
                        if (!this._storeError) {
                            // Only log the first error
                            console.error("Failed to store audio data to indexed db, transaction aborted: " + tr.error);
                            this._storeError = tr.error;
                        }
                        subscriber.error(tr.error);
                    };
                    tr.oncomplete = (ev) => {
                        //console.debug("Transaction complete");
                        if (abFl < this._chunkFrameLen) {
                            // last chunk
                            this.seal();
                        }
                        subscriber.next();
                        subscriber.complete();
                    };
                    tr.commit();
                }
                catch (err) {
                    console.error('Catched error: ' + err);
                    subscriber.error(new Error('Transfer audio data error: ' + err));
                }
            }
        });
    }
    releaseAudioData() {
        return new Observable((subscriber) => {
            let os = this._persistentAudioStorageTarget.objectStore('readwrite');
            this.deleteAllBufs(os, 0, () => {
                subscriber.next();
                subscriber.complete();
            }, (err) => {
                subscriber.error(err);
            });
        });
    }
    toString() {
        return "Indexed db audio buffer. Channels: " + this.channelCount + ", sample rate: " + this.sampleRate + ", chunk frame length: " + this._chunkFrameLen + ", number of chunks: " + this.chunkCount + ", frame length: " + this.frameLen + ", sealed: " + this.sealed();
    }
    asyncAudioInputStream() {
        return new IndexedDbAudioInputStream(this);
    }
    audioInputStream() {
        // Synchronous stream not supported
        return null;
    }
    get duration() {
        return this._chunkFrameLen / this._sampleRate;
    }
    get numberOfChannels() {
        return this._channelCount;
    }
    sampleCounts() {
        return this._channelCount * this._frameLen;
    }
    randomAccessAudioStream() {
        return new IndexedDbRandomAccessStream(this);
    }
}
class IndexedDbRandomAccessStream {
    constructor(_inddbAb) {
        this._inddbAb = _inddbAb;
        this._currCi = 0;
        this._ccCache = null;
    }
    chunk(os, ci, cb, errCb) {
        // Build bounds for channels
        let lIdx = [this._inddbAb.uuid, ci, 0];
        let hIdx = [this._inddbAb.uuid, ci, this._inddbAb.channelCount];
        let chsKr = IDBKeyRange.bound(lIdx, hIdx);
        let rq = os.getAll(chsKr);
        rq.onsuccess = () => {
            let cc = rq.result;
            let cc0;
            let ccChs = cc.length;
            if (ccChs == 0) {
                cb(null);
                return;
            }
            if (ccChs !== this._inddbAb.channelCount) {
                errCb(new Error('Number of channels of inddb data (' + ccChs + ') does not match number of channels (' + this._inddbAb.channelCount + ')'));
                return;
            }
            if (cc.length > 0) {
                cc0 = cc[0];
            }
            let arrBuf = new Array();
            let ccLen = cc0.length;
            for (let ch = 0; ch < ccChs; ch++) {
                let chArr = new Float32Array(ccLen);
                for (let si = 0; si < ccLen; si++) {
                    chArr[si] = cc[ch][si];
                }
                arrBuf.push(chArr);
            }
            cb(arrBuf);
        };
        rq.onerror = (errEv) => {
            errCb(new Error(errEv.toString()));
        };
    }
    _fillBufs(ccBufs, trgState, srcState) {
        let ccBufsChs = ccBufs.length;
        if (ccBufsChs > 0) {
            let ccBuf0 = ccBufs[0];
            let ccBufsLen = ccBuf0.length;
            //console.debug('IndexedDbAudioBuffer::fillBufs framePos: '+framePos+', srcFramePos: '+srcFramePos+', ccBufsLen: '+ccBufsLen);
            if (trgState.framePos >= srcState.srcFramePos + ccBufsLen) {
                // target frame position is ahead, seek to next source buffer
                //console.debug('IndexedDbAudioBuffer::fillBufs seek to next inddb buffer');
                this._ccCache = null;
                srcState.ci++;
                srcState.ccPos = 0;
                srcState.srcFramePos += ccBufsLen;
            }
            else {
                // Assuming target frame pos is inside current source buffer
                srcState.ccPos = trgState.framePos - srcState.srcFramePos;
                let ccAvail = ccBufsLen - srcState.ccPos;
                let toCopy = ccBufsLen;
                if (toCopy > ccAvail) {
                    toCopy = ccAvail;
                }
                if (toCopy > trgState.frameLen) {
                    toCopy = trgState.frameLen;
                }
                for (let ch = 0; ch < ccBufsChs; ch++) {
                    for (let si = 0; si < toCopy; si++) {
                        trgState.trgBufs[ch][trgState.filled + si] = ccBufs[ch][srcState.ccPos + si];
                    }
                }
                trgState.filled += toCopy;
                trgState.frameLen -= toCopy;
                trgState.framePos += toCopy;
                srcState.ccPos += toCopy;
                if (srcState.ccPos >= ccBufsLen) {
                    // Invalidate cache
                    this._ccCache = null;
                    srcState.ci++;
                    this._currCi = srcState.ci;
                    srcState.ccPos = 0;
                    srcState.srcFramePos += ccBufsLen;
                }
            }
        }
    }
    fillBufs(os, trgState, srcState, cb, cbEnd, cbErr) {
        //console.debug('IndexedDbAudioBuffer::fillBufs: framePos:'+trgState.framePos+', frameLen: '+trgState.frameLen+', filled: '+trgState.filled+', srcFramePos: '+srcState.srcFramePos+',ci: '+srcState.ci+', ccPos: '+srcState.ccPos);
        if (this._ccCache) {
            this._fillBufs(this._ccCache, trgState, srcState);
            //console.debug('IndexedDbAudioBuffer::fillBufs frameLen: '+trgState.frameLen);
            if (trgState.frameLen === 0) {
                //console.debug('IndexedDbAudioBuffer::fillBufs (framelen==0) call: cbend '+trgState.filled);
                cbEnd(trgState.filled);
            }
            else {
                this.fillBufs(os, trgState, srcState, cb, cbEnd, cbErr);
            }
        }
        else {
            this.chunk(os, srcState.ci, (ccBufs) => {
                if (ccBufs) {
                    this._currCi = srcState.ci;
                    this._ccCache = ccBufs;
                    this._fillBufs(ccBufs, trgState, srcState);
                    //console.debug('IndexedDbAudioBuffer::fillBufs frameLen: '+trgState.frameLen);
                    if (trgState.frameLen === 0) {
                        //console.debug('IndexedDbAudioBuffer::fillBufs (framelen==0) call: cbend '+trgState.filled);
                        cbEnd(trgState.filled);
                    }
                    else {
                        this.fillBufs(os, trgState, srcState, cb, cbEnd, cbErr);
                    }
                }
                else {
                    //console.debug('IndexedDbAudioBuffer::fillBufs (chunk not found) call: cbend '+trgState.filled);
                    cbEnd(trgState.filled);
                }
            }, (err) => {
                cbErr(err);
            });
        }
    }
    framesObs(framePos, frameLen, bufs) {
        return new Observable((subscriber) => {
            let tr = this._inddbAb.persistentAudioStorageTarget.transaction();
            let os = tr.objectStore(this._inddbAb.persistentAudioStorageTarget.storeName);
            // Positioning
            let newCi = Math.floor(framePos / this._inddbAb.chunkFrameLen);
            if (newCi !== this._currCi) {
                this._currCi = newCi;
                this._ccCache = null;
            }
            let srcFramePos = newCi * this._inddbAb.chunkFrameLen;
            let trgState = { framePos: framePos, frameLen: frameLen, trgBufs: bufs, filled: 0 };
            let srcState = { srcFramePos: srcFramePos, ci: newCi, ccPos: 0, ccFilled: 0 };
            this.fillBufs(os, trgState, srcState, (val) => { }, (filled) => {
                subscriber.next(filled);
                subscriber.complete();
            }, err => {
                subscriber.error(err);
            });
        });
    }
    close() {
        this._currCi = 0;
        this._ccCache = null;
    }
}
class IndexedDbAudioInputStream {
    constructor(inddbAb) {
        this.inddbAb = inddbAb;
        this.framePos = 0;
        this.inddbAbStr = new IndexedDbRandomAccessStream(inddbAb);
    }
    close() {
        this.inddbAbStr.close();
    }
    readObs(buffers) {
        return new Observable(subscr => {
            if (buffers && buffers.length > 0) {
                let fl = buffers[0].length;
                this.inddbAbStr.framesObs(this.framePos, fl, buffers).subscribe({
                    next: (read) => {
                        this.framePos += read;
                        subscr.next(read);
                    },
                    complete: () => {
                        subscr.complete();
                    },
                    error: (err) => {
                        subscr.error(err);
                    }
                });
            }
            else {
                subscr.next(0);
                subscr.complete();
            }
        });
    }
    skipFrames(n) {
        this.framePos += n;
    }
}

// Code from audio_source_worklet.js as string constant to be loaded as module
// Changes in audio_source_worklet.js must be copied and pasted to this string constant
const aswpStr = "\n" +
    "// Important note: Changes in audio_source_worklet.js must be copied and pasted to the string constant aswpStr in audio_source_worklet_module_loader.ts\n" +
    "\n" +
    "\n" +
    "class AudioSourceProcessor extends AudioWorkletProcessor{\n" +
    "\n" +
    "    filledFrames=0;\n" +
    "    audioBuffers=new Array();\n" +
    "    currentAudioBuffer=null;\n" +
    "    currentAudioBufferFramePos=0;\n" +
    "    currentAudioBufferAvail=0;\n" +
    "    running=false;\n" +
    "    stalled=false;\n" +
    "    stopped=false;\n" +
    "    endOfStream=false;\n" +
    "    ended=false;\n" +
    "\n" +
    "    constructor() {\n" +
    "        super({numberOfInputs:0,numberOfOutputs:1});\n" +
    "        this.port.onmessage=(msgEv)=>{\n" +
    "          // received audio playback data from application\n" +
    "          //console.debug(\"Audio source worklet msg: Received.\");\n" +
    "\n" +
    "          if(msgEv.data.cmd){\n" +
    "            if('data'===msgEv.data.cmd) {\n" +
    "              let chs = msgEv.data.chs;\n" +
    "\n" +
    "              let audioData = new Array(chs);\n" +
    "              for (let ch = 0; ch < chs; ch++) {\n" +
    "                audioData[ch] = new Float32Array(msgEv.data.audioData[ch]);\n" +
    "              }\n" +
    "              let msgChBufLen=audioData[0].length;\n" +
    "              this.audioBuffers.push(audioData);\n" +
    "              this.filledFrames += msgChBufLen;\n" +
    "              //console.debug(\"Audio source worklet msg: Filled \" + this.filledFrames+ \" in \"+this.audioBuffers.length+\" buffers.\");\n" +
    "\n" +
    "            }else if('start'===msgEv.data.cmd){\n" +
    "              this.running=true;\n" +
    "            }else if('stop'===msgEv.data.cmd){\n" +
    "              //console.debug(\"Stop...\");\n" +
    "              this.running=false;\n" +
    "              this.stopped=true;\n" +
    "              // clear buffers\n" +
    "              this.filledFrames=0;\n" +
    "              while(this.audioBuffers.length > 0) {\n" +
    "                this.audioBuffers.pop();\n" +
    "              }\n" +
    "              this.currentAudioBuffer=new Float32Array(0);\n" +
    "            }else if('endOfStream'===msgEv.data.cmd){\n" +
    "              this.endOfStream=true;\n" +
    "            }else if('continue'===msgEv.data.cmd){\n" +
    "              console.debug(\"Continue after stalled...\");\n" +
    "              this.stalled=false;\n" +
    "              this.port.postMessage({eventType: 'resumed'});\n" +
    "            }\n" +
    "          }\n" +
    "        }\n" +
    "    }\n" +
    "\n" +
    " process(\n" +
    "      inputs,\n" +
    "      outputs,\n" +
    "      parameters\n" +
    "  ){\n" +
    "      //console.debug(\"Audio source worklet: process \"+outputs.length+ \" output buffers.\");\n" +
    "      // copy ring buffer data to outputs\n" +
    "        if(!this.running || this.stalled){\n" +
    "            if(this.endOfStream) {\n" +
    "                this.ended = true;\n" +
    "                this.port.postMessage({eventType: 'ended'});\n" +
    "            }\n" +
    "          return !this.ended && !this.stopped;\n" +
    "        }\n" +
    "\n" +
    "        let output=outputs[0];\n" +
    "        let chs=output.length;\n" +
    "        //console.debug(\"Audio source worklet: Output channels: \"+chs);\n" +
    "        if(chs>0) {\n" +
    "\n" +
    "          let outCh0 = output[0];\n" +
    "          let outChLen = outCh0.length;\n" +
    "\n" +
    "          if(!this.currentAudioBuffer){\n" +
    "            // get first buffer\n" +
    "            let nxtBuff=this.audioBuffers.shift();\n" +
    "            if(nxtBuff) {\n" +
    "              this.currentAudioBuffer = nxtBuff;\n" +
    "              this.currentAudioBufferFramePos=0;\n" +
    "              this.currentAudioBufferAvail=this.currentAudioBuffer[0].length;\n" +
    "            }else{\n" +
    "              return true;\n" +
    "            }\n" +
    "          }\n" +
    "\n" +
    "          let copied=0;\n" +
    "          do{\n" +
    "            if(this.currentAudioBufferAvail===0){\n" +
    "              let nxtBuff=this.audioBuffers.shift();\n" +
    "              if(nxtBuff){\n" +
    "                this.currentAudioBuffer=nxtBuff;\n" +
    "                this.currentAudioBufferFramePos=0;\n" +
    "                this.currentAudioBufferAvail=this.currentAudioBuffer[0].length;\n" +
    "                //console.debug(\"Next buffer with \"+this.currentAudioBufferAvail+ \" frames\");\n" +
    "                this.port.postMessage({eventType:'bufferNotification',filledFrames:this.filledFrames});\n" +
    "              }else{\n" +
    "                if(this.endOfStream) {\n" +
    "                  this.ended = true;\n" +
    "                  this.port.postMessage({eventType: 'ended'});\n" +
    "                  //console.debug(\"Stream ended\");\n" +
    "                }else{\n" +
    "                  if(!this.stalled) {\n" +
    "                    this.stalled = true;\n" +
    "                    this.port.postMessage({eventType: 'stalled'});\n" +
    "                  }\n" +
    "                }\n" +
    "                break;\n" +
    "              }\n" +
    "            }\n" +
    "            //console.debug(\"outChLen: \"+outChLen+\", copied: \"+copied+\", current avail: \"+this.currentAudioBufferAvail);\n" +
    "            let toCopy=outChLen-copied;\n" +
    "            if(toCopy>this.currentAudioBufferAvail){\n" +
    "              toCopy=this.currentAudioBufferAvail;\n" +
    "            }\n" +
    "            //console.debug(\"Copy \"+toCopy+\" frames...\");\n" +
    "            for(let ch=0;ch<chs;ch++) {\n" +
    "              let outCh=output[ch];\n" +
    "              for (let i = 0; i < toCopy; i++) {\n" +
    "                outCh[copied+i]=this.currentAudioBuffer[ch][this.currentAudioBufferFramePos+i];\n" +
    "              }\n" +
    "            }\n" +
    "            copied+=toCopy;\n" +
    "            this.currentAudioBufferFramePos+=toCopy;\n" +
    "            this.currentAudioBufferAvail-=toCopy;\n" +
    "\n" +
    "          }while(copied<outChLen);\n" +
    "          this.filledFrames-=copied;\n" +
    "          //console.debug(\"Copied \"+copied+\" frames.\");\n" +
    "        }\n" +
    "     return !this.ended;\n" +
    "  }\n" +
    "}\n" +
    "\n" +
    "registerProcessor('audio-source-worklet',AudioSourceProcessor);\n";
class AudioSourceWorkletModuleLoader {
    static { this.moduleLoaded = false; }
    static loadModule(context) {
        return new Promise((resolve, reject) => {
            if (AudioSourceWorkletModuleLoader.moduleLoaded) {
                resolve.call(self);
            }
            else {
                const audioWorkletModuleBlob = new Blob([aswpStr], { type: 'text/javascript' });
                const audioWorkletModuleBlobUrl = window.URL.createObjectURL(audioWorkletModuleBlob);
                context.audioWorklet.addModule(audioWorkletModuleBlobUrl).then(() => {
                    AudioSourceWorkletModuleLoader.moduleLoaded = true;
                    resolve.call(self);
                }).catch((reason) => {
                    console.error(reason);
                    reject.call(reason);
                });
            }
        });
    }
}

class IndexedDbAudioBufferSourceNode extends AudioSourceNode {
    constructor(context) {
        super(context, 'audio-source-worklet');
        this._bufferFillSeconds = AudioSourceNode.DEFAULT_BUFFER_FILL_SECONDS;
        this.bufferFillFrames = 0;
        this._streamReadFrameLen = AudioSourceNode.DEFAULT_STREAM_READ_FRAME_LEN * 8; // Much overhead fetching small buffers from indexed db, use larger buffer (8192).
        this._inddbAudioBuffer = null;
        this._audioInputStream = null;
        this._aisBufs = null;
        this._active = false;
        this._endOfStream = false;
        this.filledFrames = 0;
        this.channelCountMode = 'explicit';
        this.port.onmessage = (msgEv) => {
            if (msgEv.data) {
                let evType = msgEv.data.eventType;
                if (evType) {
                    if ('bufferNotification' === evType) {
                        this.filledFrames = msgEv.data.filledFrames;
                        if (!this._endOfStream) {
                            this.fillBufferObs().subscribe();
                        }
                    }
                    else if ('ended' === evType) {
                        //console.debug("Inddb audio source ended playback.");
                        let drainTime = 0;
                        if (this._inddbAudioBuffer?.sampleRate) {
                            drainTime = ArrayAudioBufferSourceNode.QUANTUM_FRAME_LEN / this._inddbAudioBuffer.sampleRate;
                        }
                        //let dstAny:any=this.context.destination;
                        //console.debug('Destination node tail-time: '+dstAny['tail-time']);
                        window.setTimeout(() => {
                            this.onended?.call(this);
                        }, drainTime * 1000);
                    }
                }
            }
        };
    }
    fillBufferObs(frameOffset) {
        let obs = new Observable(subscriber => {
            if (frameOffset) {
                subscriber.error(new Error("Starting playback from position not equal zero not supported yet."));
            }
            else {
                let filled = this.filledFrames;
                let bufLen = 0;
                if (this._audioInputStream && this._aisBufs) {
                    this._audioInputStream.readObs(this._aisBufs).pipe(expand((read) => {
                        if (read && this._aisBufs) {
                            let trBuffers = new Array(this.channelCount);
                            for (let ch = 0; ch < this.channelCount; ch++) {
                                let adCh = this._aisBufs[ch];
                                let adChCopy = new Float32Array(read);
                                bufLen = adChCopy.length;
                                if (read === adCh.length) {
                                    adChCopy.set(adCh);
                                }
                                else {
                                    // Note: slice() does not work here, since it returns a shallow copy.
                                    for (let i = 0; i < read; i++) {
                                        adChCopy[i] = adCh[i];
                                    }
                                }
                                trBuffers[ch] = adChCopy.buffer;
                            }
                            this.port.postMessage({
                                cmd: 'data',
                                chs: this.channelCount,
                                audioData: trBuffers
                            }, trBuffers);
                            filled += read;
                            //console.debug("IndexedDbAudioBufferSourceNode::fillBufferObs: Sent "+read+" frames to audio source worklet. Filled: "+filled+", to fill: "+this.bufferFillFrames);
                            if (this._audioInputStream && filled < this.bufferFillFrames) {
                                //console.debug("IndexedDbAudioBufferSourceNode::fillBufferObs: Next inddb audio input stream readObs");
                                return this._audioInputStream.readObs(this._aisBufs);
                            }
                            else {
                                //console.debug("Return EMPTY");
                                return EMPTY;
                            }
                        }
                        else {
                            //console.debug("IndexedDbAudioBufferSourceNode::fillBufferObs: Return EMPTY (read: "+read+")");
                            this._endOfStream = true;
                            this.port.postMessage({
                                cmd: 'endOfStream'
                            });
                            return EMPTY;
                        }
                    })).subscribe(subscriber);
                }
            }
        });
        return obs;
    }
    get inddbAudioBuffer() {
        return this._inddbAudioBuffer;
    }
    set inddbAudioBuffer(value) {
        this._inddbAudioBuffer = value;
        if (this._inddbAudioBuffer?.channelCount) {
            this.channelCount = this._inddbAudioBuffer?.channelCount;
            this.bufferFillFrames = this._inddbAudioBuffer.sampleRate * this._bufferFillSeconds;
        }
    }
    get bufferFillSeconds() {
        return this._bufferFillSeconds;
    }
    set bufferFillSeconds(value) {
        this._bufferFillSeconds = value;
    }
    start(when, offset, duration) {
        if (when) {
            throw Error("when parameter currently not supported by IndexedDbAudioBufferSourceNode class");
        }
        if (this._inddbAudioBuffer) {
            let arrAis = new IndexedDbAudioInputStream(this._inddbAudioBuffer);
            if (offset === undefined && duration === undefined) {
                this._audioInputStream = arrAis;
            }
            else {
                let offsetFrames = 0;
                let durationFrames = undefined;
                if (offset !== undefined) {
                    offsetFrames = Math.floor(offset * this._inddbAudioBuffer.sampleRate);
                }
                if (duration !== undefined) {
                    durationFrames = Math.floor(duration * this._inddbAudioBuffer.sampleRate);
                }
                //console.debug("Create AsyncEditFloat32ArrayInputStream: offsetFrames:"+offsetFrames+", durationFrames:"+durationFrames);
                this._audioInputStream = new AsyncEditFloat32ArrayInputStream(arrAis, offsetFrames, durationFrames);
            }
            let chs = this._inddbAudioBuffer.channelCount;
            this._aisBufs = new Array(chs);
            for (let ch = 0; ch < chs; ch++) {
                this._aisBufs[ch] = new Float32Array(this._streamReadFrameLen);
            }
            this.fillBufferObs().subscribe({
                complete: () => {
                    //console.debug("IndexedDbAudioBufferSourceNode::start: Async play buffer fill completed. Sending start command to audio worklet.");
                    if (this._active) {
                        this.port.postMessage({ cmd: 'start' });
                        if (offset) {
                            this._playStartTime = this.context.currentTime - offset;
                        }
                        else {
                            this._playStartTime = this.context.currentTime;
                        }
                    }
                }
            });
            this._active = true;
        }
    }
    stop() {
        this._active = false;
        this.port.postMessage({ cmd: 'stop' });
        this.onended?.call(this);
    }
}

class NetAudioBuffer extends BasicAudioSource {
    get orgFetchChunkFrameLen() {
        return this._orgFetchChunkFrameLen;
    }
    get recFileService() {
        return this._recFileService;
    }
    get baseUrl() {
        return this._baseUrl;
    }
    get chunkFrameLen() {
        return this._chunkFrameLen;
    }
    get uuid() {
        return this._uuid;
    }
    constructor(_recFileService, _baseUrl, _channelCount, _sampleRate, _chunkFrameLen, _frameLen, _uuid = null, _orgFetchChunkFrameLen = _chunkFrameLen) {
        super();
        this._recFileService = _recFileService;
        this._baseUrl = _baseUrl;
        this._channelCount = _channelCount;
        this._sampleRate = _sampleRate;
        this._chunkFrameLen = _chunkFrameLen;
        this._frameLen = _frameLen;
        this._uuid = _uuid;
        this._orgFetchChunkFrameLen = _orgFetchChunkFrameLen;
        this._chunkCount = 0;
        this._sealed = false;
    }
    get channelCount() {
        return this._channelCount;
    }
    sealed() {
        return this._sealed;
    }
    seal() {
        this._sealed = true;
    }
    get sampleRate() {
        return this._sampleRate;
    }
    get frameLen() {
        return this._frameLen;
    }
    get chunkCount() {
        return this._chunkCount;
    }
    releaseAudioData() {
        return new Observable((subscriber) => {
            // nothing to remove
            subscriber.next();
            subscriber.complete();
        });
    }
    toString() {
        return "Indexed db audio buffer. Channels: " + this.channelCount + ", sample rate: " + this.sampleRate + ", chunk frame length: " + this._chunkFrameLen + ", number of chunks: " + this.chunkCount + ", frame length: " + this.frameLen + ", sealed: " + this.sealed();
    }
    static fromChunkAudioBuffer(recordingsService, baseUrl, ab, frameLen, orgFetchChunkFrameLen = ab.length) {
        let nab = new NetAudioBuffer(recordingsService, baseUrl, ab.numberOfChannels, ab.sampleRate, ab.length, frameLen, null, orgFetchChunkFrameLen);
        nab.ready();
        return nab;
    }
    asyncAudioInputStream() {
        return new NetAudioInputStream(this);
    }
    audioInputStream() {
        return null;
    }
    get duration() {
        return this._frameLen / this._sampleRate;
    }
    get numberOfChannels() {
        return this._channelCount;
    }
    sampleCounts() {
        return this._channelCount * this._frameLen;
    }
    randomAccessAudioStream() {
        return new NetRandomAccessAudioStream(this);
    }
}
// export class NetAudioChunk{
//
//   get orgSampleRate(): number {
//     return this._orgSampleRate;
//   }
//
//   get orgFrameLen(): number {
//     return this._orgFrameLen;
//   }
//   constructor(private _decodedBuffers:Float32Array[],private _orgSampleRate:number,private _orgFrameLen:number) {
//   }
// }
class NetRandomAccessAudioStream {
    constructor(_netAb) {
        this._netAb = _netAb;
        this._currCi = 0;
        this._ccCache = null;
    }
    chunk(baseUrl, ci, cb, errCb) {
        let startFrame = ci * this._netAb.orgFetchChunkFrameLen;
        this._netAb.recFileService.chunkAudioRequest(baseUrl, startFrame, this._netAb.orgFetchChunkFrameLen).subscribe({
            next: (chDl) => {
                if (chDl) {
                    const ab = chDl.decodedAudioBuffer;
                    const ccChs = ab.numberOfChannels;
                    let arrBuf = new Array();
                    for (let ch = 0; ch < ccChs; ch++) {
                        arrBuf.push(ab.getChannelData(ch));
                    }
                    cb(arrBuf, chDl.orgFrameLength);
                }
                else {
                    cb(null, null);
                }
            },
            complete: () => { },
            error: (errEv) => {
                //NetRandomAccessAudioStream._runningRequests--;
                if (errEv instanceof HttpErrorResponse) {
                    if (errEv.status === 404) {
                        cb(null, null);
                    }
                    else {
                        console.error("Net audio buffer chunk audio request Http error event: " + errEv.status + ", " + errEv.name + ", " + errEv.message);
                        errCb(new Error(errEv.toString()));
                    }
                }
                else {
                    console.error("Net audio buffer chunk audio request error event: " + errEv.message);
                    errCb(new Error(errEv.toString()));
                }
            }
        });
    }
    _fillBufs(ccBufs, orgFrameLen, trgState, srcState) {
        let ccBufsChs = ccBufs.length;
        if (ccBufsChs > 0) {
            let ccBuf0 = ccBufs[0];
            let ccBufsLen = ccBuf0.length;
            //console.debug('IndexedDbAudioBuffer::fillBufs framePos: '+framePos+', srcFramePos: '+srcFramePos+', ccBufsLen: '+ccBufsLen);
            if (trgState.framePos >= srcState.srcFramePos + ccBufsLen) {
                // target frame position is ahead, seek to next source buffer
                //console.debug('IndexedDbAudioBuffer::fillBufs seek to next inddb buffer');
                this._ccCache = null;
                srcState.ci++;
                srcState.ccPos = 0;
                if (orgFrameLen === null) {
                    srcState.orgSrcFramePos += ccBufsLen;
                }
                else {
                    srcState.orgSrcFramePos += orgFrameLen;
                }
                srcState.srcFramePos += ccBufsLen;
            }
            else {
                // Assuming target frame pos is inside current source buffer
                srcState.ccPos = trgState.framePos - srcState.srcFramePos;
                let ccAvail = ccBufsLen - srcState.ccPos;
                let toCopy = ccBufsLen;
                if (toCopy > ccAvail) {
                    toCopy = ccAvail;
                }
                if (toCopy > trgState.frameLen) {
                    toCopy = trgState.frameLen;
                }
                for (let ch = 0; ch < ccBufsChs; ch++) {
                    for (let si = 0; si < toCopy; si++) {
                        trgState.trgBufs[ch][trgState.filled + si] = ccBufs[ch][srcState.ccPos + si];
                    }
                }
                trgState.filled += toCopy;
                trgState.frameLen -= toCopy;
                trgState.framePos += toCopy;
                srcState.ccPos += toCopy;
                if (srcState.ccPos >= ccBufsLen) {
                    // Invalidate cache
                    this._ccCache = null;
                    srcState.ci++;
                    this._currCi = srcState.ci;
                    srcState.ccPos = 0;
                    if (orgFrameLen === null) {
                        srcState.orgSrcFramePos += ccBufsLen;
                    }
                    else {
                        srcState.orgSrcFramePos += orgFrameLen;
                    }
                    srcState.srcFramePos += ccBufsLen;
                }
            }
        }
    }
    fillBufs(baseUrl, orgFrameLen, trgState, srcState, cb, cbEnd, cbErr) {
        //console.debug('IndexedDbAudioBuffer::fillBufs: framePos:'+framePos+', frameLen: '+frameLen+', filled: '+filled+', srcFramePos: '+srcFramePos+',ci: '+ci+', ccPos: '+ccPos);
        if (this._ccCache) {
            this._fillBufs(this._ccCache, orgFrameLen, trgState, srcState);
            //console.debug('IndexedDbAudioBuffer::fillBufs frameLen: '+frameLen);
            if (trgState.frameLen === 0) {
                //console.debug('IndexedDbAudioBuffer::fillBufs (framelen==0) call: cbend '+filled);
                cbEnd(trgState.filled);
            }
            else {
                this.fillBufs(baseUrl, orgFrameLen, trgState, srcState, cb, cbEnd, cbErr);
            }
        }
        else {
            this.chunk(baseUrl, srcState.ci, (ccBufs, orgFrameLength) => {
                if (ccBufs) {
                    this._currCi = srcState.ci;
                    this._ccCache = ccBufs;
                    this._fillBufs(ccBufs, orgFrameLength, trgState, srcState);
                    //console.debug('IndexedDbAudioBuffer::fillBufs frameLen: '+frameLen);
                    if (trgState.frameLen === 0) {
                        //console.debug('IndexedDbAudioBuffer::fillBufs (framelen==0) call: cbend '+filled);
                        cbEnd(trgState.filled);
                    }
                    else {
                        this.fillBufs(baseUrl, orgFrameLen, trgState, srcState, cb, cbEnd, cbErr);
                    }
                }
                else {
                    //console.debug('IndexedDbAudioBuffer::fillBufs (chunk not found) call: cbend '+filled);
                    cbEnd(trgState.filled);
                }
            }, (err) => {
                cbErr(err);
            });
        }
    }
    framesObs(framePos, frameLen, bufs) {
        return new Observable((subscriber) => {
            // Positioning
            let newCi = Math.floor(framePos / this._netAb.chunkFrameLen);
            if (newCi !== this._currCi) {
                this._currCi = newCi;
                this._ccCache = null;
            }
            let srcFramePos = newCi * this._netAb.chunkFrameLen;
            let trgState = { framePos: framePos, frameLen: frameLen, trgBufs: bufs, filled: 0 };
            let srcState = { orgSrcFramePos: 0, srcFramePos: srcFramePos, ci: newCi, ccPos: 0, ccFilled: 0 };
            this.fillBufs(this._netAb.baseUrl, this._netAb.orgFetchChunkFrameLen, trgState, srcState, (val) => { }, (filled) => {
                subscriber.next(filled);
                subscriber.complete();
            }, err => {
                subscriber.error(err);
            });
        });
    }
    close() {
        this._currCi = 0;
        this._ccCache = null;
    }
}
class NetAudioInputStream {
    constructor(netAb) {
        this.netAb = netAb;
        this.framePos = 0;
        this.netAbStr = new NetRandomAccessAudioStream(netAb);
    }
    close() {
        this.netAbStr.close();
    }
    readObs(buffers) {
        return new Observable(subscr => {
            if (buffers && buffers.length > 0) {
                let fl = buffers[0].length;
                this.netAbStr.framesObs(this.framePos, fl, buffers).subscribe({
                    next: (read) => {
                        this.framePos += read;
                        subscr.next(read);
                    },
                    complete: () => {
                        subscr.complete();
                    },
                    error: (err) => {
                        subscr.error(err);
                    }
                });
            }
            else {
                subscr.next(0);
                subscr.complete();
            }
        });
    }
    skipFrames(n) {
        this.framePos += n;
    }
}

class NetAudioBufferSourceNode extends AudioSourceNode {
    constructor(context) {
        super(context, 'audio-source-worklet');
        this._bufferFillSeconds = AudioSourceNode.DEFAULT_BUFFER_FILL_SECONDS;
        this.bufferFillFrames = 0;
        this._streamReadFrameLen = AudioSourceNode.DEFAULT_STREAM_READ_FRAME_LEN * 8; // Much overhead fetching small buffers from indexed db, use larger buffer (8192).
        this._netAudioBuffer = null;
        this._audioInputStream = null;
        this._aisBufs = null;
        this._active = false;
        this.stalled = false;
        this._endOfStream = false;
        this.readDataSubscription = null;
        this.filledFrames = 0;
        this.stalledStartTime = null;
        this.stalledTime = 0;
        this.stopEndTime = null;
        this.channelCountMode = 'explicit';
        this.port.onmessage = (msgEv) => {
            if (msgEv.data) {
                let evType = msgEv.data.eventType;
                if (evType) {
                    if ('bufferNotification' === evType) {
                        this.filledFrames = msgEv.data.filledFrames;
                        //console.debug("IndexedDbAudioBufferSourceNode: Buffer notification: filled frames: " + this.filledFrames);
                        if (!this._endOfStream) {
                            this.fillBufferObs().subscribe();
                        }
                    }
                    else if ('ended' === evType) {
                        //console.debug("Inddb audio source ended playback.");
                        let drainTime = 0;
                        if (this._netAudioBuffer?.sampleRate) {
                            drainTime = ArrayAudioBufferSourceNode.QUANTUM_FRAME_LEN / this._netAudioBuffer.sampleRate;
                        }
                        //let dstAny:any=this.context.destination;
                        //console.debug('Destination node tail-time: '+dstAny['tail-time']);
                        window.setTimeout(() => {
                            this.stopEndTime = this.context.currentTime;
                            this._active = false;
                            this.onended?.call(this);
                        }, drainTime * 1000);
                    }
                    else if ('stalled' === evType) {
                        console.debug('Playback stalled...');
                        this.stalled = true;
                        this.stalledStartTime = this.context.currentTime;
                    }
                    else if ('resumed' === evType) {
                        console.debug('Playback resumed after stall.');
                        this.stalled = false;
                        if (this.stalledStartTime != null) {
                            this.stalledTime += this.context.currentTime - this.stalledStartTime;
                            this.stalledStartTime = null;
                        }
                    }
                }
            }
        };
    }
    fillBufferObs(frameOffset) {
        return new Observable(subscriber => {
            if (frameOffset) {
                subscriber.error(new Error("Starting playback from position not equal zero not supported yet."));
            }
            else {
                let filled = this.filledFrames;
                let bufLen = 0;
                if (this._audioInputStream && this._aisBufs && (this.readDataSubscription == null || this.readDataSubscription?.closed)) {
                    this.readDataSubscription = this._audioInputStream.readObs(this._aisBufs).pipe(expand((read) => {
                        if (read && this._aisBufs) {
                            let trBuffers = new Array(this.channelCount);
                            for (let ch = 0; ch < this.channelCount; ch++) {
                                let adCh = this._aisBufs[ch];
                                let adChCopy = new Float32Array(read);
                                bufLen = adChCopy.length;
                                if (read === adCh.length) {
                                    adChCopy.set(adCh);
                                }
                                else {
                                    // Note: slice() does not work here, since it returns a shallow copy.
                                    for (let i = 0; i < read; i++) {
                                        adChCopy[i] = adCh[i];
                                    }
                                }
                                trBuffers[ch] = adChCopy.buffer;
                            }
                            this.port.postMessage({
                                cmd: 'data',
                                chs: this.channelCount,
                                audioData: trBuffers
                            }, trBuffers);
                            filled += read;
                            //console.debug("IndexedDbAudioBufferSourceNode::fillBufferObs: Sent "+read+" frames to audio source worklet. Filled: "+filled+", to fill: "+this.bufferFillFrames);
                            if (this._audioInputStream && filled < this.bufferFillFrames) {
                                //console.debug("IndexedDbAudioBufferSourceNode::fillBufferObs: Next inddb audio input stream readObs");
                                return this._audioInputStream.readObs(this._aisBufs);
                            }
                            else {
                                if (this.stalled) {
                                    this.port.postMessage({
                                        cmd: 'continue'
                                    });
                                }
                                return EMPTY;
                            }
                        }
                        else {
                            //console.debug("IndexedDbAudioBufferSourceNode::fillBufferObs: Return EMPTY (read: "+read+")");
                            this._endOfStream = true;
                            this.port.postMessage({
                                cmd: 'endOfStream'
                            });
                            return EMPTY;
                        }
                    })).subscribe(subscriber);
                }
            }
        });
    }
    get netAudioBuffer() {
        return this._netAudioBuffer;
    }
    set netAudioBuffer(value) {
        this._netAudioBuffer = value;
        if (this._netAudioBuffer?.channelCount) {
            this.channelCount = this._netAudioBuffer?.channelCount;
            this.bufferFillFrames = this._netAudioBuffer.sampleRate * this._bufferFillSeconds;
        }
    }
    get bufferFillSeconds() {
        return this._bufferFillSeconds;
    }
    set bufferFillSeconds(value) {
        this._bufferFillSeconds = value;
    }
    start(when, offset, duration) {
        if (when) {
            throw Error("when parameter currently not supported by IndexedDbAudioBufferSourceNode class");
        }
        this._playStartTime = null;
        this.stopEndTime = null;
        this.stalledTime = 0;
        this.stalledStartTime = null;
        if (this._netAudioBuffer) {
            let arrAis = new NetAudioInputStream(this._netAudioBuffer);
            if (offset === undefined && duration === undefined) {
                this._audioInputStream = arrAis;
            }
            else {
                let offsetFrames = 0;
                let durationFrames = undefined;
                if (offset !== undefined) {
                    offsetFrames = Math.floor(offset * this._netAudioBuffer.sampleRate);
                }
                if (duration !== undefined) {
                    durationFrames = Math.floor(duration * this._netAudioBuffer.sampleRate);
                }
                //console.error("Playback selection not supported yet!");
                this._audioInputStream = new AsyncEditFloat32ArrayInputStream(arrAis, offsetFrames, durationFrames);
            }
            let chs = this._netAudioBuffer.channelCount;
            this._aisBufs = new Array(chs);
            for (let ch = 0; ch < chs; ch++) {
                this._aisBufs[ch] = new Float32Array(this._streamReadFrameLen);
            }
            this.fillBufferObs().subscribe({
                complete: () => {
                    //console.debug("IndexedDbAudioBufferSourceNode::start: Async play buffer fill completed. Sending start command to audio worklet.");
                    if (this._active) {
                        this.port.postMessage({ cmd: 'start' });
                        if (offset) {
                            this._playStartTime = this.context.currentTime - offset;
                        }
                        else {
                            this._playStartTime = this.context.currentTime;
                        }
                    }
                }
            });
            this._active = true;
        }
    }
    stop() {
        this._active = false;
        this.port.postMessage({ cmd: 'stop' });
        this.onended?.call(this);
    }
    get playPositionTime() {
        let ppt = null;
        if (this._playStartTime !== null) {
            if (this._active) {
                if (this.stalledStartTime == null) {
                    ppt = this.context.currentTime - this._playStartTime - this.stalledTime;
                }
                else {
                    ppt = this.stalledStartTime - this._playStartTime - this.stalledTime;
                }
            }
            else {
                if (this.stopEndTime != null) {
                    // if(this._netAudioBuffer?.frameLen !=null && this._netAudioBuffer.sampleRate) {
                    //   ppt = this._netAudioBuffer?.frameLen / this._netAudioBuffer?.sampleRate;
                    // }else{
                    ppt = this.stopEndTime - this._playStartTime - this.stalledTime;
                    //}
                }
            }
        }
        return ppt;
    }
}

class AudioContextProvider {
    static { this._audioContext = null; }
    static { this._offlineAudioContext = null; }
    static audioContextInstance() {
        if (!this._audioContext) {
            let debugFail = false;
            if (!window.AudioContext || typeof window.AudioContext !== 'function' || debugFail) {
                this._audioContext = null;
                throw new Error('Browser does not support Web Audio API!');
            }
            else {
                console.debug("Get new audio context...");
                this._audioContext = new window.AudioContext();
                console.debug("Created new audio context.");
                this._audioContext.addEventListener('statechange', () => {
                    console.debug("Audio context state changed: " + this._audioContext?.state);
                });
                console.debug("Created new audio context with state: " + this._audioContext?.state);
            }
        }
        return this._audioContext;
    }
    // public static audioContextInstanceRunning(audioContext?:AudioContext):Promise<AudioContext>{
    //
    //     return new Promise<AudioContext>((resolve,reject)=>{
    //       let aCtx=audioContext?audioContext:AudioContextProvider.audioContextInstance();
    //       if(aCtx) {
    //         if(aCtx.state==='closed') {
    //           reject(new Error('Audio context already closed.'));
    //         }else if(aCtx.state==='running') {
    //           resolve(aCtx);
    //         }else{
    //           aCtx.resume().then(() => {
    //             if(aCtx) {
    //               resolve(aCtx);
    //             }else{
    //               reject(new Error('Could not get audio context'));
    //             }
    //           }).catch(() => {
    //             reject(new Error('Could not resume audio context'));
    //           })
    //         }
    //       }else{
    //         reject(new Error('Could not get audio context from browser'));
    //       }
    //   });
    // }
    // public static decodeAudioData(data:ArrayBuffer,audioContext?:AudioContext):Promise<AudioBuffer>{
    //   return new Promise<AudioBuffer>((resolve,reject)=>{
    //     // decodeAudioData requires an audio context in running state
    //     AudioContextProvider.audioContextInstanceRunning(audioContext).then(
    //       (aCtx)=>{
    //         // Do not use Promise version, which does not work with Safari 13
    //         aCtx.decodeAudioData(data,decodedData => {
    //           resolve(decodedData);
    //         },(reason) => {
    //           reject(reason);
    //         });
    //       }
    //     ).catch((reason)=>{
    //       reject(reason);
    //     })
    //   })
    // }
    static decodeAudioData(data) {
        return new Promise((resolve, reject) => {
            if (!this._offlineAudioContext) {
                this._offlineAudioContext = new OfflineAudioContext(1, 44100, 44100);
            }
            // Do not use Promise version, which does not work with Safari 13
            this._offlineAudioContext.decodeAudioData(data, decodedData => {
                resolve(decodedData);
            }, (reason) => {
                reject(reason);
            });
        });
    }
}

var EventType;
(function (EventType) {
    EventType[EventType["CLOSED"] = 0] = "CLOSED";
    EventType[EventType["READY"] = 1] = "READY";
    EventType[EventType["STARTED"] = 2] = "STARTED";
    EventType[EventType["POS_UPDATE"] = 3] = "POS_UPDATE";
    EventType[EventType["STOPPED"] = 4] = "STOPPED";
    EventType[EventType["ENDED"] = 5] = "ENDED";
    EventType[EventType["ERROR"] = 6] = "ERROR";
})(EventType || (EventType = {}));
class AudioPlayerEvent {
    constructor(type, timePosition) {
        this._type = type;
        this._timePosition = timePosition;
    }
    get type() {
        return this._type;
    }
    get timePosition() {
        return this._timePosition;
    }
}
class AudioPlayer {
    get autoPlayOnSelectToggleAction() {
        return this._autoPlayOnSelectToggleAction;
    }
    static { this.DEFAULT_BUFSIZE = 8192; }
    constructor(listener) {
        this.running = false;
        this.context = null;
        this.ready = false;
        this._audioClip = null;
        this._audioSource = null;
        this.sourceBufferNode = null;
        this.sourceAudioWorkletNode = null;
        this.playStartTime = null;
        this.timerVar = null;
        this.listener = listener;
        this.bufSize = AudioPlayer.DEFAULT_BUFSIZE;
        this.n = navigator;
        this.buffPos = 0;
        this.zeroBufCnt = 0;
        this.zb = new Float32Array(this.bufSize);
        this._startAction = new Action('Start');
        this._startAction.disabled = true;
        this._startAction.onAction = () => this.start();
        this._startSelectionAction = new Action('Start selected');
        this._startSelectionAction.disabled = true;
        this._startSelectionAction.onAction = () => this.startSelected();
        this._autoPlayOnSelectToggleAction = new Action("Autoplay on select", false);
        this._stopAction = new Action('Stop');
        this._stopAction.disabled = true;
        this._stopAction.onAction = () => this.stop();
    }
    _audioContext() {
        if (!this.context) {
            this.context = AudioContextProvider.audioContextInstance();
            if (this.context) {
                this.context.addEventListener('statechange', (ev) => {
                    if (this.context && this.context.state !== 'running') {
                        this.stop();
                    }
                });
            }
        }
        return this.context;
    }
    get startAction() {
        return this._startAction;
    }
    get startSelectionAction() {
        return this._startSelectionAction;
    }
    get stopAction() {
        return this._stopAction;
    }
    set audioClip(audioClip) {
        this._audioClip = audioClip;
        let length = 0;
        let chs = 0;
        if (audioClip && audioClip.audioDataHolder) {
            let audioDataHolder = audioClip.audioDataHolder;
            chs = audioDataHolder.numberOfChannels;
            if (chs > 0) {
                length = audioDataHolder.frameLen;
                //if (chs > this.context.destination.maxChannelCount) {
                //    // TODO exception
                //}
            }
            this.audioSource = audioDataHolder.audioSource;
            audioClip.addSelectionObserver((ac) => {
                this._startSelectionAction.disabled = this.startSelectionDisabled();
                if (!this.startSelectionAction.disabled && this._autoPlayOnSelectToggleAction.value) {
                    this.startSelected();
                }
            });
        }
        else {
            this.audioSource = null;
        }
    }
    get audioSource() {
        return this._audioSource;
    }
    set audioSource(value) {
        this.stop();
        this._audioSource = value;
        if (this._audioSource) {
            this.ready = true;
            this.updateStartActions();
            if (this.listener) {
                this.listener.audioPlayerUpdate(new AudioPlayerEvent(EventType.READY));
            }
        }
        else {
            this.ready = false;
            this.updateStartActions();
            if (this.listener) {
                this.listener.audioPlayerUpdate(new AudioPlayerEvent(EventType.CLOSED));
            }
        }
    }
    _loadSourceWorkletAndInitStart() {
        if (this.context) {
            AudioSourceWorkletModuleLoader.loadModule(this.context).then(() => {
                //console.debug("Player ready. ( by Player::_loadSourceWorkletAndInitStart()");
                this.ready = true;
                this.updateStartActions();
                if (this.listener) {
                    this.listener.audioPlayerUpdate(new AudioPlayerEvent(EventType.READY));
                }
            }).catch((error) => {
                this.ready = false;
                this.updateStartActions();
                if (this.listener) {
                    this.listener.audioPlayerUpdate(new AudioPlayerEvent(EventType.CLOSED));
                }
                console.error('Could not add module ' + error);
            });
        }
    }
    _startAudioSourceWorkletNode() {
        this._loadSourceWorkletAndInitStart();
        if (this.context && this.sourceAudioWorkletNode) {
            this.sourceAudioWorkletNode.onprocessorerror = (ev) => {
                let msg = 'Unknwon error';
                if (ev instanceof ErrorEvent) {
                    msg = ev.message;
                }
                console.error("Audio source worklet error: " + msg);
                if (this.listener) {
                    // TODO
                    // this.listener.error(msg);
                    // this.listener.audioPlayerUpdate(new AudioPlayerEvent());
                }
            };
            this.sourceAudioWorkletNode.connect(this.context.destination); // this already starts playing
            this.sourceAudioWorkletNode.onended = () => this.onended();
            this.running = true;
            this.sourceAudioWorkletNode.start();
            //console.debug("Playback start action enabled. ( by Player::_startAudioSourceWorkletNode()");
            this._startAction.disabled = true;
            this._startSelectionAction.disabled = true;
            this._stopAction.disabled = false;
            if (this.listener) {
                this.listener.audioPlayerUpdate(new AudioPlayerEvent(EventType.STARTED));
            }
        }
    }
    start() {
        this._audioContext();
        if (this.context) {
            if (!this._startAction.disabled && !this.running) {
                if (this.context.state === 'suspended') {
                    this.context.resume().then(() => {
                        this._start();
                    }).catch((reason) => {
                        console.error(reason.message());
                        throw reason;
                    });
                }
                else if (this.context.state === 'closed') {
                    const msg = 'Error: Cannot start playback. Audio context is already closed!';
                    console.error(msg);
                    throw new Error(msg);
                }
                else {
                    this._start();
                }
            }
        }
    }
    updateStartActions() {
        if (this.ready) {
            if (this._audioSource instanceof AudioBufferSource || this._audioSource instanceof ArrayAudioBuffer || this._audioSource instanceof IndexedDbAudioBuffer) {
                this._startAction.disabled = false;
                this._startSelectionAction.disabled = this.startSelectionDisabled();
            }
            else {
                if (this._audioSource instanceof NetAudioBuffer) {
                    this._audioSource.addOnReadyListener(() => {
                        this._startAction.disabled = false;
                        this._startSelectionAction.disabled = this.startSelectionDisabled();
                    });
                }
            }
        }
        else {
            this._startAction.disabled = true;
            this._startSelectionAction.disabled = true;
        }
    }
    startSelectionDisabled() {
        return !(this._audioClip && !this.startAction.disabled && this._audioClip.selection);
    }
    _start(playSelection = false) {
        if (!this.context) {
            throw new Error("Could not get audio context!");
        }
        if (this._audioSource instanceof AudioBufferSource) {
            this.sourceBufferNode = this.context.createBufferSource();
            this.sourceBufferNode.buffer = this._audioSource.audioBuffer;
            this.sourceBufferNode.connect(this.context.destination);
            this.sourceBufferNode.onended = () => this.onended();
            this.playStartTime = this.context.currentTime;
            this.running = true;
            // unfortunately Web Audio API uses time values not frames
            const ac = this._audioClip;
            let offset = 0;
            if (playSelection && ac && ac.selection) {
                const s = ac.selection;
                const sr = ac.audioDataHolder.sampleRate;
                offset = s.leftFrame / sr;
                const stopPosInsecs = s.rightFrame / sr;
                const dur = stopPosInsecs - offset;
                this.sourceBufferNode.start(0, offset, dur);
            }
            else {
                this.sourceBufferNode.start();
            }
            this.playStartTime = this.context.currentTime - offset;
            this._startAction.disabled = true;
            this._startSelectionAction.disabled = true;
            this._stopAction.disabled = false;
            if (this.listener) {
                this.listener.audioPlayerUpdate(new AudioPlayerEvent(EventType.STARTED));
            }
        }
        else if (this._audioSource instanceof ArrayAudioBuffer || this._audioSource instanceof IndexedDbAudioBuffer || this._audioSource instanceof NetAudioBuffer) {
            AudioSourceWorkletModuleLoader.loadModule(this.context).then(() => {
                this.playStartTime = null;
                if (this.context) {
                    if (this._audioSource instanceof ArrayAudioBuffer) {
                        const aabsn = new ArrayAudioBufferSourceNode(this.context);
                        aabsn.arrayAudioBuffer = this._audioSource;
                        this.sourceAudioWorkletNode = aabsn;
                    }
                    else if (this._audioSource instanceof IndexedDbAudioBuffer) {
                        const iasn = new IndexedDbAudioBufferSourceNode(this.context);
                        iasn.inddbAudioBuffer = this._audioSource;
                        this.sourceAudioWorkletNode = iasn;
                    }
                    else if (this._audioSource instanceof NetAudioBuffer) {
                        const nabsn = new NetAudioBufferSourceNode(this.context);
                        nabsn.netAudioBuffer = this._audioSource;
                        this.sourceAudioWorkletNode = nabsn;
                    }
                    if (this.sourceAudioWorkletNode) {
                        this.sourceAudioWorkletNode.onprocessorerror = (ev) => {
                            let msg = 'Unknwon error';
                            if (ev instanceof ErrorEvent) {
                                msg = ev.message;
                            }
                            console.error("Audio source worklet error: " + msg);
                            if (this.listener) {
                                this.listener.audioPlayerUpdate(new AudioPlayerEvent(EventType.ERROR));
                            }
                        };
                        this.sourceAudioWorkletNode.connect(this.context.destination); // this already starts playing
                        this.sourceAudioWorkletNode.onended = () => this.onended();
                        this.running = true;
                        const ac = this._audioClip;
                        let offset = 0;
                        if (playSelection && ac && ac.selection) {
                            const s = ac.selection;
                            const sr = ac.audioDataHolder.sampleRate;
                            offset = s.leftFrame / sr;
                            const stopPosInsecs = s.rightFrame / sr;
                            const dur = stopPosInsecs - offset;
                            this.sourceAudioWorkletNode.start(0, offset, dur);
                        }
                        else {
                            this.sourceAudioWorkletNode.start();
                        }
                        //this.playStartTime = this.context.currentTime - offset;
                        this._startAction.disabled = true;
                        this._startSelectionAction.disabled = true;
                        this._stopAction.disabled = false;
                        if (this.listener) {
                            this.listener.audioPlayerUpdate(new AudioPlayerEvent(EventType.STARTED));
                        }
                    }
                }
            }).catch((error) => {
                console.error(error.message);
                this.ready = false;
                this.updateStartActions();
                if (this.listener) {
                    this.listener.audioPlayerUpdate(new AudioPlayerEvent(EventType.CLOSED));
                }
                throw error;
            });
        }
    }
    startSelected() {
        this._audioContext();
        if (!this.context) {
            throw new Error("Could not get audio context!");
        }
        if (!this._startAction.disabled && !this.running) {
            if (this.context.state === 'suspended') {
                this.context.resume().then(() => {
                    this._start(true);
                }).catch((reason) => {
                    console.error(reason.message);
                    throw reason;
                });
            }
            else if (this.context.state === 'closed') {
                const msg = 'Error: Cannot start playback of selection. Audio context is already closed!';
                console.error(msg);
                throw new Error(msg);
            }
            else {
                this._start(true);
            }
        }
    }
    stop() {
        if (this.running) {
            if (this.sourceBufferNode) {
                this.sourceBufferNode.stop();
            }
            if (this.sourceAudioWorkletNode) {
                this.sourceAudioWorkletNode.stop();
            }
            if (this.timerVar !== null) {
                window.clearInterval(this.timerVar);
            }
            this.running = false;
            if (this.listener) {
                this.listener.audioPlayerUpdate(new AudioPlayerEvent(EventType.STOPPED));
            }
        }
    }
    onended() {
        if (this.timerVar != null) {
            window.clearInterval(this.timerVar);
        }
        this._startAction.disabled = !this._audioSource;
        this._startSelectionAction.disabled = this.startSelectionDisabled();
        this._stopAction.disabled = true;
        this.running = false;
        if (this.listener) {
            this.listener.audioPlayerUpdate(new AudioPlayerEvent(EventType.ENDED));
        }
    }
    get playPositionTime() {
        let ppt = null;
        if (this.context && this.playStartTime !== null) {
            ppt = this.context.currentTime - this.playStartTime;
        }
        else if (this.sourceAudioWorkletNode) {
            ppt = this.sourceAudioWorkletNode.playPositionTime;
        }
        return ppt;
    }
    get playPositionFrames() {
        let ppFrs = null;
        if (this._audioSource) {
            let sr = this._audioSource.sampleRate;
            if (sr) {
                let ppTime = this.playPositionTime;
                if (ppTime !== null) {
                    ppFrs = sr * ppTime;
                }
            }
        }
        return ppFrs;
    }
}

class UserAgentComponent {
    constructor(name, version, comment) {
        this.name = name;
        this.version = version;
        this.comment = comment;
    }
    toString() {
        let s = '[' + this.name + ']';
        if (this.version) {
            s = s + ' [' + this.version + ']';
        }
        if (this.comment) {
            s = s + ' [' + this.comment + ']';
        }
        return s;
    }
}
const NAME_FIREFOX = 'Firefox';
const NAME_CHROME = 'Chrome';
const NAME_SAFARI = 'Safari';
const NAME_EDGE = 'Edge';
var Browser$1;
(function (Browser) {
    Browser["Firefox"] = "Firefox";
    Browser["Chrome"] = "Chrome";
    Browser["Safari"] = "Safari";
    Browser["Edge"] = "Edge";
})(Browser$1 || (Browser$1 = {}));
const OS_WINDOWS = 'Windows';
const OS_ANDROID = 'Android';
var Platform$1;
(function (Platform) {
    Platform["Windows"] = "Windows";
    Platform["Android"] = "Android";
    Platform["macOS"] = "MAC OS X";
})(Platform$1 || (Platform$1 = {}));
class UserAgent {
    constructor(_detectedPlatform, _detectedBrowser, _detectedBrowserVersion = null) {
        this._detectedPlatform = _detectedPlatform;
        this._detectedBrowser = _detectedBrowser;
        this._detectedBrowserVersion = _detectedBrowserVersion;
    }
    get detectedBrowser() {
        return this._detectedBrowser;
    }
    get detectedBrowserVersion() {
        return this._detectedBrowserVersion;
    }
    get detectedPlatform() {
        return this._detectedPlatform;
    }
}
class UserAgentBuilder {
    constructor() {
        this.comps = new Array();
    }
    static { this.instance = undefined; }
    build() {
        // // @ts-ignore
        // if(navigator.userAgentData){
        //   // maybe we can use this in  the future
        //   console.info("Browser provides userAgentData:");
        //
        //   console.info("Brands:");
        //   // @ts-ignore
        //   navigator.userAgentData.brands.forEach((br=>{
        //     console.info(br.brand +" "+br.version);
        //   }))
        //   // @ts-ignore
        //   console.info("Platform: "+navigator.userAgentData.platform);
        //   // @ts-ignore
        //   console.info("Mobile:"+navigator.userAgentData.mobile);
        //   // @ts-ignore
        //   //console.info(navigator.userAgentData.toJSON());
        // }else {
        //   console.info("Browser does not provide userAgentData.");
        // }
        let ua = navigator.userAgent;
        console.debug("User agent: " + ua);
        this.comps = new Array();
        let pp = 0;
        while (pp < ua.length) {
            //parse name/version
            let name = null;
            let version = null;
            let comment;
            let blPos = ua.indexOf(' ', pp);
            let prt;
            // TODO Replace substr with substring (?)
            // https://stackoverflow.com/questions/52640271/why-is-string-prototype-substr-deprecated
            if (blPos == -1) {
                prt = ua.substr(pp);
                pp += prt.length;
            }
            else {
                prt = ua.substr(pp, blPos - pp);
                pp = blPos + 1;
            }
            let sepPos = prt.indexOf('/');
            if (sepPos > 0) {
                name = prt.substr(0, sepPos);
                version = prt.substr(sepPos + 1);
            }
            else {
                name = prt;
            }
            while (ua[pp] === ' ' && pp < ua.length) {
                pp++;
            }
            if (ua[pp] === '(') {
                pp++;
                let commEnd = ua.indexOf(')', pp);
                comment = ua.substr(pp, commEnd - pp);
                pp = commEnd + 1;
            }
            while (ua[pp] === ' ' && pp < ua.length) {
                pp++;
            }
            const uac = new UserAgentComponent(name, version, comment);
            console.debug("user agent comp: " + uac);
            this.comps.push(uac);
        }
        let detPlatf = null;
        if (this.runsOnOS(Platform$1.Android)) {
            detPlatf = Platform$1.Android;
        }
        else if (this.runsOnOS(Platform$1.Windows)) {
            detPlatf = Platform$1.Windows;
        }
        else if (this.runsOnOS(Platform$1.macOS)) {
            detPlatf = Platform$1.macOS;
        }
        let detBr = null;
        if (this.matchesBrowser(Browser$1.Firefox)) {
            detBr = Browser$1.Firefox;
        }
        else if (this.matchesBrowser(Browser$1.Chrome)) {
            detBr = Browser$1.Chrome;
        }
        else if (this.matchesBrowser(Browser$1.Safari)) {
            detBr = Browser$1.Safari;
        }
        let detBrVers = null;
        if (detBr) {
            detBrVers = this.browserVersion(detBr);
        }
        this.userAgent = new UserAgent(detPlatf, detBr, detBrVers);
    }
    matchesBrowser(browserName) {
        for (let ci = 0; ci < this.comps.length; ci++) {
            let bn = this.comps[ci].name;
            let bnRe = new RegExp(browserName, 'i');
            if (bn.match(bnRe)) {
                return true;
            }
        }
        return false;
    }
    browserVersion(browserName) {
        for (let ci = 0; ci < this.comps.length; ci++) {
            const comp = this.comps[ci];
            const bn = comp.name;
            const bnRe = new RegExp(browserName, 'i');
            if (bn.match(bnRe)) {
                return comp.version;
            }
        }
        return null;
    }
    runsOnOS(os) {
        for (let ci = 0; ci < this.comps.length; ci++) {
            let cc = this.comps[ci].comment;
            if (cc) {
                var osRe = new RegExp(os, 'i');
                if (cc.match(osRe)) {
                    return true;
                }
            }
        }
        return false;
    }
    static userAgent() {
        if (!this.instance) {
            this.instance = new UserAgentBuilder();
        }
        this.instance.build();
        return this.instance.userAgent;
    }
}

var ConstraintType;
(function (ConstraintType) {
    ConstraintType["Exact"] = "EXACT";
    ConstraintType["Ideal"] = "IDEAL";
})(ConstraintType || (ConstraintType = {}));
;
var Platform;
(function (Platform) {
    Platform["Linux"] = "LINUX";
    Platform["macOS"] = "MACOS";
    Platform["Windows"] = "WINDOWS";
    Platform["Android"] = "ANDROID";
})(Platform || (Platform = {}));
var BrowserBase;
(function (BrowserBase) {
    BrowserBase["Chromium"] = "CHROMIUM";
})(BrowserBase || (BrowserBase = {}));
;
var Browser;
(function (Browser) {
    Browser["Firefox"] = "FIREFOX";
    Browser["Chromium"] = "CHROMIUM";
    Browser["Chrome"] = "CHROME";
    Browser["Edge"] = "EDGE";
    Browser["Opera"] = "OPERA";
})(Browser || (Browser = {}));
var AudioStorageType;
(function (AudioStorageType) {
    AudioStorageType["MEM_ENTIRE"] = "MEM_ENTIRE";
    AudioStorageType["MEM_CHUNKED"] = "MEM_CHUNKED";
    AudioStorageType["DB_CHUNKED"] = "DB_CHUNKED";
    AudioStorageType["NET_CHUNKED"] = "NET_CHUNKED";
    AudioStorageType["MEM_ENTIRE_AUTO_NET_CHUNKED"] = "MEM_ENTIRE_AUTO_NET_CHUNKED";
    AudioStorageType["MEM_CHUNKED_AUTO_NET_CHUNKED"] = "MEM_CHUNKED_AUTO_NET_CHUNKED";
})(AudioStorageType || (AudioStorageType = {}));
var AudioStorageFormatEncoding;
(function (AudioStorageFormatEncoding) {
    AudioStorageFormatEncoding["PCM_SIGNED"] = "PCM_SIGNED";
    AudioStorageFormatEncoding["PCM_FLOAT"] = "PCM_FLOAT";
})(AudioStorageFormatEncoding || (AudioStorageFormatEncoding = {}));
class ProjectUtil {
    static { this.DEFAULT_AUDIO_CHANNEL_COUNT = 2; }
    static audioChannelCount(project) {
        let chs = ProjectUtil.DEFAULT_AUDIO_CHANNEL_COUNT;
        if (project.mediaCaptureFormat) {
            chs = project.mediaCaptureFormat.audioChannelCount;
        }
        else if (project.audioFormat) {
            chs = project.audioFormat.channels;
        }
        return chs;
    }
}

const CHROME_ACTIVATE_ECHO_CANCELLATION_WITH_AGC = false;
const DEBUG_TRACE_LEVEL = 0;
// Dirty way to load this module
// Copy content of interceptor_worklet.js to this string
const awpStr = "class AudioCaptureInterceptorProcessor extends AudioWorkletProcessor{\n" +
    "\n" +
    "    BUFFER_QUANTUMS=64;\n" +
    "    QUANTUM_FRAME_LEN=128;\n" +
    "    BUFFER_FRAME_LEN=this.QUANTUM_FRAME_LEN*this.BUFFER_QUANTUMS;\n" +
    "    buffer=null;\n" +
    "    bufferPos=0;\n" +
    "    bufferPosBytes=0;\n" +
    "    constructor() {\n" +
    "        super();\n" +
    "\n" +
    "    }\n" +
    "\n" +
    " process(\n" +
    "      inputs,\n" +
    "      outputs,\n" +
    "      parameters\n" +
    "  ){\n" +
    "\n" +
    "     let inputsCnt=inputs.length;\n" +
    "     let channelCount=0;\n" +
    "     let inputLen=0;\n" +
    "     let inputLenBytes=0;\n" +
    "     if(inputsCnt>0) {\n" +
    "         let input0 = inputs[0];\n" +
    "         channelCount = input0.length;\n" +
    "         if (channelCount > 0) {\n" +
    "             let input0ch0=input0[0];\n" +
    "             inputLen=input0ch0.length;\n" +
    "             inputLenBytes=input0ch0.buffer.length;\n" +
    "         }\n" +
    "     }\n" +
    "     if (!this.buffer || this.buffer.length < channelCount) {\n" +
    "         this.buffer = new Array(channelCount);\n" +
    "         this.bufferPos = 0\n" +
    "         for (let bch = 0; bch < channelCount; bch++) {\n" +
    "             this.buffer[bch] = new Float32Array(this.BUFFER_FRAME_LEN);\n" +
    "             this.bufferPos = 0;\n" +
    "             this.bufferPosBytes=0;\n" +
    "         }\n" +
    "     }\n" +
    "     let bufAvail = this.BUFFER_FRAME_LEN - this.bufferPos;\n" +
    "     // check if buffer has to be transferred\n" +
    "     if (inputLen > bufAvail) {\n" +
    "         let ada=new Array(channelCount);\n" +
    "         for (let ch = 0; ch < channelCount; ch++) {\n" +
    "             ada[ch]=this.buffer[ch].buffer.slice(0);\n" +
    "         }\n" +
    "         this.port.postMessage({\n" +
    "             data: ada,\n" +
    "             chs: channelCount,\n" +
    "             len: this.bufferPos\n" +
    "         }, ada);\n" +
    "         // buffer transferred, reset\n" +
    "         this.bufferPos = 0;\n" +
    "         this.bufferPosBytes=0;\n" +
    "     }\n" +
    "\n" +
    "     for(let ii=0;ii<inputsCnt;ii++) {\n" +
    "         for (let ch = 0; ch < channelCount; ch++) {\n" +
    "             // Mute outputs\n" +
    "             //outputs[ii][ch].fill(0);\n" +
    "             let chSamples = inputs[ii][ch];\n" +
    "             this.buffer[ch].set(chSamples,this.bufferPos);\n" +
    "         }\n" +
    "         this.bufferPos+=inputLen;\n" +
    "         this.bufferPosBytes+=inputLenBytes;\n" +
    "     }\n" +
    "    \n" +
    "     return true;\n" +
    "  }\n" +
    "}\n" +
    "\n" +
    "registerProcessor('capture-interceptor',AudioCaptureInterceptorProcessor);\n";
class AudioCapture {
    get maxAutoNetMemStoreSamples() {
        return this._maxAutoNetMemStoreSamples;
    }
    set maxAutoNetMemStoreSamples(value) {
        this._maxAutoNetMemStoreSamples = value;
    }
    set recUUID(value) {
        this._recUUID = value;
    }
    get recUUID() {
        return this._recUUID;
    }
    get audioStorageType() {
        return this._audioStorageType;
    }
    set audioStorageType(value) {
        this._audioStorageType = value;
    }
    get persistentAudioStorageTarget() {
        return this._persistentAudioStorageTarget;
    }
    set persistentAudioStorageTarget(value) {
        this._persistentAudioStorageTarget = value;
    }
    get opened() {
        return this._opened;
    }
    static { this.BUFFER_SIZE = 8192; }
    static { this.DEFAULT_MAX_NET_AUTO_MEM_STORE_SAMPLES = 2880000 * 5; } // Default 5 minute at 48kHz
    static { this.captureInterceptorModuleRegistered = false; }
    //private context:AudioContext|null=null;
    constructor() {
        this._maxAutoNetMemStoreSamples = AudioCapture.DEFAULT_MAX_NET_AUTO_MEM_STORE_SAMPLES;
        this.context = null;
        this._recUUID = null;
        this.agcStatus = null;
        this.bufferingNode = null;
        this.data = null;
        this.audioOutStream = null;
        this.disconnectStreams = true;
        this._opened = false;
        this.capturing = false;
        this.framesRecorded = 0;
        this._audioStorageType = AudioStorageType.MEM_ENTIRE;
        this._persistentAudioStorageTarget = null;
        this.persisted = true;
        this.persistError = null;
        this.inddbAudioBuffer = null;
        this.n = navigator;
    }
    _audioContext() {
        if (!this.context) {
            this.context = AudioContextProvider.audioContextInstance();
            if (this.context) {
                this.context.addEventListener('statechange', () => {
                    if (this.context && this.context.state !== 'running') {
                        this.close();
                    }
                });
            }
        }
        return this.context;
    }
    initData() {
        if (!this._recUUID) {
            this._recUUID = UUID.generate();
        }
        this.persistError = null;
        //console.debug("Audio capture initialize storage for type: "+this._audioStorageType);
        if (AudioStorageType.DB_CHUNKED === this._audioStorageType && this._persistentAudioStorageTarget && this._recUUID) {
            //console.debug("Create indexed db audio buffer.");
            this.inddbAudioBuffer = new IndexedDbAudioBuffer(this._persistentAudioStorageTarget, this.channelCount, this.currentSampleRate, AudioCapture.BUFFER_SIZE, 0, this._recUUID);
        }
        if (!(AudioStorageType.NET_CHUNKED === this._audioStorageType)) {
            // Initialize audio data array except for net audio buffer mode
            this.data = new Array();
            for (let i = 0; i < this.channelCount; i++) {
                this.data.push(new Array());
            }
        }
        this.framesRecorded = 0;
    }
    listDevices() {
        navigator.mediaDevices.enumerateDevices().then((l) => this.printDevices(l));
    }
    dummySession() {
        // workaround to request permissions:
        // Start a dummy session
        let mediaStrCnstrs = { audio: { echoCancelation: false }
        };
        return navigator.mediaDevices.getUserMedia(mediaStrCnstrs);
    }
    stopAllSessionTracks(mediaStream) {
        let ats = mediaStream.getTracks();
        for (let atIdx = 0; atIdx < ats.length; atIdx++) {
            //console.debug("Stop dummy session track: #" + atIdx)
            ats[atIdx].stop();
        }
    }
    deviceInfos(cb, retry = true, dummyStream) {
        navigator.mediaDevices.enumerateDevices().then((l) => {
            let labelsAvailable = false;
            for (let i = 0; i < l.length; i++) {
                let di = l[i];
                if (di.label) {
                    labelsAvailable = true;
                }
            }
            if (!labelsAvailable) {
                //console.debug("Media device enumeration: No labels.")
                if (retry) {
                    console.info("Starting dummy session to request audio permissions...");
                    this.dummySession().then((s) => {
                        // and stop it immediately
                        if (s) {
                            //console.debug("Got dummy session stream: " + s + " .")
                        }
                        else {
                            //console.debug("No dummy stream")
                        }
                        // retry (only once)
                        this.deviceInfos(cb, false, s);
                    }, reason => {
                        //console.debug("Dummy session rejected.")
                        // TODO error callback
                        cb(null);
                    });
                }
                else {
                    cb(null);
                }
            }
            else {
                // success
                cb(l);
            }
            if (dummyStream) {
                this.stopAllSessionTracks(dummyStream);
            }
        }, (reason) => {
            //rejected
            //console.debug("Media device enumeration rejected.")
            if (retry) {
                //console.debug("Starting dummy session to request audio permissions...")
                this.dummySession().then((s) => {
                    // and stop it immediately
                    //console.debug("Dummy session.")
                    if (s) {
                        //console.debug("Got dummy session stream: " + s + " .")
                    }
                    else {
                        //console.debug("No dummy stream")
                    }
                    // retry (only once)
                    this.deviceInfos(cb, false, s);
                }, reason => {
                    //console.debug("Dummy session rejected.")
                    // TODO error callback
                    cb(null);
                });
            }
            else {
                cb(null);
            }
            if (dummyStream) {
                this.stopAllSessionTracks(dummyStream);
            }
        });
    }
    printDevices(l) {
        //let selDeviceId = '___dummy___';
        for (let i = 0; i < l.length; i++) {
            let di = l[i];
            console.log("Audio device: Id: " + di.deviceId + " groupId: " + di.groupId + " label: " + di.label + " kind: " + di.kind);
        }
    }
    addCaptureInterceptor() {
        if (this.context) {
            const awn = new AudioWorkletNode(this.context, 'capture-interceptor');
            awn.onprocessorerror = (ev) => {
                let msg = 'Unknwon error';
                if (ev instanceof ErrorEvent) {
                    msg = ev.message;
                }
                console.error("Capture audio worklet error: " + msg);
                if (this.listener) {
                    this.listener.error(msg);
                }
            };
            let awnPt = awn.port;
            if (awnPt) {
                awnPt.onmessage = (ev) => {
                    if (this.capturing) {
                        let dt = ev.data;
                        let chs = dt.chs;
                        let adaLen = dt.data.length;
                        if (DEBUG_TRACE_LEVEL > 8) {
                            console.debug('Received data from worklet: ' + chs + ' ' + dt.len + ' Data chs: ' + adaLen);
                        }
                        let chunk = new Array(chs);
                        const samples = this.framesRecorded * chs;
                        if ((AudioStorageType.MEM_ENTIRE_AUTO_NET_CHUNKED === this.audioStorageType || AudioStorageType.MEM_CHUNKED_AUTO_NET_CHUNKED === this.audioStorageType) && this.data && samples > this._maxAutoNetMemStoreSamples) {
                            this.data = null;
                        }
                        //console.debug("Data initialized: "+(this.data!=null));
                        for (let ch = 0; ch < chs; ch++) {
                            //console.debug("Data ch initialized: "+(this.data !=null && this.data[ch] !=null));
                            if (ch < this.channelCount) {
                                if (dt.data[ch]) {
                                    let fa = new Float32Array(dt.data[ch]);
                                    if (this.data && this.data[ch]) {
                                        this.data[ch].push(fa);
                                    }
                                    chunk[ch] = fa;
                                    // Use samples of channel 0 to count frames (samples)
                                    if (ch == 0) {
                                        this.framesRecorded += fa.length;
                                    }
                                }
                            }
                        }
                        if (this.audioOutStream) {
                            try {
                                this.audioOutStream.write(chunk);
                                // // Random test error:
                                // if(Math.random()>0.98) {
                                //   throw new Error('Test');
                                // }
                            }
                            catch (err) {
                                if (err instanceof Error) {
                                    this.persistError = err;
                                }
                                else {
                                    this.persistError = new Error('Error handling recorded audio data');
                                }
                                console.error("Capture error: " + err);
                                try {
                                    this.stop();
                                }
                                catch (err2) {
                                    console.error("Capture next error (ignored): " + err2);
                                }
                                finally {
                                    if (this.listener) {
                                        let errExpl = '';
                                        if (err instanceof DOMException) {
                                            errExpl = ': ' + err.name + ': ' + err.message;
                                        }
                                        this.listener.error("Could not handle recorded audio data" + errExpl, "Please try to record again.");
                                    }
                                    else {
                                        this.close();
                                    }
                                }
                            }
                        }
                        if (AudioStorageType.DB_CHUNKED === this._audioStorageType && this._persistentAudioStorageTarget) {
                            this.store();
                        }
                    }
                };
            }
            // Tried to fix that Safari does not record the second channel
            // Does not help
            //awn.channelCount=this.channelCount;
            //awn.channelCountMode='explicit';
            //console.debug('Channel count explicitly set to '+this.channelCount);
            this.bufferingNode = awn;
            //this.bufferingNode.channelCount=this.channelCount;
            this._opened = true;
            if (this.listener) {
                this.listener.opened();
            }
        }
    }
    open(channelCount, selDeviceId, autoGainControlConfigs, allowEchoCancellation) {
        //console.debug("Capture open: ctx state: "+this.context.state);
        this.context = this._audioContext();
        if (!this.context) {
            throw new Error("Could not get audio context!");
        }
        if (this.context.state === 'suspended') {
            //console.debug("Capture open: Resume context");
            this.context.resume().then(() => {
                //console.debug("Capture open (ctx resumed): ctx state: "+this.context.state);
                this._open(channelCount, selDeviceId, autoGainControlConfigs, allowEchoCancellation);
            }).catch((err) => {
                console.error(err.message);
                throw err;
            });
        }
        else if (this.context.state === 'closed') {
            const msg = 'Error on start capture: The audio context is already closed.';
            console.error(msg);
            throw new Error(msg);
        }
        else {
            this._open(channelCount, selDeviceId, autoGainControlConfigs, allowEchoCancellation);
        }
    }
    _open(channelCount, selDeviceId, autoGainControlConfigs, allowEchoCancellation) {
        this.channelCount = channelCount;
        this.framesRecorded = 0;
        this.context = this._audioContext();
        if (!this.context) {
            throw new Error("Could not get audio context!");
        }
        //var msc = new AudioStreamConstr();
        // var msc={};
        //msc.video = false;
        //msc.audio = true;
        // Chrome and Firefox stereo channels are identical !!
        // And even worse: The data coming from the source is already preprocessed on FF and Chrome. It contains DSP artifacts!!
        // https://bugs.chromium.org/p/chromium/issues/detail?id=387737
        // The workaround to set these constraints does _NOT_ help:
        //var msc={audio: {echoCancellation: false,channelCount: 2, googAudioMirroring: false},video: false};
        // Safari at least version 11: Support for media streams
        // TODO test if input is unprocessed
        let msc;
        console.info('User agent: ' + navigator.userAgent);
        let ua = UserAgentBuilder.userAgent();
        // ua.components.forEach((c)=>{
        //   console.info("UA_Comp: "+c.toString());
        // })
        let agcCfg = null;
        let autoGainControl = false;
        let chromeEchoCancellation = false;
        if (autoGainControlConfigs) {
            for (let agcc of autoGainControlConfigs) {
                if (agcc.platform === Platform.Android && ua.detectedPlatform === Platform$1.Android) {
                    agcCfg = agcc;
                    break;
                }
                if (agcc.platform === Platform.Windows && ua.detectedPlatform === Platform$1.Windows) {
                    agcCfg = agcc;
                    break;
                }
            }
            if (agcCfg) {
                // TODO use EXACT/IDEAL constraint
                autoGainControl = agcCfg.value;
                if (CHROME_ACTIVATE_ECHO_CANCELLATION_WITH_AGC) {
                    chromeEchoCancellation = agcCfg.value;
                }
                // TODO query real AGC status
                this.agcStatus = agcCfg.value;
            }
            else {
                this.agcStatus = false;
            }
        }
        // default
        msc = {
            audio: {
                deviceId: selDeviceId,
                echoCancellation: false,
                channelCount: channelCount,
                autoGainControl: autoGainControl
            },
            video: false
        };
        if (ua.detectedBrowser === Browser$1.Edge) {
            // Microsoft Edge sends unmodified audio
            // The constraint can follow the specification
            console.info("Setting media track constraints for Microsoft Edge.");
            msc = {
                audio: {
                    deviceId: selDeviceId,
                    echoCancellation: false,
                    channelCount: channelCount,
                    autoGainControl: autoGainControl
                },
                video: false
            };
        }
        else if (ua.detectedBrowser === Browser$1.Chrome) {
            // Google Chrome: we need to switch of each of the preprocessing units including the
            console.info("Setting media track constraints for Google Chrome.");
            // Chrome 60 -> 61 changed
            // it works now without mandatory/optional sub-objects
            // Requires at least Chrome 61
            msc = {
                audio: {
                    deviceId: selDeviceId,
                    channelCount: channelCount,
                    echoCancellation: { exact: chromeEchoCancellation },
                    autoGainControl: { exact: autoGainControl },
                    sampleSize: { min: 16 },
                },
                video: false,
            };
        }
        else if (ua.detectedBrowser === Browser$1.Firefox) {
            console.info("Setting media track constraints for Mozilla Firefox.");
            // Firefox
            msc = {
                audio: {
                    deviceId: selDeviceId,
                    channelCount: channelCount,
                    echoCancellation: false,
                    autoGainControl: autoGainControl,
                    noiseSuppression: false
                },
                video: false,
            };
        }
        else if (ua.detectedBrowser === Browser$1.Safari) {
            console.info("Setting media track constraints for Safari browser.");
            //console.info("Apply workaround for Safari: Avoid disconnect of streams.");
            this.disconnectStreams = true;
            msc = {
                audio: {
                    deviceId: selDeviceId,
                    channelCount: channelCount,
                    echoCancellation: allowEchoCancellation ? undefined : false
                },
                video: false,
            };
        }
        else {
            // TODO default constraints or error Browser not supported
        }
        console.debug("Audio capture, AGC: " + this.agcStatus);
        let ump = navigator.mediaDevices.getUserMedia(msc);
        ump.then((s) => {
            if (this.context) {
                this.stream = s;
                let aTracks = s.getAudioTracks();
                for (let i = 0; i < aTracks.length; i++) {
                    let aTrack = aTracks[i];
                    console.info("Track audio info: id: " + aTrack.id + " kind: " + aTrack.kind + " label: \"" + aTrack.label + "\"");
                    let mtrSts = aTrack.getSettings();
                    // Typescript lib.dom.ts MediaTrackSettings.channelCount is missing
                    // https://github.com/mdn/browser-compat-data/blob/5493d8f937e05b2ddbd41b99f5bdfad4a1f2ed85/api/MediaTrackSettings.json
                    //@ts-ignore
                    console.info("Track audio settings: Ch cnt: " + mtrSts.channelCount + ", AGC: " + mtrSts.autoGainControl + ", Echo cancell.: " + mtrSts.echoCancellation);
                    if (mtrSts.autoGainControl) {
                        this.agcStatus = mtrSts.autoGainControl;
                    }
                    console.debug("Echo cancellation: " + mtrSts.echoCancellation);
                }
                let vTracks = s.getVideoTracks();
                for (let i = 0; i < vTracks.length; i++) {
                    let vTrack = vTracks[i];
                    console.info("Track video info: id: " + vTrack.id + " kind: " + vTrack.kind + " label: " + vTrack.label);
                }
                this.mediaStream = this.context.createMediaStreamSource(s);
                // stream channel count ( is always 2 !)
                let streamChannelCount = this.mediaStream.channelCount;
                console.info("Stream channel count: " + streamChannelCount);
                // is not set!!
                //this.currentSampleRate = this.mediaStream.sampleRate;
                this.currentSampleRate = this.context.sampleRate;
                console.info("Source audio node: channels: " + streamChannelCount + " samplerate: " + this.currentSampleRate);
                if (this.audioOutStream) {
                    this.audioOutStream.setFormat(this.channelCount, this.currentSampleRate);
                }
                // W3C  -> new name is createScriptProcessor
                //
                // Again deprecated, but AudioWorker not yet implemented in stable releases (June 2016)
                // AudioWorker is now AudioWorkletProcessor ... (May 2017)
                // Update 12-2020:
                // The ScriptProcessorNode Interface - DEPRECATED
                // Update 06-2021
                //  AudioWorkletProcessor is here to stay. Web Audio API has now Recommendation status !
                if (this.context.audioWorklet) {
                    //const workletFileName = ('file-loader!./interceptor_worklet.js');
                    //const workletFileName = 'http://localhost:4200/assets/interceptor_worklet.js';
                    //console.log(awpStr);
                    if (AudioCapture.captureInterceptorModuleRegistered) {
                        // Required capture interceptor module already registered
                        this.addCaptureInterceptor();
                    }
                    else {
                        // Register capture interceptor module
                        let audioWorkletModuleBlob = new Blob([awpStr], { type: 'text/javascript' });
                        let audioWorkletModuleBlobUrl = window.URL.createObjectURL(audioWorkletModuleBlob);
                        this.context.audioWorklet.addModule(audioWorkletModuleBlobUrl).then(() => {
                            AudioCapture.captureInterceptorModuleRegistered = true;
                            this.addCaptureInterceptor();
                        }).catch((error) => {
                            console.log('Could not add module ' + error);
                        });
                    }
                }
                else if (this.context.createScriptProcessor) {
                    // The ScriptProcessorNode Interface - DEPRECATED Only as fallback
                    // TODO should we use streamChannelCount or channelCount here ?
                    let scriptProcessorNode = this.context.createScriptProcessor(AudioCapture.BUFFER_SIZE, streamChannelCount, streamChannelCount);
                    this.bufferingNode = scriptProcessorNode;
                    let c = 0;
                    if (scriptProcessorNode.onaudioprocess) {
                        scriptProcessorNode.onaudioprocess = (e) => {
                            if (this.capturing) {
                                let inBuffer = e.inputBuffer;
                                // only process requested count of channels
                                let currentBuffers = new Array(channelCount);
                                for (let ch = 0; ch < channelCount; ch++) {
                                    let chSamples = inBuffer.getChannelData(ch);
                                    let chSamplesCopy = chSamples.slice(0);
                                    currentBuffers[ch] = chSamplesCopy.slice(0);
                                    if (this.data) {
                                        this.data[ch].push(chSamplesCopy);
                                    }
                                    if (DEBUG_TRACE_LEVEL > 8) {
                                        console.debug("Process " + chSamplesCopy.length + " samples.");
                                    }
                                    this.framesRecorded += chSamplesCopy.length;
                                }
                                c++;
                                if (this.audioOutStream) {
                                    this.audioOutStream.write(currentBuffers);
                                }
                            }
                        };
                        this._opened = true;
                        if (this.listener) {
                            this.listener.opened();
                        }
                    }
                    else {
                        this.listener.error('Browser does not support audio processing (ScriptProcessor.onaudioprocess method not found)!');
                    }
                }
                else {
                    this.listener.error('Browser does not support audio processing (neither AudioWorkletProcessor nor ScriptProcessor)!');
                }
            }
        }, (e) => {
            console.error(e + " Error name: " + e.name);
            if (this.listener) {
                if ('NotAllowedError' === e.name) {
                    this.listener.error('Not allowed to use your microphone.', 'Please make sure that microphone access is allowed for this web page and reload the page.');
                }
                else if ('NotReadableError' === e.name) {
                    this.listener.error('Could not read from your audio device.', 'Please make sure your audio device is working.');
                }
                else if ('OverconstrainedError' === e.name) {
                    let eMsg = e.msg ? e.msg : 'Overconstrained media device request error.';
                    this.listener.error(eMsg);
                }
                else {
                    this.listener.error();
                }
            }
        });
    }
    _start() {
        if (this.context) {
            this.initData();
            if (this.audioOutStream) {
                this.audioOutStream.nextStream();
            }
            this.capturing = true;
            if (this.bufferingNode) {
                this.mediaStream.connect(this.bufferingNode);
                this.bufferingNode.connect(this.context.destination);
            }
            if (this.listener) {
                this.listener.started();
            }
        }
    }
    start() {
        if (this.context) {
            const aSt = this.context.state;
            if (aSt === 'running') {
                this._start();
            }
            else {
                console.debug("Capture start: audio context not running, state: " + aSt + ", resuming...");
                this.context.resume().then(() => {
                    console.debug("Capture start: audio context resumed, starting...");
                    this._start();
                });
            }
        }
    }
    stop() {
        if (this.disconnectStreams && this.bufferingNode) {
            this.mediaStream.disconnect(this.bufferingNode);
            if (this.context) {
                this.bufferingNode.disconnect(this.context.destination);
            }
        }
        try {
            if (this.audioOutStream) {
                this.audioOutStream.flush();
            }
        }
        catch (err) {
            console.error("Could not flush capture stream.");
            throw err;
        }
        finally {
            this.capturing = false;
            if (this.inddbAudioBuffer && this.persistError) {
                // Delete invalid persistent audio data and hope that it will be completely uploaded to the server
                this.inddbAudioBuffer.releaseAudioData();
                this.inddbAudioBuffer = null;
            }
            if (this.listener && (this.persistError || this.persisted)) {
                //console.debug("Stopped by stop() method call");
                this.listener.stopped();
            }
        }
    }
    store() {
        // if(this.db && this.recUUID){
        //    let tr= this.db.transaction(SprDb.RECORDING_FILE_CHUNKS_OBJECT_STORE_NAME, 'readwrite');
        //    let recFileObjStore = tr.objectStore(SprDb.RECORDING_FILE_CHUNKS_OBJECT_STORE_NAME);
        //
        //      try {
        //        let ch0Data=this.data[0];
        //        let dataChkCnt=ch0Data.length;
        //          let pos = 0;
        //          for (let chCkIdx = 0; chCkIdx < dataChkCnt; chCkIdx++) {
        //            let bufLen=0;
        //            for (let ch = 0; ch < this.channelCount; ch++) {
        //              let chChk = this.data[ch][chCkIdx];
        //              bufLen = chChk.length;
        //              //let cacheId = uuid + '_' + ch + '_' + chCkIdx;
        //              let chkDbId = [this.recUUID, this.indDbChkIdx + chCkIdx, ch];
        //              let cr = recFileObjStore.add(chChk, chkDbId);
        //              //console.debug("Added: "+ch+" "+(this.indDbChkIdx+chCkIdx));
        //              cr.onsuccess=()=>{
        //                //console.debug("Stored audio data to indexed db");
        //              }
        //              cr.onerror=()=>{
        //                console.error("Error storing audio data to indexed db");
        //              }
        //            }
        //            pos += bufLen;
        //        }
        //        this.indDbChkIdx+=dataChkCnt;
        //
        //        tr.onerror = (err) => {
        //          console.error('Failed to cache audio data to indexed db: ' + err)
        //        }
        //        tr.oncomplete = () => {
        //          //console.debug('Transferred capture audio data to indexed db, deleting original data from memory...');
        //
        //          /// Audio data saved to index db delete from in memory data array
        //          for (let ch = 0; ch < this.channelCount; ch++) {
        //           this.data[ch].splice(0);
        //            //console.debug("Spliced/removed ch: "+ch);
        //          }
        //
        //          this.persisted=true;
        //          if(this.listener && !this.capturing){
        //            //console.debug("Stopped by indexed db hook");
        //            this.listener.stopped();
        //          }
        //        }
        //        // Commit chunks
        //        this.persisted=false;
        //        tr.commit();
        //      } catch (err) {
        //        console.error('Transfer capture audio data error: '+err);
        //      }
        //    }
        // if(!this.inddbAudioBuffer && this._persistentAudioStorageTarget && this.recUUID) {
        //   this.inddbAudioBuffer = new IndexedDbAudioBuffer(this._persistentAudioStorageTarget, this.channelCount,this.currentSampleRate,AudioCapture.BUFFER_SIZE,0,this.recUUID)
        // }
        if (this.inddbAudioBuffer && this.data) {
            // Try to append to
            this.inddbAudioBuffer.appendRawAudioData(this.data).subscribe({
                complete: () => {
                    //console.debug('Transferred capture audio data to indexed db, deleting original data from memory...');
                    /// Audio data saved to index db delete from in memory data array
                    if (this.data) {
                        for (let ch = 0; ch < this.channelCount; ch++) {
                            this.data[ch].splice(0);
                            //console.debug("Spliced/removed ch: "+ch);
                        }
                    }
                    this.persisted = true;
                    if (this.listener && !this.capturing) {
                        //console.debug("Stopped by indexed db hook");
                        this.listener.stopped();
                    }
                }, error: (err) => {
                    // Only log the first error
                    if (!this.persistError) {
                        this.persistError = err;
                        console.error("Error persisting audio data: " + err);
                    }
                }
            });
            this.persisted = false;
        }
    }
    close() {
        if (this.mediaStream) {
            this.mediaStream.disconnect();
        }
        if (this.stream) {
            const mts = this.stream.getTracks();
            for (let i = 0; i < mts.length; i++) {
                mts[i].stop();
            }
        }
        this._opened = false;
    }
    audioBuffer() {
        let ab = null;
        if (this.context && this.data) {
            let frameLen = 0;
            let ch0Data = this.data[0];
            for (let ch0Chk of ch0Data) {
                frameLen += ch0Chk.length;
            }
            try {
                ab = this.context.createBuffer(this.channelCount, frameLen, this.context.sampleRate);
            }
            catch (err) {
                if (err instanceof DOMException) {
                    if (err.name === 'NotSupportedError') {
                        if (frameLen == 0) {
                            // Empty buffers are not supported by Chromium
                            // Create dummy buffer with one sample
                            ab = this.context.createBuffer(this.channelCount, 1, this.context.sampleRate);
                        }
                        else {
                            throw err;
                        }
                    }
                    else {
                        throw err;
                    }
                }
                else if (err instanceof RangeError) {
                    // Out of memory
                    // TODO What to do ??
                    throw err;
                }
                else {
                    throw err;
                }
            }
            for (let ch = 0; ch < this.channelCount; ch++) {
                let chD = ab.getChannelData(ch);
                let pos = 0;
                for (let chChk of this.data[ch]) {
                    let bufLen = chChk.length;
                    chD.set(chChk, pos);
                    pos += bufLen;
                }
            }
        }
        return ab;
    }
    audioBufferArray() {
        let arrAb = null;
        if (this.data) {
            arrAb = new ArrayAudioBuffer(this.channelCount, this.currentSampleRate, this.data);
        }
        return arrAb;
    }
    inddbAudioBufferArray() {
        if (this.persistError) {
            return null;
        }
        else {
            return this.inddbAudioBuffer;
        }
    }
}

class WavFileFormat {
    static { this.RIFF_KEY = 'RIFF'; }
    static { this.WAV_KEY = 'WAVE'; }
    static { this.PCM = 0x0001; }
    static { this.WAVE_FORMAT_IEEE_FLOAT = 0x0003; }
}

class BinaryByteWriter {
    static { this.DEFAULT_SIZE_INC = 1024; }
    constructor() {
        const size = BinaryByteWriter.DEFAULT_SIZE_INC;
        this.buf = new ArrayBuffer(size);
        this._pos = 0;
    }
    get pos() {
        return this._pos;
    }
    ensureCapacity(numBytes) {
        while (this._pos + numBytes >= this.buf.byteLength) {
            // buffer increment
            let inc = BinaryByteWriter.DEFAULT_SIZE_INC;
            if (inc < numBytes) {
                inc = numBytes;
            }
            const newSize = this.buf.byteLength + inc;
            const arrOld = new Uint8Array(this.buf, 0, this._pos);
            const arrNew = new Uint8Array(newSize);
            arrNew.set(arrOld);
            this.buf = arrNew.buffer;
        }
    }
    writeUint8(val) {
        this.ensureCapacity(1);
        const valView = new DataView(this.buf, this._pos, 1);
        valView.setUint8(0, val);
        this._pos++;
    }
    writeUint16(val, le) {
        this.ensureCapacity(2);
        const valView = new DataView(this.buf, this._pos, 2);
        valView.setUint16(0, val, le);
        this._pos += 2;
    }
    writeInt16(val, le) {
        this.ensureCapacity(2);
        const valView = new DataView(this.buf, this._pos, 2);
        valView.setInt16(0, val, le);
        this._pos += 2;
    }
    writeUint32(val, le) {
        this.ensureCapacity(4);
        const valView = new DataView(this.buf, this._pos, 4);
        valView.setUint32(0, val, le);
        this._pos += 4;
    }
    writeInt32(val, le) {
        this.ensureCapacity(4);
        const valView = new DataView(this.buf, this._pos, 4);
        valView.setInt32(0, val, le);
        this._pos += 4;
    }
    writeFloat(val) {
        this.ensureCapacity(4);
        const valView = new DataView(this.buf, this._pos, 4);
        valView.setFloat32(0, val, true);
        this._pos += 4;
    }
    finish() {
        const finalArr = new Uint8Array(this._pos);
        const dv = new DataView(this.buf, 0, this._pos);
        for (let i = 0; i < this._pos; i++) {
            finalArr[i] = dv.getUint8(i);
        }
        return finalArr;
    }
    writeAscii(text) {
        let i;
        for (i = 0; i < text.length; i++) {
            const asciiCode = text.charCodeAt(i);
            if (asciiCode < 0 || asciiCode > 255) {
                throw new Error('Not an ASCII character at char ' + i + ' in ' + text);
            }
            this.writeUint8(asciiCode);
        }
    }
}

var SampleSize;
(function (SampleSize) {
    SampleSize[SampleSize["INT16"] = 16] = "INT16";
    SampleSize[SampleSize["INT32"] = 32] = "INT32";
})(SampleSize || (SampleSize = {}));
class WavWriter {
    static { this.DEFAULT_SAMPLE_SIZE = SampleSize.INT16; }
    constructor(encodingFloat, sampleSize) {
        this.sampleSizeInBytes = WavWriter.DEFAULT_SAMPLE_SIZE.valueOf() / 8;
        this.encodingFloat = false;
        this.sampleSize = WavWriter.DEFAULT_SAMPLE_SIZE;
        this.sampleSizeInBits = this.sampleSize.valueOf();
        this.workerURL = null;
        //console.debug("WavWriter: "+encodingFloat+", "+sampleSize);
        if (encodingFloat !== undefined && encodingFloat !== null) {
            this.encodingFloat = encodingFloat;
            if (encodingFloat === true) {
                this.sampleSize = SampleSize.INT32;
            }
            else {
                if (sampleSize) {
                    this.sampleSize = sampleSize;
                }
            }
        }
        else if (sampleSize) {
            this.sampleSize = sampleSize;
        }
        this.sampleSizeInBits = this.sampleSize.valueOf();
        this.sampleSizeInBytes = Math.round(this.sampleSizeInBits / 8);
        this.bw = new BinaryByteWriter();
    }
    /*
     *  Method used as worker code.
     */
    workerFunction() {
        self.onmessage = function (msg) {
            const valView = new DataView(msg.data.buf, msg.data.bufPos);
            const sampleSizeInbytes = Math.round(msg.data.sampleSizeInBits / 8);
            let bufPos = 0;
            const hDynIntRange = 1 << (msg.data.sampleSizeInBits - 1);
            for (let s = 0; s < msg.data.frameLength; s++) {
                // interleaved channel data
                for (let ch = 0; ch < msg.data.chs; ch++) {
                    const srcPos = (ch * msg.data.frameLength) + s;
                    const valFlt = msg.data.audioData[srcPos];
                    if (msg.data.encodingFloat === true) {
                        valView.setFloat32(bufPos, valFlt, true);
                        bufPos += 4;
                    }
                    else {
                        const valInt = Math.round(valFlt * hDynIntRange);
                        if (msg.data.sampleSizeInBits === 32) {
                            valView.setInt32(bufPos, valInt, true);
                        }
                        else {
                            valView.setInt16(bufPos, valInt, true);
                        }
                        bufPos += sampleSizeInbytes;
                    }
                }
            }
            postMessage({ buf: msg.data.buf }, [msg.data.buf]);
            //self.close()
        };
    }
    writeFmtChunk(audioBuffer) {
        if (this.encodingFloat === true) {
            this.bw.writeUint16(WavFileFormat.WAVE_FORMAT_IEEE_FLOAT, true);
        }
        else {
            this.bw.writeUint16(WavFileFormat.PCM, true);
        }
        const frameSize = this.sampleSizeInBytes * audioBuffer.numberOfChannels;
        this.bw.writeUint16(audioBuffer.numberOfChannels, true);
        this.bw.writeUint32(audioBuffer.sampleRate, true);
        // dwAvgBytesPerSec
        this.bw.writeUint32(frameSize * audioBuffer.sampleRate, true);
        this.bw.writeUint16(frameSize, true);
        // sample size in bits (PCM format only)
        this.bw.writeUint16(this.sampleSizeInBits, true);
        if (this.encodingFloat === true) {
            this.bw.writeUint16(0, true);
        }
    }
    writeFactChunk(audioBuffer) {
        const ch0 = audioBuffer.getChannelData(0);
        let sampleLen = 0;
        if (ch0) {
            sampleLen = ch0.length;
        }
        this.bw.writeUint32(sampleLen, true);
    }
    writeDataChunk(audioBuffer) {
        const chData0 = audioBuffer.getChannelData(0);
        const dataLen = chData0.length;
        if (this.encodingFloat === true) {
            for (let s = 0; s < dataLen; s++) {
                // interleaved channel data
                for (let ch = 0; ch < audioBuffer.numberOfChannels; ch++) {
                    const chData = audioBuffer.getChannelData(ch);
                    const valFlt = chData[s];
                    this.bw.writeFloat(valFlt);
                }
            }
        }
        else {
            const hDynIntRange = 1 << ((this.sampleSizeInBits) - 1);
            for (let s = 0; s < dataLen; s++) {
                // interleaved channel data
                for (let ch = 0; ch < audioBuffer.numberOfChannels; ch++) {
                    const chData = audioBuffer.getChannelData(ch);
                    const valFlt = chData[s];
                    const valInt = Math.round(valFlt * hDynIntRange);
                    if (this.sampleSize === SampleSize.INT16) {
                        this.bw.writeInt16(valInt, true);
                    }
                    else if (this.sampleSize === SampleSize.INT32) {
                        this.bw.writeInt32(valInt, true);
                    }
                }
            }
        }
    }
    writeChunkHeader(name, chkLen) {
        this.bw.writeAscii(name);
        this.bw.writeUint32(chkLen, true);
    }
    writeAsync(audioBuffer, callback) {
        const dataChkByteLen = this.writeHeader(audioBuffer);
        if (!this.workerURL) {
            this.workerURL = WorkerHelper.buildWorkerBlobURL(this.workerFunction);
        }
        const wo = new Worker(this.workerURL);
        const chs = audioBuffer.numberOfChannels;
        const frameLength = audioBuffer.getChannelData(0).length;
        const ad = new Float32Array(chs * frameLength);
        for (let ch = 0; ch < chs; ch++) {
            ad.set(audioBuffer.getChannelData(ch), ch * frameLength);
        }
        // ensureCapacity blocks !!!
        this.bw.ensureCapacity(dataChkByteLen);
        wo.onmessage = (me) => {
            callback(me.data.buf);
            wo.terminate();
        };
        wo.postMessage({ encodingFloat: this.encodingFloat, sampleSizeInBits: this.sampleSizeInBits, chs: chs, frameLength: frameLength, audioData: ad, buf: this.bw.buf, bufPos: this.bw.pos }, [ad.buffer, this.bw.buf]);
    }
    write(audioBuffer) {
        this.writeHeader(audioBuffer);
        this.writeDataChunk(audioBuffer);
        return this.bw.finish();
    }
    writeHeader(audioBuffer) {
        this.bw.writeAscii(WavFileFormat.RIFF_KEY);
        let dataChkByteLen = 0;
        //const dataChkByteLen=audioBuffer.getChannelData(0).length*WavWriter.DEFAULT_SAMPLE_SIZE_BYTES*audioBuffer.numberOfChannels;
        const abChs = audioBuffer.numberOfChannels;
        if (abChs > 0) {
            const abCh0 = audioBuffer.getChannelData(0);
            dataChkByteLen = abCh0.length * this.sampleSizeInBytes * abChs;
        }
        let headerCnts = 3; //Wave,fmt and data
        let fmtChunkSize = 16;
        let factChunkSize = 4;
        if (this.encodingFloat === true) {
            fmtChunkSize = 18;
            headerCnts++; // fact
        } // Float encoding requires fmt extension (with zero length)
        let wavChunkByteLen = (4 + 4) * headerCnts;
        wavChunkByteLen += fmtChunkSize;
        wavChunkByteLen += factChunkSize;
        wavChunkByteLen += dataChkByteLen;
        console.debug("Write WAV header: Wav chunk len: " + wavChunkByteLen);
        this.bw.writeUint32(wavChunkByteLen, true); // must be set to file length-8 later
        this.bw.writeAscii(WavFileFormat.WAV_KEY);
        this.writeChunkHeader('fmt ', fmtChunkSize);
        this.writeFmtChunk(audioBuffer);
        if (this.encodingFloat === true) {
            console.debug("Write WAV header: Write 'fact' chunk.");
            this.writeChunkHeader('fact', 4);
            this.writeFactChunk(audioBuffer);
        }
        this.writeChunkHeader('data', dataChkByteLen);
        return dataChkByteLen;
    }
}

class PromptDocUtil {
    static toPlainTextString(promptDoc) {
        let pt = "";
        let b = promptDoc.body;
        if (b != null) {
            let blks = b.blocks;
            if (blks) {
                for (let bli = 0; bli < blks.length; bli++) {
                    let blk = blks[bli];
                    let txts = blk.texts;
                    for (let ti = 0; ti < txts.length; ti++) {
                        let txtEl = txts[ti];
                        let txt = txtEl.text;
                        if (txtEl.type === 'font') {
                            if (typeof txt === 'string') {
                                pt = pt.concat(txt);
                            }
                            else {
                                let subTxtEl = txt;
                                let subTxt = subTxtEl.text;
                                if (typeof subTxt === 'string') {
                                    pt = pt.concat(subTxt);
                                }
                            }
                        }
                        else if (typeof txt === 'string') {
                            pt = pt.concat(txt);
                        }
                    }
                }
            }
        }
        return pt;
    }
}
class MediaitemUtil {
    static toPlainTextString(mediaitem) {
        let txt = mediaitem.text;
        let pd = mediaitem.promptDoc;
        if (txt == null) {
            let pt = null;
            if (pd != null) {
                pt = PromptDocUtil.toPlainTextString(pd);
            }
            return pt;
        }
        else {
            return txt;
        }
    }
    static description(mi) {
        let description = "";
        if (mi.alt != null) {
            description = description.concat(mi.alt);
        }
        else {
            let src = mi.src;
            let mimeType = mi.mimetype;
            if (!mimeType) {
                mimeType = 'text/plain';
            }
            if (mimeType.startsWith("image")) {
                description = description.concat("IMAGE: ");
            }
            else if (mimeType.startsWith("audio")) {
                description = description.concat("AUDIO: ");
            }
            else if (mimeType.startsWith("video")) {
                description = description.concat("VIDEO: ");
            }
            let promptText = MediaitemUtil.toPlainTextString(mi);
            if (promptText != null) {
                description = description.concat(promptText);
            }
            else if (src != null) {
                let srcPn;
                try {
                    let srcUrl = new URL(src);
                    srcPn = srcUrl.pathname;
                }
                catch {
                    srcPn = src;
                }
                // Get filename without extension
                let srcFnM = srcPn.match(/([^\/]*)$/);
                if (srcFnM && srcFnM.length == 2) {
                    let srcFn = srcFnM[1];
                    let srcFnNm = srcFn.replace(/[\.][^\.]*/, '');
                    description = description.concat(srcFnNm);
                }
            }
        }
        return description;
    }
}
class PromptitemUtil {
    static toPlainTextString(promptItem) {
        let mis = promptItem.mediaitems;
        let description = "";
        if (mis) {
            let misSize = mis.length;
            for (let i = 0; i < misSize; i++) {
                let mi = mis[i];
                description = description.concat(MediaitemUtil.description(mi));
                if (i + 1 < misSize) {
                    // not last item
                    description = description.concat(", ");
                }
            }
        }
        return description;
    }
}

class RecordingFileDescriptorImpl {
    constructor() { }
}
class RecordingFile {
    constructor(uuid, sessionId, audioDataHolder) {
        this.recordingFileId = null;
        this.uuid = null;
        this.serverPersisted = false;
        this.date = null;
        this._dateAsDateObj = null;
        this.startedDate = null;
        this._startedAsDateObj = null;
        this.audioDataHolder = null;
        this.session = null;
        this.channels = null;
        this.frames = null;
        this.samplerate = null;
        this.timeLength = null;
        this.editSampleRate = null;
        this.editStartFrame = null;
        this.editEndFrame = null;
        this.session = sessionId;
        this.audioDataHolder = audioDataHolder;
        if (audioDataHolder) {
            this.frames = audioDataHolder.frameLen;
            this.timeLength = audioDataHolder.duration;
        }
        this.uuid = uuid;
    }
    filenameString() {
        let fns = '';
        if (this.session) {
            fns += this.session;
            fns += '_';
        }
        fns += this.uuid;
        return fns;
    }
    equals(otherRecordingFile) {
        if (otherRecordingFile !== null) {
            if (otherRecordingFile === this) {
                return true;
            }
            if (otherRecordingFile.uuid === this.uuid) {
                return true;
            }
        }
        return false;
    }
    toString() {
        return 'Recording file: UUID: ' + this.uuid + ', session: ' + this.session;
    }
}
class SprRecordingFile extends RecordingFile {
    constructor(sessionId, itemcode, version, audioDataHolder) {
        super(UUID.generate(), sessionId, audioDataHolder);
        this.session = sessionId;
        this.itemCode = itemcode;
        this.version = version;
    }
    recordingFileDone() {
        return (this.serverPersisted === true) || (this.audioDataHolder != null);
    }
    filenameString() {
        let fns = '';
        if (this.session) {
            fns += this.session;
            fns += '_';
        }
        if (this.itemCode) {
            fns += this.itemCode;
            fns += '_';
        }
        fns += this.uuid;
        return fns;
    }
    toString() {
        return 'Recording file: UUID: ' + this.uuid + ', session: ' + this.session + ', itemcode: ' + this.itemCode + ', version: ' + this.version + ', UUID: ' + this.uuid;
    }
}
class RecordingFileUtils {
    static equals(recordinFile, otherRecordingFile) {
        if (recordinFile && otherRecordingFile) {
            if (otherRecordingFile === recordinFile) {
                return true;
            }
            if (otherRecordingFile.uuid === recordinFile.uuid) {
                return true;
            }
        }
        return false;
    }
    static setAudioData(rf, audioDataHolder) {
        rf.audioDataHolder = audioDataHolder;
        if (audioDataHolder) {
            if (rf.samplerate == null) {
                rf.samplerate = audioDataHolder.sampleRate;
            }
            if (rf.frames == null) {
                rf.frames = audioDataHolder.frameLen;
            }
            rf.timeLength = audioDataHolder.duration;
        }
    }
    static sampleCount(rf) {
        if (rf.audioDataHolder) {
            return rf.audioDataHolder.sampleCounts();
        }
        else {
            return 0;
        }
    }
    static expireAudioData(rf) {
        let expiredSamples = 0;
        if (rf && rf.audioDataHolder) {
            expiredSamples = rf.audioDataHolder.sampleCounts();
            rf.audioDataHolder.releaseAudioData();
            rf.audioDataHolder = null;
        }
        return expiredSamples;
    }
}

// state of an upload
var UploadStatus$1;
(function (UploadStatus) {
    UploadStatus[UploadStatus["IDLE"] = 1] = "IDLE";
    UploadStatus[UploadStatus["UPLOADING"] = 2] = "UPLOADING";
    UploadStatus[UploadStatus["ABORT"] = 3] = "ABORT";
    UploadStatus[UploadStatus["DONE"] = 0] = "DONE";
    UploadStatus[UploadStatus["ERR"] = -1] = "ERR";
})(UploadStatus$1 || (UploadStatus$1 = {}));
// state of the uploader
// TRY_UPLOADING is uploading state after an error (for example if disconnected from server)
var UploaderStatus;
(function (UploaderStatus) {
    UploaderStatus[UploaderStatus["DONE"] = 0] = "DONE";
    UploaderStatus[UploaderStatus["UPLOADING"] = 1] = "UPLOADING";
    UploaderStatus[UploaderStatus["TRY_UPLOADING"] = 2] = "TRY_UPLOADING";
    UploaderStatus[UploaderStatus["NEXT"] = 3] = "NEXT";
    UploaderStatus[UploaderStatus["ERR"] = -1] = "ERR";
})(UploaderStatus || (UploaderStatus = {}));
class UploaderStatusChangeEvent {
    constructor(sizeQueued, sizeDone, status) {
        this._sizeQueued = sizeQueued;
        this._sizeDone = sizeDone;
        this._status = status;
    }
    get sizeQueued() {
        return this._sizeQueued;
    }
    get sizeDone() {
        return this._sizeDone;
    }
    sizeInQueue() {
        return this._sizeQueued - this._sizeDone;
    }
    get status() {
        return this._status;
    }
    uploadDone() {
        return (this._sizeDone >= this._sizeQueued);
    }
    percentDone() {
        if (this._sizeQueued == 0) {
            // no data queued, we are "done"
            return 100;
        }
        let percent = Math.floor(this._sizeDone * 100 / this._sizeQueued);
        //console.log("Upload status: queued: "+this._sizeQueued+", done: "+this._sizeDone+", "+percent+"%")
        return percent;
    }
}
class Upload {
    get serverPersistable() {
        return this._serverPersistable;
    }
    constructor(blob, url, _serverPersistable = null) {
        this._serverPersistable = _serverPersistable;
        this.onDone = null;
        this.toString = () => {
            let s = `Upload: Status: ${this.status}, URL: ${this._url}`;
            if (this._data instanceof Blob) {
                s = s + `, Size: ${this._data.size}`;
            }
            else if (this._data instanceof FormData) {
                // TODO (iterate through parts ??)
            }
            return s;
        };
        this._data = blob;
        this._url = url;
        this.status = UploadStatus$1.IDLE;
    }
    get url() {
        return this._url;
    }
    get data() {
        return this._data;
    }
    done() {
        this.status = UploadStatus$1.DONE;
        //console.debug("Single upload done.");
        if (this._serverPersistable) {
            this._serverPersistable.serverPersisted = true;
            //console.debug("Single upload set server persisted: "+this.serverPersistable);
        }
        else {
            //console.debug("Server persistable not set.");
        }
        if (this.onDone) {
            this.onDone(this);
        }
    }
}
class UploadHolder {
    constructor() {
        this.onUploadSet = null;
        this._upload = null;
    }
    get upload() {
        return this._upload;
    }
    set upload(value) {
        this._upload = value;
        if (this._upload && this.onUploadSet) {
            this.onUploadSet(this._upload);
        }
    }
}
class UploadSet {
    constructor() {
        this.uploads = new Array();
        this._complete = false;
        this._onDone = null;
    }
    add(upload) {
        if (this._complete) {
            throw new Error('Cannot add upload to upload set. Upload set already complete.');
        }
        if (upload instanceof UploadHolder) {
            upload.onUploadSet = (upl) => {
                upl.onDone = () => {
                    this.checkUploadStates();
                };
                this.checkUploadStates();
            };
        }
        this.uploads.push(upload);
    }
    complete() {
        // Mark set as complete
        this._complete = true;
        // add listeners to each upload
        for (let upl of this.uploads) {
            if (upl instanceof Upload) {
                upl.onDone = (upl) => {
                    this.checkUploadStates();
                };
            }
            else if (upl instanceof UploadHolder) {
                if (upl.upload) {
                    upl.upload.onDone = (upl) => {
                        this.checkUploadStates();
                    };
                }
            }
        }
        // check immediately if already done
        this.checkUploadStates();
    }
    set onDone(value) {
        this._onDone = value;
        this.checkUploadStates();
    }
    checkUploadStates() {
        //console.debug("Check upload state...")
        if (this._complete) {
            if (this._onDone) {
                for (let upl of this.uploads) {
                    if (upl instanceof Upload) {
                        if (UploadStatus$1.DONE !== upl.status) {
                            // At least this upload is not yet done
                            // Do nothing
                            //console.debug("Check upload state: Upload not done.")
                            return;
                        }
                    }
                    else if (upl instanceof UploadHolder) {
                        if (upl.upload) {
                            if (UploadStatus$1.DONE !== upl.upload.status) {
                                // At least this upload is not yet done
                                // Do nothing
                                //console.debug("Check upload state: Upload (holder) not done.")
                                return;
                            }
                        }
                        else {
                            // The actual upload is not yet set
                            //console.debug("Check upload state: Upload (holder): upload not yet set.")
                            return;
                        }
                    }
                }
                // set is complete and all upload parts are done, call done callback
                //console.debug("Check upload state: All done.")
                this._onDone(this);
            }
        }
    }
}
class Uploader {
    constructor(http, withCredentials = false) {
        this.http = http;
        this.withCredentials = withCredentials;
        this.POST_MIN_TIMEOUT = 120000; // 2min plus ...
        this.POST_TIMEOUT_PER_KB = 1000; // ... 1s per kB
        this.RETRY_DELAY = 30000; // retry every 30s
        this.DEBUG_DELAY = 0;
        //DEBUG_DELAY:number=0;
        this.status = UploaderStatus.DONE;
        this.listener = null;
        this._sizeQueued = 0;
        this._sizeDone = 0;
        this.retryTimerRunning = false;
        this.retryTimerId = null;
        this.te = new TextEncoder();
        this.que = new Array();
    }
    dataSize(dt) {
        let si = 0;
        if (dt instanceof Blob) {
            si = dt.size;
        }
        else if (dt instanceof FormData) {
            dt.forEach((v, k) => {
                if (v instanceof File) {
                    si += v.size;
                }
                else if (typeof v === 'string') {
                    // encode to UTF-8 to get upload size
                    si += this.te.encode().length;
                }
            });
        }
        return si;
    }
    uploadDone(ul) {
        ul.done();
        // remove upload from queue
        for (let i = 0; i < this.que.length; i++) {
            if (this.que[i] === ul) {
                // found, remove
                this.que.splice(i, 1);
                let ulSize = this.dataSize(ul.data);
                this._sizeDone += ulSize;
                break;
            }
        }
        // set to done for now...
        this.status = UploaderStatus.NEXT;
        // continue
        this.process();
    }
    startUpload(ul) {
        ul.status = UploadStatus$1.UPLOADING;
        if (UploaderStatus.ERR === this.status) {
            this.status = UploaderStatus.TRY_UPLOADING;
        }
        else {
            this.status = UploaderStatus.UPLOADING;
        }
        let dSize = this.dataSize(ul.data);
        let timeoutForDataSize = dSize * this.POST_TIMEOUT_PER_KB / 1000;
        let timeoVal = Math.round(this.POST_MIN_TIMEOUT + timeoutForDataSize);
        // pipe(timeout()) is not the same as xhr.timeout
        let uploadedUpload = null;
        //console.debug("Post upload: "+ul)
        this.http.post(ul.url, ul.data, { withCredentials: this.withCredentials }).pipe(timeout(timeoVal)).subscribe({
            next: (data) => {
                uploadedUpload = ul;
                //console.debug('Next method called for upload: '+uploadedUpload)
            },
            error: (err) => {
                if (err.error instanceof Error) {
                    // A client-side or network error occurred. Handle it accordingly.
                    console.error('Upload error occurred:', err.error.message);
                }
                else {
                    // The backend returned an unsuccessful response code.
                    // The response body may contain clues as to what went wrong,
                    console.error(`Upload error: Server returned code ${err.status}`);
                }
                this.processError(ul);
            }, complete: () => {
                //console.debug('Upload complete method called')
                if (uploadedUpload) {
                    if (this.DEBUG_DELAY > 0) {
                        window.setTimeout(() => {
                            this.uploadDone(ul);
                        }, this.DEBUG_DELAY);
                    }
                    else {
                        this.uploadDone(uploadedUpload);
                    }
                }
                else {
                    console.error('Upload post complete, but upload not set in next method!');
                }
            }
        });
    }
    processError(ul) {
        //console.debug("Process upload error...")
        ul.status = UploadStatus$1.ERR;
        this.status = UploaderStatus.ERR;
        let ue = new UploaderStatusChangeEvent(this._sizeQueued, this._sizeDone, this.status);
        if (this.listener) {
            this.listener(ue);
        }
        // set retry timer
        this.retryTimerId = window.setTimeout(() => {
            this.retryTimerRunning = false;
            //console.debug("Upload retry timer expired. Continue processing...")
            this.process();
        }, this.RETRY_DELAY);
        this.retryTimerRunning = true;
        //console.debug("Started upload retry timer "+this.RETRY_DELAY+"ms ...")
    }
    process() {
        // clear retry timer if set
        if (this.retryTimerRunning) {
            if (this.retryTimerId) {
                window.clearTimeout(this.retryTimerId);
            }
            this.retryTimerRunning = false;
            //console.debug("Cleared retry timer.")
        }
        let pul = null;
        //console.debug("Uploader status: "+this.status)
        let s = this.que.length;
        //console.debug(s+" uploads are in the queue.")
        if (s > 0 && UploaderStatus.UPLOADING != this.status && UploaderStatus.TRY_UPLOADING != this.status) {
            for (let i = 0; i < s; i++) {
                let ul = this.que[i];
                //console.log("Upload "+ul+" status:"+ul.status)
                if (ul.status === UploadStatus$1.IDLE) {
                    //console.log("Upload "+ul+" startUpload")
                    this.startUpload(ul);
                    pul = ul;
                    break;
                }
            }
            if (!pul) {
                //console.log("Check ERR uploads...")
                // now failed uploads
                //console.debug("No regular upload found. Looking for error state uploads.")
                for (let i = 0; i < s; i++) {
                    let ul = this.que[i];
                    //console.log("Upload "+ul+" status:"+ul.status)
                    if (ul.status === UploadStatus$1.ERR) {
                        //console.log("Upload (ERR) "+ul+" startUpload")
                        //console.debug("Start error state upload "+ul)
                        this.startUpload(ul);
                        pul = ul;
                        break;
                    }
                }
            }
        }
        if (s == 0) {
            //console.debug("Upload done.")
            this.status = UploaderStatus.DONE;
        }
        let ue = new UploaderStatusChangeEvent(this._sizeQueued, this._sizeDone, this.status);
        if (this.listener) {
            this.listener(ue);
        }
    }
    queueUpload(ul) {
        if (ul) {
            let ulSize = this.dataSize(ul.data);
            this.que.push(ul);
            this._sizeQueued += ulSize;
            this.process();
        }
    }
}

const SPEECHRECORDER_CONFIG = new InjectionToken('speechrecorder.config');
var ApiType;
(function (ApiType) {
    ApiType[ApiType["NORMAL"] = 0] = "NORMAL";
    ApiType[ApiType["FILES"] = 1] = "FILES";
})(ApiType || (ApiType = {}));
class SpeechRecorderConfig {
    constructor() {
        this.apiEndPoint = null;
        this.apiType = null;
        this.apiVersion = 1;
        this.withCredentials = false;
        this.enableDownloadRecordings = false;
        this.enableUploadRecordings = true;
        this.apiEndPoint = null;
        this.apiType = null;
        this.withCredentials = false;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.12", ngImport: i0, type: SpeechRecorderConfig, deps: [], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "18.2.12", ngImport: i0, type: SpeechRecorderConfig }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.12", ngImport: i0, type: SpeechRecorderConfig, decorators: [{
            type: Injectable
        }], ctorParameters: () => [] });

/**
 * Created by klausj on 17.06.2017.
 */
class ProjectService {
    static { this.PROJECT_API_CTX = 'project'; }
    constructor(http, platformLocation, config) {
        this.http = http;
        this.platformLocation = platformLocation;
        this.config = config;
        this.withCredentials = false;
        console.log("Base Href: " + platformLocation.getBaseHrefFromDOM());
        let apiEndPoint = '';
        if (config && config.apiEndPoint) {
            apiEndPoint = config.apiEndPoint;
        }
        if (apiEndPoint !== '') {
            apiEndPoint = apiEndPoint + '/';
        }
        if (config != null && config.withCredentials != null) {
            this.withCredentials = config.withCredentials;
        }
        this.projectCtxUrl = apiEndPoint + ProjectService.PROJECT_API_CTX;
    }
    appendRequestUUIDForDevelopmentServer(url) {
        let resUrl = url;
        if (this.config && this.config.apiType === ApiType.FILES) {
            // for development and demo
            // append UUID to make request URL unique to avoid localhost server caching
            resUrl = resUrl + '.json?requestUUID=' + UUID.generate();
        }
        return resUrl;
    }
    projectUrl(id) {
        let encPrjId = encodeURIComponent(id);
        return this.appendRequestUUIDForDevelopmentServer(this.projectCtxUrl + '/' + encPrjId);
    }
    projectResourceUrl(projectId, relResourcePath) {
        let encPrjId = encodeURIComponent(projectId);
        // Use encodeURI here since the relatice resource path from recording scripts is already a URI
        // encodeURIComponent function would encode the slashes and fetching the resource would fail
        let encRelResPath = encodeURI(relResourcePath);
        return this.projectCtxUrl + '/' + encPrjId + '/' + encRelResPath;
    }
    projectObservable(id) {
        let prjUrl = this.projectUrl(id);
        return this.http.get(prjUrl, { withCredentials: this.withCredentials });
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.12", ngImport: i0, type: ProjectService, deps: [{ token: i1.HttpClient }, { token: i1$1.PlatformLocation }, { token: SPEECHRECORDER_CONFIG }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "18.2.12", ngImport: i0, type: ProjectService }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.12", ngImport: i0, type: ProjectService, decorators: [{
            type: Injectable
        }], ctorParameters: () => [{ type: i1.HttpClient }, { type: i1$1.PlatformLocation }, { type: SpeechRecorderConfig, decorators: [{
                    type: Inject,
                    args: [SPEECHRECORDER_CONFIG]
                }] }] });

class SessionService {
    get uploadCount() {
        return this._uploadCount;
    }
    static { this.SESSION_API_CTX = 'session'; }
    constructor(http, config) {
        this.http = http;
        this.config = config;
        this.apiEndPoint = '';
        this.withCredentials = false;
        this._uploadCount = 0;
        if (config && config.apiEndPoint) {
            this.apiEndPoint = config.apiEndPoint;
        }
        if (this.apiEndPoint !== '') {
            this.apiEndPoint = this.apiEndPoint + '/';
        }
        if (config != null && config.withCredentials != null) {
            this.withCredentials = config.withCredentials;
        }
        this.sessionsUrl = this.apiEndPoint + SessionService.SESSION_API_CTX;
    }
    sessionObserver(id) {
        let sessUrl = this.sessionsUrl + '/' + id;
        if (this.config && this.config.apiType === ApiType.FILES) {
            // for development and demo
            // append UUID to make request URL unique to avoid localhost server caching
            sessUrl = sessUrl + '.json?requestUUID=' + UUID.generate();
        }
        return this.http.get(sessUrl, { withCredentials: this.withCredentials });
    }
    patchSessionObserver(session, body) {
        let sesssUrl = this.apiEndPoint + ProjectService.PROJECT_API_CTX + '/' + session.project + '/' + SessionService.SESSION_API_CTX + '/' + session.sessionId;
        let wrapObs = new Observable(subscriber => {
            this._uploadCount++;
            let obs = this.http.patch(sesssUrl, body, { withCredentials: this.withCredentials });
            obs.subscribe({
                next: (value) => {
                    subscriber.next(value);
                },
                error: error => {
                    this._uploadCount--;
                    subscriber.error(error);
                }, complete: () => {
                    this._uploadCount--;
                    subscriber.complete();
                }
            });
        });
        return wrapObs;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.12", ngImport: i0, type: SessionService, deps: [{ token: i1.HttpClient }, { token: SPEECHRECORDER_CONFIG }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "18.2.12", ngImport: i0, type: SessionService }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.12", ngImport: i0, type: SessionService, decorators: [{
            type: Injectable
        }], ctorParameters: () => [{ type: i1.HttpClient }, { type: SpeechRecorderConfig, decorators: [{
                    type: Inject,
                    args: [SPEECHRECORDER_CONFIG]
                }] }] });

class SimpleTrafficLight {
    constructor() {
        this.status = 4 /* State.OFF */;
    }
    set status(status) {
        if (4 /* State.OFF */ === status) {
            this.lighttop = 'grey';
            this.lightmid = 'grey';
            this.lightbottom = 'grey';
        }
        else if (0 /* State.IDLE */ === status) {
            this.lighttop = 'red';
            this.lightmid = 'grey';
            this.lightbottom = 'grey';
        }
        else if (1 /* State.PRERECORDING */ == status) {
            this.lighttop = 'red';
            this.lightmid = 'yellow';
            this.lightbottom = 'grey';
        }
        else if (3 /* State.RECORDING */ == status) {
            this.lighttop = 'grey';
            this.lightmid = 'grey';
            this.lightbottom = 'green';
        }
        else if (2 /* State.POSTRECORDING */ == status) {
            this.lighttop = 'grey';
            this.lightmid = 'yellow';
            this.lightbottom = 'grey';
        }
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.12", ngImport: i0, type: SimpleTrafficLight, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "18.2.12", type: SimpleTrafficLight, selector: "app-simpletrafficlight", inputs: { status: "status" }, ngImport: i0, template: `

    <div>
      <div class="circle {{lighttop}}"></div>
      <div class="circle {{lightmid}}"></div>
      <div class="circle {{lightbottom}}"></div>
    </div>
  `, isInline: true, styles: [".circle{width:50px;height:50px;border-radius:50%;margin:5px;background:gray}\n", ".red{background:red}\n", ".yellow{background:#ff0}\n", ".green{background:green}\n", ".black{background:#000}\n", ":host{display:flex;flex-direction:column;background:#000;padding:2px;height:170px;max-height:170px;flex:0 0 content}\n"] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.12", ngImport: i0, type: SimpleTrafficLight, decorators: [{
            type: Component,
            args: [{ selector: 'app-simpletrafficlight', template: `

    <div>
      <div class="circle {{lighttop}}"></div>
      <div class="circle {{lightmid}}"></div>
      <div class="circle {{lightbottom}}"></div>
    </div>
  `, styles: [".circle{width:50px;height:50px;border-radius:50%;margin:5px;background:gray}\n", ".red{background:red}\n", ".yellow{background:#ff0}\n", ".green{background:green}\n", ".black{background:#000}\n", ":host{display:flex;flex-direction:column;background:#000;padding:2px;height:170px;max-height:170px;flex:0 0 content}\n"] }]
        }], ctorParameters: () => [], propDecorators: { status: [{
                type: Input
            }] } });

class Position {
    constructor(left, top) {
        this.left = left;
        this.top = top;
    }
    toString() {
        return this.left + "," + this.top;
    }
}
class Dimension {
    constructor(width, height) {
        this.width = width;
        this.height = height;
    }
    toString() {
        return this.width + "x" + this.height;
    }
}
class Rectangle {
    constructor(position, dimension) {
        this.position = position;
        this.dimension = dimension;
    }
    toString() {
        return this.position + ":" + this.dimension;
    }
}

class CanvasLayerComponent {
    constructor() {
        this.bounds = null;
        // TODO make clear that first element is background canvas
        this.canvasLayers = new Array();
    }
    toXViewPortPixelPosition(virtualX) {
        let pixelPos = virtualX;
        if (this.bounds) {
            pixelPos = Math.round(virtualX - this.bounds.position.left);
        }
        return pixelPos;
    }
    toXVirtualPixelPosition(viewPortX) {
        let pixelPos = viewPortX;
        if (this.bounds) {
            pixelPos = Math.round(viewPortX + this.bounds.position.left);
        }
        return pixelPos;
    }
    toViewPortPosition(virtualPos) {
        if (this.bounds) {
            return new Position(virtualPos.left - this.bounds.position.left, virtualPos.top - this.bounds.position.top);
        }
        else {
            return virtualPos;
        }
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.12", ngImport: i0, type: CanvasLayerComponent, deps: [], target: i0.ɵɵFactoryTarget.Directive }); }
    static { this.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "18.2.12", type: CanvasLayerComponent, ngImport: i0 }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.12", ngImport: i0, type: CanvasLayerComponent, decorators: [{
            type: Directive
        }], ctorParameters: () => [] });

class AudioClip {
    constructor(_audioDataHolder) {
        this._audioDataHolder = _audioDataHolder;
        this._selection = null;
        this._levelInfos = null;
        this.selectionObservers = new Array();
    }
    get audioDataHolder() {
        return this._audioDataHolder;
    }
    get selection() {
        return this._selection;
    }
    set selection(value) {
        this._selection = value;
        // let obsCnt=this.selectionObservers.length
        // this.selectionObservers.forEach((obs)=> {
        //   console.log("Calling observer")
        //   obs(this)
        // });
        for (let selObs of this.selectionObservers) {
            selObs(this);
        }
    }
    get levelInfos() {
        return this._levelInfos;
    }
    set levelInfos(value) {
        this._levelInfos = value;
    }
    addSelectionObserver(selectionObserver, init = false) {
        let obsAlreadyInList = this.selectionObservers.find((obs) => (obs === selectionObserver));
        if (!obsAlreadyInList) {
            this.selectionObservers.push(selectionObserver);
        }
        if (init) {
            selectionObserver(this);
        }
    }
    removeSelectionObserver(selectionObserver) {
        this.selectionObservers = this.selectionObservers.filter((obs) => obs !== selectionObserver);
    }
}
// export interface Reader {
//   read(data: Blob): AudioClip;
// }
// export interface Writer {
//   write(audioData: AudioClip): Blob;
// }
class Selection {
    constructor(sampleRate, startFrame, endFrame) {
        this._sampleRate = sampleRate;
        this._startFrame = startFrame;
        this._endFrame = endFrame;
    }
    get sampleRate() {
        return this._sampleRate;
    }
    get endFrame() {
        return this._endFrame;
    }
    get startFrame() {
        return this._startFrame;
    }
    get leftFrame() {
        return (this._startFrame <= this._endFrame) ? this._startFrame : this._endFrame;
    }
    get rightFrame() {
        return (this._startFrame <= this._endFrame) ? this._endFrame : this._startFrame;
    }
    equals(otherSelection) {
        if (otherSelection) {
            return (this._sampleRate == otherSelection._sampleRate && this._startFrame === otherSelection._startFrame && this._endFrame === otherSelection._endFrame);
        }
        return false;
    }
    toString() {
        return "Selection: from: " + this.leftFrame + " to: " + this.rightFrame + " frame. Refers to sample rate :" + this._sampleRate;
    }
}

class Point {
    constructor(_x, _y) {
        this._x = _x;
        this._y = _y;
    }
    get x() {
        return this._x;
    }
    get y() {
        return this._y;
    }
}
class Marker {
    constructor() {
        this.name = null;
        this.framePosition = null;
    }
}

class ViewSelection {
    get startX() {
        return this._startX;
    }
    get endX() {
        return this._endX;
    }
    width() {
        return this._endX - this._startX;
    }
    constructor(_startX, _endX) {
        this._startX = _startX;
        this._endX = _endX;
    }
}
class BasicAudioCanvasLayerComponent extends CanvasLayerComponent {
    constructor() {
        super(...arguments);
        this._audioDataHolder = null;
        this._bgColor = 'white';
        this._selectColor = 'rgba(0%,0%,100%,25%)';
    }
    /**
     * Returns pixel position depending on current zoom setting.
     * @param framePos audio frame (sample) position
     */
    frameToXPixelPosition(framePos) {
        let pixelPos = null;
        let frameLength = this._audioDataHolder?.frameLen;
        if (frameLength !== undefined) {
            let vw;
            if (this.bounds) {
                vw = this.bounds.dimension.width;
            }
            if (this.virtualDimension) {
                vw = this.virtualDimension.width;
            }
            if (vw !== undefined) {
                pixelPos = framePos * vw / frameLength;
            }
        }
        return pixelPos;
    }
    /**
     * Returns pixel position in view port (visible window of scroll pane).
     * @param framePos audio frame (sample) position
     */
    frameToViewPortXPixelPosition(framePos) {
        let pixelPos = this.frameToXPixelPosition(framePos);
        if (pixelPos != null) {
            return this.toXViewPortPixelPosition(pixelPos);
        }
        else {
            return null;
        }
    }
    viewPortXPixelToFramePosition(xViewPortPixelPos) {
        let vpXframePos = null;
        const frameLength = this._audioDataHolder?.frameLen;
        if (frameLength !== undefined) {
            let vw = undefined;
            if (this.bounds) {
                vw = this.bounds.dimension.width;
            }
            if (this.virtualDimension) {
                vw = this.virtualDimension.width;
            }
            if (vw !== undefined) {
                const xVirtualPixelPos = this.toXVirtualPixelPosition(xViewPortPixelPos);
                const framesPerPixel = frameLength / vw;
                let framePos = framesPerPixel * xVirtualPixelPos;
                if (framePos < 0) {
                    framePos = 0;
                }
                if (framePos >= frameLength) {
                    framePos = frameLength - 1;
                }
                vpXframePos = Math.round(framePos);
            }
        }
        return vpXframePos;
    }
    layoutBounds(bounds, virtualDimension, redraw) {
        this.bounds = bounds;
        this.virtualDimension = virtualDimension;
        for (let ci = 0; ci < this.canvasLayers.length; ci++) {
            const cl = this.canvasLayers[ci];
            const leftStyle = bounds.position.left + 'px';
            if (cl.style.left != leftStyle) {
                cl.style.left = leftStyle;
            }
            const topStyle = bounds.position.top + 'px';
            if (cl.style.top != topStyle) {
                cl.style.top = topStyle;
            }
        }
        if (bounds.dimension.width) {
            const intW = Math.floor(bounds.dimension.width);
            if (redraw) {
                // Do not set width of background canvas (causes flicker on start render)
                for (let ci = 1; ci < this.canvasLayers.length; ci++) {
                    let cl = this.canvasLayers[ci];
                    if (cl.width != intW) {
                        cl.width = intW;
                    }
                }
            }
            const wStr = intW.toString() + 'px';
            for (let ci = 0; ci < this.canvasLayers.length; ci++) {
                let cl = this.canvasLayers[ci];
                if (cl.style.width != wStr) {
                    cl.style.width = wStr;
                }
            }
        }
        if (bounds.dimension.height) {
            const intH = Math.floor(bounds.dimension.height);
            if (redraw) {
                // Do not set height of background canvas (causes flicker on start render)
                for (let ci = 1; ci < this.canvasLayers.length; ci++) {
                    let cl = this.canvasLayers[ci];
                    if (cl.height != intH) {
                        cl.height = intH;
                    }
                }
            }
            const hStr = intH + 'px';
            for (let ci = 0; ci < this.canvasLayers.length; ci++) {
                let cl = this.canvasLayers[ci];
                if (cl.style.height != hStr) {
                    cl.style.height = hStr;
                }
            }
        }
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.12", ngImport: i0, type: BasicAudioCanvasLayerComponent, deps: null, target: i0.ɵɵFactoryTarget.Directive }); }
    static { this.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "18.2.12", type: BasicAudioCanvasLayerComponent, usesInheritance: true, ngImport: i0 }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.12", ngImport: i0, type: BasicAudioCanvasLayerComponent, decorators: [{
            type: Directive
        }] });
class AudioCanvasLayerComponent extends BasicAudioCanvasLayerComponent {
    constructor() {
        super(...arguments);
        this._pointerPosition = null;
        this.selectStartX = null;
        this._selecting = null;
        this._selection = null;
        this.pointerPositionEventEmitter = new EventEmitter();
        this.selectingEventEmitter = new EventEmitter();
        this.selectedEventEmitter = new EventEmitter();
    }
    static { this.ENABLE_STREAMING_NUMBER_OF_SAMPLES_THRESHOLD = 10 * 60 * 48000; } // Use streaming/chunking if audio clip has more than this number of samples
    onMouseup(me) {
        this.selectionCommit(me);
    }
    layoutBounds(bounds, virtualDimension, redraw, clear = true) {
        super.layoutBounds(bounds, virtualDimension, redraw);
        if (redraw) {
            this.startDraw(clear);
        }
    }
    set pointerPosition(pointerPosition) {
        this._pointerPosition = pointerPosition;
        this.drawCursorLayer();
    }
    set selecting(selecting) {
        this._selecting = selecting;
        this.drawBg();
        this.drawCursorLayer();
    }
    get selecting() {
        return this._selecting;
    }
    set selection(selection) {
        this._selection = selection;
        this.selecting = null;
        this.drawBg();
        this.drawCursorLayer();
    }
    get selection() {
        return this._selection;
    }
    selectionStart(me) {
        this.selectStartX = me.offsetX;
    }
    selectionCommit(me) {
        let vs = null;
        if (this.selectStartX != null) {
            vs = new ViewSelection(this.selectStartX, me.offsetX);
            this.selectStartX = null;
            this.select(vs);
        }
    }
    updateCursorCanvas(me, showCursorPosition = true) {
        if (this.cursorCanvas) {
            if (me) {
                if (this.selectStartX) {
                    this.pointerPositionChanged(null);
                    this.selectingChange(new ViewSelection(this.selectStartX, me.offsetX));
                }
                else {
                    if (showCursorPosition) {
                        this.pointerPositionChanged(me.offsetX);
                    }
                    else {
                        this.pointerPositionChanged(null);
                    }
                }
            }
        }
    }
    pointerPositionChanged(xPosition) {
        let pointerPosition = undefined;
        if (xPosition) {
            pointerPosition = new Marker();
            let vpXPos = this.viewPortXPixelToFramePosition(xPosition);
            if (vpXPos != null) {
                pointerPosition.framePosition = vpXPos;
            }
        }
        this.pointerPositionEventEmitter.emit(pointerPosition);
    }
    _selectingChange(viewSel) {
        let ns = undefined;
        if (viewSel) {
            let frameStart = this.viewPortXPixelToFramePosition(viewSel.startX);
            let frameEnd = this.viewPortXPixelToFramePosition(viewSel.endX);
            if (this._audioDataHolder && frameStart != null && frameEnd != null) {
                ns = new Selection(this._audioDataHolder.sampleRate, frameStart, frameEnd);
            }
        }
        return ns;
    }
    selectingChange(viewSel) {
        const ns = this._selectingChange(viewSel);
        this.selectingEventEmitter.emit(ns);
    }
    select(viewSel) {
        const ns = this._selectingChange(viewSel);
        this.selectedEventEmitter.emit(ns);
    }
    viewSelection() {
        let vs = null;
        let s = null;
        if (this._selecting) {
            s = this._selecting;
        }
        else if (this._selection) {
            s = this._selection;
        }
        if (s) {
            const sf = s.startFrame;
            const ef = s.endFrame;
            const xs = this.frameToViewPortXPixelPosition(sf);
            const xe = this.frameToViewPortXPixelPosition(ef);
            if (xs != null && xe != null) {
                vs = new ViewSelection(xs, xe);
            }
        }
        return vs;
    }
    drawBg() {
        if (this.bgCanvas && this.bounds) {
            this.bgCanvas.style.left = Math.round(this.bounds.position.left).toString() + 'px';
            this.bgCanvas.width = Math.round(this.bounds.dimension.width);
            this.bgCanvas.height = Math.round(this.bounds.dimension.height);
            let g1 = this.bgCanvas.getContext("2d");
            if (g1) {
                const w = this.bgCanvas.width;
                const h = this.bgCanvas.height;
                g1.clearRect(0, 0, w, h);
                if (this._bgColor) {
                    g1.fillStyle = this._bgColor;
                    g1.fillRect(0, 0, w, h);
                }
                let vs = this.viewSelection();
                if (vs) {
                    g1.fillStyle = this._selectColor;
                    g1.fillRect(vs.startX, 0, vs.width(), h);
                }
            }
        }
    }
    drawCursorLayer() {
        if (this.cursorCanvas) {
            const w = this.cursorCanvas.width;
            const h = this.cursorCanvas.height;
            const g = this.cursorCanvas.getContext("2d");
            if (g) {
                g.clearRect(0, 0, w, h);
                if (this._pointerPosition) {
                    let framePos = this._pointerPosition.framePosition;
                    if (framePos) {
                        let xViewPortPixelpos = this.frameToViewPortXPixelPosition(framePos);
                        if (xViewPortPixelpos) {
                            g.fillStyle = 'yellow';
                            g.strokeStyle = 'yellow';
                            g.beginPath();
                            g.moveTo(xViewPortPixelpos, 0);
                            g.lineTo(xViewPortPixelpos, h);
                            g.closePath();
                            g.stroke();
                            if (this._audioDataHolder) {
                                g.font = '14px sans-serif';
                                g.fillStyle = 'yellow';
                                g.fillText(framePos.toString(), xViewPortPixelpos + 2, 50);
                            }
                        }
                    }
                }
            }
        }
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.12", ngImport: i0, type: AudioCanvasLayerComponent, deps: null, target: i0.ɵɵFactoryTarget.Directive }); }
    static { this.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "18.2.12", type: AudioCanvasLayerComponent, inputs: { pointerPosition: "pointerPosition", selecting: "selecting", selection: "selection" }, outputs: { pointerPositionEventEmitter: "pointerPositionEventEmitter", selectingEventEmitter: "selectingEventEmitter", selectedEventEmitter: "selectedEventEmitter" }, host: { listeners: { "document:mouseup": "onMouseup($event)" } }, viewQueries: [{ propertyName: "bgCanvasRef", first: true, predicate: ["bg"], descendants: true, static: true }, { propertyName: "cursorCanvasRef", first: true, predicate: ["cursor"], descendants: true, static: true }], usesInheritance: true, ngImport: i0 }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.12", ngImport: i0, type: AudioCanvasLayerComponent, decorators: [{
            type: Directive
        }], propDecorators: { bgCanvasRef: [{
                type: ViewChild,
                args: ['bg', { static: true }]
            }], cursorCanvasRef: [{
                type: ViewChild,
                args: ['cursor', { static: true }]
            }], onMouseup: [{
                type: HostListener,
                args: ['document:mouseup', ['$event']]
            }], pointerPosition: [{
                type: Input
            }], selecting: [{
                type: Input
            }], selection: [{
                type: Input
            }], pointerPositionEventEmitter: [{
                type: Output
            }], selectingEventEmitter: [{
                type: Output
            }], selectedEventEmitter: [{
                type: Output
            }] } });

class AudioSignal extends AudioCanvasLayerComponent {
    constructor(ref) {
        super();
        this.ref = ref;
        this._playFramePosition = null;
        this.worker = null;
        this.raAsSubsc = null;
        this.workerURL = WorkerHelper.buildWorkerBlobURL(this.workerFunction);
        this._audioDataHolder = null;
        this._bgColor = 'black';
        this._selectColor = 'rgba(255,255,0,0.8)';
    }
    ngAfterViewInit() {
        this.ce = this.ref.nativeElement;
        this.bgCanvas = this.bgCanvasRef.nativeElement;
        this.bgCanvas.style.zIndex = '1';
        this.signalCanvas = this.audioSignalCanvasRef.nativeElement;
        this.signalCanvas.style.zIndex = '2';
        this.markerCanvas = this.playPosCanvasRef.nativeElement;
        this.markerCanvas.style.zIndex = '3';
        this.cursorCanvas = this.cursorCanvasRef.nativeElement;
        this.cursorCanvas.style.zIndex = '4';
        this.canvasLayers[0] = this.bgCanvas;
        this.canvasLayers[1] = this.signalCanvas;
        this.canvasLayers[2] = this.cursorCanvas;
        this.canvasLayers[3] = this.markerCanvas;
    }
    get playFramePosition() {
        return this._playFramePosition;
    }
    set playFramePosition(playFramePosition) {
        this._playFramePosition = playFramePosition;
        this.drawPlayPosition();
    }
    drawPlayPosition() {
        if (this.markerCanvas) {
            let w = this.markerCanvas.width;
            let h = this.markerCanvas.height;
            let g = this.markerCanvas.getContext("2d");
            if (g) {
                g.clearRect(0, 0, w, h);
                if (this._playFramePosition) {
                    let pixelPos = this.frameToViewPortXPixelPosition(this._playFramePosition);
                    if (pixelPos) {
                        g.fillStyle = 'red';
                        g.strokeStyle = 'red';
                        g.beginPath();
                        g.moveTo(pixelPos, 0);
                        g.lineTo(pixelPos, h);
                        g.closePath();
                        g.stroke();
                    }
                }
            }
        }
    }
    /*
     *  Method used as worker code.
     */
    workerFunction() {
        addEventListener('message', ({ data }) => {
            const audioData = data.audioData; // audio data part required to render view port
            const auOffset = data.audioDataOffset;
            const l = data.l; // left pixel position of view port
            const w = data.w; // width of viewport
            const vw = data.vw; //  total width of (virtual) audio view (not viewport width)
            const chs = data.chs; // number of channels
            //const dataFrameLength = data.audioDataFrameLength;  // frame length of audio data part required for view port
            const frameLength = data.frameLength; // total frame length (of audio clip)
            //console.debug("W: left: "+l+", w:"+w+", vw: "+vw+", chs: "+chs+", frameLength: "+frameLength);
            let psMinMax = new Float32Array(0);
            if (audioData && audioData.length > 0 && w >= 0 && vw > 0) {
                const framesPerPixel = frameLength / vw;
                const pointsLen = w * chs;
                // one for min one for max
                const arrLen = pointsLen * 2;
                psMinMax = new Float32Array(arrLen);
                let chFramePos = 0;
                const chFrameLength = audioData.length / chs;
                for (let ch = 0; ch < chs; ch++) {
                    chFramePos = ch * chFrameLength;
                    for (let pii = 0; pii < w; pii++) {
                        const virtPii = l + pii;
                        let pMin = Infinity;
                        let pMax = -Infinity;
                        let pixelFramePos = Math.round(chFramePos + (virtPii * framesPerPixel));
                        // calculate pixel min/max amplitude
                        for (let ai = 0; ai < framesPerPixel; ai++) {
                            const framePos = pixelFramePos + ai;
                            let a = 0;
                            const bufPos = framePos - auOffset;
                            //let bufPos=framePos;
                            if (bufPos >= 0 && bufPos < audioData.length) {
                                a = audioData[bufPos];
                                //console.debug("W: ch: "+ch+", pixelFramePos: "+pixelFramePos+", framePos: "+framePos+", auOffset: "+auOffset+", bufPos: "+bufPos+", audioData.length: "+audioData.length+", a: "+a);
                                if (a < pMin) {
                                    pMin = a;
                                }
                                if (a > pMax) {
                                    pMax = a;
                                }
                            }
                        }
                        const psMinPos = ch * w + pii;
                        psMinMax[psMinPos] = pMin;
                        const psMaxPos = pointsLen + psMinPos;
                        psMinMax[psMaxPos] = pMax;
                        //console.debug("psMinMax["+psMinPos+"]="+pMin+",psMinMax["+psMaxPos+"]="+pMax);
                    }
                }
            }
            postMessage({ psMinMax: psMinMax, l: data.l, w: data.w, chs: data.chs, eod: data.eod }, [psMinMax.buffer]);
        });
    }
    startDraw(clear = true) {
        if (clear) {
            if (this.bounds) {
                this.signalCanvas.style.left = Math.round(this.bounds.position.left).toString() + 'px';
                this.signalCanvas.width = Math.round(this.bounds.dimension.width);
                this.signalCanvas.height = Math.round(this.bounds.dimension.height);
                let g = this.signalCanvas.getContext("2d");
                if (g) {
                    //g.clearRect(0, 0,w, h);
                    g.fillStyle = "black";
                    g.fillRect(0, 0, Math.round(this.bounds.dimension.width), Math.round(this.bounds.dimension.height));
                }
            }
        }
        this.startRender();
        this.drawCursorLayer();
    }
    startRender() {
        if (this.worker) {
            this.worker.terminate();
            this.worker = null;
        }
        if (this.raAsSubsc) {
            this.raAsSubsc.unsubscribe();
        }
        if (this._audioDataHolder) {
            this._audioDataHolder.addOnReadyListener(() => {
                if (this._audioDataHolder && this.bounds && this.bounds.dimension) {
                    let w = Math.round(this.bounds.dimension.width);
                    let h = Math.round(this.bounds.dimension.height);
                    let vw = Math.round(this.virtualDimension.width);
                    if (w > 0 && h > 0 && vw > 0) {
                        //this.wo = new Worker('./audiosignal.worker.js',{type: 'module'});
                        this.worker = new Worker(this.workerURL);
                        //this.wo = new Worker('worker/audiosignal.worker.ts');
                        //let Worker = require('worker!../../../workers/uploader/main');
                        let chs = this._audioDataHolder.numberOfChannels;
                        let leftPos = Math.round(this.bounds.position.left);
                        let renderPos = leftPos;
                        let frameLength = this._audioDataHolder.frameLen;
                        let framesPerPixel = Math.ceil(frameLength / vw);
                        //console.debug("Chs: " + chs + ", vw: " + vw + ", frameLength: " + frameLength + ", framesPerPixel: " + framesPerPixel);
                        let ad = new Float32Array(chs * framesPerPixel);
                        let raAs = this._audioDataHolder.randomAccessAudioStream();
                        let audioBuffer = null;
                        let audioSource = this._audioDataHolder.audioSource;
                        if (audioSource instanceof AudioBufferSource) {
                            audioBuffer = audioSource.audioBuffer;
                        }
                        //let arrayAudioBuffer=this._audioDataHolder.arrayBuffer;
                        let arrAbBuf;
                        //let ais:ArrayAudioBufferInputStream|null=null;
                        //let aisBuf:Float32Array[]|null=null;
                        let psMinMax = null;
                        if (this.worker) {
                            this.worker.onmessage = (me) => {
                                if (me.data.eod === true) {
                                    let psMinMaxTmp;
                                    if (psMinMax) {
                                        psMinMaxTmp = psMinMax;
                                    }
                                    else {
                                        psMinMaxTmp = me.data.psMinMax;
                                    }
                                    this.drawRendered(leftPos, w, h, chs, psMinMaxTmp);
                                    if (this.worker) {
                                        this.worker.terminate();
                                    }
                                    raAs.close();
                                }
                                else if (this._audioDataHolder && arrAbBuf) {
                                    const rw = me.data.w;
                                    const rPointsLen = chs * rw;
                                    const pointsLen = chs * w;
                                    for (let ch = 0; ch < chs; ch++) {
                                        if (psMinMax) {
                                            let rBasePos = ch * rw;
                                            let basePos = ch * w;
                                            let rPosMin = rBasePos;
                                            let rPosMax = rPointsLen + rPosMin;
                                            let posMin = basePos + (renderPos - leftPos);
                                            let posMax = pointsLen + posMin;
                                            psMinMax[posMin] = me.data.psMinMax[rPosMin];
                                            //console.debug('Min: ('+posMin+'): '+me.data.psMinMax[rPosMin]);
                                            psMinMax[posMax] = me.data.psMinMax[rPosMax];
                                            //console.debug('Max: ('+(posMax)+'): '+me.data.psMinMax[rPosMax]);
                                            //console.debug("psMinMax["+posMin+"]="+me.data.psMinMax[rPosMin]+"  (rPosMin="+rPosMin+"),psMinMax["+posMax+"]="+me.data.psMinMax[rPosMax]);
                                        }
                                    }
                                    let eod = false;
                                    renderPos++;
                                    //let ad:Float32Array;
                                    const leftFramePos = Math.floor(frameLength * renderPos / vw);
                                    if (renderPos < leftPos + w) {
                                        const raAsObs = raAs.framesObs(leftFramePos, framesPerPixel, arrAbBuf);
                                        this.raAsSubsc = raAsObs.subscribe({
                                            next: (read) => {
                                                //console.debug("First read frame: "+arrAbBuf[0][0]);
                                                if (arrAbBuf) {
                                                    const adLen = chs * framesPerPixel;
                                                    if (!ad || ad.length !== adLen) {
                                                        ad = new Float32Array(adLen);
                                                    }
                                                    for (let ch = 0; ch < chs; ch++) {
                                                        ad.set(arrAbBuf[ch], ch * framesPerPixel);
                                                    }
                                                }
                                                eod = (read <= 0);
                                                let adBuf = ad.buffer;
                                                if (this.worker) {
                                                    this.worker.postMessage({
                                                        l: renderPos,
                                                        w: me.data.w,
                                                        h: h,
                                                        vw: vw,
                                                        chs: chs,
                                                        frameLength: frameLength,
                                                        audioData: ad,
                                                        audioDataOffset: leftFramePos,
                                                        eod: eod
                                                    }, [adBuf]);
                                                }
                                            },
                                            error: (err) => {
                                                console.error("AudioSignal: Error reading audio data: " + err);
                                            }
                                        });
                                    }
                                    else {
                                        ad = new Float32Array();
                                        eod = true;
                                        const adBuf = ad.buffer;
                                        if (this.worker) {
                                            this.worker.postMessage({
                                                l: renderPos,
                                                w: me.data.w,
                                                h: h,
                                                vw: vw,
                                                chs: chs,
                                                frameLength: frameLength,
                                                audioData: ad,
                                                audioDataOffset: leftFramePos,
                                                eod: eod
                                            }, [adBuf]);
                                        }
                                    }
                                }
                            };
                        }
                        if (audioBuffer && audioBuffer.length * audioBuffer.numberOfChannels < AudioCanvasLayerComponent.ENABLE_STREAMING_NUMBER_OF_SAMPLES_THRESHOLD) {
                            // Render whole clip at once
                            arrAbBuf = null;
                            psMinMax = null;
                            const ad = new Float32Array(chs * frameLength);
                            for (let ch = 0; ch < chs; ch++) {
                                ad.set(audioBuffer.getChannelData(ch), ch * frameLength);
                            }
                            this.worker.postMessage({
                                l: leftPos,
                                w: w,
                                vw: vw,
                                chs: chs,
                                frameLength: frameLength,
                                audioData: ad,
                                audioDataOffset: 0,
                                eod: true
                            }, [ad.buffer]);
                        }
                        else {
                            // Render pixel by pixel
                            if (w > 0) {
                                if (framesPerPixel > 0) {
                                    let rw = 1;
                                    arrAbBuf = new Array(chs);
                                    psMinMax = new Float32Array(chs * w * 2);
                                    //console.debug("Audiosignal: Allocating buffers: "+framesPerPixel);
                                    for (let ch = 0; ch < chs; ch++) {
                                        arrAbBuf[ch] = new Float32Array(framesPerPixel);
                                    }
                                    const leftFramePos = Math.floor(frameLength * renderPos / vw);
                                    const auOffset = leftFramePos; // should always be 0
                                    const raAsObs = raAs.framesObs(leftFramePos, framesPerPixel, arrAbBuf);
                                    this.drawStateText("Loading/Rendering...");
                                    this.raAsSubsc = raAsObs.subscribe({
                                        next: (read) => {
                                            if (arrAbBuf && this.worker) {
                                                const adLen = chs * framesPerPixel;
                                                if (!ad || ad.length !== adLen) {
                                                    ad = new Float32Array(adLen);
                                                }
                                                for (let ch = 0; ch < chs; ch++) {
                                                    ad.set(arrAbBuf[ch], ch * framesPerPixel);
                                                }
                                                this.worker.postMessage({
                                                    l: renderPos,
                                                    w: rw,
                                                    vw: vw,
                                                    chs: chs,
                                                    frameLength: frameLength,
                                                    audioData: ad,
                                                    audioDataOffset: auOffset,
                                                    eod: (read <= 0)
                                                }, [ad.buffer]);
                                            }
                                        },
                                        error: (err) => {
                                            console.error("AudioSignal: Error reading audio data: " + err);
                                        }
                                    });
                                }
                            }
                        }
                    }
                }
            });
        }
        else {
            if (this.bounds && this.bounds.dimension) {
                let w = Math.round(this.bounds.dimension.width);
                let h = Math.round(this.bounds.dimension.height);
                let g = this.signalCanvas.getContext("2d");
                if (g) {
                    g.clearRect(0, 0, w, h);
                }
            }
        }
    }
    drawStateText(stateText) {
        if (stateText) {
            const g = this.signalCanvas.getContext("2d");
            const w = this.signalCanvas.width;
            const h = this.signalCanvas.height;
            if (g && w && h) {
                g.strokeStyle = 'white';
                g.fillStyle = 'white';
                g.font = '20px sans-serif';
                g.fillText(stateText, 10, 25);
            }
        }
    }
    drawRendered(left, w, h, chs, psMinMax) {
        this.drawBg();
        this.signalCanvas.style.left = left.toString() + 'px';
        this.signalCanvas.width = w;
        this.signalCanvas.height = h;
        let g = this.signalCanvas.getContext("2d");
        if (g) {
            g.clearRect(0, 0, w, h);
            let pointsLen = w * chs;
            // one for min one for max
            //const arrLen = pointsLen * 2;
            if (this._audioDataHolder) {
                //const std = Date.now();
                const chH = h / chs;
                let y = 0;
                for (let ch = 0; ch < chs; ch++) {
                    const psMinPos = ch * w;
                    const psMaxPos = pointsLen + psMinPos;
                    g.fillStyle = 'green';
                    g.strokeStyle = 'green';
                    // draw audio signal as single polygon
                    g.beginPath();
                    g.moveTo(0, y + (chH / 2) + psMinMax[psMaxPos] * chH / 2);
                    for (let pii = 0; pii < w; pii++) {
                        const psMax = psMinMax[psMaxPos + pii];
                        const pv = psMax * chH / 2;
                        const yd = y + (chH / 2) - pv;
                        //console.log("LineTo: : "+pii+" "+yd)
                        g.lineTo(pii, yd);
                    }
                    const revPixelStart = w - 1;
                    for (let pii = revPixelStart; pii >= 0; pii--) {
                        const psMin = psMinMax[psMinPos + pii];
                        const pv = psMin * chH / 2;
                        const yd = y + (chH / 2) - pv;
                        //console.log("LineTo: : "+pii+" "+yd)
                        g.lineTo(pii, yd);
                    }
                    g.closePath();
                    g.fill();
                    g.stroke();
                    y += chH;
                }
            }
        }
    }
    // redraw() {
    //   this.drawBg()
    //   let g = this.signalCanvas.getContext("2d");
    //   if (g) {
    //     let w = this.signalCanvas.width;
    //     let h = this.signalCanvas.height;
    //     g.clearRect(0, 0, w, h);
    //     //g.fillStyle = "black";
    //     //g.fillRect(0, 0, w, h);
    //     if (this._audioDataHolder) {
    //       let std = Date.now();
    //       let chs = this._audioDataHolder.numberOfChannels;
    //       let chH = h / chs;
    //
    //       let frameLength = this._audioDataHolder.frameLen;
    //
    //       let framesPerPixel = frameLength / w;
    //       let y = 0;
    //       let ais:Float32ArrayInputStream|null=null;
    //       let audioSource=this._audioDataHolder.audioSource;
    //       let audioBuffer:AudioBuffer|null=null;
    //       if(audioSource instanceof AudioBufferSource){
    //         audioBuffer=audioSource.audioBuffer;
    //       }
    //       let aisBuffer:Array<Float32Array>|null=null;
    //       if(!audioBuffer) {
    //         ais=this._audioDataHolder.audioInputStream();
    //         aisBuffer=new Array<Float32Array>(chs);
    //         for(let ch=0;ch<chs;ch++) {
    //           aisBuffer[ch] = new Float32Array(framesPerPixel);
    //         }
    //       }
    //         for (let ch = 0; ch < chs; ch++) {
    //           let x = 0;
    //           let psMin = new Float32Array(w);
    //           let psMax = new Float32Array(w);
    //           let framePos = 0;
    //           for (let pii = 0; pii < w; pii++) {
    //             let pMin = 0;
    //             let pMax = 0;
    //
    //             if (audioBuffer){
    //               // calculate pixel min/max amplitude
    //               for (let ai = 0; ai < framesPerPixel; ai++) {
    //                 //let framePos=(pii*framesPerPixel)+ai;
    //                 let a = audioBuffer.getChannelData(ch)[framePos++];
    //
    //                 if (a < pMin) {
    //                   pMin = a;
    //                 }
    //                 if (a > pMax) {
    //                   pMax = a;
    //                 }
    //               }
    //           }else if(ais && aisBuffer) {
    //               let r = ais.read(aisBuffer);
    //               for (let ai = 0; ai < r; ai++) {
    //
    //                 let a = aisBuffer[ch][ai];
    //
    //                 if (a < pMin) {
    //                   pMin = a;
    //                 }
    //                 if (a > pMax) {
    //                   pMax = a;
    //                 }
    //               }
    //             }
    //             psMin[pii] = pMin;
    //             psMax[pii] = pMax;
    //           }
    //           g.fillStyle = 'green';
    //           g.strokeStyle = 'green';
    //
    //           // draw audio signal as single polygon
    //           g.beginPath();
    //           g.moveTo(0, y + (chH / 2) + psMin[0] * chH / 2);
    //
    //           for (let pii = 0; pii < w; pii++) {
    //             let pv = psMin[pii] * chH / 2;
    //             //console.log("Min: ",pv);
    //             g.lineTo(pii, y + (chH / 2) + pv);
    //           }
    //           for (let pii = w; pii >= 0; pii--) {
    //             let pv = psMax[pii] * chH / 2;
    //             //console.log("Max: ",pv);
    //             g.lineTo(pii, y + (chH / 2) + pv);
    //           }
    //           g.closePath();
    //           //g.lineTo()
    //           g.fill();
    //           g.stroke();
    //           g.fillStyle = "yellow";
    //           g.stroke();
    //           y += chH;
    //         }
    //       ais?.close();
    //     }
    //   }
    // }
    setData(audioData) {
        this._audioDataHolder = audioData;
        this.playFramePosition = 0;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.12", ngImport: i0, type: AudioSignal, deps: [{ token: i0.ElementRef }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "18.2.12", type: AudioSignal, selector: "audio-signal", viewQueries: [{ propertyName: "audioSignalCanvasRef", first: true, predicate: ["audioSignal"], descendants: true, static: true }, { propertyName: "playPosCanvasRef", first: true, predicate: ["marker"], descendants: true, static: true }], usesInheritance: true, ngImport: i0, template: `
    <canvas #bg height="10"></canvas>
    <canvas #audioSignal height="10"></canvas>
    <canvas #cursor height="10" (mousedown)="selectionStart($event)" (mouseover)="updateCursorCanvas($event)" (mousemove)="updateCursorCanvas($event)"
            (mouseleave)="updateCursorCanvas($event, false)"></canvas>
    <canvas #marker height="10"></canvas>`, isInline: true, styles: [":host{min-height:0px}\n", "canvas{top:0;left:0;width:0;height:0;min-height:0px;position:absolute}\n"] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.12", ngImport: i0, type: AudioSignal, decorators: [{
            type: Component,
            args: [{ selector: 'audio-signal', template: `
    <canvas #bg height="10"></canvas>
    <canvas #audioSignal height="10"></canvas>
    <canvas #cursor height="10" (mousedown)="selectionStart($event)" (mouseover)="updateCursorCanvas($event)" (mousemove)="updateCursorCanvas($event)"
            (mouseleave)="updateCursorCanvas($event, false)"></canvas>
    <canvas #marker height="10"></canvas>`, styles: [":host{min-height:0px}\n", "canvas{top:0;left:0;width:0;height:0;min-height:0px;position:absolute}\n"] }]
        }], ctorParameters: () => [{ type: i0.ElementRef }], propDecorators: { audioSignalCanvasRef: [{
                type: ViewChild,
                args: ['audioSignal', { static: true }]
            }], playPosCanvasRef: [{
                type: ViewChild,
                args: ['marker', { static: true }]
            }] } });

class Complex {
    static fromPolarForm(magnitude, argument) {
        const r = Math.cos(argument) * magnitude;
        const i = Math.sin(argument) * magnitude;
        return new Complex(r, i);
    }
    constructor(real, img) {
        this.real = real;
        this.img = img;
    }
    magnitude() {
        return Math.sqrt((this.real * this.real) + (this.img * this.img));
    }
    argument() {
        return Math.atan2(this.img, this.real);
    }
    add(addC) {
        return new Complex(this.real + addC.real, this.img + addC.img);
    }
    sub(subC) {
        return new Complex(this.real - subC.real, this.img - subC.img);
    }
    mult(multC) {
        const multR = (this.real * multC.real) - (this.img * multC.img);
        const multI = (this.real * multC.img) + (multC.real * this.img);
        return new Complex(multR, multI);
    }
    multReal(multF) {
        return new Complex(this.real * multF, this.img * multF);
    }
    div(divisor) {
        const divReal = divisor.real;
        const divImg = divisor.img;
        const div = (divReal * divReal) + (divImg * divImg);
        const divisionReal = ((this.real * divReal) + (this.img * divImg)) / div;
        const divisionImg = ((divReal * this.img) - (this.real * divImg)) / div;
        return new Complex(divisionReal, divisionImg);
    }
    divReal(divisor) {
        const div = divisor * divisor;
        const divsionReal = (this.real * divisor) / div;
        const divsionImg = (divisor * this.img) / div;
        return new Complex(divsionReal, divsionImg);
    }
    conjugate() {
        return new Complex(this.real, -this.img);
    }
    equals(c) {
        if (c === null) {
            return false;
        }
        return (this.real === c.real && this.img === c.img);
    }
    toString() {
        return 'Real: ' + this.real + ', Img: ' + this.img;
    }
}

class DFTFloat32 {
    constructor(n) {
        this.n = n;
        this.m = Math.log(n) / Math.log(2);
        // if(n != (1 << m))throw new RuntimeException("length N must be power of 2");
        // lookup tables
        this.cosLookup = new Float32Array(n / 2);
        this.sinLookup = new Float32Array(n / 2);
        for (let i = 0; i < n / 2; i++) {
            const arc = (-2 * Math.PI * i) / n;
            this.cosLookup[i] = Math.cos(arc);
            this.sinLookup[i] = Math.sin(arc);
        }
    }
    processReal(srcBuf) {
        const x = srcBuf.slice();
        const y = new Float32Array(srcBuf.length);
        for (let yi = 0; yi < y.length; yi++) {
            y[yi] = 0.0;
        }
        this.fftCooleyTukey(x, y);
        const rc = new Array(x.length);
        for (let i = 0; i < x.length; i++) {
            rc[i] = new Complex(x[i], y[i]);
        }
        return rc;
    }
    processRealMagnitude(srcBuf) {
        const x = srcBuf.slice();
        const y = new Float32Array(srcBuf.length);
        for (let yi = 0; yi < y.length; yi++) {
            y[yi] = 0.0;
        }
        this.fftCooleyTukey(x, y);
        const rc = new Float32Array(x.length);
        for (let i = 0; i < x.length; i++) {
            const rcc = new Complex(x[i], y[i]);
            rc[i] = rcc.magnitude();
        }
        return rc;
    }
    fftCooleyTukey(real, img) {
        let i;
        let j = 0;
        let k;
        let n1;
        let n2 = this.n / 2;
        let a;
        let c;
        let s;
        let t1;
        let t2;
        for (i = 1; i < this.n - 1; i++) {
            n1 = n2;
            while (j >= n1) {
                j = j - n1;
                n1 = n1 / 2;
            }
            j = j + n1;
            if (i < j) {
                t1 = real[i];
                real[i] = real[j];
                real[j] = t1;
                t1 = img[i];
                img[i] = img[j];
                img[j] = t1;
            }
        }
        n1 = 0;
        n2 = 1;
        for (i = 0; i < this.m; i++) {
            n1 = n2;
            n2 = n2 + n2;
            a = 0;
            for (j = 0; j < n1; j++) {
                c = this.cosLookup[a];
                s = this.sinLookup[a];
                a += (1 << (this.m - i - 1));
                for (k = j; k < this.n; k = k + n2) {
                    t1 = c * real[k + n1] - s * img[k + n1];
                    t2 = s * real[k + n1] + c * img[k + n1];
                    real[k + n1] = real[k] - t1;
                    img[k + n1] = img[k] - t2;
                    real[k] = real[k] + t1;
                    img[k] = img[k] + t2;
                }
            }
        }
    }
    process(t) {
        const reals = new Float32Array(this.n);
        const imgs = new Float32Array(this.n);
        const trans = new Array(this.n);
        for (let i = 0; i < this.n; i++) {
            reals[i] = t[i].real;
            imgs[i] = t[i].img;
        }
        this.fftCooleyTukey(reals, imgs);
        for (let i = 0; i < this.n; i++) {
            trans[i] = new Complex(reals[i], imgs[i]);
        }
        return trans;
    }
}
class DFT {
    constructor(n) {
        this.n = n;
        this.m = Math.log(n) / Math.log(2);
        // if(n != (1 << m))throw new RuntimeException("length N must be power of 2");
        // lookup tables
        this.cosLookup = new Array(n / 2);
        this.sinLookup = new Array(n / 2);
        for (let i = 0; i < n / 2; i++) {
            const arc = (-2 * Math.PI * i) / n;
            this.cosLookup[i] = Math.cos(arc);
            this.sinLookup[i] = Math.sin(arc);
        }
    }
    processReal(srcBuf) {
        const x = srcBuf.slice();
        const y = new Array(srcBuf.length);
        for (let yi = 0; yi < y.length; yi++) {
            y[yi] = 0.0;
        }
        this.fftCooleyTukey(x, y);
        const rc = new Array(x.length);
        for (let i = 0; i < x.length; i++) {
            rc[i] = new Complex(x[i], y[i]);
        }
        return rc;
    }
    fftCooleyTukey(real, img) {
        let i;
        let j = 0;
        let k;
        let n1;
        let n2 = this.n / 2;
        let a;
        let c;
        let s;
        let t1;
        let t2;
        for (i = 1; i < this.n - 1; i++) {
            n1 = n2;
            while (j >= n1) {
                j = j - n1;
                n1 = n1 / 2;
            }
            j = j + n1;
            if (i < j) {
                t1 = real[i];
                real[i] = real[j];
                real[j] = t1;
                t1 = img[i];
                img[i] = img[j];
                img[j] = t1;
            }
        }
        n1 = 0;
        n2 = 1;
        for (i = 0; i < this.m; i++) {
            n1 = n2;
            n2 = n2 + n2;
            a = 0;
            for (j = 0; j < n1; j++) {
                c = this.cosLookup[a];
                s = this.sinLookup[a];
                a += 1 << (this.m - i - 1);
                for (k = j; k < this.n; k = k + n2) {
                    t1 = c * real[k + n1] - s * img[k + n1];
                    t2 = s * real[k + n1] + c * img[k + n1];
                    real[k + n1] = real[k] - t1;
                    img[k + n1] = img[k] - t2;
                    real[k] = real[k] + t1;
                    img[k] = img[k] + t2;
                }
            }
        }
    }
    process(t) {
        const reals = new Array(this.n);
        const imgs = new Array(this.n);
        const trans = new Array(this.n);
        for (let i = 0; i < this.n; i++) {
            reals[i] = t[i].real;
            imgs[i] = t[i].img;
        }
        this.fftCooleyTukey(reals, imgs);
        for (let i = 0; i < this.n; i++) {
            trans[i] = new Complex(reals[i], imgs[i]);
        }
        return trans;
    }
}

const DEFAULT_DFT_SIZE = 1024;
class Sonagram extends AudioCanvasLayerComponent {
    constructor(ref) {
        super();
        this.ref = ref;
        this._playFramePosition = null;
        this.raAsSubsc = null;
        this.dftSize = DEFAULT_DFT_SIZE;
        this.worker = null;
        this._audioDataHolder = null;
        this.markers = new Array();
        this.dft = new DFTFloat32(this.dftSize);
        this.workerURL = WorkerHelper.buildWorkerBlobURL(this.workerFunction);
        this._bgColor = null;
        this._selectColor = 'rgba(255,255,0,0.1)';
    }
    ngAfterViewInit() {
        this.ce = this.ref.nativeElement;
        this.sonagramCanvas = this.sonagramCanvasRef.nativeElement;
        this.sonagramCanvas.style.zIndex = '1';
        this.bgCanvas = this.bgCanvasRef.nativeElement;
        this.bgCanvas.style.zIndex = '2';
        this.cursorCanvas = this.cursorCanvasRef.nativeElement;
        this.cursorCanvas.style.zIndex = '4';
        this.markerCanvas = this.markerCanvasRef.nativeElement;
        this.markerCanvas.style.zIndex = '3';
        this.canvasLayers[0] = this.sonagramCanvas;
        this.canvasLayers[1] = this.bgCanvas;
        this.canvasLayers[2] = this.cursorCanvas;
        this.canvasLayers[3] = this.markerCanvas;
    }
    get playFramePosition() {
        return this._playFramePosition;
    }
    set playFramePosition(playFramePosition) {
        this._playFramePosition = playFramePosition;
        // this.redraw();
        this.drawPlayPosition();
    }
    canvasMousePos(c, e) {
        const cr = c.getBoundingClientRect();
        const x = e.x - cr.left;
        const y = e.y - cr.top;
        return new Point(x, y);
    }
    drawStateText(stateText) {
        if (stateText) {
            const g = this.sonagramCanvas.getContext("2d");
            const w = this.sonagramCanvas.width;
            const h = this.sonagramCanvas.height;
            if (g && w && h) {
                g.strokeStyle = 'black';
                g.fillStyle = 'black';
                g.font = '20px sans-serif';
                g.fillText(stateText, 10, 25);
            }
        }
    }
    drawCursorPosition(e, show) {
        if (this.cursorCanvas) {
            const w = this.cursorCanvas.width;
            const h = this.cursorCanvas.height;
            const g = this.cursorCanvas.getContext('2d');
            if (g) {
                g.clearRect(0, 0, w, h);
                if (show) {
                    //const pp = this.canvasMousePos(this.cursorCanvas, e);
                    let xViewPortPixelpos = e.offsetX;
                    g.fillStyle = 'yellow';
                    g.strokeStyle = 'yellow';
                    g.beginPath();
                    g.moveTo(xViewPortPixelpos, 0);
                    g.lineTo(xViewPortPixelpos, h);
                    g.closePath();
                    g.stroke();
                    if (this._audioDataHolder) {
                        let framePosRound = this.viewPortXPixelToFramePosition(xViewPortPixelpos);
                        if (framePosRound != null) {
                            g.font = '14px sans-serif';
                            g.fillStyle = 'yellow';
                            g.fillText(framePosRound.toString(), xViewPortPixelpos + 2, 50);
                        }
                    }
                }
            }
        }
    }
    drawPlayPosition() {
        if (this.markerCanvas) {
            const w = this.markerCanvas.width;
            const h = this.markerCanvas.height;
            const g = this.markerCanvas.getContext("2d");
            if (g) {
                g.clearRect(0, 0, w, h);
                if (this._playFramePosition != null) {
                    let pixelPos = this.frameToViewPortXPixelPosition(this._playFramePosition);
                    if (pixelPos) {
                        g.fillStyle = 'red';
                        g.strokeStyle = 'red';
                        g.beginPath();
                        g.moveTo(pixelPos, 0);
                        g.lineTo(pixelPos, h);
                        g.closePath();
                        g.stroke();
                    }
                }
            }
        }
    }
    /*
     *  Method used as worker code.
     */
    workerFunction() {
        // Redefine some DSP classes for worker function
        // See e.g. audio.math.Complex
        class Complex {
            static fromPolarForm(magnitude, argument) {
                const r = Math.cos(argument) * magnitude;
                const i = Math.sin(argument) * magnitude;
                return new Complex(r, i);
            }
            constructor(real, img) {
                this.real = real;
                this.img = img;
            }
            magnitude() {
                return Math.sqrt((this.real * this.real) + (this.img * this.img));
            }
            argument() {
                return Math.atan2(this.img, this.real);
            }
            add(addC) {
                return new Complex(this.real + addC.real, this.img + addC.img);
            }
            sub(subC) {
                return new Complex(this.real - subC.real, this.img - subC.img);
            }
            mult(multC) {
                const multR = (this.real * multC.real) - (this.img * multC.img);
                const multI = (this.real * multC.img) + (multC.real * this.img);
                return new Complex(multR, multI);
            }
            multReal(multF) {
                return new Complex(this.real * multF, this.img * multF);
            }
            div(divisor) {
                const divReal = divisor.real;
                const divImg = divisor.img;
                const div = (divReal * divReal) + (divImg * divImg);
                const divisionReal = ((this.real * divReal) + (this.img * divImg)) / div;
                const divisionImg = ((divReal * this.img) - (this.real * divImg)) / div;
                return new Complex(divisionReal, divisionImg);
            }
            divReal(divisor) {
                const div = divisor * divisor;
                const divsionReal = (this.real * divisor) / div;
                const divsionImg = (divisor * this.img) / div;
                return new Complex(divsionReal, divsionImg);
            }
            conjugate() {
                return new Complex(this.real, -this.img);
            }
            equals(c) {
                if (c === null) {
                    return false;
                }
                return (this.real === c.real && this.img === c.img);
            }
            toString() {
                return 'Real: ' + this.real + ', Img: ' + this.img;
            }
        }
        class DFTFloat32 {
            constructor(n) {
                this.n = n;
                this.m = Math.log(n) / Math.log(2);
                // if(n != (1 << m))throw new RuntimeException("length N must be power of 2");
                // lookup tables
                this.cosLookup = new Float32Array(n / 2);
                this.sinLookup = new Float32Array(n / 2);
                for (let i = 0; i < n / 2; i++) {
                    const arc = (-2 * Math.PI * i) / n;
                    this.cosLookup[i] = Math.cos(arc);
                    this.sinLookup[i] = Math.sin(arc);
                }
            }
            processReal(srcBuf) {
                const x = srcBuf.slice();
                const y = new Float32Array(srcBuf.length);
                for (let yi = 0; yi < y.length; yi++) {
                    y[yi] = 0.0;
                }
                this.fftCooleyTukey(x, y);
                const rc = new Array(x.length);
                for (let i = 0; i < x.length; i++) {
                    rc[i] = new Complex(x[i], y[i]);
                }
                return rc;
            }
            processRealMagnitude(srcBuf) {
                const x = srcBuf.slice();
                const y = new Float32Array(srcBuf.length);
                for (let yi = 0; yi < y.length; yi++) {
                    y[yi] = 0.0;
                }
                this.fftCooleyTukey(x, y);
                const rc = new Float32Array(x.length);
                for (let i = 0; i < x.length; i++) {
                    const rcc = new Complex(x[i], y[i]);
                    rc[i] = rcc.magnitude();
                }
                return rc;
            }
            fftCooleyTukey(real, img) {
                let i;
                let j = 0;
                let k;
                let n1;
                let n2 = this.n / 2;
                let a;
                let c;
                let s;
                let t1;
                let t2;
                for (i = 1; i < this.n - 1; i++) {
                    n1 = n2;
                    while (j >= n1) {
                        j = j - n1;
                        n1 = n1 / 2;
                    }
                    j = j + n1;
                    if (i < j) {
                        t1 = real[i];
                        real[i] = real[j];
                        real[j] = t1;
                        t1 = img[i];
                        img[i] = img[j];
                        img[j] = t1;
                    }
                }
                n1 = 0;
                n2 = 1;
                for (i = 0; i < this.m; i++) {
                    n1 = n2;
                    n2 = n2 + n2;
                    a = 0;
                    for (j = 0; j < n1; j++) {
                        c = this.cosLookup[a];
                        s = this.sinLookup[a];
                        a += (1 << (this.m - i - 1));
                        for (k = j; k < this.n; k = k + n2) {
                            t1 = c * real[k + n1] - s * img[k + n1];
                            t2 = s * real[k + n1] + c * img[k + n1];
                            real[k + n1] = real[k] - t1;
                            img[k + n1] = img[k] - t2;
                            real[k] = real[k] + t1;
                            img[k] = img[k] + t2;
                        }
                    }
                }
            }
            process(t) {
                const reals = new Float32Array(this.n);
                const imgs = new Float32Array(this.n);
                const trans = new Array(this.n);
                for (let i = 0; i < this.n; i++) {
                    reals[i] = t[i].real;
                    imgs[i] = t[i].img;
                }
                this.fftCooleyTukey(reals, imgs);
                for (let i = 0; i < this.n; i++) {
                    trans[i] = new Complex(reals[i], imgs[i]);
                }
                return trans;
            }
        }
        class GaussianWindow {
            static { this.DEFAULT_SIGMA = 0.3; }
            constructor(size, sigma = GaussianWindow.DEFAULT_SIGMA) {
                this.buf = new Float32Array(size);
                const center = (size - 1) / 2;
                for (let i = 0; i < size; i++) {
                    const quot = (i - center) / (sigma * center);
                    const exp = -0.5 * quot * quot;
                    this.buf[i] = Math.exp(exp);
                }
            }
            getScale(i) {
                return this.buf[i];
            }
        }
        self.onmessage = function (msg) {
            //console.debug("Sonagram render thread");
            let l = msg.data.l;
            let w = msg.data.w;
            let h = msg.data.h;
            let vw = msg.data.vw;
            let chs = msg.data.chs;
            let audioDataOffset = 0;
            let adOffset = msg.data.audioDataOffset;
            if (adOffset) {
                audioDataOffset = adOffset;
            }
            let maxPsd = null;
            if (msg.data.maxPsd !== undefined) {
                maxPsd = msg.data.maxPsd;
            }
            let audioData = new Array(chs);
            for (let ch = 0; ch < chs; ch++) {
                audioData[ch] = new Float32Array(msg.data['audioData'][ch]);
            }
            let frameLength = msg.data.frameLength;
            let dftSize = msg.data.dftSize;
            let dftBands = dftSize / 2;
            let dft = new DFTFloat32(dftSize);
            let wf = new GaussianWindow(dftSize);
            let arrSize = w * h * 4;
            if (arrSize < 0) {
                arrSize = 0;
            }
            let imgData = new Uint8ClampedArray(arrSize);
            //console.log("Render method:");
            //console.debug("Created imgData arrSize: "+arrSize+" ", w, "x", h);
            let calcMaxPsd = -Infinity;
            if (arrSize > 0) {
                let chH = Math.round(h / chs);
                let framesPerPixel = frameLength / vw;
                //console.debug("Render: ", w, "x", h);
                let b = new Float32Array(dftSize);
                let sona = new Array(chs);
                for (let ch = 0; ch < chs; ch++) {
                    let chDataLen = audioData[ch].length;
                    // initialize DFT array buffer
                    sona[ch] = new Array(w);
                    let framePos = 0;
                    for (let pii = 0; pii < w; pii++) {
                        let virtPii = l + pii;
                        // Position of sample data frame is pixel position mapped to audio frame position.
                        // Then "center" the frame by shifting left by half the DFT size (=dftBands)
                        framePos = Math.round((virtPii * framesPerPixel) - dftBands);
                        // fill DFT buffer with windowed sample values
                        for (let i = 0; i < dftSize; i++) {
                            let samplePos = framePos + i;
                            // initialize for negative sample positions and out of bounds positions
                            let chDat = 0;
                            // Set audio sample if available
                            let adp = samplePos - audioDataOffset;
                            if (adp >= 0 && adp < chDataLen) {
                                chDat = audioData[ch][adp];
                                //console.debug("Audio data: "+chDat);
                            }
                            else {
                                //console.debug("Sample buf pos oob: adp: "+adp+", chDataLen: "+chDataLen+", samplePos: "+samplePos+", i: "+i);
                            }
                            // apply Window
                            b[i] = chDat * wf.getScale(i);
                        }
                        // Calc DFT magnitudes
                        let spectr = dft.processRealMagnitude(b);
                        // Get maximum value of spectral energy
                        for (let s = 0; s < dftBands; s++) {
                            let psd = (2 * Math.pow(spectr[s], 2)) / dftBands;
                            if (psd > calcMaxPsd) {
                                calcMaxPsd = psd;
                            }
                        }
                        // Set render model data for this pixel
                        sona[ch][pii] = spectr;
                    }
                }
                if (!msg.data.norender) {
                    if (!maxPsd) {
                        maxPsd = calcMaxPsd;
                    }
                    for (let ch = 0; ch < chs; ch++) {
                        for (let pii = 0; pii < w; pii++) {
                            let allBlack = true;
                            for (let y = 0; y < chH; y++) {
                                let freqIdx = Math.round(y * dftBands / chH);
                                // calculate the one-sided power spectral density PSD (f, t) in Pa2/Hz
                                // PSD(f) proportional to 2|X(f)|2 / (t2 - t1)
                                let val = sona[ch][pii][freqIdx];
                                let psd = (2 * Math.pow(val, 2)) / dftBands;
                                // Calculate logarithmic value
                                //let psdLog = ips.dsp.DSPUtils.toLevelInDB(psd / maxPsd);
                                let linearLevel = psd / maxPsd;
                                let psdLog = 10 * Math.log(linearLevel) / Math.log(10);
                                // Fixed dynamic Range value of 70dB for now
                                let dynRangeInDb = 70;
                                let scaledVal = (psdLog + dynRangeInDb) / dynRangeInDb;
                                // are the following checks necessary for clamped array ?
                                if (scaledVal > 1.0)
                                    scaledVal = 1;
                                if (scaledVal < 0.0) {
                                    scaledVal = 0;
                                }
                                let rgbVal = Math.round(255 * scaledVal);
                                if (rgbVal < 0) {
                                    //							System.out.println("Neg RGB val: "+rgbVal);
                                    rgbVal = 0;
                                }
                                if (rgbVal > 255) {
                                    rgbVal = 255;
                                }
                                rgbVal = 255 - rgbVal;
                                if (rgbVal > 0) {
                                    allBlack = false;
                                }
                                let py = chH - y;
                                let dataPos = ((((ch * chH) + py) * w) + pii) * 4;
                                imgData[dataPos + 0] = rgbVal; //R
                                imgData[dataPos + 1] = rgbVal; //G
                                imgData[dataPos + 2] = rgbVal; //B
                                imgData[dataPos + 3] = 255; //A (alpha: fully opaque)
                                //console.debug("Rendered: py: "+py+", rgbval: "+rgbVal);
                                // example 1x1, 2chs
                                //  ch0x0y0R,ch0x0y0G,ch0x0y0B,ch0x0y0A,
                                //  ch0x1y0R,ch0x1y0G,ch0x1y0B,ch0x1y0A,
                                //  ch0x0y0R,ch0x0y0G,ch0x0y0B,ch0x0y0A,
                                //  ch0x1y1R,ch0x1y1G,ch0x1y1B,ch0x1y1A,
                                //  ch1x0y0R,ch1x0y0G,ch1x0y0B,ch1x0y0A,
                                //  ch1x1y0R,ch1x1y0G,ch1x1y0B,ch1x1y0A,
                                //  ch1x0y0R,ch1x0y0G,ch1x0y0B,ch1x0y0A,
                                //  ch1x1y1R,ch1x1y1G,ch1x1y1B,ch1x1y1A
                            }
                            // if (allBlack) {
                            //   console.log("Black: ", pii, " ", ch);
                            // }
                        }
                    }
                }
            }
            //console.debug("Render thread post message imgData: "+imgData.length)
            postMessage({ imgData: imgData, l: l, w: msg.data.w, h: msg.data.h, vw: vw, maxPsd: calcMaxPsd, terminate: msg.data.terminate }, [imgData.buffer]);
        };
    }
    startDraw(clear = true) {
        if (clear) {
            if (this.bounds) {
                this.sonagramCanvas.style.left = Math.round(this.bounds.position.left).toString() + 'px';
                let intW = Math.round(this.bounds.dimension.width);
                let intH = Math.round(this.bounds.dimension.height);
                this.sonagramCanvas.width = intW;
                this.sonagramCanvas.height = intH;
                let g = this.sonagramCanvas.getContext("2d");
                if (g) {
                    //g.clearRect(0, 0,w, h);
                    g.fillStyle = "white";
                    g.fillRect(0, 0, intW, intH);
                }
            }
        }
        this.startRender();
        this.drawCursorLayer();
    }
    startRender() {
        //console.debug("Sonagram start render...");
        if (this.worker) {
            this.worker.terminate();
            this.worker = null;
        }
        if (this.raAsSubsc) {
            this.raAsSubsc.unsubscribe();
        }
        if (this._audioDataHolder) {
            this._audioDataHolder.addOnReadyListener(() => {
                if (this._audioDataHolder && this.bounds && this.bounds.dimension) {
                    let w = Math.round(this.bounds.dimension.width);
                    let h = Math.round(this.bounds.dimension.height);
                    let vw = Math.round(this.virtualDimension.width);
                    if (w > 0 && h > 0 && vw > 0) {
                        this.worker = new Worker(this.workerURL);
                        //this.wo = new Worker('./worker/sonagram.worker', { type: `module` });
                        let chs = this._audioDataHolder.numberOfChannels;
                        let vw = Math.round(this.virtualDimension.width);
                        let frameLength = this._audioDataHolder.frameLen;
                        let framesPerPixel = Math.ceil(frameLength / vw);
                        let leftPos = Math.round(this.bounds.position.left);
                        let renderPos = leftPos;
                        let raAs = this._audioDataHolder.randomAccessAudioStream();
                        let audioBuffer = null;
                        let audioSource = this._audioDataHolder.audioSource;
                        if (audioSource instanceof AudioBufferSource) {
                            audioBuffer = audioSource.audioBuffer;
                        }
                        //let arrayAudioBuffer=this._audioDataHolder.arrayBuffer;
                        let arrAbBuf;
                        let ada = new Array(chs);
                        // for(let ch=0;ch<chs;ch++) {
                        //   ada[ch] = new Float32Array(this.dftSize);
                        // }
                        let imgData;
                        let maxPsd = -Infinity;
                        let norender = true;
                        if (this.worker) {
                            this.worker.onmessage = (me) => {
                                if (true === me.data.terminate) {
                                    let drawImgData;
                                    if (imgData) {
                                        drawImgData = imgData;
                                    }
                                    else {
                                        drawImgData = me.data.imgData;
                                    }
                                    this.drawRendered(w, h, drawImgData);
                                    if (this.worker) {
                                        this.worker.terminate();
                                    }
                                    this.worker = null;
                                    raAs.close();
                                }
                                else {
                                    // set rendered vertical values of one pixel of timescale
                                    //let dataPos = renderPos * h * 4;
                                    if (norender) {
                                        if (me.data.maxPsd > maxPsd) {
                                            maxPsd = me.data.maxPsd;
                                            //console.debug("new maxPsd: "+maxPsd);
                                        }
                                    }
                                    else {
                                        let chH = Math.round(h / chs);
                                        let idp = me.data.l - leftPos;
                                        for (let ch = 0; ch < chs; ch++) {
                                            for (let y = 0; y < chH; y++) {
                                                let py = chH - y;
                                                let dataPos = ((((ch * chH) + py) * w) + idp) * 4;
                                                let mePos = ((ch * chH) + py) * 4;
                                                //let lastPos = dataPos + me.data.imgData.length;
                                                //if (lastPos < imgData.length) {
                                                // set one pixel
                                                imgData[dataPos] = me.data.imgData[mePos];
                                                imgData[dataPos + 1] = me.data.imgData[mePos + 1];
                                                imgData[dataPos + 2] = me.data.imgData[mePos + 2];
                                                imgData[dataPos + 3] = me.data.imgData[mePos + 3];
                                                //} else {
                                                //console.error("Out of range: " + dataPos + "+" + me.data.imgData.length + ">=" + imgData.length);
                                                // }
                                            }
                                        }
                                    }
                                    if (this._audioDataHolder && arrAbBuf && this.worker) {
                                        // proceed with next pixel
                                        renderPos++;
                                        //console.debug("Render pos: "+renderPos);
                                        let terminate = false;
                                        let windowEnd = renderPos >= leftPos + w;
                                        if (windowEnd) {
                                            if (norender) {
                                                // phase two: rendering
                                                norender = false;
                                                // start from beginning
                                                renderPos = leftPos;
                                                //console.debug("now rendering: maxPsd: "+maxPsd);
                                            }
                                            else {
                                                // terminate render phase
                                                terminate = true;
                                            }
                                        }
                                        let leftFramePos = Math.floor(frameLength * renderPos / vw) - this.dftSize / 2;
                                        if (leftFramePos < 0) {
                                            leftFramePos = 0;
                                        }
                                        //let ada = new Array<ArrayBuffer>(chs);
                                        //console.debug("Render pos: "+renderPos+" leftFramePos: "+leftFramePos);
                                        if (!terminate) {
                                            if (this._audioDataHolder) {
                                                //let read = this._audioDataHolder.frames(leftFramePos, this.dftSize, arrAbBuf);
                                                this.raAsSubsc = raAs.framesObs(leftFramePos, this.dftSize, arrAbBuf).subscribe({
                                                    next: (read) => {
                                                        if (arrAbBuf && this.worker) {
                                                            if (read < this.dftSize) {
                                                                // zero padding
                                                                for (let ch = 0; ch < chs; ch++) {
                                                                    for (let zp = read; zp < this.dftSize; zp++) {
                                                                        arrAbBuf[ch][zp] = 0;
                                                                    }
                                                                }
                                                            }
                                                            for (let ch = 0; ch < chs; ch++) {
                                                                // Need a copy here for the worker, otherwise this.audioData is not accessible after posting to the worker
                                                                //ada[ch] = arrAbBuf[ch].buffer.slice(0);
                                                                const arrAbBufCh = arrAbBuf[ch];
                                                                const adLen = arrAbBufCh.buffer.byteLength;
                                                                if (!ada[ch] || ada[ch].byteLength !== adLen) {
                                                                    ada[ch] = new ArrayBuffer(adLen);
                                                                }
                                                                let fAdaCh = new Float32Array(ada[ch]);
                                                                fAdaCh.set(arrAbBuf[ch]);
                                                            }
                                                            this.worker.postMessage({
                                                                audioData: ada,
                                                                audioDataOffset: leftFramePos,
                                                                l: renderPos,
                                                                w: me.data.w,
                                                                h: h,
                                                                vw: vw,
                                                                chs: chs,
                                                                frameLength: frameLength,
                                                                dftSize: this.dftSize,
                                                                maxPsd: maxPsd,
                                                                norender: norender,
                                                                terminate: terminate
                                                            }, ada);
                                                        }
                                                    },
                                                    error: (err) => {
                                                        console.error("Sonagram: Error reading audio data: " + err);
                                                    }
                                                });
                                            }
                                        }
                                        else {
                                            for (let ch = 0; ch < chs; ch++) {
                                                ada[ch] = new ArrayBuffer(0);
                                            }
                                            this.worker.postMessage({
                                                audioData: ada,
                                                audioDataOffset: leftFramePos,
                                                l: renderPos,
                                                w: me.data.w,
                                                h: h,
                                                vw: vw,
                                                chs: chs,
                                                frameLength: frameLength,
                                                dftSize: this.dftSize,
                                                maxPsd: maxPsd,
                                                norender: norender,
                                                terminate: terminate
                                            }, ada);
                                        }
                                    }
                                }
                            };
                        }
                        if (audioBuffer && audioBuffer.length * audioBuffer.numberOfChannels < AudioCanvasLayerComponent.ENABLE_STREAMING_NUMBER_OF_SAMPLES_THRESHOLD) {
                            let ada = new Array(chs);
                            for (let ch = 0; ch < chs; ch++) {
                                // Need a copy here for the worker, otherwise this.audioData is not accessible after posting to the worker
                                ada[ch] = audioBuffer.getChannelData(ch).buffer.slice(0);
                            }
                            //let start = Date.now();
                            if (this.markerCanvas) {
                                let g = this.markerCanvas.getContext("2d");
                                if (g) {
                                    g.fillText("Rendering...", 10, 20);
                                }
                            }
                            this.worker.postMessage({
                                audioData: ada,
                                l: leftPos,
                                w: w,
                                h: h,
                                vw: Math.round(this.virtualDimension.width),
                                chs: chs,
                                frameLength: frameLength,
                                dftSize: this.dftSize,
                                terminate: true
                            }, ada);
                        }
                        else {
                            if (w > 0) {
                                if (framesPerPixel > 0) {
                                    let arrSize = w * h * 4;
                                    if (arrSize < 0) {
                                        arrSize = 0;
                                    }
                                    imgData = new Uint8ClampedArray(arrSize);
                                    let rw = 1;
                                    arrAbBuf = new Array(chs);
                                    for (let ch = 0; ch < chs; ch++) {
                                        arrAbBuf[ch] = new Float32Array(this.dftSize);
                                    }
                                    let leftFramePos = Math.floor(frameLength * renderPos / vw) - this.dftSize / 2;
                                    let framesToRead = this.dftSize;
                                    if (leftFramePos < 0) {
                                        leftFramePos = 0;
                                    }
                                    this.drawStateText('Loading/Rendering...');
                                    this.raAsSubsc = raAs.framesObs(leftFramePos, framesToRead, arrAbBuf).subscribe({
                                        next: (read) => {
                                            if (arrAbBuf && this.worker) {
                                                if (read < this.dftSize) {
                                                    // zero padding
                                                    for (let ch = 0; ch < chs; ch++) {
                                                        for (let zp = read; zp < this.dftSize; zp++) {
                                                            arrAbBuf[ch][zp] = 0;
                                                        }
                                                    }
                                                }
                                                for (let ch = 0; ch < chs; ch++) {
                                                    const arrAbBufCh = arrAbBuf[ch];
                                                    const adLen = arrAbBufCh.buffer.byteLength;
                                                    if (!ada[ch] || ada[ch].byteLength !== adLen) {
                                                        ada[ch] = new ArrayBuffer(adLen);
                                                    }
                                                    let fAdaCh = new Float32Array(ada[ch]);
                                                    fAdaCh.set(arrAbBuf[ch]);
                                                }
                                                this.worker.postMessage({
                                                    l: renderPos,
                                                    w: rw,
                                                    h: h,
                                                    vw: vw,
                                                    chs: chs,
                                                    frameLength: frameLength,
                                                    audioData: ada,
                                                    audioDataOffset: leftFramePos,
                                                    dftSize: this.dftSize,
                                                    norender: norender,
                                                    terminate: false
                                                }, ada);
                                            }
                                        },
                                        error: (err) => {
                                            console.error("Sonagram: Error reading audio data: " + err);
                                        }
                                    });
                                }
                            }
                        }
                    }
                }
            });
        }
        else {
            if (this.bounds && this.bounds.dimension) {
                let w = Math.round(this.bounds.dimension.width);
                let h = Math.round(this.bounds.dimension.height);
                let g = this.sonagramCanvas.getContext("2d");
                if (g) {
                    g.clearRect(0, 0, w, h);
                }
            }
        }
    }
    drawRendered(w, h, imgData) {
        if (this.sonagramCanvas) {
            this.sonagramCanvas.width = w;
            this.sonagramCanvas.height = h;
            let g = this.sonagramCanvas.getContext("2d");
            if (g) {
                if (w > 0 && h > 0) {
                    let gImgData = g.createImageData(w, h);
                    gImgData.data.set(imgData);
                    g.putImageData(gImgData, 0, 0);
                }
            }
        }
        this.drawBg();
        this.drawPlayPosition();
    }
    //     // synchronous draw (not used anymore)
    //   redraw() {
    //
    //     let g = this.sonagramCanvas.getContext("2d");
    //
    //     let w = this.sonagramCanvas.width;
    //     let h = this.sonagramCanvas.height;
    //     if (g) {
    //       g.clearRect(0, 0, w, h);
    //       g.fillStyle = "white";
    //       g.fillRect(0, 0, w, h);
    //       if (this._audioDataHolder) {
    //         let spectSize = Math.floor(this.dftSize / 2)
    //         let chs = this._audioDataHolder.numberOfChannels;
    //         let chH = h / chs;
    //
    //         let frameLength = this._audioDataHolder.frameLen;
    //
    //         let framesPerPixel = frameLength / w;
    //         let y = 0;
    //         let audioBuffer:AudioBuffer|null=null;
    //         let audioSource=this._audioDataHolder.audioSource;
    //         if(audioSource instanceof AudioBufferSource){
    //           audioBuffer=audioSource.audioBuffer;
    //         }
    //
    //         if(audioBuffer) {
    //           let b = new Float32Array(this.dftSize)
    //
    //           let sona = new Array<Array<Float32Array>>(chs);
    //           let max = 0;
    //           let maxPsd = -Infinity;
    //           for (let ch = 0; ch < chs; ch++) {
    //             let x = 0;
    //             sona[ch] = new Array<Float32Array>(w);
    //
    //             let chData = audioBuffer.getChannelData(ch);
    //             // TODO center buffer
    //
    //             let framePos = 0;
    //             for (let pii = 0; pii < w; pii++) {
    //               framePos = Math.round(pii * framesPerPixel);
    //               // calculate DFT at pixel position
    //               for (let i = 0; i < this.dftSize; i++) {
    //                 let chDat = chData[framePos + i];
    //                 b[i] = chDat;
    //               }
    //               let spectr = this.dft.processRealMagnitude(b);
    //               sona[ch][pii] = spectr;
    //               // @ts-ignore
    //               let pMax = Math.max.apply(null, spectr);
    //               if (pMax > max) {
    //                 max = pMax;
    //               }
    //
    //               for (let s = 0; s < spectSize; s++) {
    //                 let psd = (2 * Math.pow(spectr[s], 2)) / spectSize;
    //                 if (psd > maxPsd) {
    //                   maxPsd = psd;
    //                 }
    //               }
    //             }
    //           }
    //           //console.log("max: ", max);
    //           maxPsd = (2 * Math.pow(max, 2)) / spectSize;
    //           for (let ch = 0; ch < chs; ch++) {
    //
    //             let framePos = 0;
    //             for (let pii = 0; pii < w; pii++) {
    //               framePos = pii * framesPerPixel;
    //
    //               for (let y = 0; y < h; y++) {
    //                 let freqIdx = Math.round(y * spectSize / h);
    //
    //                 // calculate the one sided power spectral density PSD (f, t) in Pa2/Hz
    //                 // PSD(f) proportional to 2|X(f)|2 / (t2 - t1)
    //                 let val = sona[ch][pii][freqIdx];
    //                 let psd = (2 * Math.pow(val, 2)) / spectSize;
    //
    //                 // Calculate logarithmic
    //                 let psdLog = DSPUtils.toLevelInDB(psd / maxPsd);
    //                 let dynRangeInDb = 70;
    //                 let scaledVal = (psdLog + dynRangeInDb) / dynRangeInDb;
    //
    //                 if (scaledVal > 1)
    //                   scaledVal = 1;
    //                 if (scaledVal < 0) {
    //                   scaledVal = 0;
    //                 }
    //                 let rgbVal = (255 * scaledVal);
    //                 if (rgbVal < 0) {
    // //							System.out.println("Neg RGB val: "+rgbVal);
    //                   rgbVal = 0;
    //                 }
    //                 if (rgbVal > 255) {
    //                   rgbVal = 255;
    //                 }
    //                 rgbVal = 255 - rgbVal;
    //                 let colorStr = CSSUtils.toColorString(rgbVal, rgbVal, rgbVal);
    //                 g.fillStyle = colorStr;
    //                 g.fillRect(pii, chH - y, 1, 1);
    //               }
    //             }
    //           }
    //           this.drawPlayPosition();
    //         }else{
    //           throw Error("Redraw only supported with audio buffer.")
    //         }
    //       }
    //     }
    //   }
    //
    setData(audioData) {
        this._audioDataHolder = audioData;
        this.playFramePosition = 0;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.12", ngImport: i0, type: Sonagram, deps: [{ token: i0.ElementRef }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "18.2.12", type: Sonagram, selector: "audio-sonagram", viewQueries: [{ propertyName: "sonagramCanvasRef", first: true, predicate: ["sonagram"], descendants: true, static: true }, { propertyName: "markerCanvasRef", first: true, predicate: ["marker"], descendants: true, static: true }], usesInheritance: true, ngImport: i0, template: `
        <canvas #sonagram height="10"></canvas>
        <canvas #bg height="10"></canvas>
        <canvas #cursor height="10" (mousedown)="selectionStart($event)" (mouseover)="updateCursorCanvas($event)" (mousemove)="updateCursorCanvas($event)"
                (mouseleave)="updateCursorCanvas($event, false)"></canvas>
        <canvas #marker height="10"></canvas>`, isInline: true, styles: [":host{min-height:0px}\n", "canvas{top:0;left:0;width:0;height:0;min-height:0px;position:absolute}\n"] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.12", ngImport: i0, type: Sonagram, decorators: [{
            type: Component,
            args: [{ selector: 'audio-sonagram', template: `
        <canvas #sonagram height="10"></canvas>
        <canvas #bg height="10"></canvas>
        <canvas #cursor height="10" (mousedown)="selectionStart($event)" (mouseover)="updateCursorCanvas($event)" (mousemove)="updateCursorCanvas($event)"
                (mouseleave)="updateCursorCanvas($event, false)"></canvas>
        <canvas #marker height="10"></canvas>`, styles: [":host{min-height:0px}\n", "canvas{top:0;left:0;width:0;height:0;min-height:0px;position:absolute}\n"] }]
        }], ctorParameters: () => [{ type: i0.ElementRef }], propDecorators: { sonagramCanvasRef: [{
                type: ViewChild,
                args: ['sonagram', { static: true }]
            }], markerCanvasRef: [{
                type: ViewChild,
                args: ['marker', { static: true }]
            }] } });

/*
  ResizeObserver not yet available in official Typescript declaration
  Crreated declaration from IDL until its available.
  See specs:
  https://www.w3.org/TR/resize-observer

 */
// interface ResizeObserverSize {
//   readonly inlineSize:number;
//   readonly blockSize:number;
// }
//
// declare interface ResizeObserverEntry{
//   readonly target: Element;
//   readonly contentRect: DOMRectReadOnly ;
//   readonly borderBoxSize: Array<ResizeObserverSize> ;
//   readonly contentBoxSize: Array<ResizeObserverSize> ;
//   readonly devicePixelContentBoxSize: Array<ResizeObserverSize> ;
// }
//
// declare interface ResizeObserverCallback {
//   (entries: Array<ResizeObserverEntry>, observer: ResizeObserver):void;
// }
//
// declare enum ResizeObserverBoxOptions {
//   "border-box", "content-box", "device-pixel-content-box"
// };
// // Declare Resizeobserver
// declare class ResizeObserver{
//   constructor(callback: ResizeObserverCallback);
//   observe: (el:Element,opts: ResizeObserverBoxOptions | null)=>void;
//   unobserve: (el:Element)=>void;
//   disconnect: ()=>void;
// }
/*
 * Container component for audio display.
 * The display elements are children of a virtual canvas. The virtual canvas makes it possible to have high zoom factors with very wide virtual audio displays.
 * Only the visible part of the virtual canvas is implemented as a browser canvas and therefore consuming memory.
 * The visible part has the same width as the viewport of the scroll pane parent.
 * The virtual canvas itself is implemented as an HTML div element.
 * The layout of the component is updated on resize of the parent or changes of the zoom factor.
 */
class AudioClipUIContainer extends BasicAudioCanvasLayerComponent {
    static { this.DIVIDER_PIXEL_SIZE = 10; }
    get xZoom() {
        return this._xZoom;
    }
    set xZoom(value) {
        this.userAction = true;
        this._xZoom = value;
        this.layout();
        this.userAction = false;
    }
    set fixFitToPanel(value) {
        this._fixFitToPanel = value;
        if (value) {
            // we don't need  clip bounds
            this.bounds = null;
            this._xZoom = null;
        }
        else {
            // hold current zoom value
            //this._xZoom=this.ce.offsetWidth/this._audioData.duration;
        }
        this.layout();
    }
    constructor(ref) {
        super();
        this.ref = ref;
        this._audioClip = null;
        this.pointer = null;
        this.selecting = null;
        this.selection = null;
        this.selectionEventEmitter = new EventEmitter();
        this._playFramePosition = null;
        this.dragStartMouseY = null;
        this.dragStartY = null;
        this.dividerPosition = 0.5;
        this.userAction = false;
        this._xZoom = null; // pixels per second
        // if true the complete audio file is shown, the display fits to the visible panel, the x-zoom factor is variable, this is the default
        this._fixFitToPanel = true;
        this.parentE = this.ref.nativeElement;
    }
    ngOnInit() {
        this.ce = this.ceRef.nativeElement;
        this.dc = this.canvasRef.nativeElement;
    }
    ngAfterViewInit() {
        this.layout();
        const heightListener = new MutationObserver((mrs, mo) => {
            let layout = false;
            mrs.forEach((mr) => {
                if (!this.userAction && 'attributes' === mr.type && ('class' === mr.attributeName || 'style' === mr.attributeName)) {
                    layout = true;
                }
            });
            if (layout) {
                // re-layout required
                this.layout(false);
            }
        });
        heightListener.observe(this.ce, { attributes: true, childList: true, characterData: true });
        heightListener.observe(this.dc, { attributes: true, childList: true, characterData: true });
        const resizeObserver = new ResizeObserver((entries, obs) => {
            //console.log("Resize observed:");
            entries.forEach((e) => {
                //console.log(e.contentRect.width+"x"+e.contentRect.height);
                this.layout();
            });
        });
        resizeObserver.observe(this.ce);
    }
    onResize(event) {
        this.layout();
    }
    mouseover(me) {
        this.dividerCursorPosition(me, true);
    }
    mouseleave(me) {
        this.dividerCursorPosition(me, false);
    }
    mousedown(me) {
        this.dragStartMouseY = me.clientY;
        this.dragStartY = this.dc.offsetTop;
        this.dragStartMouseY = me.clientY;
    }
    onMouseup(me) {
        if (this.dragStartY != null) {
            this.userAction = true;
            this.dividerDrag(me);
            this.layout(false);
            this.dragStartY = null;
            this.userAction = false;
        }
    }
    onMousemove(me) {
        if (this.dragStartY != null) {
            this.userAction = true;
            this.dividerDrag(me);
            this.layoutScaled();
            this.userAction = true;
        }
    }
    pointerPositionChanged(pp) {
        this.pointer = pp;
    }
    selectingChanged(s) {
        this.selecting = s;
    }
    selectionChanged(s) {
        this.selection = s;
        if (this._audioClip) {
            this._audioClip.selection = s;
        }
        this.selectionEventEmitter.emit(this.selection);
    }
    canvasMousePos(c, e) {
        const cr = c.getBoundingClientRect();
        const x = e.x - cr.left;
        const y = e.y - cr.top;
        return new Point(x, y);
    }
    dividerCursorPosition(e, show) {
        if (this.dc) {
            this.canvasMousePos(this.dc, e);
        }
    }
    dividerDrag(e) {
        if (this.dc && this.dragStartMouseY && this.dragStartY) {
            const dragOffset = e.clientY - this.dragStartMouseY;
            const ceHeight = this.ce.offsetHeight;
            let newTop = (this.dragStartY + dragOffset);
            if (newTop < 0) {
                newTop = 0;
            }
            if (newTop > ceHeight - AudioClipUIContainer.DIVIDER_PIXEL_SIZE) {
                newTop = ceHeight - AudioClipUIContainer.DIVIDER_PIXEL_SIZE;
            }
            this.dc.style.top = newTop.toString() + 'px';
            this.dividerPosition = (this.dc.offsetTop + AudioClipUIContainer.DIVIDER_PIXEL_SIZE / 2) / ceHeight;
            if (this.dividerPosition > 1.0) {
                this.dividerPosition = 1.0;
            }
            if (this.dividerPosition < 0.0) {
                this.dividerPosition = 0.0;
            }
            this.drawDivider();
        }
    }
    drawDivider() {
        const w = this.dc.width;
        const h = this.dc.height;
        const g = this.dc.getContext('2d');
        if (g && w > 10 && h >= 1) {
            g.fillStyle = 'white';
            g.fillRect(0, 0, w, h);
            g.fillStyle = 'black';
            g.fillRect(5, 5, w - 10, 1);
        }
    }
    clipBounds(clipBounds) {
        this.bounds = clipBounds;
        this.layout();
    }
    currentXZoom() {
        let xz = this._xZoom;
        if (xz == null && this._audioDataHolder) {
            let ow = this.ce.offsetWidth;
            if (ow < 1) {
                // at least one pixel width to avoid x-zoom zero values
                ow = 1;
            }
            xz = ow / this._audioDataHolder.duration;
        }
        return xz;
    }
    _layout(clear, redraw) {
        let ceBcr = this.ce.getBoundingClientRect();
        const ceBcrIntW = Math.floor(ceBcr.width);
        const ceBcrIntH = Math.floor(ceBcr.height);
        // height available for plugins (audiosignal and sonagram)
        let psH = ceBcrIntH - AudioClipUIContainer.DIVIDER_PIXEL_SIZE;
        if (psH < 0) {
            psH = 0;
        }
        // audio signal height
        const asH = Math.round(psH * this.dividerPosition);
        // sonagram height (rest: available height minus divider height minus audiosignal height)
        let soH = ceBcrIntH - AudioClipUIContainer.DIVIDER_PIXEL_SIZE - asH;
        if (soH < 0) {
            soH = 0;
        }
        // sonagram top position
        const soTop = asH + AudioClipUIContainer.DIVIDER_PIXEL_SIZE;
        // Visible bounds
        // left position
        let vbLeft = 0;
        // width
        let vbWidth = ceBcrIntW;
        if (!this._fixFitToPanel && this.bounds) {
            vbLeft = Math.round(this.bounds.position.left);
            vbWidth = Math.round(this.bounds.dimension.width);
        }
        // Divider
        // left position
        let vbLeftStyl = vbLeft + 'px';
        if (this.dc.style.left != vbLeftStyl) {
            this.dc.style.left = vbLeftStyl;
        }
        // top position
        //const dTop = asH;
        const dTopStr = asH + 'px';
        if (this.dc.style.top != dTopStr) {
            this.dc.style.top = dTopStr;
        }
        // width
        let vbWidthStyle = vbWidth + 'px';
        if (this.dc.style.width != vbWidthStyle) {
            this.dc.style.width = vbWidthStyle;
        }
        if (this.dc.width != vbWidth) {
            this.dc.width = vbWidth;
        }
        // height
        if (this.dc.height != AudioClipUIContainer.DIVIDER_PIXEL_SIZE) {
            this.dc.height = AudioClipUIContainer.DIVIDER_PIXEL_SIZE;
        }
        let divPixelSizeStyle = AudioClipUIContainer.DIVIDER_PIXEL_SIZE.toString() + 'px';
        if (this.dc.style.height != divPixelSizeStyle) {
            this.dc.style.height = divPixelSizeStyle;
        }
        this.drawDivider();
        // Virtual dimension, only width is used
        let virtualDim = new Dimension(ceBcrIntW, 0);
        // Visible bounds of container
        let br = new Rectangle(new Position(vbLeft, 0), new Dimension(vbWidth, ceBcrIntH));
        // Set container bounds
        this.layoutBounds(br, virtualDim, false);
        // Visible bounds of audiosignal
        let asR = new Rectangle(new Position(vbLeft, 0), new Dimension(vbWidth, asH));
        // Set audiosignal bounds
        this.as.layoutBounds(asR, virtualDim, redraw, clear);
        // Visible bounds of sonagram
        let soR = new Rectangle(new Position(vbLeft, soTop), new Dimension(vbWidth, soH));
        // Set sonagram bounds
        this.so.layoutBounds(soR, virtualDim, redraw, clear);
    }
    layoutScaled() {
        this._layout(false, false);
    }
    layout(clear = true) {
        if (this.ce && this.dc) {
            const clientW = this.ce.clientWidth;
            if (this._audioDataHolder) {
                if (this._fixFitToPanel) {
                    // Set the virtual canvas width to the visible width
                    if (this.ce.style.width != '100%') {
                        //console.log("set width to 100%");
                        this.ce.style.width = '100%';
                    }
                }
                else {
                    if (this._xZoom) {
                        // Set the virtual canvas width according to the value of the user selected xZoom value
                        const newClW = Math.round(this._xZoom * this._audioDataHolder?.duration);
                        this.ce.style.width = newClW + 'px';
                    }
                    else {
                        // Set the virtual canvas width to the visible width only
                        this.ce.style.width = clientW + 'px';
                    }
                }
            }
            this._layout(clear, true);
        }
    }
    set audioData(audioDataHolder) {
        this._audioClip = null;
        this._audioDataHolder = audioDataHolder;
        this.as.setData(audioDataHolder);
        this.so.setData(audioDataHolder);
        this.layout();
    }
    get audioData() {
        return this._audioDataHolder;
    }
    set audioClip(audioClip) {
        this._audioClip = audioClip;
        let audioData = null;
        let sel = null;
        if (audioClip) {
            audioData = audioClip.audioDataHolder;
            if (this._audioClip) {
                this._audioClip.addSelectionObserver((clip) => {
                    this.selection = clip.selection;
                });
            }
            sel = audioClip.selection;
        }
        this._audioDataHolder = audioData;
        this.as.setData(this._audioDataHolder);
        this.so.setData(this._audioDataHolder);
        this.selecting = null;
        this.selection = sel;
        this.layout();
    }
    get playFramePosition() {
        return this._playFramePosition;
    }
    set playFramePosition(playFramePosition) {
        this._playFramePosition = playFramePosition;
        this.as.playFramePosition = playFramePosition;
        this.so.playFramePosition = playFramePosition;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.12", ngImport: i0, type: AudioClipUIContainer, deps: [{ token: i0.ElementRef }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "18.2.12", type: AudioClipUIContainer, selector: "app-audio", inputs: { audioData: "audioData", audioClip: "audioClip" }, outputs: { selectionEventEmitter: "selectionEventEmitter" }, host: { listeners: { "window:resize": "onResize($event)", "document:mouseup": "onMouseup($event)", "document:mousemove": "onMousemove($event)" } }, viewQueries: [{ propertyName: "canvasRef", first: true, predicate: ["divider"], descendants: true, static: true }, { propertyName: "ceRef", first: true, predicate: ["virtualCanvas"], descendants: true, static: true }, { propertyName: "as", first: true, predicate: AudioSignal, descendants: true, static: true }, { propertyName: "so", first: true, predicate: Sonagram, descendants: true, static: true }], usesInheritance: true, ngImport: i0, template: `
    <div #virtualCanvas>
    <canvas #divider (mousedown)="mousedown($event)" (mouseover)="mouseover($event)"
            (mouseleave)="mouseleave($event)" height="10"></canvas>
    <audio-signal [pointerPosition]="pointer" [selecting]="selecting" [selection]="selection" (pointerPositionEventEmitter)="pointerPositionChanged($event)" (selectingEventEmitter)="selectingChanged($event)" (selectedEventEmitter)="selectionChanged($event)"></audio-signal>
    <audio-sonagram [pointerPosition]="pointer" [selecting]="selecting" [selection]="selection" (pointerPositionEventEmitter)="pointerPositionChanged($event)" (selectingEventEmitter)="selectingChanged($event)" (selectedEventEmitter)="selectionChanged($event)"></audio-sonagram>
    </div>
  `, isInline: true, styles: ["div{margin:0;padding:0;top:0;left:0;width:100%;height:100%;position:relative;box-sizing:border-box;transform:none;overflow:hidden}\n", "canvas{top:0;left:0;width:0;height:0;cursor:ns-resize;position:absolute;z-index:1;transform:none}\n", "audio-signal{top:0;left:0;position:absolute;z-index:1;transform:none}\n", "audio-sonagram{top:0;left:0;position:absolute;z-index:1;transform:none}\n"], dependencies: [{ kind: "component", type: AudioSignal, selector: "audio-signal" }, { kind: "component", type: Sonagram, selector: "audio-sonagram" }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.12", ngImport: i0, type: AudioClipUIContainer, decorators: [{
            type: Component,
            args: [{ selector: 'app-audio', template: `
    <div #virtualCanvas>
    <canvas #divider (mousedown)="mousedown($event)" (mouseover)="mouseover($event)"
            (mouseleave)="mouseleave($event)" height="10"></canvas>
    <audio-signal [pointerPosition]="pointer" [selecting]="selecting" [selection]="selection" (pointerPositionEventEmitter)="pointerPositionChanged($event)" (selectingEventEmitter)="selectingChanged($event)" (selectedEventEmitter)="selectionChanged($event)"></audio-signal>
    <audio-sonagram [pointerPosition]="pointer" [selecting]="selecting" [selection]="selection" (pointerPositionEventEmitter)="pointerPositionChanged($event)" (selectingEventEmitter)="selectingChanged($event)" (selectedEventEmitter)="selectionChanged($event)"></audio-sonagram>
    </div>
  `, styles: ["div{margin:0;padding:0;top:0;left:0;width:100%;height:100%;position:relative;box-sizing:border-box;transform:none;overflow:hidden}\n", "canvas{top:0;left:0;width:0;height:0;cursor:ns-resize;position:absolute;z-index:1;transform:none}\n", "audio-signal{top:0;left:0;position:absolute;z-index:1;transform:none}\n", "audio-sonagram{top:0;left:0;position:absolute;z-index:1;transform:none}\n"] }]
        }], ctorParameters: () => [{ type: i0.ElementRef }], propDecorators: { canvasRef: [{
                type: ViewChild,
                args: ['divider', { static: true }]
            }], ceRef: [{
                type: ViewChild,
                args: ['virtualCanvas', { static: true }]
            }], as: [{
                type: ViewChild,
                args: [AudioSignal, { static: true }]
            }], so: [{
                type: ViewChild,
                args: [Sonagram, { static: true }]
            }], selectionEventEmitter: [{
                type: Output
            }], onResize: [{
                type: HostListener,
                args: ['window:resize', ['$event']]
            }], onMouseup: [{
                type: HostListener,
                args: ['document:mouseup', ['$event']]
            }], onMousemove: [{
                type: HostListener,
                args: ['document:mousemove', ['$event']]
            }], audioData: [{
                type: Input
            }], audioClip: [{
                type: Input
            }] } });

class AudioDisplayScrollPane {
    constructor(ref) {
        this.ref = ref;
        this.zoomInAction = new Action('+');
        this.zoomOutAction = new Action('-');
        this.zoomSelectedAction = new Action("Selected");
        this.zoomFitToPanelAction = new Action("Fit to panel");
        this.zoomFixFitToPanelAction = new Action("Fix fit to panel");
        this.spEl = this.ref.nativeElement;
        this.zoomInAction.onAction = (e) => {
            this.ac.fixFitToPanel = false;
            const oldXZoom = this.ac.currentXZoom();
            if (oldXZoom === null) {
                return;
            }
            this.ac.xZoom = oldXZoom * 2;
            let cbr = new Rectangle(new Position(this.spEl.scrollLeft, this.spEl.scrollTop), new Dimension(this.spEl.clientWidth, this.spEl.clientHeight));
            this.ac.clipBounds(cbr);
            this.zoomFitToPanelAction.disabled = false;
        };
        this.zoomOutAction.onAction = (e) => {
            this.ac.fixFitToPanel = false;
            const cbr1 = new Rectangle(new Position((this.spEl.scrollLeft / 2) - this.spEl.clientWidth, this.spEl.scrollTop), new Dimension(this.spEl.clientWidth, this.spEl.clientHeight));
            this.ac.clipBounds(cbr1);
            let oldXZoom = this.ac.currentXZoom();
            if (oldXZoom === null) {
                return;
            }
            this.ac.xZoom = oldXZoom / 2;
            let cbr = new Rectangle(new Position(this.spEl.scrollLeft, this.spEl.scrollTop), new Dimension(this.spEl.clientWidth, this.spEl.clientHeight));
            this.ac.clipBounds(cbr);
            this.zoomFitToPanelAction.disabled = false;
        };
        this.zoomFitToPanelAction.onAction = (e) => {
            this.zoomFitToPanelAction.disabled = true;
            // set container div width to this (viewport) width
            this.ac.ce.style.width = this.spEl.offsetWidth + 'px';
            this.ac.fixFitToPanel = true;
        };
        this.zoomSelectedAction.onAction = (e) => {
            //alert("not implemented yet")
            let s = this.ac.selection;
            if (s) {
                // reset auto fit to panel mode
                this.ac.fixFitToPanel = false;
                // calculate selection length in seconds
                if (this.ac.audioData) {
                    let sr = this.ac.audioData.sampleRate;
                    let selFrLen = s.endFrame - s.startFrame;
                    let selLenInSecs = selFrLen / sr;
                    // calculate corresponding xZoom value and apply
                    this.ac.xZoom = this.spEl.clientWidth / selLenInSecs;
                    // Move viewport to show selection
                    let x1 = this.ac.frameToXPixelPosition(s.startFrame);
                    if (x1 !== null) {
                        this.spEl.scrollLeft = x1;
                    }
                }
                this.updateClipBounds();
                this.zoomFitToPanelAction.disabled = false;
            }
        };
    }
    updateClipBounds() {
        let cbr = new Rectangle(new Position(this.spEl.scrollLeft, this.spEl.scrollTop), new Dimension(this.spEl.clientWidth, this.spEl.clientHeight));
        this.ac.clipBounds(cbr);
    }
    onScroll(se) {
        this.updateClipBounds();
    }
    onResize(event) {
        this.updateClipBounds();
    }
    layout() {
        this.ac.layout();
    }
    selectionChanged(s) {
        this.zoomSelectedAction.disabled = (s == null);
    }
    set audioData(audioData) {
        this.ac.audioData = audioData;
        this.zoomOutAction.disabled = (!audioData);
        this.zoomInAction.disabled = (!audioData);
    }
    set audioClip(audioClip) {
        let audioData = null;
        let sel = null;
        if (audioClip) {
            audioData = audioClip.audioDataHolder;
            sel = audioClip.selection;
            audioClip.addSelectionObserver((clip) => {
                this.zoomSelectedAction.disabled = (clip.selection == null);
            });
        }
        this.selectionChanged(sel);
        this.ac.audioClip = audioClip;
        this.zoomOutAction.disabled = (!audioData);
        this.zoomInAction.disabled = (!audioData);
        window.setTimeout(() => {
            this.layout();
        });
    }
    set playFramePosition(framePos) {
        this.ac.playFramePosition = framePos;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.12", ngImport: i0, type: AudioDisplayScrollPane, deps: [{ token: i0.ElementRef }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "18.2.12", type: AudioDisplayScrollPane, selector: "audio-display-scroll-pane", inputs: { audioClip: "audioClip" }, outputs: { zoomInAction: "zoomInAction", zoomOutAction: "zoomOutAction", zoomSelectedAction: "zoomSelectedAction", zoomFitToPanelAction: "zoomFitToPanelAction" }, host: { listeners: { "scroll": "onScroll($event)", "window:resize": "onResize($event)" } }, viewQueries: [{ propertyName: "ac", first: true, predicate: AudioClipUIContainer, descendants: true, static: true }], ngImport: i0, template: `

    <app-audio #audioSignalContainer (selectionEventEmitter)="selectionChanged($event)"></app-audio>

  `, isInline: true, styles: [":host{flex:2;width:100%;background:#a9a9a9;box-sizing:border-box;height:100%;position:relative;overflow-x:scroll;overflow-y:auto}\n", "app-audio{margin:0;padding:0;top:0;left:0;width:100%;height:100%;box-sizing:border-box}\n"], dependencies: [{ kind: "component", type: AudioClipUIContainer, selector: "app-audio", inputs: ["audioData", "audioClip"], outputs: ["selectionEventEmitter"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.12", ngImport: i0, type: AudioDisplayScrollPane, decorators: [{
            type: Component,
            args: [{ selector: 'audio-display-scroll-pane', template: `

    <app-audio #audioSignalContainer (selectionEventEmitter)="selectionChanged($event)"></app-audio>

  `, styles: [":host{flex:2;width:100%;background:#a9a9a9;box-sizing:border-box;height:100%;position:relative;overflow-x:scroll;overflow-y:auto}\n", "app-audio{margin:0;padding:0;top:0;left:0;width:100%;height:100%;box-sizing:border-box}\n"] }]
        }], ctorParameters: () => [{ type: i0.ElementRef }], propDecorators: { zoomInAction: [{
                type: Output
            }], zoomOutAction: [{
                type: Output
            }], zoomSelectedAction: [{
                type: Output
            }], zoomFitToPanelAction: [{
                type: Output
            }], ac: [{
                type: ViewChild,
                args: [AudioClipUIContainer, { static: true }]
            }], onScroll: [{
                type: HostListener,
                args: ['scroll', ['$event']]
            }], onResize: [{
                type: HostListener,
                args: ['window:resize', ['$event']]
            }], audioClip: [{
                type: Input
            }] } });

class AudioDisplayControl {
    constructor() {
        this.audioClip = null;
        this.autoplaySelectedCheckbox = null;
        this.zoomInAction = null;
        this.zoomOutAction = null;
        this.status = null;
    }
    clearSelection() {
        if (this.audioClip != null) {
            this.audioClip.selection = null;
        }
    }
    hasSelection() {
        let hs = false;
        if (this.audioClip) {
            hs = (this.audioClip.selection != null);
        }
        return hs;
    }
    autoPlaySelectionChange(ch) {
        if (this.autoPlayOnSelectToggleAction) {
            this.autoPlayOnSelectToggleAction.perform(ch.checked);
        }
    }
    error() {
        this.status = 'ERROR';
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.12", ngImport: i0, type: AudioDisplayControl, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "18.2.12", type: AudioDisplayControl, selector: "audio-display-control", inputs: { audioClip: "audioClip", playStartAction: "playStartAction", playSelectionAction: "playSelectionAction", playStopAction: "playStopAction", zoomInAction: "zoomInAction", zoomOutAction: "zoomOutAction", zoomFitToPanelAction: "zoomFitToPanelAction", zoomSelectedAction: "zoomSelectedAction", autoPlayOnSelectToggleAction: "autoPlayOnSelectToggleAction" }, viewQueries: [{ propertyName: "autoplaySelectedCheckbox", first: true, predicate: MatCheckbox, descendants: true, static: true }], ngImport: i0, template: `
        <div #controlPanel style="display:flex;flex-direction: row;">
            <fieldset>

                <legend>Play</legend>

                <button (click)="playStartAction?.perform()" [disabled]="playStartAction?.disabled"
                        [style.color]="playStartAction?.disabled ? 'grey' : 'green'" matTooltip="Play all">
                    <mat-icon>play_arrow</mat-icon>
                </button>
                <button (click)="playSelectionAction?.perform()" [disabled]="playSelectionAction?.disabled"
                        [style.color]="playSelectionAction?.disabled ? 'grey' : 'green'" matTooltip="Play selection">
                    <mat-icon>play_circle_outline</mat-icon>
                </button>
                <button (click)="playStopAction?.perform()" [disabled]="playStopAction?.disabled"
                        [style.color]="playStopAction?.disabled ? 'grey' : 'yellow'">
                    <mat-icon>stop</mat-icon>
                </button>&nbsp;
                <mat-checkbox #autoplaySelectionCheckbox (change)="autoPlaySelectionChange($event)">Autoplay on select
                </mat-checkbox>
            </fieldset>
            <fieldset>

                <legend>Zoom</legend>
                <button (click)="zoomFitToPanelAction?.perform()"
                        [disabled]="zoomFitToPanelAction?.disabled">{{zoomFitToPanelAction?.name}}</button>
                <button (click)="zoomOutAction?.perform()"
                        [disabled]="zoomOutAction?.disabled">{{zoomOutAction?.name}}</button>
                <button (click)="zoomInAction?.perform()"
                        [disabled]="zoomInAction?.disabled">{{zoomInAction?.name}}</button>
                <button (click)="zoomSelectedAction?.perform()"
                        [disabled]="zoomSelectedAction?.disabled">{{zoomSelectedAction?.name}}</button>
            </fieldset>
            <fieldset>
                <legend>Selection</legend>
                {{audioClip?.selection?.leftFrame}} <span
                    *ngIf="audioClip?.selection">to</span> {{audioClip?.selection?.rightFrame}}
                <button (click)="clearSelection()" [disabled]="audioClip?.selection==null"
                        [style.color]="hasSelection() ? 'red' : 'grey'" matTooltip="Clear selection">
                    <mat-icon>clear</mat-icon>
                </button>

            </fieldset>
        </div>`, isInline: true, styles: [":host{flex:0}\n"], dependencies: [{ kind: "directive", type: i1$1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "component", type: i2.MatIcon, selector: "mat-icon", inputs: ["color", "inline", "svgIcon", "fontSet", "fontIcon"], exportAs: ["matIcon"] }, { kind: "directive", type: i4.MatTooltip, selector: "[matTooltip]", inputs: ["matTooltipPosition", "matTooltipPositionAtOrigin", "matTooltipDisabled", "matTooltipShowDelay", "matTooltipHideDelay", "matTooltipTouchGestures", "matTooltip", "matTooltipClass"], exportAs: ["matTooltip"] }, { kind: "component", type: i4$1.MatCheckbox, selector: "mat-checkbox", inputs: ["aria-label", "aria-labelledby", "aria-describedby", "id", "required", "labelPosition", "name", "value", "disableRipple", "tabIndex", "color", "disabledInteractive", "checked", "disabled", "indeterminate"], outputs: ["change", "indeterminateChange"], exportAs: ["matCheckbox"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.12", ngImport: i0, type: AudioDisplayControl, decorators: [{
            type: Component,
            args: [{ selector: 'audio-display-control', template: `
        <div #controlPanel style="display:flex;flex-direction: row;">
            <fieldset>

                <legend>Play</legend>

                <button (click)="playStartAction?.perform()" [disabled]="playStartAction?.disabled"
                        [style.color]="playStartAction?.disabled ? 'grey' : 'green'" matTooltip="Play all">
                    <mat-icon>play_arrow</mat-icon>
                </button>
                <button (click)="playSelectionAction?.perform()" [disabled]="playSelectionAction?.disabled"
                        [style.color]="playSelectionAction?.disabled ? 'grey' : 'green'" matTooltip="Play selection">
                    <mat-icon>play_circle_outline</mat-icon>
                </button>
                <button (click)="playStopAction?.perform()" [disabled]="playStopAction?.disabled"
                        [style.color]="playStopAction?.disabled ? 'grey' : 'yellow'">
                    <mat-icon>stop</mat-icon>
                </button>&nbsp;
                <mat-checkbox #autoplaySelectionCheckbox (change)="autoPlaySelectionChange($event)">Autoplay on select
                </mat-checkbox>
            </fieldset>
            <fieldset>

                <legend>Zoom</legend>
                <button (click)="zoomFitToPanelAction?.perform()"
                        [disabled]="zoomFitToPanelAction?.disabled">{{zoomFitToPanelAction?.name}}</button>
                <button (click)="zoomOutAction?.perform()"
                        [disabled]="zoomOutAction?.disabled">{{zoomOutAction?.name}}</button>
                <button (click)="zoomInAction?.perform()"
                        [disabled]="zoomInAction?.disabled">{{zoomInAction?.name}}</button>
                <button (click)="zoomSelectedAction?.perform()"
                        [disabled]="zoomSelectedAction?.disabled">{{zoomSelectedAction?.name}}</button>
            </fieldset>
            <fieldset>
                <legend>Selection</legend>
                {{audioClip?.selection?.leftFrame}} <span
                    *ngIf="audioClip?.selection">to</span> {{audioClip?.selection?.rightFrame}}
                <button (click)="clearSelection()" [disabled]="audioClip?.selection==null"
                        [style.color]="hasSelection() ? 'red' : 'grey'" matTooltip="Clear selection">
                    <mat-icon>clear</mat-icon>
                </button>

            </fieldset>
        </div>`, styles: [":host{flex:0}\n"] }]
        }], ctorParameters: () => [], propDecorators: { audioClip: [{
                type: Input
            }], autoplaySelectedCheckbox: [{
                type: ViewChild,
                args: [MatCheckbox, { static: true }]
            }], playStartAction: [{
                type: Input
            }], playSelectionAction: [{
                type: Input
            }], playStopAction: [{
                type: Input
            }], zoomInAction: [{
                type: Input
            }], zoomOutAction: [{
                type: Input
            }], zoomFitToPanelAction: [{
                type: Input
            }], zoomSelectedAction: [{
                type: Input
            }], autoPlayOnSelectToggleAction: [{
                type: Input
            }] } });

class AudioDisplay {
    constructor(ref, eRef) {
        this.ref = ref;
        this.eRef = eRef;
        this._audioClip = null;
        //console.log("constructor: "+this.ac);
        this.parentE = this.eRef.nativeElement;
        this.playStartAction = new Action("Start");
        this.playSelectionAction = new Action("Play selected");
        this.playStopAction = new Action("Stop");
        this.status = "Player created.";
    }
    ngOnInit() {
        this.zoomSelectedAction = this.audioDisplayScrollPane.zoomSelectedAction;
        this.zoomFitToPanelAction = this.audioDisplayScrollPane.zoomFitToPanelAction;
        this.zoomOutAction = this.audioDisplayScrollPane.zoomOutAction;
        this.zoomInAction = this.audioDisplayScrollPane.zoomInAction;
    }
    ngAfterViewInit() {
        this.layout();
        let heightListener = new MutationObserver((mrs, mo) => {
            mrs.forEach((mr) => {
                if ('attributes' === mr.type && ('class' === mr.attributeName || 'style' === mr.attributeName)) {
                    this.layout();
                }
            });
        });
        heightListener.observe(this.parentE, { attributes: true, childList: true, characterData: true });
    }
    layout() {
        this.audioDisplayScrollPane.layout();
    }
    started() {
        console.log("Play started");
        this.status = 'Playing...';
    }
    set audioData(audioData) {
        this.audioDisplayScrollPane.audioData = audioData;
        if (this.playStartAction) {
            console.debug("Play start action (by AudioDisplay::set audioData) disabled: " + (audioData == null));
            this.playStartAction.disabled = (audioData == null);
        }
    }
    set audioClip(audioClip) {
        //let audioData:AudioBuffer|null=null;
        let sel = null;
        if (audioClip) {
            //audioData=audioClip.audioDataHolder.buffer;
            sel = audioClip.selection;
        }
        this._audioClip = audioClip;
        this.audioDisplayScrollPane.audioClip = audioClip;
        //this.playStartAction.disabled = (audioData!==null)
    }
    get audioClip() {
        return this._audioClip;
    }
    set playFramePosition(playFramePosition) {
        this.audioDisplayScrollPane.playFramePosition = playFramePosition;
    }
    error() {
        this.status = 'ERROR';
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.12", ngImport: i0, type: AudioDisplay, deps: [{ token: i0.ChangeDetectorRef }, { token: i0.ElementRef }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "18.2.12", type: AudioDisplay, selector: "app-audiodisplay", inputs: { playStartAction: "playStartAction", playStopAction: "playStopAction", playSelectionAction: "playSelectionAction", autoPlayOnSelectToggleAction: "autoPlayOnSelectToggleAction", audioData: "audioData", audioClip: "audioClip" }, viewQueries: [{ propertyName: "audioDisplayScrollPane", first: true, predicate: AudioDisplayScrollPane, descendants: true, static: true }], ngImport: i0, template: `

    <audio-display-scroll-pane #audioDisplayScrollPane></audio-display-scroll-pane>

    <audio-display-control [audioClip]="audioClip"
                             [playStartAction]="playStartAction"
                             [playSelectionAction]="playSelectionAction"
                            [playStopAction]="playStopAction"
    [autoPlayOnSelectToggleAction]="autoPlayOnSelectToggleAction"
    [zoomInAction]="zoomInAction"
    [zoomOutAction]="zoomOutAction"
    [zoomSelectedAction]="zoomSelectedAction"
    [zoomFitToPanelAction]="zoomFitToPanelAction"></audio-display-control>
  `, isInline: true, styles: [":host{display:flex;flex-direction:column;position:absolute;bottom:0;height:100%;width:100%;overflow:hidden;padding:20px;z-index:5;box-sizing:border-box;background-color:#e6e6e6}\n", "legend{margin-left:1em;padding:.2em .8em;font-size:.8em}\n", "fieldset{border:1px darkgray solid}\n"], dependencies: [{ kind: "component", type: AudioDisplayScrollPane, selector: "audio-display-scroll-pane", inputs: ["audioClip"], outputs: ["zoomInAction", "zoomOutAction", "zoomSelectedAction", "zoomFitToPanelAction"] }, { kind: "component", type: AudioDisplayControl, selector: "audio-display-control", inputs: ["audioClip", "playStartAction", "playSelectionAction", "playStopAction", "zoomInAction", "zoomOutAction", "zoomFitToPanelAction", "zoomSelectedAction", "autoPlayOnSelectToggleAction"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.12", ngImport: i0, type: AudioDisplay, decorators: [{
            type: Component,
            args: [{ selector: 'app-audiodisplay', template: `

    <audio-display-scroll-pane #audioDisplayScrollPane></audio-display-scroll-pane>

    <audio-display-control [audioClip]="audioClip"
                             [playStartAction]="playStartAction"
                             [playSelectionAction]="playSelectionAction"
                            [playStopAction]="playStopAction"
    [autoPlayOnSelectToggleAction]="autoPlayOnSelectToggleAction"
    [zoomInAction]="zoomInAction"
    [zoomOutAction]="zoomOutAction"
    [zoomSelectedAction]="zoomSelectedAction"
    [zoomFitToPanelAction]="zoomFitToPanelAction"></audio-display-control>
  `, styles: [":host{display:flex;flex-direction:column;position:absolute;bottom:0;height:100%;width:100%;overflow:hidden;padding:20px;z-index:5;box-sizing:border-box;background-color:#e6e6e6}\n", "legend{margin-left:1em;padding:.2em .8em;font-size:.8em}\n", "fieldset{border:1px darkgray solid}\n"] }]
        }], ctorParameters: () => [{ type: i0.ChangeDetectorRef }, { type: i0.ElementRef }], propDecorators: { playStartAction: [{
                type: Input
            }], playStopAction: [{
                type: Input
            }], playSelectionAction: [{
                type: Input
            }], autoPlayOnSelectToggleAction: [{
                type: Input
            }], audioDisplayScrollPane: [{
                type: ViewChild,
                args: [AudioDisplayScrollPane, { static: true }]
            }], audioData: [{
                type: Input
            }], audioClip: [{
                type: Input
            }] } });

class ResponsiveComponent {
    constructor(breakpointObserver) {
        this.breakpointObserver = breakpointObserver;
        this.screenXs = false;
        breakpointObserver
            .observe([
            Breakpoints.XSmall
        ])
            .subscribe(result => {
            this.screenXs = (result.matches);
            //console.debug("Screen XS: "+this.screenXs);
        });
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.12", ngImport: i0, type: ResponsiveComponent, deps: [{ token: i1$2.BreakpointObserver }], target: i0.ɵɵFactoryTarget.Directive }); }
    static { this.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "18.2.12", type: ResponsiveComponent, ngImport: i0 }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.12", ngImport: i0, type: ResponsiveComponent, decorators: [{
            type: Directive
        }], ctorParameters: () => [{ type: i1$2.BreakpointObserver }] });

class IntersectionObserverDirective {
    //private intersectionObserver:IntersectionObserver|null=null;
    constructor(elRef) {
        this.elRef = elRef;
        const ne = this.elRef.nativeElement;
        //ne.style.backgroundColor = 'yellow';
    }
    set updateObservation(elIntersection) {
        //console.debug("visi: "+elIntersection.selected);
        if (elIntersection.observe) {
            //this.elRef.nativeElement.scrollIntoView(false);
            elIntersection.observer.observe(this.elRef.nativeElement);
        }
        else {
            elIntersection.observer.unobserve(this.elRef.nativeElement);
        }
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.12", ngImport: i0, type: IntersectionObserverDirective, deps: [{ token: i0.ElementRef }], target: i0.ɵɵFactoryTarget.Directive }); }
    static { this.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "18.2.12", type: IntersectionObserverDirective, isStandalone: true, selector: "[updateObservation]", inputs: { updateObservation: "updateObservation" }, ngImport: i0 }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.12", ngImport: i0, type: IntersectionObserverDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[updateObservation]',
                    standalone: true,
                }]
        }], ctorParameters: () => [{ type: i0.ElementRef }], propDecorators: { updateObservation: [{
                type: Input
            }] } });

class Progress {
    constructor(elRef) {
        this.elRef = elRef;
        this.items = undefined;
        this.selectedItemIdx = 0;
        this.enableDownload = false;
        this.onRowSelect = new EventEmitter();
        this.onShowDoneAction = new EventEmitter();
        this.onDownloadDoneAction = new EventEmitter();
        this.isObs = new IntersectionObserver(ise => {
            //console.debug("Intersection changed: ");
            ise.forEach((isee) => {
                //console.debug("Intersection: "+isee.isIntersecting+' '+isee.intersectionRatio);
                if (isee.intersectionRatio < 1) {
                    isee.target.scrollIntoView(false);
                    this.isObs.unobserve(isee.target);
                }
            });
        }, { root: this.elRef.nativeElement });
    }
    set rowSelect(rowIdx) {
        this.onRowSelect.emit(rowIdx);
    }
    set clickDone(rowIdx) {
        if (this.items && this.items[rowIdx] && this.items[rowIdx].recs) {
            this.onRowSelect.emit(rowIdx);
            this.onShowDoneAction.emit(rowIdx);
        }
    }
    set clickDownloadDone(rowIdx) {
        if (this.items && this.items[rowIdx] && this.items[rowIdx].recs) {
            this.onRowSelect.emit(rowIdx);
            this.onDownloadDoneAction.emit(rowIdx);
        }
    }
    latestRecordingAvail(item) {
        let cached = null;
        if (item && item.recs) {
            let recsLen = item.recs.length;
            if (recsLen > 0) {
                let rf = item.recs[recsLen - 1];
                if (rf && rf.serverPersisted) {
                    cached = (rf.audioDataHolder != null);
                }
            }
        }
        return cached;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.12", ngImport: i0, type: Progress, deps: [{ token: i0.ElementRef }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "18.2.12", type: Progress, selector: "app-sprprogress", inputs: { items: "items", selectedItemIdx: "selectedItemIdx", enableDownload: "enableDownload" }, outputs: { onRowSelect: "onRowSelect", rowSelect: "rowSelect", onShowDoneAction: "onShowDoneAction", clickDone: "clickDone", onDownloadDoneAction: "onDownloadDoneAction", clickDownloadDone: "clickDownloadDone" }, ngImport: i0, template: `

    <table class="mat-typography">
      <thead>
      <tr>
        <th>#</th><!--<th>Code</th>-->
        <th>Prompt</th>
        <th>Status</th>
      </tr>
      </thead>
      <tbody>
      <ng-container *ngIf="items">

        <tr *ngFor="let item of items; let itIdx=index;"
            (click)="rowSelect=itIdx" [class.selRow]="itIdx===selectedItemIdx"
            [updateObservation]="{observer:isObs,observe:(itIdx===selectedItemIdx)}">
          <td>{{itIdx}}</td>
          <td class="promptDescriptor">{{item.promptAsString}}</td>
          <td>
            <mat-icon  *ngIf="item.itemDone()">done</mat-icon>
            <!--<mat-icon *ngIf="latestRecordingAvail(item)===false" style="font-size:0.6em;width:0.6em;height:0.6em">cloud_download</mat-icon>-->

          </td>
        </tr>
      </ng-container>

      </tbody>
    </table>
  `, isInline: true, styles: [":host{overflow-x:hidden;overflow-y:scroll;padding:10pt;flex:.1 0 content;background:#fff;min-height:1px}\n", "table{min-height:1px;border-collapse:collapse}table,th,td{border:1px solid lightgrey;padding:.5em}\n", ".selRow{background:#add8e6}\n", ".promptDescriptor{max-width:200px;text-overflow:ellipsis;overflow:hidden;white-space:nowrap}\n"], dependencies: [{ kind: "directive", type: i1$1.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i1$1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "component", type: i2.MatIcon, selector: "mat-icon", inputs: ["color", "inline", "svgIcon", "fontSet", "fontIcon"], exportAs: ["matIcon"] }, { kind: "directive", type: IntersectionObserverDirective, selector: "[updateObservation]", inputs: ["updateObservation"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.12", ngImport: i0, type: Progress, decorators: [{
            type: Component,
            args: [{ selector: 'app-sprprogress', template: `

    <table class="mat-typography">
      <thead>
      <tr>
        <th>#</th><!--<th>Code</th>-->
        <th>Prompt</th>
        <th>Status</th>
      </tr>
      </thead>
      <tbody>
      <ng-container *ngIf="items">

        <tr *ngFor="let item of items; let itIdx=index;"
            (click)="rowSelect=itIdx" [class.selRow]="itIdx===selectedItemIdx"
            [updateObservation]="{observer:isObs,observe:(itIdx===selectedItemIdx)}">
          <td>{{itIdx}}</td>
          <td class="promptDescriptor">{{item.promptAsString}}</td>
          <td>
            <mat-icon  *ngIf="item.itemDone()">done</mat-icon>
            <!--<mat-icon *ngIf="latestRecordingAvail(item)===false" style="font-size:0.6em;width:0.6em;height:0.6em">cloud_download</mat-icon>-->

          </td>
        </tr>
      </ng-container>

      </tbody>
    </table>
  `, styles: [":host{overflow-x:hidden;overflow-y:scroll;padding:10pt;flex:.1 0 content;background:#fff;min-height:1px}\n", "table{min-height:1px;border-collapse:collapse}table,th,td{border:1px solid lightgrey;padding:.5em}\n", ".selRow{background:#add8e6}\n", ".promptDescriptor{max-width:200px;text-overflow:ellipsis;overflow:hidden;white-space:nowrap}\n"] }]
        }], ctorParameters: () => [{ type: i0.ElementRef }], propDecorators: { items: [{
                type: Input
            }], selectedItemIdx: [{
                type: Input
            }], enableDownload: [{
                type: Input
            }], onRowSelect: [{
                type: Output
            }], rowSelect: [{
                type: Output
            }], onShowDoneAction: [{
                type: Output
            }], clickDone: [{
                type: Output
            }], onDownloadDoneAction: [{
                type: Output
            }], clickDownloadDone: [{
                type: Output
            }] } });

class Recinstructions {
    displayText() {
        let riTxt = '';
        if (this.itemCount && this.selectedItemIdx) {
            riTxt = riTxt + this.selectedItemIdx + '/' + (this.itemCount - 1);
        }
        if (this.recinstructions) {
            riTxt = riTxt + ': ' + this.recinstructions;
        }
        return riTxt;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.12", ngImport: i0, type: Recinstructions, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "18.2.12", type: Recinstructions, selector: "spr-recinstructions", inputs: { recinstructions: "recinstructions", selectedItemIdx: "selectedItemIdx", itemCount: "itemCount" }, ngImport: i0, template: `

    {{displayText()}}
  `, isInline: true, styles: [":host{justify-content:left;align-items:flex-start;background:#fff;text-align:left;font-size:1em;flex:0;width:100%}\n"] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.12", ngImport: i0, type: Recinstructions, decorators: [{
            type: Component,
            args: [{ selector: 'spr-recinstructions', template: `

    {{displayText()}}
  `, styles: [":host{justify-content:left;align-items:flex-start;background:#fff;text-align:left;font-size:1em;flex:0;width:100%}\n"] }]
        }], propDecorators: { recinstructions: [{
                type: Input
            }], selectedItemIdx: [{
                type: Input
            }], itemCount: [{
                type: Input
            }] } });
class Prompter {
    constructor(elRef, renderer, projectService) {
        this.elRef = elRef;
        this.renderer = renderer;
        this.projectService = projectService;
        this._promptMediaItems = null;
        this.prompterHeight = 0;
        this._text = null;
        this._src = null;
        this.currPromptChild = null;
        this.prompterStyleFill = false;
    }
    get text() {
        return this._text;
    }
    get src() {
        return this._src;
    }
    srcUrl() {
        if (this.projectName && this._src) {
            return this.projectService.projectResourceUrl(this.projectName, this._src);
        }
        return null;
    }
    width() {
        if (this.elRef) {
            if (this.elRef.nativeElement) {
                return this.elRef.nativeElement.clientWidth;
            }
        }
        return null;
    }
    height() {
        if (this.elRef) {
            if (this.elRef.nativeElement) {
                return this.elRef.nativeElement.clientHeight;
            }
        }
        return null;
    }
    appendTextElement(parentEl, txt) {
        let t = txt.text;
        let txtNd = this.renderer.createText(t);
        if (txt.decoration || txt.color) {
            let spEl = this.renderer.createElement('span');
            let styleStr = '';
            if (txt.decoration) {
                styleStr = styleStr + 'text-decoration: ' + txt.decoration + ';';
            }
            if (txt.color) {
                styleStr = styleStr + 'color: ' + txt.color + ';';
            }
            spEl.style = styleStr;
            this.renderer.appendChild(parentEl, spEl);
            this.renderer.appendChild(spEl, txtNd);
        }
        else {
            this.renderer.appendChild(parentEl, txtNd);
        }
    }
    set promptMediaItems(pMis) {
        this._promptMediaItems = pMis;
        if (this.currPromptChild != null) {
            this.renderer.removeChild(this.elRef.nativeElement, this.currPromptChild);
        }
        if (this._promptMediaItems && this._promptMediaItems.length == 1) {
            let mi = this._promptMediaItems[0];
            this.mimetype = 'text/plain';
            if (mi.mimetype) {
                this.mimetype = mi.mimetype.trim();
            }
            if (this.mimetype === 'text/plain') {
                this._text = mi.text;
                this._src = null;
                let prTxt = '';
                if (this._text) {
                    prTxt = this._text;
                }
                this.currPromptChild = this.renderer.createText(prTxt);
                this.prompterStyleFill = false;
                this.renderer.appendChild(this.elRef.nativeElement, this.currPromptChild);
            }
            else if (this.mimetype === 'text/x-prompt') {
                //this.rendering=true
                this._text = null;
                this._src = null;
                this._blocks = new Array();
                let pd = mi.promptDoc;
                if (pd) {
                    let pdBody = pd.body;
                    if (pdBody) {
                        this._blocks = pdBody.blocks;
                    }
                }
                this.prompterStyleFill = false;
                this.currPromptChild = this.renderer.createElement('div');
                if (this._blocks) {
                    for (let bi = 0; bi < this._blocks.length; bi++) {
                        let bl = this._blocks[bi];
                        if ('p' === bl.type) {
                            let pBlEl = this.renderer.createElement('p');
                            this.renderer.appendChild(this.currPromptChild, pBlEl);
                            for (let ti = 0; ti < bl.texts.length; ti++) {
                                let txt = bl.texts[ti];
                                if (txt) {
                                    if ('text' === txt.type) {
                                        this.appendTextElement(pBlEl, txt);
                                    }
                                    else if ('font' === txt.type) {
                                        let spEl = this.renderer.createElement('span');
                                        let styleStr = '';
                                        if (txt.style) {
                                            styleStr = styleStr + 'font-style: ' + txt.style + ';';
                                        }
                                        if (txt.size) {
                                            styleStr = styleStr + 'font-size: ' + txt.size + ';';
                                        }
                                        if (txt.weight) {
                                            styleStr = styleStr + 'font-weight: ' + txt.weight + ';';
                                        }
                                        spEl.style = styleStr;
                                        this.renderer.appendChild(pBlEl, spEl);
                                        this.appendTextElement(spEl, txt.text);
                                    }
                                    else if ('linebreak' === txt.type) {
                                        let brEl = this.renderer.createElement('br');
                                        this.renderer.appendChild(pBlEl, brEl);
                                    }
                                }
                            }
                        }
                    }
                }
                this.renderer.appendChild(this.elRef.nativeElement, this.currPromptChild);
                //this.rendering=false
            }
            else if (this.mimetype.startsWith('image')) {
                this._text = null;
                this._src = mi.src;
                let promptImage = new Image();
                this.currPromptChild = promptImage;
                this.renderer.appendChild(this.elRef.nativeElement, this.currPromptChild);
                this.renderer.setStyle(this.currPromptChild, "max-width", "100%");
                this.renderer.setStyle(this.currPromptChild, "max-height", "100%");
                this.prompterStyleFill = true;
                // TODO vertical alignment
                // https://stackoverflow.com/questions/7273338/how-to-vertically-align-an-image-inside-a-div
                //console.log(promptImage.naturalWidth + "x"+promptImage.naturalHeight);
                promptImage.onload = (ev) => { };
                let srcUrl = this.srcUrl();
                if (srcUrl) {
                    promptImage.src = srcUrl;
                }
            }
        }
        else {
            this._text = null;
            this._src = null;
        }
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.12", ngImport: i0, type: Prompter, deps: [{ token: i0.ElementRef }, { token: i0.Renderer2 }, { token: ProjectService }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "18.2.12", type: Prompter, selector: "app-sprprompter", inputs: { projectName: "projectName", prompterHeight: "prompterHeight", promptMediaItems: "promptMediaItems" }, host: { properties: { "class.fill": "this.prompterStyleFill" } }, ngImport: i0, template: `

    <!--<ng-template [ngIf]="text">{{text}}</ng-template>-->
    <!-- <img *ngIf="src" #promptImage [src]="srcUrl()" [height]="prompterHeight-20" /> -->
  `, isInline: true, styles: [":host{justify-content:center;align-items:center;background:#fff;text-align:center;line-height:1.2em;font-weight:700;flex:0 1}\n", ":host(.fill){flex:3;width:100%;height:100%;max-height:100%;max-width:100%;vertical-align:middle}\n"] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.12", ngImport: i0, type: Prompter, decorators: [{
            type: Component,
            args: [{ selector: 'app-sprprompter', template: `

    <!--<ng-template [ngIf]="text">{{text}}</ng-template>-->
    <!-- <img *ngIf="src" #promptImage [src]="srcUrl()" [height]="prompterHeight-20" /> -->
  `, styles: [":host{justify-content:center;align-items:center;background:#fff;text-align:center;line-height:1.2em;font-weight:700;flex:0 1}\n", ":host(.fill){flex:3;width:100%;height:100%;max-height:100%;max-width:100%;vertical-align:middle}\n"] }]
        }], ctorParameters: () => [{ type: i0.ElementRef }, { type: i0.Renderer2 }, { type: ProjectService }], propDecorators: { projectName: [{
                type: Input
            }], prompterHeight: [{
                type: Input
            }], prompterStyleFill: [{
                type: HostBinding,
                args: ['class.fill']
            }], promptMediaItems: [{
                type: Input
            }] } });
const VIRTUAL_HEIGHT = 600;
const DEFAULT_PROMPT_FONTSIZE = 48;
const MIN_FONT_SIZE = 6;
const FALLBACK_DEF_USER_AGENT_FONT_SIZE = 14;
class PromptContainer {
    constructor(elRef) {
        this.elRef = elRef;
        this._mediaitems = null;
        this.prompterHeight = VIRTUAL_HEIGHT;
        this.fontSizeChange = false;
        this.contentChecked = false;
        this.prDisplay = 'hidden';
        this.autoFontSize = false;
    }
    ngOnInit() {
        // fallback
        this.defaultFontSizePx = FALLBACK_DEF_USER_AGENT_FONT_SIZE;
        // try to parse default user agent font size (no comment about DOM API design ;) )
        this.defaultStyle = window.getComputedStyle(this.elRef.nativeElement);
        let defFontSizeStr = this.defaultStyle.fontSize;
        if (defFontSizeStr) {
            defFontSizeStr = defFontSizeStr.trim();
            if (defFontSizeStr.endsWith('px')) {
                // parseFloat ignores non number characters at the end (again no comment ;) )
                this.defaultFontSizePx = parseFloat(defFontSizeStr);
                //console.info("Default font size: "+this.defaultFontSizePx)
            }
        }
        this.contentChecked = false;
    }
    ngAfterContentChecked() {
        if (this.autoFontSize) {
            if (this.fontSizeChange) {
                //console.log("ngaftercontentchecked, call fontSizeToFit ");
                // check prompter size again
                this.fontSizeToFit();
            }
            else {
                // font size was checked, but we need to check again after angular content check
                if (!this.contentChecked) {
                    this.contentChecked = true;
                    //console.log("ngaftercontentchecked, not font size changed, call ");
                    this.fontSizeToFit();
                }
            }
        }
    }
    set mediaitems(mediaitems) {
        this._mediaitems = mediaitems;
        let mimetype = null;
        if (this._mediaitems && this._mediaitems.length == 1) {
            let mi = this._mediaitems[0];
            mimetype = 'text/plain';
            if (mi.mimetype) {
                mimetype = mi.mimetype.trim();
            }
            if (mi.defaultVirtualViewBox) {
                this.prompterHeight = mi.defaultVirtualViewBox.height;
            }
        }
        else {
            this.prompterHeight = VIRTUAL_HEIGHT;
        }
        this.prompter.promptMediaItems = this._mediaitems;
        this.autoFontSize = (mimetype != null && mimetype.startsWith('text/'));
        this.layout();
    }
    get mediaitems() {
        return this._mediaitems;
    }
    onResize(event) {
        //console.debug("onresize, call fontSizeToFit hook ");
        this.layout();
    }
    layout() {
        if (this.autoFontSize && this.elRef) {
            this.fontSizeChange = true;
            this.contentChecked = false;
            this.prDisplay = 'hidden';
            let elH = this.elRef.nativeElement.offsetHeight;
            // prompt text font size should scale according to prompt container height
            let scaledSize = Math.round((elH / this.prompterHeight) * DEFAULT_PROMPT_FONTSIZE);
            // min prompt font size is default user agent size
            let newSize = Math.max(scaledSize, this.defaultFontSizePx);
            if (this.fontSize !== newSize) {
                this.fontSize = newSize;
            }
            //console.log("layout, call fontSizeToFit hook ");
            window.setTimeout(() => this.fontSizeToFit());
        }
        else {
            this.contentChecked = true;
            this.prDisplay = 'visible';
        }
    }
    fontSizeToFit() {
        if (this.prompter) {
            let pW = this.prompter.width();
            let pH = this.prompter.height();
            if (this._mediaitems && this.elRef && pW && pH) {
                let nEl = this.elRef.nativeElement;
                //console.log("prompter: " + this.prompter.width() + "x" + this.prompter.height()+ " font size: "+this.fontSize)
                if (this.fontSize >= MIN_FONT_SIZE && (pW > nEl.offsetWidth || pH > nEl.offsetHeight)) {
                    // prompter oversizes prompter container. Decrease font size.
                    // set invisible during font size checks
                    this.prDisplay = 'hidden';
                    // decrease font size
                    this.fontSize = this.fontSize - 1;
                    // console.log("Decreased font size: "+this.fontSize )
                    // Set flags
                    this.fontSizeChange = true;
                    this.contentChecked = false;
                    // hook the next check
                    window.setTimeout(() => this.fontSizeToFit());
                }
                else {
                    // prompter fits in  prompter container, font size should be fine
                    //console.log("prDisplay: "+this.prDisplay)
                    //if(this.contentChecked && ! this.fontSizeChange) {
                    //console.log("Display!")
                    // set prompter visible now
                    this.prDisplay = 'visible';
                    //}
                    this.fontSizeChange = false;
                }
                //console.log("Prompt text width: "+textSize.width+" "+this.elRef.nativeElement.offsetWidth+"x"+this.elRef.nativeElement.offsetHeight)
            }
        }
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.12", ngImport: i0, type: PromptContainer, deps: [{ token: i0.ElementRef }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "18.2.12", type: PromptContainer, selector: "app-sprpromptcontainer", inputs: { projectName: "projectName", mediaitems: "mediaitems" }, host: { listeners: { "window:resize": "onResize($event)" } }, viewQueries: [{ propertyName: "prompter", first: true, predicate: Prompter, descendants: true, static: true }], ngImport: i0, template: `
    <app-sprprompter #prompter [projectName]="projectName" [promptMediaItems]="mediaitems" [style.font-size]="fontSize+'px'" [style.visibility]="prDisplay" [prompterHeight]="prompterHeight"></app-sprprompter>
  `, isInline: true, styles: [":host{flex:3;padding:10pt;height:100%;max-height:100%;justify-content:center;align-items:center;background:#fff;text-align:center;display:flex;flex-direction:column;min-height:0px;width:100%}\n"], dependencies: [{ kind: "component", type: Prompter, selector: "app-sprprompter", inputs: ["projectName", "prompterHeight", "promptMediaItems"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.12", ngImport: i0, type: PromptContainer, decorators: [{
            type: Component,
            args: [{ selector: 'app-sprpromptcontainer', template: `
    <app-sprprompter #prompter [projectName]="projectName" [promptMediaItems]="mediaitems" [style.font-size]="fontSize+'px'" [style.visibility]="prDisplay" [prompterHeight]="prompterHeight"></app-sprprompter>
  `, styles: [":host{flex:3;padding:10pt;height:100%;max-height:100%;justify-content:center;align-items:center;background:#fff;text-align:center;display:flex;flex-direction:column;min-height:0px;width:100%}\n"] }]
        }], ctorParameters: () => [{ type: i0.ElementRef }], propDecorators: { projectName: [{
                type: Input
            }], prompter: [{
                type: ViewChild,
                args: [Prompter, { static: true }]
            }], mediaitems: [{
                type: Input
            }], onResize: [{
                type: HostListener,
                args: ['window:resize', ['$event']]
            }] } });
class PromptingContainer {
    constructor(ref) {
        this.ref = ref;
        this.promptItem = null;
        this.showPrompt = false;
        this.startX = null;
        this.touchStartTimeStamp = null;
    }
    ngOnInit() {
        this.e = this.ref.nativeElement;
    }
    onTouchstart(ev) {
        //console.log("Touch start! ")
        if (!(this.transportActions.fwdAction.disabled &&
            this.transportActions.bwdAction.disabled &&
            this.transportActions.nextAction.disabled)) {
            let targetTouchesLen = ev.targetTouches.length;
            //for(let ti=0;ti<ev.targetTouches.length;ti++){
            //let t=ev.targetTouches.item(ti);
            // All x values are the same ??
            //console.log("Touch #"+ti+": pageX: "+t.pageX+" clientX: "+t.clientX+" screenX: "+t.screenX)
            //}
            if (targetTouchesLen == 1) {
                // single touch
                let t = ev.targetTouches.item(0);
                if (t) {
                    this.startX = Math.round(t.screenX);
                    this.touchStartTimeStamp = ev.timeStamp;
                    this.e.style.transition = 'none';
                    //console.log("Touch start x: "+this.startX)
                    //ev.preventDefault();
                }
            }
        }
    }
    onTouchEnd(ev) {
        //console.log("Touch end!")
        // Reset offset shift
        if (!(this.transportActions.fwdAction.disabled && this.transportActions.bwdAction.disabled &&
            this.transportActions.nextAction.disabled)) {
            let changedTouchesLen = ev.changedTouches.length;
            //console.log(changedTouchesLen+" "+this.startX)
            if (changedTouchesLen == 1 && this.startX) {
                // single touch
                let t = ev.changedTouches.item(0);
                if (t) {
                    let deltaX = Math.round(t.clientX - this.startX);
                    let touchMoveSpeed = 0;
                    if (this.touchStartTimeStamp) {
                        touchMoveSpeed = deltaX / (ev.timeStamp - this.touchStartTimeStamp);
                    }
                    let futureDeltaX = deltaX + (800 * touchMoveSpeed);
                    //console.log("DeltaX: " + deltaX + " Future deltaX: " + futureDeltaX + "  width: " + this.e.offsetWidth)
                    if (futureDeltaX > this.e.offsetWidth / 2) {
                        //console.log("Swipe right detected!!")
                        //this.swipedRight.emit()
                        if (!this.transportActions.bwdAction.disabled) {
                            this.transportActions.bwdAction.perform();
                        }
                        this.e.style.left = -this.e.offsetLeft + "px";
                    }
                    if (-futureDeltaX > this.e.offsetWidth / 2) {
                        //console.log("Swipe left detected!!")
                        this.e.style.left = -this.e.offsetLeft + "px";
                        //this.swipedLeft.emit()
                        if (!this.transportActions.nextAction.disabled) {
                            this.transportActions.nextAction.perform();
                        }
                        else if (!this.transportActions.fwdAction.disabled) {
                            this.transportActions.fwdAction.perform();
                        }
                    }
                    else {
                    }
                    ev.preventDefault();
                }
            }
            // reset animated
            this.e.style.transition = "left 0.8s";
        }
        this.startX = null;
        this.touchStartTimeStamp = null;
        this.e.style.left = "0px";
    }
    onTouchMove(ev) {
        //console.log("Touch move!")
        if (!(this.transportActions.fwdAction.disabled && this.transportActions.bwdAction.disabled &&
            this.transportActions.nextAction.disabled)) {
            let targetTouchesLen = ev.targetTouches.length;
            if (targetTouchesLen == 1 && this.startX) {
                // single touch
                let t = ev.targetTouches.item(0);
                if (t) {
                    let deltaX = Math.round(t.screenX - this.startX);
                    this.e.style.left = deltaX + "px";
                    // console.log("Touch move delta x: "+deltaX)
                }
                ev.preventDefault();
            }
        }
    }
    onTouchCancel(ev) {
        //console.log("Touch cancel!")
        this.e.style.left = "0px";
        //ev.preventDefault();
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.12", ngImport: i0, type: PromptingContainer, deps: [{ token: i0.ElementRef }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "18.2.12", type: PromptingContainer, selector: "app-sprpromptingcontainer", inputs: { projectName: "projectName", promptItem: "promptItem", showPrompt: "showPrompt", selectedItemIdx: "selectedItemIdx", itemCount: "itemCount", transportActions: "transportActions" }, host: { listeners: { "touchstart": "onTouchstart($event)", "touchend": "onTouchEnd($event)", "touchmove": "onTouchMove($event)", "touchcancel": "onTouchCancel($event)" } }, ngImport: i0, template: `
    <spr-recinstructions [selectedItemIdx]="selectedItemIdx" [itemCount]="itemCount"
                         [recinstructions]="promptItem?.recinstructions?.recinstructions"></spr-recinstructions>
    <app-sprpromptcontainer [projectName]="projectName"
                            [mediaitems]="showPrompt?(promptItem?promptItem.mediaitems:null):null"></app-sprpromptcontainer>

  `, isInline: true, styles: [":host{position:relative;flex:3;padding:10pt;justify-content:center;align-items:center;background:#fff;text-align:center;display:flex;flex-direction:column;min-height:0px}\n"], dependencies: [{ kind: "component", type: Recinstructions, selector: "spr-recinstructions", inputs: ["recinstructions", "selectedItemIdx", "itemCount"] }, { kind: "component", type: PromptContainer, selector: "app-sprpromptcontainer", inputs: ["projectName", "mediaitems"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.12", ngImport: i0, type: PromptingContainer, decorators: [{
            type: Component,
            args: [{ selector: 'app-sprpromptingcontainer', template: `
    <spr-recinstructions [selectedItemIdx]="selectedItemIdx" [itemCount]="itemCount"
                         [recinstructions]="promptItem?.recinstructions?.recinstructions"></spr-recinstructions>
    <app-sprpromptcontainer [projectName]="projectName"
                            [mediaitems]="showPrompt?(promptItem?promptItem.mediaitems:null):null"></app-sprpromptcontainer>

  `, styles: [":host{position:relative;flex:3;padding:10pt;justify-content:center;align-items:center;background:#fff;text-align:center;display:flex;flex-direction:column;min-height:0px}\n"] }]
        }], ctorParameters: () => [{ type: i0.ElementRef }], propDecorators: { projectName: [{
                type: Input
            }], promptItem: [{
                type: Input
            }], showPrompt: [{
                type: Input
            }], selectedItemIdx: [{
                type: Input
            }], itemCount: [{
                type: Input
            }], transportActions: [{
                type: Input
            }], onTouchstart: [{
                type: HostListener,
                args: ['touchstart', ['$event']]
            }], onTouchEnd: [{
                type: HostListener,
                args: ['touchend', ['$event']]
            }], onTouchMove: [{
                type: HostListener,
                args: ['touchmove', ['$event']]
            }], onTouchCancel: [{
                type: HostListener,
                args: ['touchcancel', ['$event']]
            }] } });
class Prompting extends ResponsiveComponent {
    constructor(bpo) {
        super(bpo);
        this.bpo = bpo;
        this.promptItem = null;
        this.showPrompt = false;
        this.items = undefined;
        this.enableDownload = false;
        this.audioSignalCollapsed = true;
        this.displayAudioClip = null;
        this.onItemSelect = new EventEmitter();
        this.onNextItem = new EventEmitter();
        this.onPrevItem = new EventEmitter();
    }
    itemSelect(rowIdx) {
        this.onItemSelect.emit(rowIdx);
    }
    nextItem() {
        this.onNextItem.emit();
    }
    prevItem() {
        this.onPrevItem.emit();
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.12", ngImport: i0, type: Prompting, deps: [{ token: i1$2.BreakpointObserver }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "18.2.12", type: Prompting, selector: "app-sprprompting", inputs: { projectName: "projectName", startStopSignalState: "startStopSignalState", promptItem: "promptItem", showPrompt: "showPrompt", items: "items", selectedItemIdx: "selectedItemIdx", transportActions: "transportActions", enableDownload: "enableDownload", audioSignalCollapsed: "audioSignalCollapsed", displayAudioClip: "displayAudioClip", playStartAction: "playStartAction", playSelectionAction: "playSelectionAction", autoPlayOnSelectToggleAction: "autoPlayOnSelectToggleAction", playStopAction: "playStopAction" }, outputs: { onItemSelect: "onItemSelect", onNextItem: "onNextItem", onPrevItem: "onPrevItem" }, viewQueries: [{ propertyName: "simpleTrafficLight", first: true, predicate: SimpleTrafficLight, descendants: true, static: true }, { propertyName: "audioDisplay", first: true, predicate: AudioDisplay, descendants: true, static: true }], usesInheritance: true, ngImport: i0, template: `

    <app-simpletrafficlight [status]="startStopSignalState"></app-simpletrafficlight>
    <app-sprpromptingcontainer [projectName]="projectName" [promptItem]="promptItem" [showPrompt]="showPrompt"
                               [itemCount]="items?.length" [selectedItemIdx]="selectedItemIdx"
                               [transportActions]="transportActions"></app-sprpromptingcontainer>
    <app-sprprogress *ngIf="!screenXs" [items]="items" [selectedItemIdx]="selectedItemIdx"
                     (onRowSelect)="itemSelect($event)"></app-sprprogress>
    <div #asCt [class.active]="!audioSignalCollapsed && !screenXs">

      <app-audiodisplay #audioSignalContainer [class.active]="!audioSignalCollapsed"
                        [audioClip]="displayAudioClip"
                        [playStartAction]="playStartAction"
                        [playSelectionAction]="playSelectionAction"
                        [autoPlayOnSelectToggleAction]="autoPlayOnSelectToggleAction"
                        [playStopAction]="playStopAction"></app-audiodisplay>


    </div>



  `, isInline: true, styles: [":host{position:relative;margin:0;padding:0;background:#d3d3d3;width:100%;flex:1;min-height:0px;display:flex;flex-direction:row;flex-wrap:nowrap}\n", "app-simpletrafficlight{margin:10px;min-height:0px;z-index:3}\n", "app-sprprogress{z-index:3}\n", "div{display:none;position:absolute;z-index:5}\n", "div.active{display:flex;position:absolute;bottom:0;height:90%;width:100%;overflow:hidden;padding:0;z-index:5;box-sizing:border-box;background-color:#0000}\n"], dependencies: [{ kind: "directive", type: i1$1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "component", type: AudioDisplay, selector: "app-audiodisplay", inputs: ["playStartAction", "playStopAction", "playSelectionAction", "autoPlayOnSelectToggleAction", "audioData", "audioClip"] }, { kind: "component", type: Progress, selector: "app-sprprogress", inputs: ["items", "selectedItemIdx", "enableDownload"], outputs: ["onRowSelect", "rowSelect", "onShowDoneAction", "clickDone", "onDownloadDoneAction", "clickDownloadDone"] }, { kind: "component", type: SimpleTrafficLight, selector: "app-simpletrafficlight", inputs: ["status"] }, { kind: "component", type: PromptingContainer, selector: "app-sprpromptingcontainer", inputs: ["projectName", "promptItem", "showPrompt", "selectedItemIdx", "itemCount", "transportActions"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.12", ngImport: i0, type: Prompting, decorators: [{
            type: Component,
            args: [{ selector: 'app-sprprompting', template: `

    <app-simpletrafficlight [status]="startStopSignalState"></app-simpletrafficlight>
    <app-sprpromptingcontainer [projectName]="projectName" [promptItem]="promptItem" [showPrompt]="showPrompt"
                               [itemCount]="items?.length" [selectedItemIdx]="selectedItemIdx"
                               [transportActions]="transportActions"></app-sprpromptingcontainer>
    <app-sprprogress *ngIf="!screenXs" [items]="items" [selectedItemIdx]="selectedItemIdx"
                     (onRowSelect)="itemSelect($event)"></app-sprprogress>
    <div #asCt [class.active]="!audioSignalCollapsed && !screenXs">

      <app-audiodisplay #audioSignalContainer [class.active]="!audioSignalCollapsed"
                        [audioClip]="displayAudioClip"
                        [playStartAction]="playStartAction"
                        [playSelectionAction]="playSelectionAction"
                        [autoPlayOnSelectToggleAction]="autoPlayOnSelectToggleAction"
                        [playStopAction]="playStopAction"></app-audiodisplay>


    </div>



  `, styles: [":host{position:relative;margin:0;padding:0;background:#d3d3d3;width:100%;flex:1;min-height:0px;display:flex;flex-direction:row;flex-wrap:nowrap}\n", "app-simpletrafficlight{margin:10px;min-height:0px;z-index:3}\n", "app-sprprogress{z-index:3}\n", "div{display:none;position:absolute;z-index:5}\n", "div.active{display:flex;position:absolute;bottom:0;height:90%;width:100%;overflow:hidden;padding:0;z-index:5;box-sizing:border-box;background-color:#0000}\n"] }]
        }], ctorParameters: () => [{ type: i1$2.BreakpointObserver }], propDecorators: { simpleTrafficLight: [{
                type: ViewChild,
                args: [SimpleTrafficLight, { static: true }]
            }], audioDisplay: [{
                type: ViewChild,
                args: [AudioDisplay, { static: true }]
            }], projectName: [{
                type: Input
            }], startStopSignalState: [{
                type: Input
            }], promptItem: [{
                type: Input
            }], showPrompt: [{
                type: Input
            }], items: [{
                type: Input
            }], selectedItemIdx: [{
                type: Input
            }], transportActions: [{
                type: Input
            }], enableDownload: [{
                type: Input
            }], audioSignalCollapsed: [{
                type: Input
            }], displayAudioClip: [{
                type: Input
            }], playStartAction: [{
                type: Input
            }], playSelectionAction: [{
                type: Input
            }], autoPlayOnSelectToggleAction: [{
                type: Input
            }], playStopAction: [{
                type: Input
            }], onItemSelect: [{
                type: Output
            }], onNextItem: [{
                type: Output
            }], onPrevItem: [{
                type: Output
            }] } });

class SessionFinishedDialog {
    constructor(dialogRef, data) {
        this.dialogRef = dialogRef;
        this.data = data;
    }
    closeDialog() {
        this.dialogRef.close();
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.12", ngImport: i0, type: SessionFinishedDialog, deps: [{ token: i1$3.MatDialogRef }, { token: MAT_DIALOG_DATA }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "18.2.12", type: SessionFinishedDialog, selector: "spr-session-finished-dialog", ngImport: i0, template: `<h1 mat-dialog-title><mat-icon [style.color]="'green'">done_all</mat-icon> Session finished</h1>
  <div mat-dialog-content>

    <p>Thank you! The recording session is complete.</p>

  </div>
  <div mat-dialog-actions>
    <button mat-button (click)="closeDialog()">OK</button>
  </div>
  `, isInline: true, dependencies: [{ kind: "component", type: i2.MatIcon, selector: "mat-icon", inputs: ["color", "inline", "svgIcon", "fontSet", "fontIcon"], exportAs: ["matIcon"] }, { kind: "component", type: i3.MatButton, selector: "    button[mat-button], button[mat-raised-button], button[mat-flat-button],    button[mat-stroked-button]  ", exportAs: ["matButton"] }, { kind: "directive", type: i1$3.MatDialogTitle, selector: "[mat-dialog-title], [matDialogTitle]", inputs: ["id"], exportAs: ["matDialogTitle"] }, { kind: "directive", type: i1$3.MatDialogActions, selector: "[mat-dialog-actions], mat-dialog-actions, [matDialogActions]", inputs: ["align"] }, { kind: "directive", type: i1$3.MatDialogContent, selector: "[mat-dialog-content], mat-dialog-content, [matDialogContent]" }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.12", ngImport: i0, type: SessionFinishedDialog, decorators: [{
            type: Component,
            args: [{
                    selector: 'spr-session-finished-dialog',
                    template: `<h1 mat-dialog-title><mat-icon [style.color]="'green'">done_all</mat-icon> Session finished</h1>
  <div mat-dialog-content>

    <p>Thank you! The recording session is complete.</p>

  </div>
  <div mat-dialog-actions>
    <button mat-button (click)="closeDialog()">OK</button>
  </div>
  `
                }]
        }], ctorParameters: () => [{ type: i1$3.MatDialogRef }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [MAT_DIALOG_DATA]
                }] }] });

class MessageDialog {
    constructor(dialogRef, data) {
        this.dialogRef = dialogRef;
        this.data = data;
    }
    closeDialog() {
        this.dialogRef.close();
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.12", ngImport: i0, type: MessageDialog, deps: [{ token: i1$3.MatDialogRef }, { token: MAT_DIALOG_DATA }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "18.2.12", type: MessageDialog, selector: "msg-dialog", ngImport: i0, template: `<h1 mat-dialog-title><mat-icon *ngIf="data.type==='error'" [style.color]="'red'">error</mat-icon>
    <mat-icon *ngIf="data.type==='warning'" [style.color]="'yellow'">warning</mat-icon>{{data.title}}</h1>
  <div mat-dialog-content>

    <p>{{data.msg}}</p>
    <p>{{data.advice}}</p>

  </div>
  <div mat-dialog-actions>
    <button mat-button (click)="closeDialog()">OK</button>
  </div>
  `, isInline: true, dependencies: [{ kind: "directive", type: i1$1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "component", type: i2.MatIcon, selector: "mat-icon", inputs: ["color", "inline", "svgIcon", "fontSet", "fontIcon"], exportAs: ["matIcon"] }, { kind: "component", type: i3.MatButton, selector: "    button[mat-button], button[mat-raised-button], button[mat-flat-button],    button[mat-stroked-button]  ", exportAs: ["matButton"] }, { kind: "directive", type: i1$3.MatDialogTitle, selector: "[mat-dialog-title], [matDialogTitle]", inputs: ["id"], exportAs: ["matDialogTitle"] }, { kind: "directive", type: i1$3.MatDialogActions, selector: "[mat-dialog-actions], mat-dialog-actions, [matDialogActions]", inputs: ["align"] }, { kind: "directive", type: i1$3.MatDialogContent, selector: "[mat-dialog-content], mat-dialog-content, [matDialogContent]" }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.12", ngImport: i0, type: MessageDialog, decorators: [{
            type: Component,
            args: [{
                    selector: 'msg-dialog',
                    template: `<h1 mat-dialog-title><mat-icon *ngIf="data.type==='error'" [style.color]="'red'">error</mat-icon>
    <mat-icon *ngIf="data.type==='warning'" [style.color]="'yellow'">warning</mat-icon>{{data.title}}</h1>
  <div mat-dialog-content>

    <p>{{data.msg}}</p>
    <p>{{data.advice}}</p>

  </div>
  <div mat-dialog-actions>
    <button mat-button (click)="closeDialog()">OK</button>
  </div>
  `
                }]
        }], ctorParameters: () => [{ type: i1$3.MatDialogRef }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [MAT_DIALOG_DATA]
                }] }] });

class AudioFormat {
    constructor(sampleRate, channelCount) {
        this.sampleRate = sampleRate;
        this.channelCount = channelCount;
    }
}
class PCMAudioFormat extends AudioFormat {
    constructor(sampleRate, channelCount, sampleSize, sampleSizeInBits, encodingFloat = false) {
        super(sampleRate, channelCount);
        this.encodingFloat = false;
        this.sampleSize = sampleSize;
        this.sampleSizeInBits = sampleSizeInBits;
        this.encodingFloat = encodingFloat;
    }
    toString() {
        const encStr = this.encodingFloat ? 'Encoding: float,' : '';
        return 'Audio format: PCM,' + encStr + this.sampleRate + ' Hz,' + this.channelCount + ' channels, ' + this.sampleSizeInBits + ' bits';
    }
}

class BinaryByteReader {
    constructor(buf) {
        this.buf = new Uint8Array(buf);
        this.sbuf = new Int8Array(buf);
        this._pos = 0;
    }
    get pos() {
        return this._pos;
    }
    set pos(pos) {
        this._pos = pos;
    }
    length() {
        return this.buf.byteLength;
    }
    eof() {
        return (this._pos >= this.buf.byteLength);
    }
    skip(byteCound) {
        this.pos += 4;
    }
    readAscii(size) {
        let i;
        let txt = '';
        for (i = 0; i < size; i++) {
            txt += String.fromCharCode(this.buf[this._pos++]);
        }
        return txt;
    }
    readInt8() {
        return (this.buf[this._pos++]);
    }
    readInt16BE() {
        const b0 = this.sbuf[this._pos++];
        const b1 = this.buf[this._pos++];
        const val = (b0 << 8) | b1;
        return val;
    }
    readInt16LE() {
        const b0 = this.buf[this._pos++];
        const b1 = this.sbuf[this._pos++];
        const val = (b1 << 8) | b0;
        return val;
    }
    readUint16LE() {
        const seg = new Uint8Array(2);
        let i;
        for (i = 0; i < 2; i++) {
            seg[i] = this.buf[this._pos++];
        }
        let val = 0;
        val |= seg[1] << 8;
        val |= seg[0];
        return val;
    }
    readInt32BE() {
        const seg = new Uint8Array(4);
        let i;
        for (i = 0; i < 4; i++) {
            seg[i] = this.buf[this._pos++];
        }
        const val = seg[0] << 24 | seg[1] << 16 | seg[2] << 8 | seg[3];
        return val;
    }
    readUint32LE() {
        // this dircet data view does not work with nodejs: all avlues are zero
        // var seg=new Uint8Array(this.buf,this._pos,4);
        // ... copy value by value
        const seg = new Uint8Array(4);
        let i;
        for (i = 0; i < 4; i++) {
            seg[i] = this.buf[this._pos++];
        }
        // console.log("len:", seg.length, " ", seg.byteLength, " ", seg[0], " ", seg[1], " ", seg[2], " ", seg[3]);
        let val = 0;
        val |= seg[3] << 24;
        val |= seg[2] << 16;
        val |= seg[1] << 8;
        val |= seg[0];
        // var val = < 24(seg[3] <) | (seg[2] << 16) | (seg[1] << 8) | seg[0];
        // this._pos=this._pos+4;
        return val;
    }
    readFloat32() {
        const seg = new Float32Array(1);
        let i;
        for (i = 0; i < 4; i++) {
            seg[i] = this.buf[this._pos++];
        }
        return seg[0];
    }
}

class WavReader {
    constructor(data) {
        this.format = null;
        this.totalLength = 0;
        this.dataChunkLength = null;
        this.br = new BinaryByteReader(data);
    }
    readHeader() {
        const rh = this.br.readAscii(4);
        if (rh !== WavFileFormat.RIFF_KEY) {
            const errMsg = "Expected RIFF header, not: " + rh;
            throw new Error(errMsg);
        }
        const cl = this.br.readUint32LE();
        if (this.br.pos + cl !== this.br.length()) {
            throw new Error("Wrong chunksize in RIFF header: " + cl + " (expected: " + (this.br.length() - this.br.pos) + " )");
        }
        this.totalLength = cl;
        const rt = this.br.readAscii(4);
        if (rt !== WavFileFormat.WAV_KEY) {
            const errMsg = "Expected " + WavFileFormat.WAV_KEY + " not: " + rt;
            throw new Error(errMsg);
        }
    }
    readFormat() {
        this.br.pos = 0;
        this.readHeader();
        const s = this.navigateToChunk('fmt ');
        if (!s) {
            let errMsg = "WAV file does not contain a fmt chunk";
            throw new Error(errMsg);
        }
        this.format = this.parseFmtChunk();
        return this.format;
    }
    _frameLength() {
        let fl = null;
        if (this.format && this.dataChunkLength != null) {
            fl = this.dataChunkLength / this.format.channelCount / this.format.sampleSize;
        }
        return fl;
    }
    frameLength() {
        let fl = this._frameLength();
        if (fl === null) {
            this.readFormat();
            this.dataChunkLength = this.navigateToChunk('data');
            fl = this._frameLength();
        }
        return fl;
    }
    // Not tested yet!!!
    read() {
        this.br.pos = 0;
        let ab = null;
        this.readHeader();
        let s = this.navigateToChunk('fmt ');
        if (!s) {
            let errMsg = "WAV file does not contain a fmt chunk";
            throw new Error(errMsg);
        }
        this.format = this.parseFmtChunk();
        this.dataChunkLength = this.navigateToChunk('data');
        let chsArr = this.readData();
        let sr = this.format?.sampleRate;
        let nChs = this.format?.channelCount;
        if (sr && chsArr && nChs && nChs > 0 && nChs == chsArr?.length) {
            ab = new AudioBuffer({
                length: chsArr[0].length,
                numberOfChannels: this.format?.channelCount,
                sampleRate: sr
            });
            for (let ch = 0; ch < nChs; ch++) {
                ab.copyToChannel(chsArr[ch], ch);
            }
        }
        return ab;
    }
    navigateToChunk(chunkString) {
        // position after RIFF header
        // TODO assumes no other chunks except 'data'
        this.br.pos = 12;
        let chkStr = null;
        let chkLen = -1;
        while (!this.br.eof()) {
            chkStr = this.br.readAscii(4);
            chkLen = this.br.readUint32LE();
            if (chunkString === chkStr) {
                return chkLen;
            }
            this.br.pos += chkLen;
        }
        return chkLen;
    }
    parseFmtChunk() {
        let pcmAf = null;
        const fmt = this.br.readUint16LE();
        if (fmt === WavFileFormat.PCM || fmt == WavFileFormat.WAVE_FORMAT_IEEE_FLOAT) {
            const channels = this.br.readUint16LE();
            const sampleRate = this.br.readUint32LE();
            // skip bandwidth
            this.br.skip(4);
            // frame size
            const frameSize = this.br.readUint16LE();
            // sample size in bits (PCM format only)
            const sampleSizeInBits = this.br.readUint16LE();
            pcmAf = new PCMAudioFormat(sampleRate, channels, frameSize / channels, sampleSizeInBits, (fmt === WavFileFormat.WAVE_FORMAT_IEEE_FLOAT));
        }
        return pcmAf;
    }
    readData() {
        let chsArr = null;
        if (this.format) {
            chsArr = new Array(this.format.channelCount);
            const sampleCount = this.totalLength / this.format.channelCount / this.format.sampleSize;
            for (let ch = 0; ch < this.format.channelCount; ch++) {
                chsArr[ch] = new Float32Array(sampleCount);
            }
            if (this.format.encodingFloat) {
                // Not tested yet!
                for (let i = 0; i < this.totalLength / 4; i++) {
                    for (let ch = 0; ch < this.format.channelCount; ch++) {
                        chsArr[ch][i] = this.br.readFloat32();
                    }
                }
            }
            else {
                if (this.format.sampleSize == 2) {
                    for (let i = 0; i < this.totalLength / 2; i++) {
                        for (let ch = 0; ch < this.format.channelCount; ch++) {
                            const s16Ampl = this.br.readInt16LE();
                            chsArr[ch][i] = s16Ampl / 32768;
                        }
                    }
                }
            }
        }
        return chsArr;
    }
}

var BasicRecordingService_1;
class ChunkDownload {
    get orgPCMAudioFormat() {
        return this._orgPCMAudioFormat;
    }
    get orgFrameLength() {
        return this._orgFrameLength;
    }
    get decodedAudioBuffer() {
        return this._decodedAudioBuffer;
    }
    constructor(_orgPCMAudioFormat, _orgFrameLength, _decodedAudioBuffer) {
        this._orgPCMAudioFormat = _orgPCMAudioFormat;
        this._orgFrameLength = _orgFrameLength;
        this._decodedAudioBuffer = _decodedAudioBuffer;
    }
}
let BasicRecordingService = class BasicRecordingService {
    static { BasicRecordingService_1 = this; }
    // iPad 9th generation, iOS 15.7.1, sometimes:
    // Failed to load resource: WebKit hat einen internen Fehler festgestellt
    // Firefox on Windows crashes
    static { this.DEFAULT_CHUNKED_DOWNLOAD_SECONDS = 10; }
    static { this.DEFAULT_MAX_NET_AUTO_MEM_STORE_SAMPLES = 2880000 * 5; } // Default 5 minutes one channel at 48kHz
    constructor(http, config) {
        this.http = http;
        this.config = config;
        this._maxAutoNetMemStoreSamples = Number.MAX_SAFE_INTEGER;
        this.withCredentials = false;
        this.apiEndPoint = '';
        if (config && config.apiEndPoint) {
            this.apiEndPoint = config.apiEndPoint;
        }
        if (this.apiEndPoint !== '') {
            this.apiEndPoint = this.apiEndPoint + '/';
        }
        if (config != null && config.withCredentials != null) {
            this.withCredentials = config.withCredentials;
        }
        if (config && config.apiVersion > 1) {
            this._maxAutoNetMemStoreSamples = BasicRecordingService_1.DEFAULT_MAX_NET_AUTO_MEM_STORE_SAMPLES;
        }
    }
    audioRequestByURL(audioBaseUrl, audioURLSearchParams) {
        let audioUrl = audioBaseUrl;
        if (this.config && this.config.apiType === ApiType.FILES) {
            // for development and demo
            audioUrl = audioUrl + '.wav';
            // append UUID to make request URL unique to avoid localhost server caching
            audioURLSearchParams.set('requestUUID', UUID.generate());
            //audioUrl = audioUrl + '.wav?requestUUID=' + UUID.generate();
        }
        audioUrl = audioUrl + '?' + audioURLSearchParams.toString();
        let headers = new HttpHeaders();
        headers = headers.set('Accept', 'audio/wav');
        return this.http.get(audioUrl, {
            headers: headers,
            observe: 'response',
            responseType: 'arraybuffer',
            withCredentials: this.withCredentials
        });
    }
    chunkAudioRequest(baseAudioUrl, startFrame = 0, frameLength) {
        let ausps = new URLSearchParams();
        ausps.set('startFrame', startFrame.toString());
        ausps.set('frameLength', frameLength.toString());
        if (this.config && this.config.apiType === ApiType.FILES) {
            // for development and demo
            // append UUID to make request URL unique to avoid localhost server caching
            //audioUrl = audioUrl + '.wav?requestUUID=' + UUID.generate();
            ausps.set('requestUUID', UUID.generate());
        }
        let obs = new Observable(observer => {
            this.audioRequestByURL(baseAudioUrl, ausps).subscribe({
                next: resp => {
                    // Do not use Promise version, which does not work with Safari 13 (13.0.5)
                    if (resp.body) {
                        //console.debug("chunkAudioRequest: observer.closed: "+observer.closed);
                        //console.debug("Audio file bytes: "+resp.body.byteLength);
                        // Check original audio format
                        let wr = new WavReader(resp.body);
                        const pcmFmt = wr.readFormat();
                        const orgFl = wr.frameLength();
                        // if(pcmFmt){
                        //   console.debug("Original WAVE format of download chunk: "+pcmFmt);
                        // }else{
                        //   console.error("Could not read WAVE format of original download chunk!");
                        // }
                        // if(orgFl){
                        //   console.debug("Original frame length of download chunk: "+orgFl);
                        // }else{
                        //   console.error("Could not read WAVE format of original download chunk!");
                        // }
                        if (pcmFmt && orgFl) {
                            AudioContextProvider.decodeAudioData(resp.body).then((ab) => {
                                //console.debug("Decoded audio chunk frames: "+ab.length);
                                let chDl = new ChunkDownload(pcmFmt, orgFl, ab);
                                observer.next(chDl);
                                observer.complete();
                            }).catch(error => {
                                //if(error instanceof HttpErrorResponse) {
                                // if (error.status == 404) {
                                //   // Interpret not as an error, the file ist not recorded yet
                                //   observer.next(null);
                                //   observer.complete()
                                // } else {
                                //   // all other states are errors
                                console.error("Recordings service chunkAudioRequest error decoding audio data: " + error.name + ": " + error.message);
                                observer.error(error);
                                // }
                                // }
                            });
                        }
                        else {
                            const errMsg = 'Could not parse audio header for format and/or frame length of download.';
                            console.error(errMsg);
                            observer.error(errMsg);
                        }
                    }
                    else {
                        const errMsg = 'Fetching audio file: response has no body';
                        console.error(errMsg);
                        observer.error(errMsg);
                    }
                }, error: (error) => {
                    // all other states are errors
                    //const errMsg='Fetching audio file HTTP error: '+error;
                    //console.error(errMsg);
                    observer.error(error);
                    //observer.complete();
                }
            });
        });
        return obs;
    }
    chunkAudioRequestToNetAudioBuffer(baseAudioUrl, startFrame = 0, orgSampleRate, seconds, frames) {
        //let audioUrl=baseAudioUrl+'?startFrame='+startFrame+'&frameLength='+frameLength;
        //let audioUrl=new URL(baseAudioUrl);
        // if(orgSampleRate!=null && frameLength%orgSampleRate>0){
        //   const errMsg='frameLength must be equal or multiple of original samplerate.';
        //   console.error(errMsg+' ('+frameLength+'%'+orgSampleRate+'=='+(frameLength%orgSampleRate)+')');
        //   throw Error(errMsg)
        // }
        let frameLength = orgSampleRate * Math.round(seconds);
        let ausps = new URLSearchParams();
        ausps.set('startFrame', startFrame.toString());
        ausps.set('frameLength', frameLength.toString());
        if (this.config && this.config.apiType === ApiType.FILES) {
            // for development and demo
            // append UUID to make request URL unique to avoid localhost server caching
            //audioUrl = audioUrl + '.wav?requestUUID=' + UUID.generate();
            ausps.set('requestUUID', UUID.generate());
        }
        let obs = new Observable(subscriber => {
            this.audioRequestByURL(baseAudioUrl, ausps).subscribe({ next: (resp) => {
                    // Do not use Promise version, which does not work with Safari 13 (13.0.5)
                    if (resp.body) {
                        //console.debug("chunkAudioRequestTonetAb: subscriber.closed: "+subscriber.closed);
                        //console.debug("chunkAudioRequestTonetAb: Audio file bytes: "+resp.body.byteLength);
                        AudioContextProvider.decodeAudioData(resp.body).then(ab => {
                            //console.debug("chunkAudioRequestTonetAb: Decoded audio chunk frames for netAb: "+ab.length);
                            //console.debug("chunkAudioRequestTonetAb: Create netAb ab from chunk ab...");
                            if (frames === null) {
                                subscriber.error(new Error('Could not get frame length from recording file object'));
                            }
                            else {
                                let fl = frames;
                                if (ab.sampleRate !== orgSampleRate) {
                                    if (orgSampleRate && frames) {
                                        fl = Math.round(ab.sampleRate * frames / orgSampleRate);
                                        //console.debug("Platform sr: "+ab.sampleRate+", file sr: "+orgSampleRate+", decoded/org frame length: "+fl+"/"+frames+", ab.length: "+ab.length);
                                    }
                                }
                                let nab = NetAudioBuffer.fromChunkAudioBuffer(this, baseAudioUrl, ab, fl, frameLength);
                                //let rp=new ReadyProvider();
                                //nab.readyProvider=rp;
                                //rp.ready();
                                nab.ready();
                                if (nab.frameLen < frameLength) {
                                    //console.debug("chunkAudioRequestTonetAb: Built netAb ab from chunk ab: First chunk shorter tha frameLength ("+netAbAudioBuffer.frameLen+"<"+frameLength+"), assuming end of data, sealing netAb ab.");
                                    nab.seal();
                                }
                                subscriber.next(nab);
                                subscriber.complete();
                            }
                        }).catch(error => {
                            console.error('chunkAudioRequestToNetAb: error: ' + error);
                            //if(error instanceof HttpErrorResponse) {
                            subscriber.error(error);
                            //}
                        });
                    }
                    else {
                        console.error('chunkAudioRequestToNetAb: Fetching audio file: response has no body');
                        subscriber.error('chunkAudioRequestToNetAb: Fetching audio file: response has no body');
                    }
                },
                error: (error) => {
                    console.error('chunkAudioRequestToNetAb: error: ' + error);
                    subscriber.error(error);
                    //subscriber.complete();
                }
            });
        });
        return obs;
    }
};
BasicRecordingService = BasicRecordingService_1 = __decorate([
    __param(1, Inject(SPEECHRECORDER_CONFIG))
], BasicRecordingService);

/**
 * Created by klausj on 17.06.2017.
 */
class RecordingService extends BasicRecordingService {
    // This seems to work
    //public static readonly DEFAULT_CHUNKED_DOWNLOAD_SECONDS:number=4;
    static { this.REC_API_CTX = 'recfile'; }
    static { this.RECORDING_API_CTX = 'recordingfile'; }
    constructor(http, config) {
        super(http, config);
        this.http = http;
        this.config = config;
        //private debugDelay:number=10000;
        this.debugDelay = 0;
    }
    recordingFilesUrl() {
        let recFilesUrl = this.apiEndPoint + RecordingService.RECORDING_API_CTX;
        return recFilesUrl;
    }
    sessionRecordingFilesUrl(projectName, sessId) {
        let encPrjName = encodeURIComponent(projectName);
        let encSessId = encodeURIComponent(sessId);
        let recFilesUrl = this.apiEndPoint + ProjectService.PROJECT_API_CTX + '/' + encPrjName + '/' +
            SessionService.SESSION_API_CTX + '/' + encSessId + '/' + RecordingService.RECORDING_API_CTX;
        return recFilesUrl;
    }
    // private sessionRecordingFilesUrl(projectName: string, sessId: string | number):URL{
    //   let encPrjName=encodeURIComponent(projectName);
    //   let encSessId=encodeURIComponent(sessId);
    //
    //   let recFilesUrlStr = this.apiEndPoint + ProjectService.PROJECT_API_CTX + '/' + encPrjName + '/' +
    //     SessionService.SESSION_API_CTX + '/' + encSessId + '/' + RecordingService.RECORDING_API_CTX;
    //   let recFilesUrl=new URL(recFilesUrlStr);
    //   return recFilesUrl;
    // }
    sessionRecFilesUrl(projectName, sessId) {
        let encPrjName = encodeURIComponent(projectName);
        let encSessId = encodeURIComponent(sessId);
        let recFilesUrl = this.apiEndPoint + ProjectService.PROJECT_API_CTX + '/' + encPrjName + '/' +
            SessionService.SESSION_API_CTX + '/' + encSessId + '/' + RecordingService.REC_API_CTX;
        return recFilesUrl;
    }
    sessionRecFilesReqUrl(projectName, sessId) {
        let recFilesUrl = this.sessionRecFilesUrl(projectName, sessId);
        if (this.config && this.config.apiType === ApiType.FILES) {
            // for development and demo
            // append UUID to make request URL unique to avoid localhost server caching
            recFilesUrl = recFilesUrl + '.json?requestUUID=' + UUID.generate();
        }
        return recFilesUrl;
    }
    recordingFileDescrList(projectName, sessId) {
        let recFilesReqUrl = this.sessionRecFilesReqUrl(projectName, sessId);
        let wobs = this.http.get(recFilesReqUrl, { withCredentials: this.withCredentials });
        return wobs;
    }
    recordingFileList(projectName, sessId) {
        let recFilesReqUrl = this.sessionRecFilesReqUrl(projectName, sessId);
        let wobs = this.http.get(recFilesReqUrl, { withCredentials: this.withCredentials });
        return wobs;
    }
    sprRecordingFileList(projectName, sessId) {
        let recFilesReqUrl = this.sessionRecFilesReqUrl(projectName, sessId);
        let wobs = this.http.get(recFilesReqUrl, { withCredentials: this.withCredentials });
        return wobs;
    }
    audioRequest(audioUrl) {
        if (this.config && this.config.apiType === ApiType.FILES) {
            // for development and demo
            // append UUID to make request URL unique to avoid localhost server caching
            audioUrl = audioUrl + '.wav?requestUUID=' + UUID.generate();
        }
        let headers = new HttpHeaders();
        headers = headers.set('Accept', 'audio/wav');
        return this.http.get(audioUrl, {
            headers: headers,
            observe: 'response',
            responseType: 'arraybuffer',
            withCredentials: this.withCredentials
        });
    }
    chunkAudioRequestToIndDb(persistentAudioStorageTarget, inddbAudioBuffer, baseAudioUrl, startFrame = 0, orgSampleRate, seconds) {
        //let audioUrl=baseAudioUrl+'?startFrame='+startFrame+'&frameLength='+frameLength;
        //let audioUrl=new URL(baseAudioUrl);
        let frameLength = orgSampleRate * Math.round(seconds); // Important: multiple of original sample rate to prevent numeric rounding errors on resampling. 10 seconds is a good value for ind db storage.
        let ausps = new URLSearchParams();
        ausps.set('startFrame', startFrame.toString());
        ausps.set('frameLength', frameLength.toString());
        if (this.config && this.config.apiType === ApiType.FILES) {
            // for development and demo
            // append UUID to make request URL unique to avoid localhost server caching
            //audioUrl = audioUrl + '.wav?requestUUID=' + UUID.generate();
            ausps.set('requestUUID', UUID.generate());
        }
        let obs = new Observable(subscriber => {
            this.audioRequestByURL(baseAudioUrl, ausps).subscribe({ next: (resp) => {
                    // Do not use Promise version, which does not work with Safari 13 (13.0.5)
                    if (resp.body) {
                        //console.debug("chunkAudioRequestToIndDb: subscriber.closed: "+subscriber.closed);
                        //console.debug("chunkAudioRequestToIndDb: Audio file bytes: "+resp.body.byteLength);
                        AudioContextProvider.decodeAudioData(resp.body).then(ab => {
                            //console.debug("chunkAudioRequestToIndDb: Decoded audio chunk frames for inddb: "+ab.length);
                            if (!inddbAudioBuffer) {
                                //console.debug("chunkAudioRequestToIndDb: Create inddb ab from chunk ab...");
                                IndexedDbAudioBuffer.fromChunkAudioBuffer(persistentAudioStorageTarget, ab).subscribe({
                                    next: (iab) => {
                                        //console.debug("chunkAudioRequestToIndDb: Built inddb ab from chunk ab: "+iab);
                                        inddbAudioBuffer = iab;
                                        if (inddbAudioBuffer.frameLen < frameLength) {
                                            //console.debug("chunkAudioRequestToIndDb: Built inddb ab from chunk ab: First chunk shorter tha frameLength ("+inddbAudioBuffer.frameLen+"<"+frameLength+"), assuming end of data, sealing inddb ab.");
                                            inddbAudioBuffer.seal();
                                        }
                                        subscriber.next(iab);
                                    },
                                    complete: () => {
                                        //console.debug("chunkAudioRequestToIndDb: Built inddb ab from chunk ab complete.");
                                        subscriber.complete();
                                    },
                                    error: (err) => {
                                        // iPad may throw QuotaExceededError here
                                        console.error("chunkAudioRequestToIndDb: Built inddb ab from chunk ab error: " + err);
                                        subscriber.error(err);
                                    }
                                });
                            }
                            else {
                                //console.debug("chunkAudioRequestToIndDb: Append audio chunk to inddb ab...");
                                inddbAudioBuffer.appendChunkAudioBuffer(ab).subscribe({
                                    next: (iab) => {
                                        // if(inddbAudioBuffer) {
                                        //   console.debug("chunkAudioRequestToIndDb: Appended audio chunk to inddb audio buffer: "+inddbAudioBuffer);
                                        // }else{
                                        //   console.debug("chunkAudioRequestToIndDb: Append audio chunk returned null");
                                        // }
                                        subscriber.next(inddbAudioBuffer);
                                    },
                                    complete: () => {
                                        subscriber.complete();
                                    },
                                    error: (err) => {
                                        subscriber.error(err);
                                    }
                                });
                            }
                        }).catch(error => {
                            console.error('chunkAudioRequestToIndDb: error: ' + error);
                            //if(error instanceof HttpErrorResponse) {
                            subscriber.error(error);
                            //}
                        });
                    }
                    else {
                        const errMsg = 'chunkAudioRequestToIndDb: Fetching audio file: response has no body';
                        console.error(errMsg);
                        subscriber.error(new Error(errMsg));
                    }
                },
                error: (error) => {
                    console.error('chunkAudioRequestToIndDb: error: ' + error);
                    subscriber.error(error);
                    //subscriber.complete();
                }
            });
        });
        return obs;
    }
    chunkedAudioRequestToArrayBuffer(baseAudioUrl, orgSampleRate, seconds) {
        let obs = new Observable(subscriber => {
            let arrayAudioBuffer = null;
            let startFrame = 0;
            let frameLength = orgSampleRate * Math.round(seconds); // Important: multiple of original sample rate to prevent numeric rounding errors on resampling.
            //console.debug("Chunk audio request startFrame 0");
            let subscr = this.chunkAudioRequest(baseAudioUrl, startFrame, frameLength).pipe(expand(value => {
                if (subscriber.closed) {
                    subscr.unsubscribe();
                }
                if (value) {
                    if (arrayAudioBuffer) {
                        if (arrayAudioBuffer?.sealed()) {
                            return EMPTY;
                        }
                        else {
                            //let nextStartFrame=arrayAudioBuffer.frameLen + 1;
                            // We cannot use the frame length of the array audio buffer to determine the next start frame because
                            // AudioContext.decodeAudioData might change the sample rate of the original file. (E.g. Recordings from Mac/iOS with SR 44100 and listen to the on Windows platform will resmaple the audio data to 48000.)
                            // Frame count then differs on client and server
                            // Simply proceed in steps of frameLength
                            // More advanced method would be to parse the WAV header to find out the rela frame length of the chunk audio file
                            startFrame += frameLength;
                            //console.debug("Next start frame: "+startFrame);
                            //console.debug("chunkedAudioRequest: expand() subscriber.closed: "+subscriber.closed);
                            return this.chunkAudioRequest(baseAudioUrl, startFrame, frameLength);
                        }
                    }
                    else {
                        return EMPTY;
                    }
                }
                else {
                    return EMPTY;
                }
            }), map(chDl => {
                let ab = null;
                if (chDl === null) {
                    return null;
                }
                else {
                    ab = chDl.decodedAudioBuffer;
                }
                if (ab) {
                    if (arrayAudioBuffer) {
                        arrayAudioBuffer.appendAudioBuffer(ab);
                    }
                    else {
                        arrayAudioBuffer = ArrayAudioBuffer.fromAudioBuffer(ab, ab.length);
                    }
                    // Following code is wrong if original samplerate is less-then platform samplerate
                    // E.g. Loading 44100Hz file on Safari
                    // console.debug("Array ab seal?: "+ab.length+" < "+frameLength);
                    // if (ab.length < frameLength) {
                    //   arrayAudioBuffer.seal();
                    //   console.debug("Array ab sealed.");
                    // }
                }
                return arrayAudioBuffer;
            })).subscribe({
                next: (aab) => {
                    //console.debug("chunkedAudioRequest: subscriber.closed: "+subscriber.closed);
                    subscriber.next(aab);
                },
                complete: () => {
                    subscriber.complete();
                },
                error: (err) => {
                    if (err instanceof HttpErrorResponse) {
                        if (err.status == 404) {
                            if (arrayAudioBuffer) {
                                arrayAudioBuffer.seal();
                                subscriber.next(arrayAudioBuffer);
                                subscriber.complete();
                            }
                            else {
                                // Interpret not as an error, the file ist not recorded yet
                                subscriber.next(null);
                                subscriber.complete();
                            }
                            //   observer.complete()
                        }
                        else {
                            // all other states are errors
                            subscriber.error(err);
                        }
                    }
                    else {
                        subscriber.error(err);
                    }
                }
            });
        });
        return obs;
    }
    chunkedInddbAudioRequest(persistentAudioStorageTarget, baseAudioUrl, orgSampleRate, seconds) {
        let obs = new Observable(subscriber => {
            let inddbAudioBuffer = null;
            let startFrame = 0;
            //let frameLength = DEFAULT_CHUNKED_DOWNLOAD_FRAMELENGTH;
            let frameLength = orgSampleRate * Math.round(seconds);
            //console.debug("chunkedInddbAudioRequest: Chunk audio request for inddb. startFrame: "+startFrame);
            let subscr = this.chunkAudioRequestToIndDb(persistentAudioStorageTarget, null, baseAudioUrl, startFrame, orgSampleRate, seconds).pipe(expand(iab => {
                // console.debug("chunkedInddbAudioRequest (pipe/expand): Got inddb ab: "+iab);
                if (subscriber.closed) {
                    subscr.unsubscribe();
                }
                if (iab) {
                    inddbAudioBuffer = iab;
                    //if (inddbAudioBuffer) {
                    if (inddbAudioBuffer?.sealed()) {
                        return EMPTY;
                    }
                    else {
                        //let nextStartFrame=inddbAudioBuffer.frameLen + 1;
                        // We cannot use the frame length of the array audio buffer to determine the next start frame because
                        // AudioContext.decodeAudioData might change the sample rate of the original file. (E.g. Recordings from Mac/iOS with SR 44100 and listen to the on Windows platform will resmaple the audio data to 48000.)
                        // Frame count then differs on client and server
                        // Simply proceed in steps of frameLength
                        // More advanced method would be to parse the WAV header to find out the real frame length of the chunk audio file
                        startFrame += frameLength;
                        //console.debug("Next start frame: "+startFrame);
                        //console.debug("chunkedInddbAudioRequest: expand() subscriber.closed: "+subscriber.closed);
                        return this.chunkAudioRequestToIndDb(persistentAudioStorageTarget, inddbAudioBuffer, baseAudioUrl, startFrame, orgSampleRate, seconds);
                    }
                    // } else {
                    //   return EMPTY;
                    // }
                }
                else {
                    return EMPTY;
                }
            })).subscribe({
                next: (aab) => {
                    //console.debug("chunkedInddbAudioRequest: subscriber.closed: "+subscriber.closed);
                    subscriber.next(aab);
                },
                complete: () => {
                    subscriber.complete();
                },
                error: (err) => {
                    if (err instanceof HttpErrorResponse) {
                        if (err.status == 404) {
                            //console.debug("chunkedInddbAudioRequest: Received HTTP 404 not found.");
                            if (inddbAudioBuffer) {
                                inddbAudioBuffer.seal();
                                //console.debug("chunkedInddbAudioRequest: Sealed inddb audio buffer.");
                                subscriber.next(inddbAudioBuffer);
                                subscriber.complete();
                            }
                            else {
                                // Interpret not as an error, the file ist not recorded yet
                                //console.debug("chunkedInddbAudioRequest: Interpret HTTP 404 as not recorded yet.");
                                subscriber.next(null);
                                subscriber.complete();
                            }
                            //   observer.complete()
                        }
                        else {
                            // all other states are (real) errors
                            console.error("chunkedInddbAudioRequest: Error: " + err.message);
                            subscriber.error(err);
                        }
                    }
                    else {
                        // all other errors are (real) errors
                        console.error("chunkedInddbAudioRequest: Error: " + err);
                        subscriber.error(err);
                    }
                }
            });
        });
        return obs;
    }
    // private chunkedNetAudioRequest(aCtx:AudioContext,baseAudioUrl:string): Observable<NetAudioBuffer|null> {
    //   let obs=new Observable<NetAudioBuffer|null>(subscriber => {
    //     let inddbAudioBuffer: NetAudioBuffer | null = null;
    //     let startFrame=0;
    //     let frameLength = DEFAULT_CHUNKED_DOWNLOAD_FRAMELENGTH;
    //     //console.debug("chunkedInddbAudioRequest: Chunk audio request for inddb. startFrame: "+startFrame);
    //     let subscr=this.chunkAudioRequestToIndDb(aCtx,persistentAudioStorageTarget,null, baseAudioUrl, startFrame, frameLength).pipe(
    //
    //         expand(iab => {
    //               // console.debug("chunkedInddbAudioRequest (pipe/expand): Got inddb ab: "+iab);
    //               if(subscriber.closed){
    //                 subscr.unsubscribe();
    //               }
    //               if (iab) {
    //                 inddbAudioBuffer=iab;
    //                 //if (inddbAudioBuffer) {
    //                 if (inddbAudioBuffer?.sealed()) {
    //                   return EMPTY;
    //                 } else {
    //                   //let nextStartFrame=inddbAudioBuffer.frameLen + 1;
    //                   // We cannot use the frame length of the array audio buffer to determine the next start frame because
    //                   // AudioContext.decodeAudioData might change the sample rate of the original file. (E.g. Recordings from Mac/iOS with SR 44100 and listen to the on Windows platform will resmaple the audio data to 48000.)
    //                   // Frame count then differs on client and server
    //
    //                   // Simply proceed in steps of frameLength
    //                   // More advanced method would be to parse the WAV header to find out the rela frame length of the chunk audio file
    //                   startFrame+=frameLength;
    //                   //console.debug("Next start frame: "+startFrame);
    //                   //console.debug("chunkedInddbAudioRequest: expand() subscriber.closed: "+subscriber.closed);
    //                   return this.chunkAudioRequestToIndDb(aCtx,persistentAudioStorageTarget,inddbAudioBuffer, baseAudioUrl, startFrame, frameLength);
    //                 }
    //                 // } else {
    //                 //   return EMPTY;
    //                 // }
    //               }else{
    //                 return EMPTY;
    //               }
    //             }
    //         )
    //     ).subscribe({
    //       next: (aab)=>{
    //         //console.debug("chunkedInddbAudioRequest: subscriber.closed: "+subscriber.closed);
    //         subscriber.next(aab)
    //       },
    //       complete: ()=>{
    //         subscriber.complete()
    //       },
    //       error: (err)=>{
    //         if(err instanceof HttpErrorResponse){
    //           if (err.status == 404) {
    //             //console.debug("chunkedInddbAudioRequest: Received HTTP 404 not found.");
    //             if(inddbAudioBuffer){
    //               inddbAudioBuffer.seal();
    //               //console.debug("chunkedInddbAudioRequest: Sealed inddb audio buffer.");
    //               subscriber.next(inddbAudioBuffer);
    //               subscriber.complete();
    //             }else {
    //               // Interpret not as an error, the file ist not recorded yet
    //               //console.debug("chunkedInddbAudioRequest: Interpret HTTP 404 as not recorded yet.");
    //               subscriber.next(null);
    //               subscriber.complete();
    //             }
    //             //   observer.complete()
    //           } else {
    //             // all other states are (real) errors
    //             console.error("chunkedInddbAudioRequest: Error: "+err.message);
    //             subscriber.error(err);
    //           }
    //         }else {
    //           // all other errors are (real) errors
    //           console.error("chunkedInddbAudioRequest: Error: "+err);
    //           subscriber.error(err);
    //         }
    //       }
    //     });
    //   });
    //   return obs;
    // }
    audioFileUrlById(projectName, sessId, recFileId) {
        let recFilesUrl = this.sessionRecordingFilesUrl(projectName, sessId);
        let encRecFileId = encodeURIComponent(recFileId);
        return recFilesUrl + '/' + encRecFileId;
    }
    fetchAudiofile(projectName, sessId, recFileId) {
        let recUrl = this.audioFileUrlById(projectName, sessId, recFileId);
        return this.audioRequest(recUrl);
    }
    audioFileUrl(projectName, recordingFile) {
        let url = null;
        let recFileId = recordingFile.recordingFileId;
        if (!recFileId) {
            recFileId = recordingFile.uuid;
        }
        if (recordingFile.session && recFileId) {
            url = this.audioFileUrlById(projectName, recordingFile.session, recFileId);
        }
        return url;
    }
    audioFileUrlByUUID(projectName, session, uuid) {
        let url = this.audioFileUrlById(projectName, session, uuid);
        return url;
    }
    fetchSprAudiofile(projectName, sessId, itemcode, version) {
        let recFilesUrl = this.sessionRecFilesUrl(projectName, sessId);
        let encItemcode = encodeURIComponent(itemcode);
        let recUrl = recFilesUrl + '/' + encItemcode + '/' + version;
        return this.audioRequest(recUrl);
    }
    sprAudioFileUrlByItemcode(projectName, sessId, itemcode, version) {
        let recFilesUrl = this.sessionRecFilesUrl(projectName, sessId);
        let encItemcode = encodeURIComponent(itemcode);
        let recUrl = recFilesUrl + '/' + encItemcode + '/' + version;
        return recUrl;
    }
    sprAudioFileUrl(projectName, recordingFile) {
        let url = null;
        if (recordingFile.session) {
            url = this.sprAudioFileUrlByItemcode(projectName, recordingFile.session, recordingFile.itemCode, recordingFile.version);
        }
        return url;
    }
    // private fetchSprAudiofileArrayBuffer(aCtx:AudioContext,projectName: string, sessId: string | number, itemcode: string,version:number): Observable<ArrayAudioBuffer|null>{
    //   let recFilesUrl=this.sessionRecFilesUrl(projectName,sessId);
    //   let encItemcode=encodeURIComponent(itemcode);
    //   let recUrl = recFilesUrl + '/' + encItemcode +'/'+version;
    //   return this.chunkedAudioRequest(aCtx,recUrl);
    // }
    // private fetchSprAudiofileInddbBuffer(aCtx:AudioContext, persistentAudioStorageTarget:PersistentAudioStorageTarget,projectName: string, sessId: string | number, itemcode: string,version:number): Observable<IndexedDbAudioBuffer|null>{
    //   let recFilesUrlStr=this.sessionRecFilesUrl(projectName,sessId);
    //   let encItemcode=encodeURIComponent(itemcode);
    //   let recUrlStr = recFilesUrlStr + '/' + encItemcode +'/'+version;
    //   //let recUrl=new URL(recUrlStr);
    //   return this.chunkedInddbAudioRequest(aCtx,persistentAudioStorageTarget,recUrlStr);
    // }
    // private sprNetAudiofileBuffer(aCtx:AudioContext,projectName: string, sessId: string | number, itemcode: string,version:number): Observable<IndexedDbAudioBuffer|null>{
    //   let recFilesUrlStr=this.sessionRecFilesUrl(projectName,sessId);
    //   let encItemcode=encodeURIComponent(itemcode);
    //   let recUrlStr = recFilesUrlStr + '/' + encItemcode +'/'+version;
    //   //let recUrl=new URL(recUrlStr);
    //   return this.chunkedInddbAudioRequest(aCtx,recUrlStr);
    // }
    fetchRecordingFileAudioBuffer(projectName, recordingFile) {
        let wobs = new Observable(observer => {
            let recFileId = recordingFile.recordingFileId;
            if (!recFileId) {
                recFileId = recordingFile.uuid;
            }
            if (recordingFile.session && recFileId) {
                let obs = this.fetchAudiofile(projectName, recordingFile.session, recFileId);
                obs.subscribe({
                    next: resp => {
                        // Do not use Promise version, which does not work with Safari 13 (13.0.5)
                        if (resp.body) {
                            AudioContextProvider.decodeAudioData(resp.body).then(ab => {
                                observer.next(ab);
                                observer.complete();
                            }).catch(error => {
                                observer.error(error);
                                observer.complete();
                            });
                        }
                        else {
                            observer.error('Fetching audio file: response has no body');
                        }
                    }, error: (err) => {
                        if (err instanceof HttpErrorResponse) {
                            if (err.status == 404) {
                                // Interpret not as an error, the file ist not recorded yet
                                observer.next(null);
                                observer.complete();
                            }
                            else {
                                // all other states are errors
                                observer.error(err);
                                observer.complete();
                            }
                        }
                        else {
                            observer.error(err);
                        }
                    }
                });
            }
            else {
                observer.error();
            }
        });
        return wobs;
    }
    fetchAndApplyRecordingFile(aCtx, projectName, recordingFile) {
        let wobs = new Observable(observer => {
            let recFileId = recordingFile.recordingFileId;
            if (!recFileId) {
                recFileId = recordingFile.uuid;
            }
            if (recordingFile.session && recFileId) {
                let obs = this.fetchAudiofile(projectName, recordingFile.session, recFileId);
                obs.subscribe({ next: resp => {
                        //console.log("Fetched audio file. HTTP response status: "+resp.status+", type: "+resp.type+", byte length: "+ resp.body.byteLength);
                        // Do not use Promise version, which does not work with Safari 13 (13.0.5)
                        if (resp.body) {
                            AudioContextProvider.decodeAudioData(resp.body).then(ab => {
                                let abs = new AudioBufferSource(ab);
                                let adh = new AudioDataHolder(abs);
                                RecordingFileUtils.setAudioData(recordingFile, adh);
                                if (this.debugDelay > 0) {
                                    window.setTimeout(() => {
                                        observer.next(recordingFile);
                                        observer.complete();
                                    }, this.debugDelay);
                                }
                                else {
                                    observer.next(recordingFile);
                                    observer.complete();
                                }
                            }).catch(error => {
                                observer.error(error);
                                observer.complete();
                            });
                        }
                        else {
                            observer.error('Fetching audio file: response has no body');
                        }
                    },
                    error: (err) => {
                        if (err instanceof HttpErrorResponse) {
                            if (err.status == 404) {
                                // Interpret not as an error, the file ist not recorded yet
                                observer.next(null);
                                observer.complete();
                            }
                            else {
                                // all other states are errors
                                observer.error(err);
                                observer.complete();
                            }
                        }
                        else {
                            observer.error(err);
                        }
                    } });
            }
            else {
                observer.error();
            }
        });
        return wobs;
    }
    fetchSprRecordingFileAudioBuffer(projectName, recordingFile) {
        let wobs = new Observable(observer => {
            if (recordingFile.session) {
                let obs = this.fetchSprAudiofile(projectName, recordingFile.session, recordingFile.itemCode, recordingFile.version);
                obs.subscribe({
                    next: resp => {
                        // Do not use Promise version, which does not work with Safari 13 (13.0.5)
                        if (resp.body) {
                            AudioContextProvider.decodeAudioData(resp.body).then(ab => {
                                //RecordingFileUtils.setAudioData(recordingFile,new AudioDataHolder(ab,null));
                                observer.next(ab);
                                observer.complete();
                            }).catch(error => {
                                observer.error(error);
                                observer.complete();
                            });
                        }
                        else {
                            observer.error('Fetching audio file: response has no body');
                        }
                    },
                    error: (err) => {
                        if (err instanceof HttpErrorResponse && err.status == 404) {
                            // Interpret not as an error, the file ist not recorded yet
                            observer.next(null);
                            observer.complete();
                        }
                        else {
                            // all other states are errors
                            observer.error(err);
                        }
                    }
                });
            }
            else {
                observer.error();
            }
        });
        return wobs;
    }
    fetchSprRecordingFileArrayAudioBuffer(projectName, recordingFile) {
        let wobs = new Observable(observer => {
            if (recordingFile.session) {
                let baseUrl = this.sprAudioFileUrl(projectName, recordingFile);
                if (baseUrl) {
                    if (recordingFile.samplerate) {
                        let lengthInSeconds = RecordingService.DEFAULT_CHUNKED_DOWNLOAD_SECONDS;
                        let obs = this.chunkedAudioRequestToArrayBuffer(baseUrl, recordingFile.samplerate, lengthInSeconds);
                        //let obs = this.fetchSprAudiofileArrayBuffer(aCtx,projectName, recordingFile.session, recordingFile.itemCode, recordingFile.version);
                        let subscr = obs.subscribe({
                            next: aab => {
                                //console.debug("fetchSprRecordingFileArrayAudioBuffer: observer.closed: "+observer.closed);
                                if (observer.closed) {
                                    subscr.unsubscribe();
                                }
                                observer.next(aab);
                            },
                            complete: () => {
                                observer.complete();
                            },
                            error: (err) => {
                                if (err instanceof HttpErrorResponse && err.status == 404) {
                                    // Interpret not as an error, the file ist not recorded yet
                                    observer.next(null);
                                    observer.complete();
                                }
                                else {
                                    // all other states are errors
                                    observer.error(err);
                                }
                            }
                        });
                    }
                    else {
                        observer.error(new Error('Unknown sample rate of recording file ID: ' + recordingFile.recordingFileId));
                    }
                }
            }
            else {
                observer.error(new Error('Could not get session ID of recording file'));
            }
        });
        return wobs;
    }
    fetchRecordingFileArrayAudioBuffer(projectName, recordingFile) {
        let wobs = new Observable(observer => {
            if (recordingFile.session) {
                let baseUrl = this.audioFileUrl(projectName, recordingFile);
                if (baseUrl) {
                    if (recordingFile.samplerate) {
                        let lengthInSeconds = RecordingService.DEFAULT_CHUNKED_DOWNLOAD_SECONDS;
                        let obs = this.chunkedAudioRequestToArrayBuffer(baseUrl, recordingFile.samplerate, lengthInSeconds);
                        //let obs = this.fetchSprAudiofileArrayBuffer(aCtx,projectName, recordingFile.session, recordingFile.itemCode, recordingFile.version);
                        let subscr = obs.subscribe({
                            next: aab => {
                                //console.debug("fetchSprRecordingFileArrayAudioBuffer: observer.closed: "+observer.closed);
                                if (observer.closed) {
                                    subscr.unsubscribe();
                                }
                                observer.next(aab);
                            },
                            complete: () => {
                                observer.complete();
                            },
                            error: (err) => {
                                if (err instanceof HttpErrorResponse && err.status == 404) {
                                    // Interpret not as an error, the file ist not recorded yet
                                    observer.next(null);
                                    observer.complete();
                                }
                                else {
                                    // all other states are errors
                                    observer.error(err);
                                }
                            }
                        });
                    }
                    else {
                        observer.error(new Error('Unknown sample rate of recording file ID: ' + recordingFile.recordingFileId));
                    }
                }
            }
            else {
                observer.error(new Error('Could not get session ID of recording file'));
            }
        });
        return wobs;
    }
    fetchSprRecordingFileIndDbAudioBuffer(persistentAudioStorageTarget, projectName, recordingFile) {
        let wobs = new Observable(observer => {
            if (recordingFile.session) {
                let baseUrl = this.sprAudioFileUrl(projectName, recordingFile);
                if (baseUrl) {
                    if (recordingFile.samplerate) {
                        let lengthInSeconds = RecordingService.DEFAULT_CHUNKED_DOWNLOAD_SECONDS;
                        let obs = this.chunkedInddbAudioRequest(persistentAudioStorageTarget, baseUrl, recordingFile.samplerate, lengthInSeconds);
                        let subscr = obs.subscribe({
                            next: aab => {
                                //console.debug("fetchSprRecordingFileIndDbAudioBuffer: observer.closed: "+observer.closed);
                                if (observer.closed) {
                                    subscr.unsubscribe();
                                }
                                observer.next(aab);
                            },
                            complete: () => {
                                observer.complete();
                            },
                            error: (err) => {
                                if (err instanceof HttpErrorResponse && err.status == 404) {
                                    // Interpret not as an error, the file ist not recorded yet
                                    observer.next(null);
                                    observer.complete();
                                }
                                else {
                                    // all other errors are real errors
                                    observer.error(err);
                                }
                            }
                        });
                    }
                    else {
                        observer.error(new Error('Unknown sample rate of recording file ID: ' + recordingFile.recordingFileId));
                    }
                }
            }
            else {
                observer.error();
            }
        });
        return wobs;
    }
    fetchRecordingFileIndDbAudioBuffer(persistentAudioStorageTarget, projectName, recordingFile) {
        let wobs = new Observable(observer => {
            if (recordingFile.session) {
                let baseUrl = this.audioFileUrl(projectName, recordingFile);
                if (baseUrl) {
                    if (recordingFile.samplerate) {
                        let lengthInSeconds = RecordingService.DEFAULT_CHUNKED_DOWNLOAD_SECONDS;
                        let obs = this.chunkedInddbAudioRequest(persistentAudioStorageTarget, baseUrl, recordingFile.samplerate, lengthInSeconds);
                        let subscr = obs.subscribe({
                            next: aab => {
                                //console.debug("fetchSprRecordingFileIndDbAudioBuffer: observer.closed: "+observer.closed);
                                if (observer.closed) {
                                    subscr.unsubscribe();
                                }
                                observer.next(aab);
                            },
                            complete: () => {
                                observer.complete();
                            },
                            error: (err) => {
                                if (err instanceof HttpErrorResponse && err.status == 404) {
                                    // Interpret not as an error, the file ist not recorded yet
                                    observer.next(null);
                                    observer.complete();
                                }
                                else {
                                    // all other errors are real errors
                                    observer.error(err);
                                }
                            }
                        });
                    }
                    else {
                        observer.error(new Error('Unknown sample rate of recording file ID: ' + recordingFile.recordingFileId));
                    }
                }
            }
            else {
                observer.error();
            }
        });
        return wobs;
    }
    fetchSprRecordingFileNetAudioBuffer(projectName, recordingFile) {
        let wobs = new Observable(observer => {
            if (recordingFile.session) {
                let baseUrl = this.sprAudioFileUrl(projectName, recordingFile);
                if (baseUrl) {
                    let seconds = RecordingService.DEFAULT_CHUNKED_DOWNLOAD_SECONDS;
                    if (recordingFile.samplerate) {
                        let obs = this.chunkAudioRequestToNetAudioBuffer(baseUrl, 0, recordingFile.samplerate, seconds, recordingFile.frames);
                        let subscr = obs.subscribe({
                            next: aab => {
                                //console.debug("fetchSprRecordingFileIndDbAudioBuffer: observer.closed: "+observer.closed);
                                if (observer.closed) {
                                    subscr.unsubscribe();
                                }
                                else {
                                    observer.next(aab);
                                }
                            },
                            complete: () => {
                                observer.complete();
                            },
                            error: (err) => {
                                if (err instanceof HttpErrorResponse && err.status == 404) {
                                    // Interpret not as an error, the file ist not recorded yet
                                    observer.next(null);
                                    observer.complete();
                                }
                                else {
                                    // all other errors are real errors
                                    observer.error(err);
                                }
                            }
                        });
                    }
                    else {
                        observer.error(new Error('Unknown sample rate of recording file ID: ' + recordingFile.recordingFileId));
                    }
                }
                else {
                    observer.error();
                }
            }
            else {
                observer.error();
            }
        });
        return wobs;
    }
    fetchRecordingFileNetAudioBuffer(projectName, recordingFile) {
        let wobs = new Observable(observer => {
            if (recordingFile.session) {
                let baseUrl = this.audioFileUrl(projectName, recordingFile);
                if (baseUrl) {
                    let seconds = RecordingService.DEFAULT_CHUNKED_DOWNLOAD_SECONDS;
                    if (recordingFile.samplerate) {
                        let obs = this.chunkAudioRequestToNetAudioBuffer(baseUrl, 0, recordingFile.samplerate, seconds, recordingFile.frames);
                        let subscr = obs.subscribe({
                            next: aab => {
                                //console.debug("fetchSprRecordingFileIndDbAudioBuffer: observer.closed: "+observer.closed);
                                if (observer.closed) {
                                    subscr.unsubscribe();
                                }
                                else {
                                    observer.next(aab);
                                }
                            },
                            complete: () => {
                                observer.complete();
                            },
                            error: (err) => {
                                if (err instanceof HttpErrorResponse && err.status == 404) {
                                    // Interpret not as an error, the file ist not recorded yet
                                    observer.next(null);
                                    observer.complete();
                                }
                                else {
                                    // all other errors are real errors
                                    observer.error(err);
                                }
                            }
                        });
                    }
                    else {
                        observer.error(new Error('Unknown sample rate of recording file ID: ' + recordingFile.recordingFileId));
                    }
                }
                else {
                    observer.error();
                }
            }
            else {
                observer.error();
            }
        });
        return wobs;
    }
    fetchAndApplySprRecordingFile(aCtx, projectName, recordingFile) {
        let wobs = new Observable(observer => {
            if (recordingFile.session) {
                let obs = this.fetchSprAudiofile(projectName, recordingFile.session, recordingFile.itemCode, recordingFile.version);
                obs.subscribe({
                    next: resp => {
                        //console.log("Fetched audio file. HTTP response status: "+resp.status+", type: "+resp.type+", byte length: "+ resp.body.byteLength);
                        // Do not use Promise version, which does not work with Safari 13 (13.0.5)
                        if (resp.body) {
                            AudioContextProvider.decodeAudioData(resp.body).then(ab => {
                                let abs = new AudioBufferSource(ab);
                                RecordingFileUtils.setAudioData(recordingFile, new AudioDataHolder(abs));
                                if (this.debugDelay > 0) {
                                    window.setTimeout(() => {
                                        observer.next(recordingFile);
                                        observer.complete();
                                    }, this.debugDelay);
                                }
                                else {
                                    observer.next(recordingFile);
                                    observer.complete();
                                }
                            }).catch(error => {
                                observer.error(error);
                                observer.complete();
                            });
                        }
                        else {
                            observer.error('Fetching audio file: response has no body');
                        }
                    },
                    error: (err) => {
                        if (err instanceof HttpErrorResponse && err.status == 404) {
                            // Interpret not as an error, the file ist not recorded yet
                            observer.next(null);
                            observer.complete();
                        }
                        else {
                            // all other states are errors
                            observer.error(err);
                        }
                    }
                });
            }
            else {
                observer.error();
            }
        });
        return wobs;
    }
    fetchRecordingFile(aCtx, projectName, sessId, itemcode, version) {
        let wobs = new Observable(observer => {
            let obs = this.fetchSprAudiofile(projectName, sessId, itemcode, version);
            obs.subscribe({ next: resp => {
                    if (resp.body) {
                        AudioContextProvider.decodeAudioData(resp.body).then(ab => {
                            let abs = new AudioBufferSource(ab);
                            let adh = new AudioDataHolder(abs);
                            let rf = new SprRecordingFile(sessId, itemcode, version, adh);
                            if (this.debugDelay > 0) {
                                window.setTimeout(() => {
                                    observer.next(rf);
                                    observer.complete();
                                }, this.debugDelay);
                            }
                            else {
                                observer.next(rf);
                                observer.complete();
                            }
                        }).catch((reason) => { observer.error(reason); });
                    }
                    else {
                        observer.error();
                    }
                },
                error: (err) => {
                    if (err instanceof HttpErrorResponse && err.status == 404) {
                        // Interpret not as an error, the file ist not recorded yet
                        observer.next(null);
                        observer.complete();
                    }
                    else {
                        // all other errors are real errors
                        observer.error(err);
                    }
                }
            });
        });
        return wobs;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.12", ngImport: i0, type: RecordingService, deps: [{ token: i1.HttpClient }, { token: SPEECHRECORDER_CONFIG }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "18.2.12", ngImport: i0, type: RecordingService }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.12", ngImport: i0, type: RecordingService, decorators: [{
            type: Injectable
        }], ctorParameters: () => [{ type: i1.HttpClient }, { type: SpeechRecorderConfig, decorators: [{
                    type: Inject,
                    args: [SPEECHRECORDER_CONFIG]
                }] }] });

class Item {
    constructor(_promptAsString, _training, _recording) {
        this._promptAsString = _promptAsString;
        this._training = _training;
        this._recording = _recording;
        this.recs = null;
    }
    itemDone() {
        let done = false;
        if (this.recs) {
            for (let rf of this.recs) {
                if (rf.recordingFileDone()) {
                    done = true;
                    break;
                }
            }
        }
        return done;
    }
    get promptAsString() {
        return this._promptAsString;
    }
    get training() {
        return this._training;
    }
    get recording() {
        return this._recording;
    }
}

const DEFAULT_WARN_DB_LEVEL$1 = -2;
const MIN_DB_LEVEL$2 = -60.0;
const CONSIDERED_SILENCE_DB_LEVEL = MIN_DB_LEVEL$2 * 2;
const LINE_WIDTH = 2;
const LINE_DISTANCE = 2;
const LEVEL_INDICATOR_HEIGHT = 3;
const OVERFLOW_THRESHOLD = 0.25;
const OVERFLOW_INCR_FACTOR = 0.5;
var State;
(function (State) {
    State[State["LOADING"] = 0] = "LOADING";
    State[State["RENDERING"] = 1] = "RENDERING";
    State[State["READY"] = 2] = "READY";
})(State || (State = {}));
class LevelBar {
    constructor(ref, changeDetectorRef) {
        this.ref = ref;
        this.changeDetectorRef = changeDetectorRef;
        this.pixelsPerValue = LINE_DISTANCE + LINE_WIDTH;
        this.peakDbLvl = MIN_DB_LEVEL$2;
        this._streamingMode = false;
        this._streamingFrameLength = 0;
        this._staticLevelInfos = null;
        this._playFramePosition = null;
        this._state = null;
        this.warnDBLevel = DEFAULT_WARN_DB_LEVEL$1;
        this.dbValues = new Array();
    }
    ngAfterViewInit() {
        this.ce = this.ref.nativeElement;
        this.liveLevelCanvas = this.liveLevelCanvasRef.nativeElement;
        this.markerCanvas = this.markerCanvasRef.nativeElement;
        this.markerCanvas.style.zIndex = '4';
        this.virtualCanvas = this.virtualCanvasRef.nativeElement;
        this.layout();
        this.drawAll();
    }
    onScroll(se) {
        setTimeout(() => {
            this.updateViewportPosition();
            this.drawAll();
            this.drawPlayPosition();
        });
    }
    updateViewportPosition() {
        // Move canvases to visible viewport position
        let viewPortStyleLeft = this.ce.scrollLeft + 'px';
        this.liveLevelCanvas.style.left = viewPortStyleLeft;
        this.markerCanvas.style.left = viewPortStyleLeft;
    }
    set streamingMode(streamingMode) {
        if (this._streamingMode !== streamingMode) {
            this._streamingMode = streamingMode;
            this.reset();
            this.layoutStatic();
        }
    }
    set displayLevelInfos(levelInfos) {
        if (levelInfos) {
            this._staticLevelInfos = levelInfos;
            this.dbValues = levelInfos.bufferLevelInfos.map((li) => {
                return li.powerLevelsDB();
            });
        }
        else {
            this._staticLevelInfos = null;
            this.dbValues = new Array();
        }
        this.layoutStatic();
    }
    set state(state) {
        this._state = state;
        this.layoutStatic();
    }
    set channelCount(channelCount) {
        this.reset();
    }
    set playFramePosition(playFramePosition) {
        this._playFramePosition = playFramePosition;
        this.drawPlayPosition();
    }
    onResize(event) {
        this.layout();
        this.drawAll();
    }
    layout() {
        // set Canvas size to viewport size
        this.liveLevelCanvas.width = this.ce.offsetWidth;
        this.liveLevelCanvas.height = this.ce.offsetHeight;
        this.markerCanvas.width = this.ce.offsetWidth;
        this.markerCanvas.height = this.ce.offsetHeight;
        // and move to viewport position
        this.updateViewportPosition();
        this.drawAll();
        this.drawPlayPosition();
    }
    update(levelInfos) {
        if (this._streamingMode) {
            let dbVals = levelInfos.powerLevelsDB();
            let peakDBVal = levelInfos.powerLevelDB();
            this._streamingFrameLength += levelInfos.frameLength;
            //console.debug("Update level info frameLength: "+levelInfos.frameLength+", total streaming frame length: "+this._streamingFrameLength);
            if (this.peakDbLvl < peakDBVal) {
                this.peakDbLvl = peakDBVal;
                this.changeDetectorRef.detectChanges();
            }
            this.dbValues.push(dbVals);
            let i = this.dbValues.length - 1;
            let x = i * this.pixelsPerValue;
            this.drawPushValue(x, dbVals);
            this.checkWidth();
        }
    }
    streamFinished() {
        this.layoutStatic();
    }
    layoutStatic() {
        let requiredWidth = Math.round(this.dbValues.length * this.pixelsPerValue);
        if (this.virtualCanvas && this.ce) {
            this.virtualCanvas.style.width = requiredWidth + 'px';
            this.ce.scrollLeft = requiredWidth - this.ce.offsetWidth;
            this.layout();
        }
    }
    checkWidth() {
        let requiredWidth = this.dbValues.length * this.pixelsPerValue;
        if (this.virtualCanvas.offsetWidth - requiredWidth < this.ce.offsetWidth * OVERFLOW_THRESHOLD) {
            let newWidth = Math.floor(this.virtualCanvas.offsetWidth + (this.ce.offsetWidth * OVERFLOW_INCR_FACTOR));
            this.virtualCanvas.style.width = newWidth + 'px';
            this.ce.scrollLeft = newWidth - this.ce.offsetWidth;
            // do not call layout here it is triggered by the scroll event
            //this.layout();
        }
    }
    reset(stat = false) {
        this.peakDbLvl = MIN_DB_LEVEL$2;
        this.dbValues = new Array();
        this._streamingFrameLength = 0;
        if (stat) {
            this.layoutStatic();
        }
        else {
            this.layout();
        }
        this.drawAll();
        this.drawPlayPosition();
    }
    drawLevelBackground(g, x, h) {
        g.strokeStyle = 'black';
        g.fillStyle = 'black';
        g.fillRect(x, 0, this.pixelsPerValue, h);
    }
    // private drawLevelLine(g: CanvasRenderingContext2D, x: number, h: number, dbVal: number) {
    //   //translate to viewport
    //   let xc = x - this.ce.scrollLeft;
    //
    //   this.drawLevelBackground(g,xc,h);
    //   g.lineWidth = LINE_WIDTH;
    //   if (dbVal >= this.warnDBLevel) {
    //     g.strokeStyle = 'red';
    //     g.fillStyle = 'red';
    //
    //   } else {
    //     g.strokeStyle = '#00c853';
    //     g.fillStyle = '#00c853';
    //   }
    //   g.beginPath();
    //   g.moveTo(xc, h);
    //   let pVal = ((dbVal - MIN_DB_LEVEL) / -MIN_DB_LEVEL) * h;
    //
    //   g.lineTo(xc, h - pVal);
    //   g.closePath();
    //   g.stroke();
    //
    // }
    drawLevelLines(g, x, h, dbVals) {
        //translate to viewport
        let xc = x - this.ce.scrollLeft;
        this.drawLevelBackground(g, xc, h);
        let chH = Math.floor(h / dbVals.length);
        g.lineWidth = LINE_WIDTH;
        for (let ch = 0; ch < dbVals.length; ch++) {
            let dbVal = dbVals[ch];
            let y = Math.floor(ch * chH);
            if (dbVal >= this.warnDBLevel) {
                g.strokeStyle = 'red';
                g.fillStyle = 'red';
            }
            else if (dbVal < CONSIDERED_SILENCE_DB_LEVEL) {
                g.strokeStyle = 'grey';
                g.fillStyle = 'grey';
            }
            else {
                g.strokeStyle = '#00c853';
                g.fillStyle = '#00c853';
            }
            g.beginPath();
            g.moveTo(xc, y + chH);
            g.lineTo(xc, y + chH - LEVEL_INDICATOR_HEIGHT);
            let pnVal = ((dbVal - MIN_DB_LEVEL$2) / -MIN_DB_LEVEL$2);
            let lvlIndicatorSpace = LEVEL_INDICATOR_HEIGHT + LINE_DISTANCE;
            let levelH = chH - lvlIndicatorSpace;
            let pVal = pnVal * levelH;
            if (pVal > levelH - 1) {
                pVal = levelH - 1;
            }
            else if (pVal < 0) {
                pVal = 0;
            }
            g.moveTo(xc, y + chH - lvlIndicatorSpace);
            g.lineTo(xc, y + chH - lvlIndicatorSpace - pVal);
            g.closePath();
            g.stroke();
        }
    }
    drawPushValue(x, dbVals) {
        if (this.liveLevelCanvas) {
            let h = this.liveLevelCanvas.height;
            let g = this.liveLevelCanvas.getContext("2d");
            if (g) {
                this.drawLevelLines(g, x, h, dbVals);
            }
        }
    }
    drawAll() {
        if (this.liveLevelCanvas) {
            let w = this.liveLevelCanvas.width;
            let h = this.liveLevelCanvas.height;
            let g = this.liveLevelCanvas.getContext("2d");
            if (g) {
                // clear canvas
                g.fillStyle = 'grey';
                g.fillRect(0, 0, w, h);
                g.lineWidth = LINE_WIDTH;
                if (this.dbValues.length > 0) {
                    // draw only viewport part:
                    // draw from x1 to x2
                    let x1 = this.ce.scrollLeft;
                    let x2 = x1 + this.ce.offsetWidth;
                    // corresponds to this level values:
                    let i1 = Math.floor(x1 / this.pixelsPerValue);
                    let i2 = Math.ceil(x2 / this.pixelsPerValue);
                    // some values around
                    i1 -= 2;
                    i2 += 2;
                    // limits
                    if (i1 < 0) {
                        i1 = 0;
                    }
                    if (i2 > this.dbValues.length) {
                        i2 = this.dbValues.length;
                    }
                    let c = 0;
                    for (let i = i1; i < i2; i++) {
                        let x = i * this.pixelsPerValue;
                        let dbVals = this.dbValues[i];
                        if (dbVals) {
                            this.drawLevelLines(g, x, h, dbVals);
                            c++;
                        }
                    }
                }
                else if (this._state !== State.READY) {
                    g.strokeStyle = 'white';
                    g.fillStyle = 'white';
                    g.font = '20px sans-serif';
                    let stateTxt = '';
                    if (this._state === State.LOADING) {
                        stateTxt = "Loading...";
                    }
                    else if (this._state === State.RENDERING) {
                        stateTxt = "Rendering...";
                    }
                    g.fillText(stateTxt, 10, 25);
                }
            }
        }
    }
    framesPerPixel() {
        let fpp = null;
        // one buffer
        if (this._staticLevelInfos) {
            let framesPerBuffer = this._staticLevelInfos.framesPerBuffer();
            fpp = framesPerBuffer / this.pixelsPerValue;
        }
        else {
            if (this.dbValues && this.dbValues.length > 0) {
                fpp = this._streamingFrameLength / (this.dbValues.length * this.pixelsPerValue);
            }
        }
        return fpp;
    }
    drawPlayPosition() {
        if (this.markerCanvas) {
            let w = this.markerCanvas.width;
            let h = this.markerCanvas.height;
            let g = this.markerCanvas.getContext("2d");
            if (g) {
                g.clearRect(0, 0, w, h);
                let framesPerPixel = this.framesPerPixel();
                if (framesPerPixel && this._playFramePosition) {
                    let x = this._playFramePosition / framesPerPixel;
                    // Get position in viewport
                    let xc = x - this.ce.scrollLeft;
                    // Only draw if inside marker (viewport) canvas
                    if (xc >= 0 && xc <= w) {
                        g.fillStyle = 'red';
                        g.strokeStyle = 'red';
                        g.lineWidth = LINE_WIDTH;
                        g.beginPath();
                        // paint over all channels
                        g.moveTo(xc, 0);
                        g.lineTo(xc, h);
                        g.closePath();
                        g.stroke();
                    }
                }
            }
        }
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.12", ngImport: i0, type: LevelBar, deps: [{ token: i0.ElementRef }, { token: i0.ChangeDetectorRef }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "18.2.12", type: LevelBar, selector: "audio-levelbar", inputs: { streamingMode: "streamingMode", displayLevelInfos: "displayLevelInfos", state: "state" }, host: { listeners: { "scroll": "onScroll($event)", "window:resize": "onResize($event)" } }, viewQueries: [{ propertyName: "virtualCanvasRef", first: true, predicate: ["virtualCanvas"], descendants: true, static: true }, { propertyName: "liveLevelCanvasRef", first: true, predicate: ["levelbar"], descendants: true, static: true }, { propertyName: "markerCanvasRef", first: true, predicate: ["markerCanvas"], descendants: true, static: true }], ngImport: i0, template: `
    <div #virtualCanvas>
      <canvas #levelbar></canvas>
      <canvas #markerCanvas></canvas>
    </div>
  `, isInline: true, styles: [":host{width:100%;background:#a9a9a9;box-sizing:border-box;height:100%;position:relative;overflow-x:scroll;overflow-y:auto}\n", "div{top:0;left:0;width:100%;height:100%;box-sizing:border-box}\n", "canvas{top:0;left:0;width:100%;height:100%;position:absolute}\n"] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.12", ngImport: i0, type: LevelBar, decorators: [{
            type: Component,
            args: [{ selector: 'audio-levelbar', template: `
    <div #virtualCanvas>
      <canvas #levelbar></canvas>
      <canvas #markerCanvas></canvas>
    </div>
  `, styles: [":host{width:100%;background:#a9a9a9;box-sizing:border-box;height:100%;position:relative;overflow-x:scroll;overflow-y:auto}\n", "div{top:0;left:0;width:100%;height:100%;box-sizing:border-box}\n", "canvas{top:0;left:0;width:100%;height:100%;position:absolute}\n"] }]
        }], ctorParameters: () => [{ type: i0.ElementRef }, { type: i0.ChangeDetectorRef }], propDecorators: { virtualCanvasRef: [{
                type: ViewChild,
                args: ['virtualCanvas', { static: true }]
            }], liveLevelCanvasRef: [{
                type: ViewChild,
                args: ['levelbar', { static: true }]
            }], markerCanvasRef: [{
                type: ViewChild,
                args: ['markerCanvas', { static: true }]
            }], onScroll: [{
                type: HostListener,
                args: ['scroll', ['$event']]
            }], streamingMode: [{
                type: Input
            }], displayLevelInfos: [{
                type: Input
            }], state: [{
                type: Input
            }], onResize: [{
                type: HostListener,
                args: ['window:resize', ['$event']]
            }] } });

class StatusDisplay {
    constructor() {
        this.statusAlertType = 'info';
        this.statusMsg = 'Initialize...';
        this.statusWaiting = false;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.12", ngImport: i0, type: StatusDisplay, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "18.2.12", type: StatusDisplay, selector: "app-sprstatusdisplay", inputs: { statusAlertType: "statusAlertType", statusMsg: "statusMsg", statusWaiting: "statusWaiting" }, ngImport: i0, template: `
    <p matTooltip="Status">
      <mat-progress-spinner *ngIf="statusWaiting" color="black"  mode="indeterminate" [diameter]="30" [strokeWidth]="5"></mat-progress-spinner><mat-icon *ngIf="statusAlertType==='error'" style="color:red">report_problem</mat-icon>
      {{statusMsg}}
    </p>
  `, isInline: true, styles: [":host{display:inline;text-align:left;font-size:smaller}\n", "p{padding:4px;white-space:nowrap;display:inline-block}\n", "mat-progress-spinner{color:#000;display:inline-block}\n", "span{color:red}\n"], dependencies: [{ kind: "directive", type: i1$1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "component", type: i2.MatIcon, selector: "mat-icon", inputs: ["color", "inline", "svgIcon", "fontSet", "fontIcon"], exportAs: ["matIcon"] }, { kind: "component", type: i3$1.MatProgressSpinner, selector: "mat-progress-spinner, mat-spinner", inputs: ["color", "mode", "value", "diameter", "strokeWidth"], exportAs: ["matProgressSpinner"] }, { kind: "directive", type: i4.MatTooltip, selector: "[matTooltip]", inputs: ["matTooltipPosition", "matTooltipPositionAtOrigin", "matTooltipDisabled", "matTooltipShowDelay", "matTooltipHideDelay", "matTooltipTouchGestures", "matTooltip", "matTooltipClass"], exportAs: ["matTooltip"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.12", ngImport: i0, type: StatusDisplay, decorators: [{
            type: Component,
            args: [{ selector: 'app-sprstatusdisplay', template: `
    <p matTooltip="Status">
      <mat-progress-spinner *ngIf="statusWaiting" color="black"  mode="indeterminate" [diameter]="30" [strokeWidth]="5"></mat-progress-spinner><mat-icon *ngIf="statusAlertType==='error'" style="color:red">report_problem</mat-icon>
      {{statusMsg}}
    </p>
  `, styles: [":host{display:inline;text-align:left;font-size:smaller}\n", "p{padding:4px;white-space:nowrap;display:inline-block}\n", "mat-progress-spinner{color:#000;display:inline-block}\n", "span{color:red}\n"] }]
        }], propDecorators: { statusAlertType: [{
                type: Input
            }], statusMsg: [{
                type: Input
            }], statusWaiting: [{
                type: Input
            }] } });
class UploadStatus {
    constructor() {
        this._awaitNewUpload = false;
        this.spinnerMode = 'determinate';
        this.colorStatus = 'primary';
        this._value = 100;
        this.displayValue = null;
        this.toolTipText = '';
    }
    _updateSpinner() {
        let uplMsg;
        if (this._awaitNewUpload || this._value === 0) {
            this.spinnerMode = 'indeterminate';
            this.displayValue = '&nbsp;&nbsp;&nbsp;&nbsp;';
            uplMsg = 'Preparing upload.';
        }
        else {
            this.spinnerMode = 'determinate';
            this.displayValue = this._value + '%';
            if (this._value === 100) {
                uplMsg = 'Upload complete';
            }
            else {
                uplMsg = 'Upload progress: ' + this.displayValue;
            }
        }
        if (this.status === 'warn') {
            uplMsg = 'Upload error occurred. Please check your network connection. ' + uplMsg;
        }
        this.toolTipText = uplMsg;
    }
    set value(value) {
        this._value = value;
        this._updateSpinner();
    }
    ;
    set awaitNewUpload(awaitNewUpload) {
        this._awaitNewUpload = awaitNewUpload;
        this._updateSpinner();
    }
    set status(status) {
        this._status = status;
        if ('accent' === status) {
            this.colorStatus = 'accent';
        }
        else if ('warn' === status) {
            this.colorStatus = 'warn';
        }
        else {
            this.colorStatus = 'primary';
        }
        this._updateSpinner();
    }
    get status() {
        return this._status;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.12", ngImport: i0, type: UploadStatus, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "18.2.12", type: UploadStatus, selector: "app-uploadstatus", inputs: { value: "value", awaitNewUpload: "awaitNewUpload", status: "status" }, ngImport: i0, template: `
    <mat-progress-spinner [mode]="spinnerMode" [color]="colorStatus" [diameter]="30" [strokeWidth]="5" [value]="_value"
                          [matTooltip]="toolTipText"></mat-progress-spinner>
  `, isInline: true, styles: [":host{text-align:left}\n", "mat-progress-spinner{display:inline-block}\n"], dependencies: [{ kind: "component", type: i3$1.MatProgressSpinner, selector: "mat-progress-spinner, mat-spinner", inputs: ["color", "mode", "value", "diameter", "strokeWidth"], exportAs: ["matProgressSpinner"] }, { kind: "directive", type: i4.MatTooltip, selector: "[matTooltip]", inputs: ["matTooltipPosition", "matTooltipPositionAtOrigin", "matTooltipDisabled", "matTooltipShowDelay", "matTooltipHideDelay", "matTooltipTouchGestures", "matTooltip", "matTooltipClass"], exportAs: ["matTooltip"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.12", ngImport: i0, type: UploadStatus, decorators: [{
            type: Component,
            args: [{ selector: 'app-uploadstatus', template: `
    <mat-progress-spinner [mode]="spinnerMode" [color]="colorStatus" [diameter]="30" [strokeWidth]="5" [value]="_value"
                          [matTooltip]="toolTipText"></mat-progress-spinner>
  `, styles: [":host{text-align:left}\n", "mat-progress-spinner{display:inline-block}\n"] }]
        }], propDecorators: { value: [{
                type: Input
            }], awaitNewUpload: [{
                type: Input
            }], status: [{
                type: Input
            }] } });
class ProgressDisplay {
    constructor() {
        this.progressMsg = '[itemcode]';
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.12", ngImport: i0, type: ProgressDisplay, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "18.2.12", type: ProgressDisplay, selector: "app-sprprogressdisplay", ngImport: i0, template: `
    <p>{{progressMsg}}</p>
  `, isInline: true, styles: [":host{flex:1;width:100%;text-align:left}\n"] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.12", ngImport: i0, type: ProgressDisplay, decorators: [{
            type: Component,
            args: [{ selector: 'app-sprprogressdisplay', template: `
    <p>{{progressMsg}}</p>
  `, styles: [":host{flex:1;width:100%;text-align:left}\n"] }]
        }] });
class TransportActions {
    constructor() {
        this.startAction = new Action('Start');
        this.stopAction = new Action('Stop');
        this.nextAction = new Action('Next');
        this.pauseAction = new Action('Pause');
        this.fwdNextAction = new Action('Next recording');
        this.fwdAction = new Action('Forward');
        this.bwdAction = new Action('Backward');
        this.stopNonrecordingAction = new Action('Next');
    }
}
class TransportPanel extends ResponsiveComponent {
    constructor(breakpointObserver) {
        super(breakpointObserver);
        this.navigationEnabled = true;
        this.pausingEnabled = true;
    }
    startDisabled() {
        return !this.actions || this.readonly || this.actions.startAction.disabled;
    }
    stopDisabled() {
        return !this.actions || this.actions.stopAction.disabled;
    }
    nextDisabled() {
        return !this.actions || this.actions.nextAction.disabled || !this.navigationEnabled;
    }
    stopNonrecordingDisabled() {
        return !this.actions || this.actions.stopNonrecordingAction.disabled || !this.navigationEnabled;
    }
    pauseDisabled() {
        return !this.actions || this.actions.pauseAction.disabled || !this.pausingEnabled;
    }
    fwdDisabled() {
        return !this.actions || this.actions.fwdAction.disabled || !this.navigationEnabled;
    }
    fwdNextDisabled() {
        return !this.actions || this.actions.fwdNextAction.disabled || !this.navigationEnabled;
    }
    bwdDisabled() {
        return !this.actions || this.actions.bwdAction.disabled || !this.navigationEnabled;
    }
    startStopNextName() {
        if (!this.nextDisabled() || !this.stopNonrecordingDisabled()) {
            this.startStopNextButtonName = "Next";
        }
        else if (!this.startDisabled()) {
            this.startStopNextButtonName = "Start";
        }
        else if (!this.stopDisabled()) {
            this.startStopNextButtonName = "Stop";
        }
        return this.startStopNextButtonName;
    }
    startStopNextIconName() {
        if (!this.startDisabled()) {
            this.startStopNextButtonIconName = "fiber_manual_record";
        }
        else if (!this.stopDisabled() || !this.stopNonrecordingDisabled()) {
            this.startStopNextButtonIconName = "stop";
        }
        else if (!this.nextDisabled()) {
            this.startStopNextButtonIconName = "stop";
        }
        return this.startStopNextButtonIconName;
    }
    startStopNextIconColor() {
        if (!this.startDisabled()) {
            return "red";
        }
        else if (!this.stopDisabled() || !this.nextDisabled()) {
            return "yellow";
        }
        else {
            return "grey";
        }
    }
    startStopNextPerform() {
        if (!this.startDisabled()) {
            this.actions.startAction.perform();
        }
        else if (!this.stopDisabled()) {
            this.actions.stopAction.perform();
        }
        else if (!this.nextDisabled()) {
            this.actions.nextAction.perform();
        }
        else if (!this.stopNonrecordingDisabled()) {
            this.actions.stopNonrecordingAction.perform();
        }
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.12", ngImport: i0, type: TransportPanel, deps: [{ token: i1$2.BreakpointObserver }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "18.2.12", type: TransportPanel, selector: "app-sprtransport", inputs: { readonly: "readonly", actions: "actions", navigationEnabled: "navigationEnabled", pausingEnabled: "pausingEnabled" }, usesInheritance: true, ngImport: i0, template: `
    <button id="bwdBtn" *ngIf="navigationEnabled"  (click)="actions.bwdAction.perform()" [disabled]="bwdDisabled()"
            mat-raised-button class="transport-button-icon">
      <span><mat-icon>chevron_left</mat-icon></span>
    </button>
    <button (click)="startStopNextPerform()" [disabled]="startDisabled() && stopDisabled() && nextDisabled() && stopNonrecordingDisabled()"  mat-raised-button  class="transport-button-icon">
      <span><mat-icon class="transport-button-icon" [style.color]="startStopNextIconColor()">{{startStopNextIconName()}}</mat-icon><mat-icon class="transport-button-icon" *ngIf="!nextDisabled() || !stopNonrecordingDisabled()" [style.color]="nextDisabled() ? 'grey' : 'black'">chevron_right</mat-icon></span>
      <span *ngIf="!screenXs" class="transport-button-text">{{startStopNextName()}}</span>
    </button>
    <button *ngIf="pausingEnabled" (click)="actions.pauseAction.perform()" [disabled]="pauseDisabled()" mat-raised-button  class="transport-button-icon">
      <span><mat-icon class="transport-button-icon">pause</mat-icon></span>
      <span *ngIf="!screenXs" class="transport-button-text">Pause</span>
    </button>
    <button id="fwdNextBtn" *ngIf="navigationEnabled && !screenXs" (click)="actions.fwdNextAction.perform()" [disabled]="fwdNextDisabled()" mat-raised-button class="transport-button-icon">
      <span><mat-icon>redo</mat-icon></span>
    </button>
    <button id="fwdBtn" *ngIf="navigationEnabled"  (click)="actions.fwdAction.perform()" [disabled]="fwdDisabled()" mat-raised-button class="transport-button-icon">
      <span><mat-icon>chevron_right</mat-icon></span>
    </button>

  `, isInline: true, styles: [":host{flex:20;align-self:center;width:100%;text-align:center;align-content:center;margin:0}\n", "div{display:inline;flex:0}\n", "button{touch-action:manipulation}\n", ".transport-button-icon{font-size:24px;vertical-align:middle;overflow:hidden;text-overflow:clip;white-space:nowrap}\n", ".transport-button-text{font-size:14px;letter-spacing:normal;vertical-align:baseline}\n"], dependencies: [{ kind: "directive", type: i1$1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "component", type: i2.MatIcon, selector: "mat-icon", inputs: ["color", "inline", "svgIcon", "fontSet", "fontIcon"], exportAs: ["matIcon"] }, { kind: "component", type: i3.MatButton, selector: "    button[mat-button], button[mat-raised-button], button[mat-flat-button],    button[mat-stroked-button]  ", exportAs: ["matButton"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.12", ngImport: i0, type: TransportPanel, decorators: [{
            type: Component,
            args: [{ selector: 'app-sprtransport', template: `
    <button id="bwdBtn" *ngIf="navigationEnabled"  (click)="actions.bwdAction.perform()" [disabled]="bwdDisabled()"
            mat-raised-button class="transport-button-icon">
      <span><mat-icon>chevron_left</mat-icon></span>
    </button>
    <button (click)="startStopNextPerform()" [disabled]="startDisabled() && stopDisabled() && nextDisabled() && stopNonrecordingDisabled()"  mat-raised-button  class="transport-button-icon">
      <span><mat-icon class="transport-button-icon" [style.color]="startStopNextIconColor()">{{startStopNextIconName()}}</mat-icon><mat-icon class="transport-button-icon" *ngIf="!nextDisabled() || !stopNonrecordingDisabled()" [style.color]="nextDisabled() ? 'grey' : 'black'">chevron_right</mat-icon></span>
      <span *ngIf="!screenXs" class="transport-button-text">{{startStopNextName()}}</span>
    </button>
    <button *ngIf="pausingEnabled" (click)="actions.pauseAction.perform()" [disabled]="pauseDisabled()" mat-raised-button  class="transport-button-icon">
      <span><mat-icon class="transport-button-icon">pause</mat-icon></span>
      <span *ngIf="!screenXs" class="transport-button-text">Pause</span>
    </button>
    <button id="fwdNextBtn" *ngIf="navigationEnabled && !screenXs" (click)="actions.fwdNextAction.perform()" [disabled]="fwdNextDisabled()" mat-raised-button class="transport-button-icon">
      <span><mat-icon>redo</mat-icon></span>
    </button>
    <button id="fwdBtn" *ngIf="navigationEnabled"  (click)="actions.fwdAction.perform()" [disabled]="fwdDisabled()" mat-raised-button class="transport-button-icon">
      <span><mat-icon>chevron_right</mat-icon></span>
    </button>

  `, styles: [":host{flex:20;align-self:center;width:100%;text-align:center;align-content:center;margin:0}\n", "div{display:inline;flex:0}\n", "button{touch-action:manipulation}\n", ".transport-button-icon{font-size:24px;vertical-align:middle;overflow:hidden;text-overflow:clip;white-space:nowrap}\n", ".transport-button-text{font-size:14px;letter-spacing:normal;vertical-align:baseline}\n"] }]
        }], ctorParameters: () => [{ type: i1$2.BreakpointObserver }], propDecorators: { readonly: [{
                type: Input
            }], actions: [{
                type: Input
            }], navigationEnabled: [{
                type: Input
            }], pausingEnabled: [{
                type: Input
            }] } });
class WakeLockIndicator {
    constructor() {
        this._screenLocked = false;
    }
    set screenLocked(screenLock) {
        this._screenLocked = screenLock;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.12", ngImport: i0, type: WakeLockIndicator, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "18.2.12", type: WakeLockIndicator, selector: "app-wakelockindicator", inputs: { screenLocked: "screenLocked" }, ngImport: i0, template: `
    <mat-icon *ngIf="_screenLocked">screen_lock_portrait</mat-icon>
  `, isInline: true, dependencies: [{ kind: "directive", type: i1$1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "component", type: i2.MatIcon, selector: "mat-icon", inputs: ["color", "inline", "svgIcon", "fontSet", "fontIcon"], exportAs: ["matIcon"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.12", ngImport: i0, type: WakeLockIndicator, decorators: [{
            type: Component,
            args: [{ selector: 'app-wakelockindicator', template: `
    <mat-icon *ngIf="_screenLocked">screen_lock_portrait</mat-icon>
  ` }]
        }], ctorParameters: () => [], propDecorators: { screenLocked: [{
                type: Input
            }] } });
class ReadyStateIndicator {
    constructor() {
        this._ready = true;
        this.hourGlassIconName = 'hourglass_empty';
        this.readyStateToolTip = '';
    }
    set ready(ready) {
        this._ready = ready;
        this.hourGlassIconName = this._ready ? 'hourglass_empty' : 'hourglass_full';
        this.readyStateToolTip = this._ready ? 'Audio processing and upload done. You can leave the page without data loss.' : 'Please wait until audio processing and upload have finished. Please do not leave the page.';
    }
    get ready() {
        return this._ready;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.12", ngImport: i0, type: ReadyStateIndicator, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "18.2.12", type: ReadyStateIndicator, selector: "app-readystateindicator", inputs: { ready: "ready" }, ngImport: i0, template: `
    <mat-icon [matTooltip]="readyStateToolTip">{{hourGlassIconName}}</mat-icon>
  `, isInline: true, dependencies: [{ kind: "component", type: i2.MatIcon, selector: "mat-icon", inputs: ["color", "inline", "svgIcon", "fontSet", "fontIcon"], exportAs: ["matIcon"] }, { kind: "directive", type: i4.MatTooltip, selector: "[matTooltip]", inputs: ["matTooltipPosition", "matTooltipPositionAtOrigin", "matTooltipDisabled", "matTooltipShowDelay", "matTooltipHideDelay", "matTooltipTouchGestures", "matTooltip", "matTooltipClass"], exportAs: ["matTooltip"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.12", ngImport: i0, type: ReadyStateIndicator, decorators: [{
            type: Component,
            args: [{ selector: 'app-readystateindicator', template: `
    <mat-icon [matTooltip]="readyStateToolTip">{{hourGlassIconName}}</mat-icon>
  ` }]
        }], ctorParameters: () => [], propDecorators: { ready: [{
                type: Input
            }] } });
class ControlPanel extends ResponsiveComponent {
    constructor(bpo, dialog) {
        super(bpo);
        this.bpo = bpo;
        this.dialog = dialog;
        this.processing = false;
        this.navigationEnabled = true;
        this._ready = true;
    }
    set ready(ready) {
        this._ready = ready;
    }
    get ready() {
        return this._ready;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.12", ngImport: i0, type: ControlPanel, deps: [{ token: i1$2.BreakpointObserver }, { token: i1$3.MatDialog }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "18.2.12", type: ControlPanel, selector: "app-sprcontrolpanel", inputs: { readonly: "readonly", transportActions: "transportActions", processing: "processing", statusMsg: "statusMsg", statusAlertType: "statusAlertType", statusWaiting: "statusWaiting", uploadStatus: "uploadStatus", uploadProgress: "uploadProgress", currentRecording: "currentRecording", enableUploadRecordings: "enableUploadRecordings", navigationEnabled: "navigationEnabled", ready: "ready" }, viewQueries: [{ propertyName: "statusDisplay", first: true, predicate: StatusDisplay, descendants: true, static: true }, { propertyName: "transportPanel", first: true, predicate: TransportPanel, descendants: true, static: true }], usesInheritance: true, ngImport: i0, template: `
    <div *ngIf="!screenXs" style="flex-direction: row" >
     <app-sprstatusdisplay style="flex:0 0 0" [statusMsg]="statusMsg" [statusAlertType]="statusAlertType" [statusWaiting]="statusWaiting"
                          class="hidden-xs"></app-sprstatusdisplay>
      <app-sprtransport style="flex:10 0 0" [readonly]="readonly" [actions]="transportActions" [navigationEnabled]="navigationEnabled"></app-sprtransport>
      <app-uploadstatus style="flex:0 0 0" *ngIf="enableUploadRecordings" [value]="uploadProgress"
                      [status]="uploadStatus" [awaitNewUpload]="processing"></app-uploadstatus>
      <app-readystateindicator [ready]="_ready"></app-readystateindicator>
    </div>
    <div *ngIf="screenXs" style="flex-direction: column">
      <div style="flex-direction: row" class="flexFill" >
       <app-sprstatusdisplay style="flex:10 0 0" [statusMsg]="statusMsg" [statusAlertType]="statusAlertType" [statusWaiting]="statusWaiting"
                            class="hidden-xs"></app-sprstatusdisplay>
       <app-uploadstatus style="flex:0 0 0" *ngIf="enableUploadRecordings" [value]="uploadProgress"
                        [status]="uploadStatus" [awaitNewUpload]="processing"></app-uploadstatus>
        <app-readystateindicator [ready]="_ready"></app-readystateindicator>
      </div>
      <app-sprtransport [readonly]="readonly" [actions]="transportActions" [navigationEnabled]="navigationEnabled"></app-sprtransport>

    </div>
  `, isInline: true, styles: ["div{align-content:center;align-items:center;margin:0;padding:20px;min-height:min-content}\n"], dependencies: [{ kind: "directive", type: i1$1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "component", type: StatusDisplay, selector: "app-sprstatusdisplay", inputs: ["statusAlertType", "statusMsg", "statusWaiting"] }, { kind: "component", type: UploadStatus, selector: "app-uploadstatus", inputs: ["value", "awaitNewUpload", "status"] }, { kind: "component", type: TransportPanel, selector: "app-sprtransport", inputs: ["readonly", "actions", "navigationEnabled", "pausingEnabled"] }, { kind: "component", type: ReadyStateIndicator, selector: "app-readystateindicator", inputs: ["ready"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.12", ngImport: i0, type: ControlPanel, decorators: [{
            type: Component,
            args: [{ selector: 'app-sprcontrolpanel', template: `
    <div *ngIf="!screenXs" style="flex-direction: row" >
     <app-sprstatusdisplay style="flex:0 0 0" [statusMsg]="statusMsg" [statusAlertType]="statusAlertType" [statusWaiting]="statusWaiting"
                          class="hidden-xs"></app-sprstatusdisplay>
      <app-sprtransport style="flex:10 0 0" [readonly]="readonly" [actions]="transportActions" [navigationEnabled]="navigationEnabled"></app-sprtransport>
      <app-uploadstatus style="flex:0 0 0" *ngIf="enableUploadRecordings" [value]="uploadProgress"
                      [status]="uploadStatus" [awaitNewUpload]="processing"></app-uploadstatus>
      <app-readystateindicator [ready]="_ready"></app-readystateindicator>
    </div>
    <div *ngIf="screenXs" style="flex-direction: column">
      <div style="flex-direction: row" class="flexFill" >
       <app-sprstatusdisplay style="flex:10 0 0" [statusMsg]="statusMsg" [statusAlertType]="statusAlertType" [statusWaiting]="statusWaiting"
                            class="hidden-xs"></app-sprstatusdisplay>
       <app-uploadstatus style="flex:0 0 0" *ngIf="enableUploadRecordings" [value]="uploadProgress"
                        [status]="uploadStatus" [awaitNewUpload]="processing"></app-uploadstatus>
        <app-readystateindicator [ready]="_ready"></app-readystateindicator>
      </div>
      <app-sprtransport [readonly]="readonly" [actions]="transportActions" [navigationEnabled]="navigationEnabled"></app-sprtransport>

    </div>
  `, styles: ["div{align-content:center;align-items:center;margin:0;padding:20px;min-height:min-content}\n"] }]
        }], ctorParameters: () => [{ type: i1$2.BreakpointObserver }, { type: i1$3.MatDialog }], propDecorators: { statusDisplay: [{
                type: ViewChild,
                args: [StatusDisplay, { static: true }]
            }], transportPanel: [{
                type: ViewChild,
                args: [TransportPanel, { static: true }]
            }], readonly: [{
                type: Input
            }], transportActions: [{
                type: Input
            }], processing: [{
                type: Input
            }], statusMsg: [{
                type: Input
            }], statusAlertType: [{
                type: Input
            }], statusWaiting: [{
                type: Input
            }], uploadStatus: [{
                type: Input
            }], uploadProgress: [{
                type: Input
            }], currentRecording: [{
                type: Input
            }], enableUploadRecordings: [{
                type: Input
            }], navigationEnabled: [{
                type: Input
            }], ready: [{
                type: Input
            }] } });

class DSPUtils {
    static { this.OCTAVE_FACTOR = 1.0 / (Math.log(2) / Math.log(10)); }
    /**
     * Get normalized amplitude level in dB
     * @param linearLevel a normalized positive linear level (1.0 corresponds to 0dB)
     * @return level in dB
     */
    static toLevelInDB(linearLevel) {
        if (linearLevel < 0) {
            throw new RangeError('Linear level argument must be positive.');
        }
        return 10 * Math.log(linearLevel) / Math.log(10);
    }
    static toLinearLevel(dbLevel) {
        return Math.pow(10, (dbLevel / 10));
    }
    /**
     * Get normalized amplitude power level in dB
     * @param linearLevel a normalized positive linear level (1.0 corresponds to 0dB)
     * @return power level in dB
     */
    static toPowerLevelInDB(linearLevel) {
        if (linearLevel < 0) {
            throw new RangeError('Linear level argument must be positive.');
        }
        return 20 * Math.log(linearLevel) / Math.log(10);
    }
    static toPowerLinearLevel(dbLevel) {
        return Math.pow(10, (dbLevel / 20));
    }
    static toOctaves(fq) {
        return DSPUtils.OCTAVE_FACTOR * Math.log(fq) / Math.log(10);
    }
    static maxLevel(audioBuffer) {
        let ml = 0.0;
        for (let ch = 0; ch < audioBuffer.numberOfChannels; ch++) {
            const chArr = audioBuffer.getChannelData(ch);
            for (let s = 0; s < chArr.length; s++) {
                const l = Math.abs(chArr[s]);
                if (l > ml) {
                    ml = l;
                }
            }
        }
        return ml;
    }
}

const MIN_DB_LEVEL$1 = -40.0;
class LevelInfo {
    constructor(channelCount, startFrame = 0, frameLength = 0, minLinLevels, maxLinLevels) {
        this.channelCount = channelCount;
        this.startFrame = startFrame;
        this.frameLength = frameLength;
        this._minLinLevels = this.checkOrInitArray(minLinLevels);
        this._maxLinLevels = this.checkOrInitArray(maxLinLevels);
    }
    get minLinLevels() {
        return this._minLinLevels;
    }
    get maxLinLevels() {
        return this._maxLinLevels;
    }
    checkOrInitArray(arr) {
        if (arr) {
            if (arr.length !== this.channelCount)
                throw new Error("Level arrays must be equal to channel count " + this.channelCount);
            return arr;
        }
        else {
            return new Array(this.channelCount);
        }
    }
    merge(levelInfo) {
        if (levelInfo === null) {
            return;
        }
        if (this.channelCount !== levelInfo.channelCount) {
            throw new Error("Channel count of level info to merge must be equal. (" + this.channelCount + " != " + levelInfo.channelCount + ")");
        }
        let endFrame = this.startFrame + this.frameLength;
        let mergeEndFrame = levelInfo.startFrame + levelInfo.frameLength;
        if (levelInfo.startFrame < this.startFrame) {
            this.startFrame = levelInfo.startFrame;
        }
        if (mergeEndFrame > endFrame) {
            this.frameLength = mergeEndFrame - this.startFrame;
        }
        for (let ch = 0; ch < this.channelCount; ch++) {
            if (levelInfo.minLinLevels[ch] < this.minLinLevels[ch]) {
                this.minLinLevels[ch] = levelInfo.minLinLevels[ch];
            }
            if (levelInfo.maxLinLevels[ch] > this.maxLinLevels[ch]) {
                this.maxLinLevels[ch] = levelInfo.maxLinLevels[ch];
            }
        }
    }
    levelsLin() {
        let lvlsLin = new Array(this.channelCount);
        for (let ch = 0; ch < this.channelCount; ch++) {
            lvlsLin[ch] = Math.max(Math.abs(this.minLinLevels[ch]), Math.abs(this.maxLinLevels[ch]));
        }
        return lvlsLin;
    }
    powerLevelsDB() {
        let lvlsDb = new Array(this.channelCount);
        for (let ch = 0; ch < this.channelCount; ch++) {
            lvlsDb[ch] = DSPUtils.toPowerLevelInDB(this.levelsLin()[ch]);
        }
        return lvlsDb;
    }
    powerLevelDB() {
        let pLvlsDb = this.powerLevelsDB();
        return Math.max(...pLvlsDb);
    }
    clone() {
        return new LevelInfo(this.channelCount, this.startFrame, this.frameLength, Arrays.cloneNumberArray(this.minLinLevels), Arrays.cloneNumberArray(this.maxLinLevels));
    }
}
class LevelInfos {
    constructor(bufferLevelInfos, peakLevelInfo) {
        this.bufferLevelInfos = bufferLevelInfos;
        this.peakLevelInfo = peakLevelInfo;
    }
    framesPerBuffer() {
        if (this.bufferLevelInfos.length > 0) {
            return this.bufferLevelInfos[0].frameLength;
        }
        return this.peakLevelInfo.frameLength / this.bufferLevelInfos.length;
    }
}
class LevelMeasure {
    constructor() {
        this.workerURL = WorkerHelper.buildWorkerBlobURL(this.workerFunction);
    }
    calcBufferLevelInfos(audioDataHolder, bufferTimeLength) {
        return new Observable(subscriber => {
            let chs = audioDataHolder.numberOfChannels;
            let bufferFrameLength = Math.round(audioDataHolder.sampleRate * bufferTimeLength);
            let ais = audioDataHolder.audioInputStream();
            // Test: Check CRC
            //let crcVal:number=0;
            //let crclen:number=0;
            if (ais) {
                let audioBuffers = new Array(chs);
                let trBuffers = new Array(chs);
                for (let ch = 0; ch < chs; ch++) {
                    audioBuffers[ch] = new Float32Array(bufferFrameLength);
                }
                let bufferLevelInfos = new Array();
                let peakLevelInfo = new LevelInfo(chs);
                let worker = new Worker(this.workerURL);
                worker.onmessage = (me) => {
                    if (me.data.linLevelBuffers) {
                        let linLevelArrs = new Array(chs);
                        for (let ch = 0; ch < chs; ch++) {
                            linLevelArrs[ch] = new Float32Array(me.data.linLevelBuffers[ch]);
                        }
                        let bufferCount = Math.ceil(me.data.frameLength / me.data.bufferFrameLength);
                        let framePos = 0;
                        for (let bi = 0; bi < bufferCount; bi++) {
                            let minLevels = new Array(chs);
                            let maxLevels = new Array(chs);
                            for (let ch = 0; ch < chs; ch++) {
                                let linLvlArrPos = bi * 2;
                                minLevels[ch] = linLevelArrs[ch][linLvlArrPos];
                                maxLevels[ch] = linLevelArrs[ch][linLvlArrPos + 1];
                            }
                            let bli = new LevelInfo(chs, framePos, me.data.bufferFrameLength, minLevels, maxLevels);
                            bufferLevelInfos.push(bli);
                            peakLevelInfo.merge(bli);
                        }
                    }
                    if (me.data.eod === true) {
                        // end of data, terminate worker and return result
                        //this.terminateWorker();
                        worker.terminate();
                        ais?.close();
                        //console.debug("Audio input stream CRC hex: "+crcVal.toString(16)+", crcLen: "+crclen+", buffer frame len: "+bufferFrameLength);
                        subscriber.next(new LevelInfos(bufferLevelInfos, peakLevelInfo));
                        subscriber.complete();
                    }
                    else {
                        if (ais) {
                            let read = ais.read(audioBuffers);
                            // TEST:
                            // if(audioBuffers && audioBuffers.length>0) {
                            //   crcVal = crc32(audioBuffers[0].buffer, crcVal);
                            //   crclen += audioBuffers[0].buffer.byteLength;
                            //   //console.debug("trBuffers.length: "+trBuffers[0].length+", CRC len: "+crclen);
                            // }else{
                            //   console.debug("audioBuffers not avail!");
                            // }
                            for (let ch = 0; ch < chs; ch++) {
                                // let copy = new Float32Array(audioBuffers[ch]);
                                // trBuffers[ch] = copy.buffer;
                                const arrAbBufCh = audioBuffers[ch];
                                const adLen = arrAbBufCh.buffer.byteLength;
                                if (!trBuffers[ch] || trBuffers[ch].byteLength !== adLen) {
                                    trBuffers[ch] = new ArrayBuffer(adLen);
                                }
                                let fAdaCh = new Float32Array(trBuffers[ch]);
                                fAdaCh.set(audioBuffers[ch]);
                            }
                            worker.postMessage({
                                bufferFrameLength: bufferFrameLength,
                                audioData: trBuffers,
                                chs: chs,
                                len: read
                            }, trBuffers);
                        }
                    }
                };
                let read = ais.read(audioBuffers);
                // TEST:
                // if(audioBuffers && audioBuffers.length>0) {
                //   crcVal = crc32(audioBuffers[0].buffer, crcVal);
                //   crclen += audioBuffers[0].buffer.byteLength;
                //   //console.debug("trBuffers.length: "+trBuffers[0].length+", CRC len: "+crclen);
                // }else{
                //   console.debug("audioBuffers not avail!");
                // }
                for (let ch = 0; ch < chs; ch++) {
                    // let copy = new Float32Array(audioBuffers[ch]);
                    // trBuffers[ch] = copy.buffer;
                    const arrAbBufCh = audioBuffers[ch];
                    const adLen = arrAbBufCh.buffer.byteLength;
                    if (!trBuffers[ch] || trBuffers[ch].byteLength !== adLen) {
                        trBuffers[ch] = new ArrayBuffer(adLen);
                    }
                    let fAdaCh = new Float32Array(trBuffers[ch]);
                    fAdaCh.set(audioBuffers[ch]);
                }
                worker.postMessage({
                    bufferFrameLength: bufferFrameLength,
                    audioData: trBuffers,
                    chs: chs,
                    len: read
                }, trBuffers);
            }
            else {
                let aAis = audioDataHolder.asyncAudioInputStream();
                let audioBuffers = new Array(chs);
                let trBuffers = new Array(chs);
                for (let ch = 0; ch < chs; ch++) {
                    audioBuffers[ch] = new Float32Array(bufferFrameLength);
                }
                let bufferLevelInfos = new Array();
                let peakLevelInfo = new LevelInfo(chs);
                let worker = new Worker(this.workerURL);
                worker.onmessage = (me) => {
                    if (subscriber.closed) {
                        // subscriber abandoned
                        worker.terminate();
                        if (aAis) {
                            aAis.close();
                        }
                    }
                    else {
                        if (me.data.linLevelBuffers) {
                            let linLevelArrs = new Array(chs);
                            for (let ch = 0; ch < chs; ch++) {
                                linLevelArrs[ch] = new Float32Array(me.data.linLevelBuffers[ch]);
                            }
                            let bufferCount = Math.ceil(me.data.frameLength / me.data.bufferFrameLength);
                            let framePos = 0;
                            for (let bi = 0; bi < bufferCount; bi++) {
                                let minLevels = new Array(chs);
                                let maxLevels = new Array(chs);
                                for (let ch = 0; ch < chs; ch++) {
                                    let linLvlArrPos = bi * 2;
                                    minLevels[ch] = linLevelArrs[ch][linLvlArrPos];
                                    maxLevels[ch] = linLevelArrs[ch][linLvlArrPos + 1];
                                }
                                let bli = new LevelInfo(chs, framePos, me.data.bufferFrameLength, minLevels, maxLevels);
                                bufferLevelInfos.push(bli);
                                peakLevelInfo.merge(bli);
                            }
                        }
                        if (me.data.eod === true) {
                            // end of data, terminate worker and return result
                            //this.terminateWorker();
                            worker.terminate();
                            //ais?.close();
                            aAis?.close();
                            //console.debug("Audio input stream CRC hex: "+crcVal.toString(16)+", crcLen: "+crclen+", buffer frame len: "+bufferFrameLength);
                            subscriber.next(new LevelInfos(bufferLevelInfos, peakLevelInfo));
                            subscriber.complete();
                        }
                        else {
                            if (aAis) {
                                aAis?.readObs(audioBuffers).subscribe({
                                    next: (read) => {
                                        // TEST:
                                        // if(audioBuffers && audioBuffers.length>0) {
                                        //   crcVal = crc32(audioBuffers[0].buffer, crcVal);
                                        //   crclen += audioBuffers[0].buffer.byteLength;
                                        //   //console.debug("trBuffers.length: "+trBuffers[0].length+", CRC len: "+crclen);
                                        // }else{
                                        //   console.debug("audioBuffers not avail!");
                                        // }
                                        for (let ch = 0; ch < chs; ch++) {
                                            // let copy = new Float32Array(audioBuffers[ch]);
                                            // trBuffers[ch] = copy.buffer;
                                            const arrAbBufCh = audioBuffers[ch];
                                            const adLen = arrAbBufCh.buffer.byteLength;
                                            if (!trBuffers[ch] || trBuffers[ch].byteLength !== adLen) {
                                                trBuffers[ch] = new ArrayBuffer(adLen);
                                            }
                                            let fAdaCh = new Float32Array(trBuffers[ch]);
                                            fAdaCh.set(audioBuffers[ch]);
                                        }
                                        worker.postMessage({
                                            bufferFrameLength: bufferFrameLength,
                                            audioData: trBuffers,
                                            chs: chs,
                                            len: read
                                        }, trBuffers);
                                    }
                                });
                            }
                        }
                    }
                };
                aAis?.readObs(audioBuffers).subscribe({
                    next: (read) => {
                        // TEST:
                        // if(audioBuffers && audioBuffers.length>0) {
                        //   crcVal = crc32(audioBuffers[0].buffer, crcVal);
                        //   crclen += audioBuffers[0].buffer.byteLength;
                        //   //console.debug("trBuffers.length: "+trBuffers[0].length+", CRC len: "+crclen);
                        // }else{
                        //   console.debug("audioBuffers not avail!");
                        // }
                        for (let ch = 0; ch < chs; ch++) {
                            // let copy = new Float32Array(audioBuffers[ch]);
                            // trBuffers[ch] = copy.buffer;
                            const arrAbBufCh = audioBuffers[ch];
                            const adLen = arrAbBufCh.buffer.byteLength;
                            if (!trBuffers[ch] || trBuffers[ch].byteLength !== adLen) {
                                trBuffers[ch] = new ArrayBuffer(adLen);
                            }
                            let fAdaCh = new Float32Array(trBuffers[ch]);
                            fAdaCh.set(audioBuffers[ch]);
                        }
                        worker.postMessage({
                            bufferFrameLength: bufferFrameLength,
                            audioData: trBuffers,
                            chs: chs,
                            len: read
                        }, trBuffers);
                    }
                });
            }
        });
    }
    /*
     *  Method used as worker code.
     */
    workerFunction() {
        self.onmessage = function (msg) {
            let len = msg.data.len;
            let bufferFrameLength = msg.data.bufferFrameLength;
            if (len == -1) {
                // start
                postMessage({
                    eod: false,
                    bufferFrameLength: bufferFrameLength,
                    frameLength: len
                });
            }
            if (len == 0) {
                postMessage({
                    eod: true,
                    bufferFrameLength: bufferFrameLength,
                    frameLength: len
                });
            }
            else {
                let chs = msg.data.chs;
                let audioData = new Array(chs);
                let linLevels = new Array(chs);
                for (let ch = 0; ch < chs; ch++) {
                    audioData[ch] = new Float32Array(msg.data.audioData[ch]);
                }
                //let frameLength = audioData[0].length;
                let bufferCount = Math.ceil(len / bufferFrameLength);
                for (let ch = 0; ch < chs; ch++) {
                    linLevels[ch] = new Float32Array(bufferCount * 2);
                }
                if (audioData && chs > 0) {
                    for (let ch = 0; ch < chs; ch++) {
                        let chData = audioData[ch];
                        for (let s = 0; s < len; s++) {
                            let bi = Math.floor(s / bufferFrameLength);
                            let lvlArrPos = bi * 2;
                            //let bs = s % bufferFrameLength;
                            let chSample = chData[s];
                            if (chSample < linLevels[ch][lvlArrPos]) {
                                linLevels[ch][lvlArrPos] = chSample;
                            }
                            lvlArrPos++;
                            if (chSample > linLevels[ch][lvlArrPos]) {
                                linLevels[ch][lvlArrPos] = chSample;
                            }
                        }
                    }
                    const linLevelBufs = new Array(chs);
                    for (let ch = 0; ch < chs; ch++) {
                        linLevelBufs[ch] = linLevels[ch].buffer;
                    }
                    postMessage({
                        eod: false,
                        bufferFrameLength: bufferFrameLength,
                        frameLength: len,
                        linLevelBuffers: linLevelBufs
                    }, linLevelBufs);
                }
            }
        };
    }
}
class StreamLevelMeasure {
    constructor() {
        this.currentLevelInfos = null;
        this.peakLevelInfo = null;
        this.worker = null;
        this.channelCount = 0;
        this.bufferIndex = 0;
        this.frameCount = 0;
        this.levelListener = null;
        this.peakLevelListener = null;
        this.peakLevelInDb = MIN_DB_LEVEL$1;
        this.workerURL = WorkerHelper.buildWorkerBlobURL(this.workerFunction);
    }
    setFormat(channels, sampleRate) {
        this.channelCount = channels;
        this.currentLevelInfos = new LevelInfo(this.channelCount);
        this.peakLevelInfo = new LevelInfo(this.channelCount);
        this.worker = new Worker(this.workerURL);
        this.worker.onmessage = (me) => {
            let streamFinished = me.data.streamFinished;
            if (streamFinished) {
                if (this.levelListener) {
                    this.levelListener.streamFinished();
                }
            }
            else {
                let minLevels = new Array(this.channelCount);
                let maxLevels = new Array(this.channelCount);
                for (let ch = 0; ch < this.channelCount; ch++) {
                    let fls = new Float32Array(me.data.linLevelBuffers[ch]);
                    minLevels[ch] = fls[0];
                    maxLevels[ch] = fls[1];
                }
                let bi = new LevelInfo(this.channelCount, this.frameCount, me.data.frameLength, minLevels, maxLevels);
                this.updateLevels(bi);
            }
        };
    }
    nextStream() {
        this.reset();
    }
    reset() {
        this.currentLevelInfos = new LevelInfo(this.channelCount);
        this.peakLevelInfo = new LevelInfo(this.channelCount);
        if (this.levelListener) {
            this.levelListener.reset();
            this.levelListener.channelCount = this.channelCount;
        }
        if (this.peakLevelListener) {
            this.peakLevelInDb = MIN_DB_LEVEL$1;
            this.peakLevelListener(this.peakLevelInDb);
        }
    }
    write(bufferData) {
        let bufArrCopies = new Array(bufferData.length);
        let buffers = new Array(bufferData.length);
        for (let ch = 0; ch < bufferData.length; ch++) {
            bufArrCopies[ch] = bufferData[ch].slice();
            buffers[ch] = bufArrCopies[ch].buffer;
        }
        this.worker?.postMessage({
            streamFinished: false,
            audioData: buffers,
            chs: this.channelCount,
            bufferIndex: this.bufferIndex
        }, buffers);
        this.bufferIndex++;
        return bufArrCopies[0].length;
    }
    flush() {
        this.worker?.postMessage({ streamFinished: true });
    }
    close() {
        this.worker?.terminate();
    }
    /*
     *  Method used as worker code.
     */
    workerFunction() {
        self.onmessage = function (msg) {
            let streamFinished = msg.data.streamFinished;
            if (streamFinished) {
                postMessage({ streamFinished: true });
            }
            else {
                let chs = msg.data.chs;
                let frameLength = null;
                let audioData = new Array(chs);
                let linLevels = new Array(chs);
                for (let ch = 0; ch < chs; ch++) {
                    linLevels[ch] = new Float32Array(2);
                    audioData[ch] = new Float32Array(msg.data.audioData[ch]);
                }
                if (audioData) {
                    for (let ch = 0; ch < chs; ch++) {
                        let chData = audioData[ch];
                        if (frameLength === null) {
                            frameLength = chData.length;
                        }
                        for (let s = 0; s < frameLength; s++) {
                            let chSample = chData[s];
                            if (chSample < linLevels[ch][0]) {
                                linLevels[ch][0] = chSample;
                            }
                            if (chSample > linLevels[ch][1]) {
                                linLevels[ch][1] = chSample;
                            }
                        }
                    }
                }
                let linLevelBufs = new Array(chs);
                for (let ch = 0; ch < chs; ch++) {
                    linLevelBufs[ch] = linLevels[ch].buffer;
                }
                postMessage({ streamFinished: false, frameLength: frameLength, linLevelBuffers: linLevelBufs }, linLevelBufs);
            }
        };
    }
    updateLevels(bufferLevelInfo) {
        this.currentLevelInfos = bufferLevelInfo;
        if (this.peakLevelInfo) {
            this.peakLevelInfo.merge(bufferLevelInfo);
            if (this.levelListener) {
                this.levelListener.update(this.currentLevelInfos, this.peakLevelInfo.clone());
            }
            if (this.peakLevelListener) {
                let peakDBVal = bufferLevelInfo.powerLevelDB();
                if (this.peakLevelInDb < peakDBVal) {
                    this.peakLevelInDb = peakDBVal;
                    // the event comes from outside an Angular zone
                    this.peakLevelListener(this.peakLevelInDb);
                }
            }
        }
    }
    stop() {
        this.worker?.terminate();
    }
}

const MIN_DB_LEVEL = -40.0;
const DEFAULT_WARN_DB_LEVEL = -2;
class RecordingItemControls extends ResponsiveComponent {
    set agc(agc) {
        this._agc = agc;
        if (this._agc === undefined || this._agc === null) {
            this.agcString = 'n/a';
        }
        else {
            if (this._agc === true) {
                this.agcString = 'On';
            }
            else {
                this.agcString = 'Off';
            }
        }
    }
    constructor(bpo, ref, changeDetectorRef) {
        super(bpo);
        this.bpo = bpo;
        this.ref = ref;
        this.changeDetectorRef = changeDetectorRef;
        this.ce = null;
        this.audioSignalCollapsed = true;
        this.enableDownload = false;
        this.peakDbLvl = MIN_DB_LEVEL;
        this._displayLevelInfos = null;
        this._agc = undefined;
        this.agcString = 'n/a';
        this.onShowRecordingDetails = new EventEmitter();
        this.onDownloadRecording = new EventEmitter();
        this.disableAudioDetails = true;
        this.audioLoaded = false;
        this.playStartEnabled = false;
        this.playStopEnabled = false;
        this.updateTimerId = null;
        this.destroyed = false;
        this.warnDbLevel = DEFAULT_WARN_DB_LEVEL;
    }
    ngOnDestroy() {
        this.destroyed = true;
    }
    showRecordingDetails() {
        this.onShowRecordingDetails.emit();
    }
    downloadRecording() {
        this.onDownloadRecording.emit();
    }
    ngAfterViewInit() {
        this.ce = this.ref.nativeElement;
    }
    set displayLevelInfos(levelInfos) {
        this._displayLevelInfos = levelInfos;
    }
    error() {
        // this.status = 'ERROR';
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.12", ngImport: i0, type: RecordingItemControls, deps: [{ token: i1$2.BreakpointObserver }, { token: i0.ElementRef }, { token: i0.ChangeDetectorRef }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "18.2.12", type: RecordingItemControls, selector: "spr-recordingitemcontrols", inputs: { audioSignalCollapsed: "audioSignalCollapsed", enableDownload: "enableDownload", peakDbLvl: "peakDbLvl", agc: "agc", disableAudioDetails: "disableAudioDetails", audioLoaded: "audioLoaded", playStartAction: "playStartAction", playStopAction: "playStopAction", displayLevelInfos: "displayLevelInfos" }, outputs: { onShowRecordingDetails: "onShowRecordingDetails", onDownloadRecording: "onDownloadRecording" }, usesInheritance: true, ngImport: i0, template: `
        <button matTooltip="Start playback" (click)="playStartAction?.perform()"
                [disabled]="playStartAction?playStartAction.disabled:true"
                [style.color]="playStartAction?.disabled ? 'grey' : 'green'">
            <mat-icon>play_arrow</mat-icon>
        </button>
        <button matTooltip="Stop playback" (click)="playStopAction?.perform()"
                [disabled]="playStopAction?.disabled"
                [style.color]="playStopAction?.disabled ? 'grey' : 'yellow'">
            <mat-icon>stop</mat-icon>
        </button>
        <button *ngIf="!screenXs" matTooltip="Toggle detailed audio display" [disabled]="disableAudioDetails || !audioLoaded"
                (click)="showRecordingDetails()">
            <mat-icon>{{(audioSignalCollapsed) ? "expand_less" : "expand_more"}}</mat-icon>
        </button>
        <button matTooltip="Download current recording" *ngIf="enableDownload" [disabled]="disableAudioDetails || !audioLoaded"
                (click)="downloadRecording()">
            <mat-icon>file_download</mat-icon>
        </button>
        <div style="min-width: 14ch;padding:2px"><table style="border-style: none"><tr><td>Peak:</td><td><span matTooltip="Peak level"
                                                                        [style.color]="(peakDbLvl > warnDbLevel)?'red':'black'">{{peakDbLvl | number:'1.1-1'}} dB </span></td></tr>
          <tr *ngIf="_agc"><td>AGC:</td><td><span matTooltip="Auto gain control">{{agcString}}</span></td></tr></table></div>
    `, isInline: true, styles: [":host{flex:0;width:100%;background:#a9a9a9;padding:4px;box-sizing:border-box;height:100%;display:flex;flex-direction:row;flex-wrap:nowrap}\n", "span{flex:0;font-weight:700;display:inline-block;white-space:nowrap;box-sizing:border-box}\n", "button{touch-action:manipulation}\n"], dependencies: [{ kind: "directive", type: i1$1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "component", type: i2.MatIcon, selector: "mat-icon", inputs: ["color", "inline", "svgIcon", "fontSet", "fontIcon"], exportAs: ["matIcon"] }, { kind: "directive", type: i4.MatTooltip, selector: "[matTooltip]", inputs: ["matTooltipPosition", "matTooltipPositionAtOrigin", "matTooltipDisabled", "matTooltipShowDelay", "matTooltipHideDelay", "matTooltipTouchGestures", "matTooltip", "matTooltipClass"], exportAs: ["matTooltip"] }, { kind: "pipe", type: i1$1.DecimalPipe, name: "number" }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.12", ngImport: i0, type: RecordingItemControls, decorators: [{
            type: Component,
            args: [{ selector: 'spr-recordingitemcontrols', template: `
        <button matTooltip="Start playback" (click)="playStartAction?.perform()"
                [disabled]="playStartAction?playStartAction.disabled:true"
                [style.color]="playStartAction?.disabled ? 'grey' : 'green'">
            <mat-icon>play_arrow</mat-icon>
        </button>
        <button matTooltip="Stop playback" (click)="playStopAction?.perform()"
                [disabled]="playStopAction?.disabled"
                [style.color]="playStopAction?.disabled ? 'grey' : 'yellow'">
            <mat-icon>stop</mat-icon>
        </button>
        <button *ngIf="!screenXs" matTooltip="Toggle detailed audio display" [disabled]="disableAudioDetails || !audioLoaded"
                (click)="showRecordingDetails()">
            <mat-icon>{{(audioSignalCollapsed) ? "expand_less" : "expand_more"}}</mat-icon>
        </button>
        <button matTooltip="Download current recording" *ngIf="enableDownload" [disabled]="disableAudioDetails || !audioLoaded"
                (click)="downloadRecording()">
            <mat-icon>file_download</mat-icon>
        </button>
        <div style="min-width: 14ch;padding:2px"><table style="border-style: none"><tr><td>Peak:</td><td><span matTooltip="Peak level"
                                                                        [style.color]="(peakDbLvl > warnDbLevel)?'red':'black'">{{peakDbLvl | number:'1.1-1'}} dB </span></td></tr>
          <tr *ngIf="_agc"><td>AGC:</td><td><span matTooltip="Auto gain control">{{agcString}}</span></td></tr></table></div>
    `, styles: [":host{flex:0;width:100%;background:#a9a9a9;padding:4px;box-sizing:border-box;height:100%;display:flex;flex-direction:row;flex-wrap:nowrap}\n", "span{flex:0;font-weight:700;display:inline-block;white-space:nowrap;box-sizing:border-box}\n", "button{touch-action:manipulation}\n"] }]
        }], ctorParameters: () => [{ type: i1$2.BreakpointObserver }, { type: i0.ElementRef }, { type: i0.ChangeDetectorRef }], propDecorators: { audioSignalCollapsed: [{
                type: Input
            }], enableDownload: [{
                type: Input
            }], peakDbLvl: [{
                type: Input
            }], agc: [{
                type: Input
            }], onShowRecordingDetails: [{
                type: Output
            }], onDownloadRecording: [{
                type: Output
            }], disableAudioDetails: [{
                type: Input
            }], audioLoaded: [{
                type: Input
            }], playStartAction: [{
                type: Input
            }], playStopAction: [{
                type: Input
            }], displayLevelInfos: [{
                type: Input
            }] } });
class RecordingItemDisplay extends ResponsiveComponent {
    set agc(agc) {
        this._agc = agc;
    }
    constructor(bpo, ref, changeDetectorRef) {
        super(bpo);
        this.bpo = bpo;
        this.ref = ref;
        this.changeDetectorRef = changeDetectorRef;
        this.ce = null;
        this.streamingMode = false;
        this.audioSignalCollapsed = true;
        this.enableDownload = false;
        this.peakDbLvl = MIN_DB_LEVEL;
        this._displayLevelInfos = null;
        this._agc = undefined;
        this.agcString = 'n/a';
        this.onShowRecordingDetails = new EventEmitter();
        this.onDownloadRecording = new EventEmitter();
        this.playStartEnabled = false;
        this.playStopEnabled = false;
        this.updateTimerId = null;
        this.destroyed = false;
        this.warnDbLevel = DEFAULT_WARN_DB_LEVEL;
    }
    ngOnDestroy() {
        this.destroyed = true;
    }
    set displayAudioBuffer(displayAudioBuffer) {
        this._displayAudioBuffer = displayAudioBuffer;
    }
    get displayAudioBuffer() {
        return this._displayAudioBuffer;
    }
    showRecordingDetails() {
        this.onShowRecordingDetails.emit();
    }
    downloadRecording() {
        this.onDownloadRecording.emit();
    }
    ngAfterViewInit() {
        this.ce = this.ref.nativeElement;
        //this.controlAudioPlayer.listener=this;
    }
    set displayLevelInfos(levelInfos) {
        this._displayLevelInfos = levelInfos;
    }
    set channelCount(channelCount) {
        this.reset();
        this.liveLevel.channelCount = channelCount;
    }
    set playFramePosition(playFramePosition) {
        this.liveLevel.playFramePosition = playFramePosition;
    }
    update(levelInfo, peakLevelInfo) {
        let peakDBVal = levelInfo.powerLevelDB();
        if (this.peakDbLvl < peakDBVal) {
            this.peakDbLvl = peakDBVal;
            // the event comes from outside an Angular zone
            this.changeDetectorRef.detectChanges();
        }
        this.liveLevel.update(levelInfo);
    }
    error() {
        // this.status = 'ERROR';
    }
    streamFinished() {
        this.liveLevel.streamFinished();
    }
    reset() {
        this.peakDbLvl = MIN_DB_LEVEL;
        this.changeDetectorRef.detectChanges();
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.12", ngImport: i0, type: RecordingItemDisplay, deps: [{ token: i1$2.BreakpointObserver }, { token: i0.ElementRef }, { token: i0.ChangeDetectorRef }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "18.2.12", type: RecordingItemDisplay, selector: "spr-recordingitemdisplay", inputs: { streamingMode: "streamingMode", audioSignalCollapsed: "audioSignalCollapsed", enableDownload: "enableDownload", agc: "agc", playStartAction: "playStartAction", playStopAction: "playStopAction", displayAudioBuffer: "displayAudioBuffer", displayLevelInfos: "displayLevelInfos" }, outputs: { onShowRecordingDetails: "onShowRecordingDetails", onDownloadRecording: "onDownloadRecording" }, viewQueries: [{ propertyName: "liveLevel", first: true, predicate: LevelBar, descendants: true, static: true }], usesInheritance: true, ngImport: i0, template: `
      <div [class]="{audioStatusDisplay:!screenXs,audioStatusDisplayXs:screenXs}">
        <audio-levelbar style="flex:1 0 1%" [streamingMode]="streamingMode" [displayLevelInfos]="_displayLevelInfos"></audio-levelbar>
        <spr-recordingitemcontrols style="flex:0 0 0px" [audioLoaded]="displayAudioBuffer!==null" [playStartAction]="playStartAction" [playStopAction]="playStopAction" [peakDbLvl]="peakDbLvl" [agc]="_agc" (onShowRecordingDetails)="onShowRecordingDetails.emit()"></spr-recordingitemcontrols>
      </div>
    `, isInline: true, styles: ["div{width:100%;background:#a9a9a9;padding:4px;box-sizing:border-box;flex-wrap:nowrap}\n", "audio-levelbar{box-sizing:border-box}\n", ".audioStatusDisplay{display:flex;flex-direction:row;height:100px;min-height:100px}\n", ".audioStatusDisplayXs{display:flex;flex-direction:column;height:125px;min-height:125px}\n"], dependencies: [{ kind: "component", type: LevelBar, selector: "audio-levelbar", inputs: ["streamingMode", "displayLevelInfos", "state"] }, { kind: "component", type: RecordingItemControls, selector: "spr-recordingitemcontrols", inputs: ["audioSignalCollapsed", "enableDownload", "peakDbLvl", "agc", "disableAudioDetails", "audioLoaded", "playStartAction", "playStopAction", "displayLevelInfos"], outputs: ["onShowRecordingDetails", "onDownloadRecording"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.12", ngImport: i0, type: RecordingItemDisplay, decorators: [{
            type: Component,
            args: [{ selector: 'spr-recordingitemdisplay', template: `
      <div [class]="{audioStatusDisplay:!screenXs,audioStatusDisplayXs:screenXs}">
        <audio-levelbar style="flex:1 0 1%" [streamingMode]="streamingMode" [displayLevelInfos]="_displayLevelInfos"></audio-levelbar>
        <spr-recordingitemcontrols style="flex:0 0 0px" [audioLoaded]="displayAudioBuffer!==null" [playStartAction]="playStartAction" [playStopAction]="playStopAction" [peakDbLvl]="peakDbLvl" [agc]="_agc" (onShowRecordingDetails)="onShowRecordingDetails.emit()"></spr-recordingitemcontrols>
      </div>
    `, styles: ["div{width:100%;background:#a9a9a9;padding:4px;box-sizing:border-box;flex-wrap:nowrap}\n", "audio-levelbar{box-sizing:border-box}\n", ".audioStatusDisplay{display:flex;flex-direction:row;height:100px;min-height:100px}\n", ".audioStatusDisplayXs{display:flex;flex-direction:column;height:125px;min-height:125px}\n"] }]
        }], ctorParameters: () => [{ type: i1$2.BreakpointObserver }, { type: i0.ElementRef }, { type: i0.ChangeDetectorRef }], propDecorators: { liveLevel: [{
                type: ViewChild,
                args: [LevelBar, { static: true }]
            }], streamingMode: [{
                type: Input
            }], audioSignalCollapsed: [{
                type: Input
            }], enableDownload: [{
                type: Input
            }], agc: [{
                type: Input
            }], onShowRecordingDetails: [{
                type: Output
            }], onDownloadRecording: [{
                type: Output
            }], playStartAction: [{
                type: Input
            }], playStopAction: [{
                type: Input
            }], displayAudioBuffer: [{
                type: Input
            }], displayLevelInfos: [{
                type: Input
            }] } });

class SequenceAudioFloat32ChunkerOutStream extends Float32ArrayChunkerOutStream {
    constructor(outStream, chunkDurationSeconds) {
        super(outStream);
        this.chunkDurationSeconds = chunkDurationSeconds;
        this.sampleRate = null;
        this.sequenceAudioFloat32OutStream = outStream;
    }
    setFormat(channels, sampleRate) {
        //console.debug("SequenceAudioFloat32ChunkerOutStream:setFormat(channels: "+channels+",sampleRate: "+sampleRate+")")
        this.channels = channels;
        this.sampleRate = sampleRate;
        this.chunkSize = Math.round(sampleRate * this.chunkDurationSeconds);
        //console.debug("SequenceAudioFloat32ChunkerOutStream: chunkSize: "+this.chunkSize);
        this.sequenceAudioFloat32OutStream.setFormat(channels, sampleRate);
    }
    nextStream() {
        this.sequenceAudioFloat32OutStream.nextStream();
    }
}
/**
 * Streams a SequenceAudioFloat32OutStream to multiple streams
 */
class SequenceAudioFloat32OutStreamMultiplier {
    constructor() {
        this._sequenceAudioFloat32OutStreams = new Array();
    }
    get sequenceAudioFloat32OutStreams() {
        return this._sequenceAudioFloat32OutStreams;
    }
    setFormat(channels, sampleRate) {
        for (let os of this._sequenceAudioFloat32OutStreams) {
            os.setFormat(channels, sampleRate);
        }
    }
    nextStream() {
        for (let os of this._sequenceAudioFloat32OutStreams) {
            os.nextStream();
        }
    }
    close() {
        for (let os of this._sequenceAudioFloat32OutStreams) {
            os.close();
        }
    }
    flush() {
        for (let os of this._sequenceAudioFloat32OutStreams) {
            os.flush();
        }
    }
    write(buffers) {
        let toWrite = buffers.length;
        for (let os of this._sequenceAudioFloat32OutStreams) {
            os.write(buffers);
        }
        return toWrite;
    }
}

const WAKE_LOCK_VIDEO_MP4_URI = 'data:video/mp4;base64,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';

/**
 * Utility to prevent devices from screen lock.
 * If supported uses the HTML5 wake lock API, if not, plays an invisible video.
 *
 * Note: I've used the GitHub project richtr/nosleep.js for that. The worked in most cases, but failed sometimes on an
 *   Android smartphone.
 */
class WakeLockManager {
    get behaviorSubject() {
        return this._behaviorSubject;
    }
    constructor() {
        this.wakeLockApiSupported = false;
        this.wakeLockRetryCount = 0;
        this.randomSeekRequired = false;
        this._behaviorSubject = new BehaviorSubject(false);
        this.VIDEO_LENGTH = 10;
        this.wakeLockApiSupported = ('wakeLock' in navigator);
        console.debug("Wake lock API supported: " + this.wakeLockApiSupported);
        this.userAgent = UserAgentBuilder.userAgent();
        this.randomSeekRequired = (this.userAgent?.detectedBrowser === Browser$1.Safari);
    }
    enableWakeLock() {
        if (this.wakeLockApiSupported) {
            //@ts-ignore
            navigator.wakeLock.request('screen').then((wls) => {
                this.wakeLockSentinel = wls;
                this.wakeLockRetryCount = 0;
                console.debug('Wake lock screen request successful.');
                this._behaviorSubject.next(true);
            }).catch((reason) => {
                console.error('Wakelock failed: ' + reason);
                this._behaviorSubject.error(reason);
            });
        }
        else {
            if (!this.mp4VideoElement) {
                this.mp4VideoElement = document.createElement('video');
                this.mp4VideoElement.loop = !this.randomSeekRequired;
                this.mp4VideoElement.playsInline = true;
                this.mp4VideoElement.src = WAKE_LOCK_VIDEO_MP4_URI;
                this.mp4VideoElement.addEventListener('play', (ev) => {
                    console.debug('Wake lock video playing...');
                    this._behaviorSubject.next(true);
                });
                this.mp4VideoElement.addEventListener('ended', (ev) => {
                    console.debug('Wake lock video ended.');
                    this._behaviorSubject.next(false);
                });
                this.mp4VideoElement.addEventListener('pause', (ev) => {
                    console.debug('Wake lock video pause.');
                    this._behaviorSubject.next(false);
                });
                if (this.randomSeekRequired) {
                    this.mp4VideoElement.addEventListener('timeupdate', (ev) => {
                        if (this.randomSeekRequired && this.mp4VideoElement) {
                            let thirdVideoLen = this.VIDEO_LENGTH / 3;
                            if (this.mp4VideoElement.currentTime > thirdVideoLen * 2) {
                                let newPos = (thirdVideoLen * Math.random());
                                //console.debug('Wake lock random seek to '+newPos+'s');
                                this.mp4VideoElement.currentTime = newPos;
                            }
                        }
                    });
                }
                this.mp4VideoElement.addEventListener('error', (ev) => {
                    console.debug('Wake lock video error: ' + ev.message);
                    this._behaviorSubject.error(ev.error);
                });
                console.debug('Added listeners to wake lock video.');
            }
            this.startWakeLockVideo();
        }
    }
    startWakeLockVideo() {
        if (this.mp4VideoElement) {
            this.mp4VideoElement.play().then(() => {
                this.wakeLockRetryCount = 0;
            }).catch((err) => {
                console.debug('Failed starting wake lock video!');
                if (this.wakeLockRetryCount < 1) {
                    window.setTimeout(() => {
                        this.wakeLockRetryCount++;
                        console.debug('Retry wake lock video #' + this.wakeLockRetryCount);
                        this.startWakeLockVideo();
                    }, 4000);
                }
                else {
                    console.debug('Giving up to try to start wake lock video.');
                }
            });
        }
    }
    disableWakeLock() {
        if (this.wakeLockApiSupported) {
            this.wakeLockSentinel.release().then(() => {
                console.debug('Wake lock release successful.');
                this._behaviorSubject.next(false);
            }).catch((reason) => {
                console.error('Wakelock release failed: ' + reason);
                this._behaviorSubject.error(reason);
            });
        }
        else {
            if (this.mp4VideoElement) {
                this.mp4VideoElement.pause();
            }
        }
    }
}

var BasicRecorder_1;
const FORCE_REQUEST_AUDIO_PERMISSIONS = false;
const RECFILE_API_CTX = 'recfile';
const MAX_RECORDING_TIME_MS = 1000 * 60 * 60 * 60; // 1 hour
const LEVEL_BAR_INTERVALL_SECONDS = 0.1; // 100ms
const NOSLEEP_VIDEO_TITLE = 'No Sleep';
class ChunkManager {
    set recordingFile(value) {
        this._rf = value;
    }
    constructor(chunkAudioBufferReceiver) {
        this.chunkAudioBufferReceiver = chunkAudioBufferReceiver;
        this.channels = 0;
        this.sampleRate = -1;
        this.chunkIdx = 0;
    }
    close() {
        // Nothing to do
    }
    flush() {
        this.chunkAudioBufferReceiver.postAudioStreamEnd(this.chunkIdx);
    }
    nextStream() {
        // reset chunk counter
        this.chunkIdx = 0;
        this.chunkAudioBufferReceiver.postAudioStreamStart();
    }
    setFormat(channels, sampleRate) {
        this.channels = channels;
        this.sampleRate = sampleRate;
    }
    write(buffers) {
        let aCtx = AudioContextProvider.audioContextInstance();
        let bChs = buffers.length;
        let frameLen = 0;
        if (aCtx && bChs > 0) {
            frameLen = buffers[0].length;
            try {
                let ad = aCtx.createBuffer(this.channels, frameLen, this.sampleRate);
                for (let ch = 0; ch < this.channels; ch++) {
                    ad.copyToChannel(buffers[ch], ch);
                }
                this.chunkAudioBufferReceiver.postChunkAudioBuffer(ad, this.chunkIdx);
                this.chunkIdx++;
            }
            catch (err) {
                // TODO Handle errors
                // iOS Safari sometimes throws NotSupportedError
                console.error("Could not create audio buffer for chunked upload.");
                console.error("Nr. of chs: " + this.channels + ", frame length: " + frameLen + ", sample rate: " + this.sampleRate);
                if (err instanceof DOMException) {
                    console.error("DOM exception: Name: " + err.name + ", Msg: " + err.message);
                    if (err.name === 'NotSupportedError') {
                        if (frameLen == 0) {
                            // Empty buffers are not supported by Chromium
                            // No data to transfer, but this case should never happen
                            return frameLen;
                        }
                        else {
                            throw err;
                        }
                    }
                    else if (err.name === 'RangeError') {
                        console.error("DOM RangeError");
                        // Out of memory
                        // TODO What to do ??
                        throw err;
                    }
                    else {
                        console.error("DOM Exception unknown");
                        throw err;
                    }
                }
                else if (err instanceof RangeError) {
                    console.error("RangeError: Name: " + err.name + ", Msg: " + err.message);
                    // Out of memory
                    // TODO What to do ??
                    throw err;
                }
                else {
                    throw err;
                }
            }
        }
        return frameLen;
    }
}
let BasicRecorder = class BasicRecorder extends ResponsiveComponent {
    static { BasicRecorder_1 = this; }
    get allowEchoCancellation() {
        return this._allowEchoCancellation;
    }
    set allowEchoCancellation(value) {
        this._allowEchoCancellation = value;
    }
    get maxAutoNetMemStoreSamples() {
        return this._maxAutoNetMemStoreSamples;
    }
    set maxAutoNetMemStoreSamples(value) {
        this._maxAutoNetMemStoreSamples = value;
    }
    static { this.DEFAULT_MAX_NET_AUTO_MEM_STORE_SAMPLES = 2880000 * 5; } // Default 5 minutes one channel at 48kHz
    static { this.DEFAULT_CHUNK_SIZE_SECONDS = 30; }
    get clientAudioStorageType() {
        return this._clientAudioStorageType;
    }
    set clientAudioStorageType(value) {
        let oldValue = this._clientAudioStorageType;
        this._clientAudioStorageType = value;
        if (value !== oldValue) {
            this.configureStreamCaptureStream();
        }
    }
    get clientMediaStorageFormat() {
        return this._clientMediaStorageFormat;
    }
    set clientMediaStorageFormat(value) {
        this._clientMediaStorageFormat = value;
    }
    get persistentAudioStorageTarget() {
        return this._persistentAudioStorageTarget;
    }
    set persistentAudioStorageTarget(value) {
        let oldValue = this._persistentAudioStorageTarget;
        this._persistentAudioStorageTarget = value;
        if (value !== oldValue) {
            this.configureStreamCaptureStream();
        }
    }
    // Enable only for developemnt/debug purposes of array audio buffers !!
    static { this.FORCE_ARRRAY_AUDIO_BUFFER = false; }
    get uploadChunkSizeSeconds() {
        return this._uploadChunkSizeSeconds;
    }
    set uploadChunkSizeSeconds(value) {
        let oldValue = this.uploadChunkSizeSeconds;
        this._uploadChunkSizeSeconds = value;
        if (value !== oldValue) {
            this.configureStreamCaptureStream();
        }
    }
    constructor(bpo, changeDetectorRef, dialog, sessionService, uploader, config) {
        super(bpo);
        this.bpo = bpo;
        this.changeDetectorRef = changeDetectorRef;
        this.dialog = dialog;
        this.sessionService = sessionService;
        this.uploader = uploader;
        this.config = config;
        this.maxRecTimerId = null;
        this.maxRecTimerRunning = false;
        this._maxAutoNetMemStoreSamples = BasicRecorder_1.DEFAULT_MAX_NET_AUTO_MEM_STORE_SAMPLES;
        this.statusMsg = '';
        this.statusWaiting = false;
        this.readonly = false;
        this.rfUuid = null;
        this.processingRecording = false;
        this.ac = null;
        this._wakeLock = false;
        this._selectedDeviceId = undefined;
        this._channelCount = 2;
        this._allowEchoCancellation = false;
        this._session = null;
        this._recordingFile = null;
        this.startedDate = null;
        this.uploadProgress = 100;
        this.uploadStatus = 'ok';
        this.uploadSet = null;
        this.audioSignalCollapsed = true;
        this.peakLevelInDb = MIN_DB_LEVEL;
        this.audioLoaded = false;
        this.disableAudioDetails = false;
        this._controlAudioPlayer = null;
        this.displayAudioClip = null;
        this.audioFetchSubscription = null;
        this.liveLevelDisplayState = State.READY;
        this.keepLiveLevel = false;
        this.calcBufferInfosSubscr = null;
        this.destroyed = false;
        this.navigationDisabled = true;
        this._uploadChunkSizeSeconds = null;
        //=BasicRecorder.DEFAULT_CHUNK_SIZE_SECONDS;
        // Default: Continuous HTML5 Audio API AudioBuffer, no chunked upload
        this._clientAudioStorageType = AudioStorageType.MEM_ENTIRE;
        this._clientMediaStorageFormat = undefined;
        this._persistentAudioStorageTarget = null;
        this._screenLocked = false;
        this.userAgent = UserAgentBuilder.userAgent();
        const detPfm = this.userAgent.detectedPlatform;
        if (detPfm) {
            console.debug("Detected platform: " + detPfm);
        }
        const detBr = this.userAgent.detectedBrowser;
        const detBrVers = this.userAgent.detectedBrowserVersion;
        if (detBr) {
            let detBrVersStr = (detBrVers) ? ' ' + detBrVers : '';
            console.debug("Detected browser: " + detBr + detBrVersStr);
        }
        this.transportActions = new TransportActions();
        this.playStartAction = new Action('Play');
        this.levelMeasure = new LevelMeasure();
        this.streamLevelMeasure = new StreamLevelMeasure();
        this.selCaptureDeviceId = null;
    }
    get wakeLock() {
        return this._wakeLock;
    }
    set wakeLock(value) {
        this._wakeLock = value;
    }
    enableWakeLockCond() {
        if (this.wakeLock === true) {
            if (!this.wakeLockManager) {
                this.wakeLockManager = new WakeLockManager();
                this.wakeLockManager.behaviorSubject.subscribe({
                    next: (v) => {
                        this._screenLocked = v;
                    },
                    error: (err) => {
                        console.error("Wake lock error!");
                        this._screenLocked = false;
                    }
                });
            }
            this.wakeLockManager.enableWakeLock();
        }
    }
    disableWakeLockCond() {
        this.wakeLockManager?.disableWakeLock();
    }
    get screenLocked() {
        return this._screenLocked;
    }
    set audioDevices(audioDevices) {
        this._audioDevices = audioDevices;
    }
    set autoGainControlConfigs(autoGainControlConfigs) {
        this._autoGainControlConfigs = autoGainControlConfigs;
    }
    set channelCount(channelCount) {
        this._channelCount = channelCount;
    }
    set session(session) {
        this._session = session;
    }
    get session() {
        return this._session;
    }
    enableStartUserGesture() {
        this.statusAlertType = 'info';
        this.statusMsg = 'Ready.';
    }
    configureStreamCaptureStream() {
        let outStream;
        if (AudioStorageType.MEM_ENTIRE !== this._clientAudioStorageType || this.uploadChunkSizeSeconds) {
            if (!this.uploadChunkSizeSeconds) {
                this.uploadChunkSizeSeconds = BasicRecorder_1.DEFAULT_CHUNK_SIZE_SECONDS;
            }
            // Multiply the capture stream to...
            let sasm = new SequenceAudioFloat32OutStreamMultiplier();
            // ...upload audio data in chunks...
            let chMng = new ChunkManager(this); // The chunk manager connects the chunked audio stream to this class to upload the chunks
            let chOsUpload = new SequenceAudioFloat32ChunkerOutStream(chMng, this.uploadChunkSizeSeconds); // The audio stream chunker itself
            sasm.sequenceAudioFloat32OutStreams.push(chOsUpload);
            // ...and to measure the level
            let chOsLvlMeas = new SequenceAudioFloat32ChunkerOutStream(this.streamLevelMeasure, LEVEL_BAR_INTERVALL_SECONDS);
            sasm.sequenceAudioFloat32OutStreams.push(chOsLvlMeas);
            outStream = sasm;
        }
        else {
            outStream = new SequenceAudioFloat32ChunkerOutStream(this.streamLevelMeasure, LEVEL_BAR_INTERVALL_SECONDS);
        }
        if (this.ac) {
            this.ac.maxAutoNetMemStoreSamples = this._maxAutoNetMemStoreSamples;
            this.ac.audioStorageType = this._clientAudioStorageType;
            this.ac.audioOutStream = outStream;
            if (AudioStorageType.DB_CHUNKED === this._clientAudioStorageType && this._persistentAudioStorageTarget !== null) {
                this.ac.persistentAudioStorageTarget = this._persistentAudioStorageTarget;
            }
        }
    }
    showRecording() {
        if (this._controlAudioPlayer) {
            this._controlAudioPlayer.stop();
        }
        if (this.calcBufferInfosSubscr) {
            this.calcBufferInfosSubscr.unsubscribe();
        }
        if (this.displayAudioClip) {
            let dap = this.displayAudioClip;
            let adh = dap.audioDataHolder;
            if (adh) {
                if (!this.keepLiveLevel) {
                    this.liveLevelDisplayState = State.LOADING;
                }
                adh.addOnReadyListener(() => {
                    //console.debug("Audio data holder ready. Enable playback. Audio loaded true.")
                    if (!this.keepLiveLevel) {
                        this.liveLevelDisplayState = State.RENDERING;
                        this.calcBufferInfosSubscr = this.levelMeasure.calcBufferLevelInfos(adh, LEVEL_BAR_INTERVALL_SECONDS).subscribe((levelInfos) => {
                            //console.debug("Level infos: levelInfos number size: "+levelInfos.numberSize());
                            dap.levelInfos = levelInfos;
                            this.liveLevelDisplayState = State.READY;
                            this.changeDetectorRef.detectChanges();
                        });
                    }
                    this.playStartAction.disabled = false;
                    this.audioLoaded = true;
                    this.changeDetectorRef.detectChanges();
                });
                //console.debug("Audio data holder added onReady.")
            }
            //this.playStartAction.disabled = false;
        }
        else {
            this.playStartAction.disabled = true;
            this.audioLoaded = false;
            // Collapse audio signal display if open
            if (!this.audioSignalCollapsed) {
                this.audioSignalCollapsed = true;
            }
        }
        this.changeDetectorRef.detectChanges();
    }
    start() {
        this.statusAlertType = 'info';
        this.statusMsg = 'Starting session...';
        this.statusWaiting = false;
        if (this._session) {
            if (this._session.sealed) {
                this.readonly = true;
                this.statusMsg = 'Session sealed!';
                //let dialogRef = this.dialog.open(SessionSealedDialog, {});
                this.dialog.open(MessageDialog, {
                    data: {
                        type: 'error',
                        title: 'Error',
                        msg: "This session is sealed. Recordings cannot be added anymore.",
                        advice: 'Please ask your experimenter what to do (e.g start a new session).',
                    }
                });
            }
            else {
                let body = {};
                if (this._session.status === "CREATED") {
                    this._session.status = "LOADED";
                    body.status = this._session.status;
                    if (!this._session.loadedDate) {
                        this._session.loadedDate = new Date();
                        body.loadedDate = this._session.loadedDate;
                    }
                }
                else {
                    this._session.restartedDate = new Date();
                    body.restartedDate = this._session.restartedDate;
                }
                this.sessionService.patchSessionObserver(this._session, body).subscribe();
            }
        }
        // Check browser compatibility
        // Safari seems to support Stereo recordings now (2024-06-12, iPadOS 17.5.1)
        // if(this.userAgent.detectedBrowser===Browser.Safari && this._channelCount>1){
        //   let eMsg="Error: Safari browser does not support stereo recordings.";
        //   console.error(eMsg);
        //   this.dialog.open(MessageDialog, {
        //     data: {
        //       type: 'error',
        //       title: 'Browser not supported',
        //       msg: eMsg,
        //       advice: "Please use a supported browser, e.g. Mozilla Firefox."
        //     }
        //   })
        // }
        //console.log("Session ID: "+this._session.session+ " status: "+this._session.status)
        this._selectedDeviceId = undefined;
        if (!this.readonly && this.ac && (FORCE_REQUEST_AUDIO_PERMISSIONS || (this._audioDevices && this._audioDevices.length > 0))) {
            this.statusMsg = 'Requesting audio permissions...';
            this.statusAlertType = 'info';
            this.ac.deviceInfos((mdis) => {
                let audioCaptureDeviceAvail = false;
                let audioPlayDeviceAvail = false;
                if (mdis) {
                    if (this.ac) {
                        this.ac.printDevices(mdis);
                    }
                    if (mdis.length > 0) {
                        for (let mdii = 0; mdii < mdis.length; mdii++) {
                            let mdi = mdis[mdii];
                            let kind = mdi.kind;
                            if (kind === "audioinput") {
                                audioCaptureDeviceAvail = true;
                            }
                            else if (kind === "audiooutput") {
                                audioPlayDeviceAvail = true;
                            }
                        }
                    }
                    if (this._session && this._session.type !== 'TEST_DEF_A' && this._audioDevices && this._audioDevices.length > 0) {
                        let fdi = null;
                        for (let adI = 0; adI < this._audioDevices.length; adI++) {
                            let ad = this._audioDevices[adI];
                            if (ad.playback) {
                                // project audio device config for playback device
                                // not used for now
                                continue;
                            }
                            for (let mdii = 0; mdii < mdis.length; mdii++) {
                                let mdi = mdis[mdii];
                                let kind = mdi.kind;
                                if (kind === "audioinput") {
                                    audioCaptureDeviceAvail = true;
                                }
                                else if (kind === "audiooutput") {
                                    audioPlayDeviceAvail = true;
                                }
                                if (ad.regex) {
                                    //console.log("Match?: \'"+mdi.label+"\' \'"+ad.name+"\'");
                                    if (mdi.label.match(ad.name)) {
                                        fdi = mdi;
                                        //console.log("Match!");
                                    }
                                }
                                else {
                                    if (mdi.label.trim() === ad.name.trim()) {
                                        fdi = mdi;
                                    }
                                }
                                if (fdi) {
                                    break;
                                }
                            }
                            if (fdi) {
                                break;
                            }
                        }
                        if (fdi) {
                            // matching device found
                            // Not able to open device here since Chrome 71
                            // Chrome 71 requires a user gesture before the AudioContext can be resumed
                            // sessionmanager.ts:712 Open session with default audio device for 1 channels
                            // capture.ts:128 The AudioContext was not allowed to start. It must be resumed (or created) after a user gesture on the page. https://goo.gl/7K7WLu
                            // push../projects/speechrecorderng/src/lib/audio/capture/capture.ts.AudioCapture.open @ capture.ts:128
                            //this.ac.open(this._channelCount, fdi.deviceId);
                            console.info("Set selected audio device: \'" + fdi.label + "\' Id: \'" + fdi.deviceId + "\'");
                            this._selectedDeviceId = fdi.deviceId;
                            this.enableStartUserGesture();
                        }
                        else {
                            // device not found
                            this.statusMsg = 'ERROR: Required audio device not available!';
                            this.statusAlertType = 'error';
                            this.readonly = true;
                            this.dialog.open(MessageDialog, {
                                data: {
                                    type: 'error',
                                    title: 'Required audio device',
                                    msg: "Required audio device not found",
                                    advice: "Please connect a suitable audio device for this project and retry (press the browser reload button)."
                                }
                            });
                        }
                    }
                    else {
                        if (!audioCaptureDeviceAvail && !audioPlayDeviceAvail) {
                            // no device found
                            this.statusMsg = 'ERROR: No audio device available!';
                            this.statusAlertType = 'warn';
                            //this.readonly = true;
                            this.dialog.open(MessageDialog, {
                                data: {
                                    type: 'warn',
                                    title: 'No audio device',
                                    msg: "No audio device found",
                                    advice: "Please connect an audio device and retry (press the browser reload button) or try to continue anyway."
                                }
                            });
                        }
                        else {
                            if (!this.readonly && !audioCaptureDeviceAvail) {
                                // no device found
                                this.statusMsg = 'WARNING: No audio capture device available!';
                                this.statusAlertType = 'warning';
                                //this.readonly = true;
                                this.dialog.open(MessageDialog, {
                                    data: {
                                        type: 'warning',
                                        title: 'No audio capture device',
                                        msg: "No audio capture device found",
                                        advice: "Please connect an audio capture device and retry (press the browser reload button) or try to continue anyway."
                                    }
                                });
                            }
                            // Safari does not list playback devices
                            if (!audioPlayDeviceAvail) {
                                // Firefox does not enumerate audiooutput devices
                                // Do not show this warning, because it would always appear on Firefox
                                // When https://bugzilla.mozilla.org/show_bug.cgi?id=1498512 is fixed the warning can be enabled for Firefox as well
                                // It is already implemneted but kept behind a preference setting https://bugzilla.mozilla.org/show_bug.cgi?id=1152401
                                // Output devices are listed if about:config media.setsinkid.enabled=true
                                // but default setting is false
                                // Same problem with Safari
                                if (!(this.userAgent.detectedBrowser === Browser$1.Safari || this.userAgent.detectedBrowser === Browser$1.Firefox)) {
                                    // no device found
                                    this.statusMsg = 'WARNING: No audio playback device available!';
                                    this.statusAlertType = 'warn';
                                    //this.readonly = true;
                                    this.dialog.open(MessageDialog, {
                                        data: {
                                            type: 'warn',
                                            title: 'No audio playback device',
                                            msg: "No audio playback device found",
                                            advice: "Please connect an audio playback device and retry (press the browser reload button) or try to continue anyway."
                                        }
                                    });
                                }
                            }
                        }
                        // Not able to open device here since Chrome 71
                        // Chrome 71 requires a user gesture before the AudioContext can be resumed
                        // sessionmanager.ts:712 Open session with default audio device for 1 channels
                        // capture.ts:128 The AudioContext was not allowed to start. It must be resumed (or created) after a user gesture on the page. https://goo.gl/7K7WLu
                        // push../projects/speechrecorderng/src/lib/audio/capture/capture.ts.AudioCapture.open @ capture.ts:128
                        //console.log("Open session with default audio device for "+this._channelCount+" channels");
                        //this.ac.open(this._channelCount);
                        // enable start gesture anyway
                        this.enableStartUserGesture();
                    }
                }
            });
        }
        this.statusMsg = 'Ready.';
    }
    startItem() {
        this.rfUuid = UUID.generate();
        if (this.ac) {
            this.ac.recUUID = this.rfUuid;
        }
        this.startedDate = null;
        this.enableWakeLockCond();
        //this.rfUuid=UUID.generate();
        this.uploadSet = null;
        this.transportActions.startAction.disabled = true;
        this.transportActions.pauseAction.disabled = true;
    }
    startCapture() {
        if (this.ac) {
            if (!this.ac.opened) {
                if (this._selectedDeviceId) {
                    console.log("Open session with audio device Id: \'" + this._selectedDeviceId + "\' for " + this._channelCount + " channels");
                }
                else {
                    console.log("Open session with default audio device for " + this._channelCount + " channels");
                }
                this.ac.open(this._channelCount, this._selectedDeviceId, this._autoGainControlConfigs, this._allowEchoCancellation);
            }
            else {
                this.ac.start();
            }
        }
    }
    opened() {
        if (this.ac) {
            this.ac.start();
        }
    }
    started() {
        if (!this.startedDate) {
            this.startedDate = new Date();
        }
        this.transportActions.startAction.disabled = true;
    }
    postRecording(wavFile, recUrl, rf, uploadHolder) {
        let wavBlob = new Blob([wavFile], { type: 'audio/wav' });
        let ul = new Upload(wavBlob, recUrl, rf);
        if (uploadHolder) {
            uploadHolder.upload = ul;
        }
        this.uploader.queueUpload(ul);
    }
    postAudioStreamStart() {
        if (this.rfUuid) {
            this.uploadSet = new UploadSet();
            let apiEndPoint = '';
            if (this.config && this.config.apiEndPoint) {
                apiEndPoint = this.config.apiEndPoint;
            }
            if (apiEndPoint !== '') {
                apiEndPoint = apiEndPoint + '/';
            }
            let sessionsUrl = apiEndPoint + SessionService.SESSION_API_CTX;
            let recUrl = sessionsUrl + '/' + this.session?.sessionId + '/' + RECFILE_API_CTX + '/' + this.rfUuid + '/prepareChunksRequest';
            let fd = new FormData();
            // Note: At least one parameter must be set
            fd.set('uuid', this.rfUuid);
            if (!this.startedDate) {
                this.startedDate = new Date();
            }
            fd.set('startedDate', this.startedDate.toJSON());
            let ul = new Upload(fd, recUrl);
            this.uploadSet.add(ul);
            this.uploader.queueUpload(ul);
        }
        else {
            console.error("Recording file UUID not set!");
        }
    }
    sessionsBaseUrl() {
        let apiEndPoint = '';
        if (this.config && this.config.apiEndPoint) {
            apiEndPoint = this.config.apiEndPoint;
        }
        if (apiEndPoint !== '') {
            apiEndPoint = apiEndPoint + '/';
        }
        return apiEndPoint + SessionService.SESSION_API_CTX;
    }
    postAudioStreamEnd(chunkCount) {
        if (this.rfUuid) {
            let sessionsUrl = this.sessionsBaseUrl();
            let recUrl = sessionsUrl + '/' + this.session?.sessionId + '/' + RECFILE_API_CTX + '/' + this.rfUuid + '/concatChunksRequest';
            let fd = new FormData();
            fd.set('uuid', this.rfUuid);
            fd.set('chunkCount', chunkCount.toString());
            let ul = new Upload(fd, recUrl, this._recordingFile);
            if (this.uploadSet) {
                this.uploadSet.add(ul);
                this.uploadSet.complete();
            }
            this.uploader.queueUpload(ul);
            //console.debug("Queued for upload: "+this._recordingFile);
        }
        else {
            console.error("Recording file UUID not set!");
        }
    }
    closed() {
        this.statusAlertType = 'info';
        this.statusMsg = 'Session closed.';
    }
    error(msg = 'An unknown error occured during recording.', advice = 'Please retry.') {
        this.navigationDisabled = false;
        this.statusMsg = 'ERROR: Recording.';
        this.statusAlertType = 'error';
        this.dialog.open(MessageDialog, {
            data: {
                type: 'error',
                title: 'Recording error',
                msg: msg,
                advice: advice
            }
        });
    }
};
BasicRecorder = BasicRecorder_1 = __decorate([
    __param(5, Inject(SPEECHRECORDER_CONFIG))
], BasicRecorder);

class BasicRecFilesCache {
    constructor() {
        //public static readonly DEFAULT_MAX_SAMPLES=30*48000;  // TEST 30 seconds
        this._sampleCount = 0;
        this.maxSampleCount = BasicRecFilesCache.DEFAULT_MAX_SAMPLES;
        this._currentRecordingFile = null;
    }
    static { this.DEBUG = false; }
    static { this.DEFAULT_MAX_SAMPLES = 10 * 60 * 48000; } // 10 Minutes mono 48kHz
    get currentRecordingFile() {
        return this._currentRecordingFile;
    }
    set currentRecordingFile(value) {
        this._currentRecordingFile = value;
        this.expire();
    }
}
class SprItemsCache extends BasicRecFilesCache {
    constructor() {
        super(...arguments);
        this._items = new Array();
    }
    get items() {
        return this._items;
    }
    addItem(item) {
        this._items.push(item);
    }
    getItem(index) {
        return this._items[index];
    }
    length() {
        return this._items.length;
    }
    tryExpire(toBeExpiredRf) {
        if (BasicRecFilesCache.DEBUG)
            console.debug("Rec. files cache: " + toBeExpiredRf.toString() + " try expire:");
        if (!RecordingFileUtils.equals(toBeExpiredRf, this.currentRecordingFile)) {
            if (BasicRecFilesCache.DEBUG)
                console.debug("Rec. files cache: " + toBeExpiredRf.toString() + " not current file...");
            if (toBeExpiredRf.serverPersisted) {
                if (BasicRecFilesCache.DEBUG)
                    console.debug("Rec. files cache: " + toBeExpiredRf.toString() + " is server persisted...");
                // expire recording files first stored to the cache
                let expiredSamples = RecordingFileUtils.expireAudioData(toBeExpiredRf);
                this._sampleCount -= expiredSamples;
                if (expiredSamples > 0) {
                    if (BasicRecFilesCache.DEBUG)
                        console.debug("Rec. files cache: Expired: " + toBeExpiredRf.toString() + ". Cache samples now: " + this._sampleCount);
                }
            }
            else {
                if (BasicRecFilesCache.DEBUG)
                    console.debug("Rec. files cache: #" + toBeExpiredRf.toString() + " not yet persisted on server.");
            }
        }
        else {
            if (BasicRecFilesCache.DEBUG)
                console.debug("Rec. files cache: " + toBeExpiredRf.toString() + " is current file.");
        }
    }
    expire() {
        // expire corrected versions first
        if (BasicRecFilesCache.DEBUG)
            console.debug("Rec. files cache: Expire? current: " + this._sampleCount + ", max: " + this.maxSampleCount);
        if (this._sampleCount > this.maxSampleCount) {
            // expire older versions of an item first
            for (let ii = 0; ii < this._items.length; ii++) {
                if (this._sampleCount <= this.maxSampleCount) {
                    break;
                }
                let it = this._items[ii];
                let itRfs = it.recs;
                if (itRfs && itRfs.length > 1) {
                    for (let rfi = 0; rfi < itRfs.length - 1; rfi++) {
                        if (this._sampleCount <= this.maxSampleCount) {
                            break;
                        }
                        let toBeExpiredRf = itRfs[rfi];
                        this.tryExpire(toBeExpiredRf);
                    }
                }
            }
            // if that's not sufficient expire audio data of latest versions as well
            for (let ii = 0; ii < this._items.length; ii++) {
                if (this._sampleCount <= this.maxSampleCount) {
                    break;
                }
                let it = this._items[ii];
                let itRfs = it.recs;
                if (itRfs && itRfs.length > 0) {
                    for (let rfi = 0; rfi < itRfs.length; rfi++) {
                        if (this._sampleCount <= this.maxSampleCount) {
                            break;
                        }
                        let toBeExpiredRf = itRfs[rfi];
                        this.tryExpire(toBeExpiredRf);
                    }
                }
            }
        }
    }
    addSprRecFile(item, sprRecFile) {
        this.expire();
        if (!item.recs) {
            item.recs = new Array();
        }
        item.recs[sprRecFile.version] = sprRecFile;
        this._sampleCount += RecordingFileUtils.sampleCount(sprRecFile);
        if (BasicRecFilesCache.DEBUG)
            console.debug("Rec. files cache: Added. Cache samples: " + this._sampleCount);
    }
    setSprRecFileAudioData(sprRecFile, adh) {
        this.expire();
        if (BasicRecFilesCache.DEBUG)
            console.debug("Rec. files cache: Set audio data after expire. Cache samples: " + this._sampleCount);
        let currSampleCnt = RecordingFileUtils.sampleCount(sprRecFile);
        this._sampleCount -= currSampleCnt;
        if (BasicRecFilesCache.DEBUG)
            console.debug("Rec. files cache: Set audio data subtracted curr sample count: " + currSampleCnt + ". Cache samples: " + this._sampleCount);
        RecordingFileUtils.setAudioData(sprRecFile, adh);
        let newSampleCnt = RecordingFileUtils.sampleCount(sprRecFile);
        this._sampleCount += newSampleCnt;
        if (BasicRecFilesCache.DEBUG)
            console.debug("Rec. files cache: Set audio data added new sample count: " + newSampleCnt + ". Cache samples: " + this._sampleCount);
        let fl = adh?.frameLen;
        if (sprRecFile.frames == null && fl) {
            sprRecFile.frames = fl;
        }
        if (BasicRecFilesCache.DEBUG)
            console.debug("Rec. files cache: Set audio data. Cache samples: " + this._sampleCount);
    }
}
class RecFilesCache extends BasicRecFilesCache {
    constructor() {
        super(...arguments);
        this._recFiles = new Array();
    }
    get recFiles() {
        return this._recFiles;
    }
    getRecFile(index) {
        return this._recFiles[index];
    }
    length() {
        return this._recFiles.length;
    }
    expire() {
        if (this._sampleCount > this.maxSampleCount) {
            // audio recorder list is sorted: lower index is newer
            for (let rfI = this._recFiles.length - 1; rfI >= 0; rfI--) {
                if (this._sampleCount <= this.maxSampleCount) {
                    break;
                }
                let toBeExpiredRf = this._recFiles[rfI];
                if (toBeExpiredRf.serverPersisted) {
                    if (!RecordingFileUtils.equals(toBeExpiredRf, this.currentRecordingFile)) {
                        // expire recording files first stored to the cache
                        let expiredSamples = RecordingFileUtils.expireAudioData(toBeExpiredRf);
                        this._sampleCount -= expiredSamples;
                        if (expiredSamples > 0) {
                            if (BasicRecFilesCache.DEBUG)
                                console.debug("Rec. files cache: Expired #" + rfI + ". Cache samples: " + this._sampleCount);
                        }
                    }
                    else {
                        if (BasicRecFilesCache.DEBUG)
                            console.debug("Rec. files cache: #" + rfI + " is current file. (not expiring)");
                    }
                }
                else {
                    if (BasicRecFilesCache.DEBUG)
                        console.debug("Rec. files cache: #" + rfI + " not yet server persisted.");
                }
            }
        }
    }
    addRecFile(recFile) {
        this.expire();
        this._recFiles.push(recFile);
        this._sampleCount += RecordingFileUtils.sampleCount(recFile);
        if (BasicRecFilesCache.DEBUG)
            console.debug("Rec. files cache: Added. Cache samples: " + this._sampleCount);
    }
    setRecFileAudioData(recFile, adh) {
        this.expire();
        this._sampleCount -= RecordingFileUtils.sampleCount(recFile);
        RecordingFileUtils.setAudioData(recFile, adh);
        this._sampleCount += RecordingFileUtils.sampleCount(recFile);
        if (BasicRecFilesCache.DEBUG)
            console.debug("Rec. files cache: Set audio data. Cache samples: " + this._sampleCount);
    }
}

class SpeechRecorderUploader extends Uploader {
    constructor(httpClient, config) {
        super(httpClient, (config) ? config.withCredentials : false);
        this.httpClient = httpClient;
        this.config = config;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.12", ngImport: i0, type: SpeechRecorderUploader, deps: [{ token: i1.HttpClient }, { token: SPEECHRECORDER_CONFIG }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "18.2.12", ngImport: i0, type: SpeechRecorderUploader }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.12", ngImport: i0, type: SpeechRecorderUploader, decorators: [{
            type: Injectable
        }], ctorParameters: () => [{ type: i1.HttpClient }, { type: SpeechRecorderConfig, decorators: [{
                    type: Inject,
                    args: [SPEECHRECORDER_CONFIG]
                }] }] });

class WarningBar {
    constructor() {
        this.displayClass = 'off';
    }
    set show(show) {
        if (show) {
            this.displayClass = 'on';
        }
        else {
            this.displayClass = 'off';
        }
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.12", ngImport: i0, type: WarningBar, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "18.2.12", type: WarningBar, selector: "app-warningbar", inputs: { warningText: "warningText", show: "show" }, providers: [SessionService], ngImport: i0, template: `
    <div [class]="displayClass">{{warningText}}</div>

  `, isInline: true, styles: [":host{flex:0 0 content;background:orange}\n", ".off{display:none}\n", ".on{padding:2px;display:inline-block;width:100%;font-weight:700;font-size:larger;text-align:center}\n"] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.12", ngImport: i0, type: WarningBar, decorators: [{
            type: Component,
            args: [{ selector: 'app-warningbar', providers: [SessionService], template: `
    <div [class]="displayClass">{{warningText}}</div>

  `, styles: [":host{flex:0 0 content;background:orange}\n", ".off{display:none}\n", ".on{padding:2px;display:inline-block;width:100%;font-weight:700;font-size:larger;text-align:center}\n"] }]
        }], propDecorators: { warningText: [{
                type: Input
            }], show: [{
                type: Input
            }] } });

const DEFAULT_PRE_REC_DELAY = 1000;
const DEFAULT_POST_REC_DELAY = 500;
class SessionManager extends BasicRecorder {
    get persistentAudioStorageTarget() {
        return this._persistentAudioStorageTarget;
    }
    set persistentAudioStorageTarget(value) {
        this._persistentAudioStorageTarget = value;
        if (this.ac) {
            this.ac.persistentAudioStorageTarget = this.persistentAudioStorageTarget;
        }
    }
    constructor(bpo, changeDetectorRef, renderer, dialog, sessionService, recFileService, uploader, config) {
        super(bpo, changeDetectorRef, dialog, sessionService, uploader, config);
        this.bpo = bpo;
        this.renderer = renderer;
        this.recFileService = recFileService;
        this.offlineAudioContext = null;
        this.enableUploadRecordings = true;
        this.enableDownloadRecordings = false;
        this.status = 0 /* Status.BLOCKED */;
        this.dataSaved = true;
        this.preRecTimerId = null;
        this.preRecTimerRunning = null;
        this.postDelay = DEFAULT_POST_REC_DELAY;
        this.postRecTimerId = null;
        this.postRecTimerRunning = null;
        //private maxRecTimerRunning: boolean|null=null;
        this.nonRecordingDurationTimerId = null;
        this.nonRecordingDurationTimerRunning = false;
        this._promptIndex = 0;
        this.items = null;
        //selectedItemIdx: number;
        this._displayRecFile = null;
        this.showSessionCompleteMessage = true;
        this.status = 1 /* Status.IDLE */;
        this.audio = document.getElementById('audio');
        if (this.config && this.config.enableUploadRecordings !== undefined) {
            this.enableUploadRecordings = this.config.enableUploadRecordings;
        }
        if (this.config && this.config.enableDownloadRecordings !== undefined) {
            this.enableDownloadRecordings = this.config.enableDownloadRecordings;
        }
        this.init();
    }
    ngAfterViewInit() {
        this.streamLevelMeasure.levelListener = this.liveLevelDisplay;
        this.streamLevelMeasure.peakLevelListener = (peakLvlInDb) => {
            this.peakLevelInDb = peakLvlInDb;
            this.changeDetectorRef.detectChanges();
        };
    }
    ngOnDestroy() {
        //console.debug("Com destroy, disable wake lock.")
        this.disableWakeLockCond();
        this.destroyed = true;
        // TODO stop capture /playback
    }
    init() {
        this.sectIdx = 0;
        this.groupIdxInSection = 0;
        this.promptItemIdxInGroup = 0;
        this.autorecording = false;
        this.transportActions.startAction.disabled = true;
        this.transportActions.stopAction.disabled = true;
        this.transportActions.nextAction.disabled = true;
        this.transportActions.stopNonrecordingAction.disabled = true;
        this.transportActions.pauseAction.disabled = true;
        this.playStartAction.disabled = true;
        // let context:AudioContext|null=null;
        // try {
        //   context = AudioContextProvider.audioContextInstance();
        // } catch (err) {
        //   this.status = Status.ERROR;
        //   let errMsg = 'Unknown error';
        //   if(err instanceof Error){
        //     errMsg=err.message;
        //   }
        //   this.statusMsg = 'ERROR: ' + errMsg;
        //   this.statusAlertType = 'error';
        //   this.dialog.open(MessageDialog, {
        //     data: {
        //       type: 'error',
        //       title: 'Error',
        //       msg: errMsg,
        //       advice: 'Please use a supported browser.',
        //     }
        //   });
        //   return;
        // }
        // if(context) {
        //   console.info("State of audio context: " + context.state)
        // }else{
        //   console.info("No audio context available!");
        // }
        // if (!context || !navigator.mediaDevices) {
        //   this.status = Status.ERROR;
        //   let errMsg = 'Browser does not support Media streams!';
        //   this.statusMsg = 'ERROR: ' + errMsg;
        //   this.statusAlertType = 'error';
        //   this.dialog.open(MessageDialog, {
        //     data: {
        //       type: 'error',
        //       title: 'Error',
        //       msg: errMsg,
        //       advice: 'Please use a supported browser.',
        //     }
        //   });
        //   return;
        // } else {
        this.ac = new AudioCapture();
        if (this.ac) {
            this.transportActions.startAction.onAction = () => this.startItem();
            this.ac.listener = this;
            this.configureStreamCaptureStream();
            // Don't list the devices here. If we do not have audio permissions we only get anonymized devices without labels.
            //this.ac.listDevices();
        }
        else {
            this.transportActions.startAction.disabled = true;
            let errMsg = 'Browser does not support Media/Audio API!';
            this.statusMsg = 'ERROR: ' + errMsg;
            this.statusAlertType = 'error';
            this.dialog.open(MessageDialog, {
                data: {
                    type: 'error',
                    title: 'Error',
                    msg: errMsg,
                    advice: 'Please use a supported browser.',
                }
            });
            return;
        }
        this.transportActions.stopAction.onAction = () => this.stopItem();
        this.transportActions.nextAction.onAction = () => this.stopItem();
        this.transportActions.pauseAction.onAction = () => this.pauseItem();
        this.transportActions.fwdAction.onAction = () => this.nextItem();
        this.transportActions.stopNonrecordingAction.onAction = () => this.stopNonrecording();
        this.transportActions.fwdNextAction.onAction = () => this.nextUnrecordedItem();
        this.transportActions.bwdAction.onAction = () => this.prevItem();
        this.playStartAction.onAction = () => this.controlAudioPlayer?.start();
        this.startStopSignalState = 4 /* StartStopSignalState.OFF */;
    }
    onKeyPress(ke) {
        if (ke.key == ' ') {
            this.transportActions.startAction.perform();
            this.transportActions.nextAction.perform();
            this.transportActions.stopNonrecordingAction.perform();
        }
    }
    onKeyDown(ke) {
        if (ke.key == ' ') {
            this.transportActions.stopAction.perform();
        }
        if (ke.key == 'p') {
            this.transportActions.pauseAction.perform();
        }
        if (ke.key == 'Escape') {
            if (!this.audioSignalCollapsed) {
                this.audioSignalCollapsed = true;
            }
            this.transportActions.stopAction.perform();
            this.transportActions.pauseAction.perform();
        }
        if (ke.key == 'MediaPlayPause') {
            this.playStartAction.perform();
        }
        if (ke.key === 'ArrowRight') {
            this.transportActions.fwdAction.perform();
        }
        if (ke.key === 'ArrowLeft') {
            this.transportActions.bwdAction.perform();
        }
    }
    updateWakeLock(dataSaved = this.dataSaved) {
        //console.debug("Update wake lock: dataSaved: "+dataSaved+", not active: "+! this.isActive())
        if (dataSaved && !this.isActive()) {
            this.disableWakeLockCond();
        }
    }
    progressPercentValue() {
        let v = 100;
        if (this.items) {
            v = this.promptIndex * 100 / (this.items.length() - 1);
        }
        return v;
    }
    isTestSession() {
        return ((this._session != null) && (this._session.type === 'TEST' || this._session.type === 'TEST_DEF_A' || this._session.type === 'SINUS_TEST'));
    }
    isDefaultAudioTestSession() {
        return ((this._session != null) && (this._session.type === 'TEST_DEF_A'));
    }
    isDefaultAudioTestSessionOverwritingProjectRequirements() {
        return ((this._session != null) && (this._session.type === 'TEST_DEF_A') && (this.audioDevices != null) && this.audioDevices.length > 0);
    }
    set controlAudioPlayer(controlAudioPlayer) {
        this._controlAudioPlayer = controlAudioPlayer;
        if (this._controlAudioPlayer) {
            this._controlAudioPlayer.listener = this;
        }
    }
    get controlAudioPlayer() {
        return this._controlAudioPlayer;
    }
    set script(script) {
        this._script = script;
        this.loadScript();
    }
    update(e) {
        if (e.type == EventType.STARTED) {
            this.playStartAction.disabled = true;
            this.updateTimerId = window.setInterval(() => {
                //this.audioSignal.playFramePosition = this.ap.playPositionFrames;
            }, 50);
        }
        else if (e.type == EventType.STOPPED || e.type == EventType.ENDED) {
            window.clearInterval(this.updateTimerId);
            // this.audioSignal.playFramePosition = this.ap.playPositionFrames;
            this.playStartAction.disabled = (!(this.displayRecFile));
        }
    }
    get promptIndex() {
        return this._promptIndex;
    }
    set promptIndex(promptIndex) {
        if (promptIndex < 0 || promptIndex >= this.promptItemCount) {
            throw new Error("Prompt index out of range");
        }
        let i = 0;
        let sections = this._script.sections;
        let found = false;
        for (let si = 0; si < sections.length && !found; si++) {
            let section = sections[si];
            let gs = section._shuffledGroups;
            for (let gi = 0; gi < gs.length; gi++) {
                let pis = gs[gi]._shuffledPromptItems;
                let pisSize = pis.length;
                if (promptIndex < i + pisSize) {
                    this.sectIdx = si;
                    this.groupIdxInSection = gi;
                    this.promptItemIdxInGroup = promptIndex - i;
                    found = true;
                    break;
                }
                else {
                    i += pisSize;
                }
            }
        }
        if (found) {
            this._promptIndex = promptIndex;
        }
        else {
            throw new Error("Internal error: Prompt index not found");
        }
        this.keepLiveLevel = false;
        this.applyItem();
    }
    itemSelect(itemIdx) {
        if (this.status === 1 /* Status.IDLE */) {
            this.promptIndex = itemIdx;
        }
    }
    clearPreRecTimer() {
        if (this.preRecTimerRunning) {
            if (this.preRecTimerId) {
                window.clearTimeout(this.preRecTimerId);
            }
            this.preRecTimerRunning = false;
        }
    }
    clearPostRecTimer() {
        if (this.postRecTimerRunning) {
            if (this.postRecTimerId) {
                window.clearTimeout(this.postRecTimerId);
            }
            this.postRecTimerRunning = false;
        }
    }
    clearMaxRecTimer() {
        if (this.maxRecTimerRunning) {
            if (this.maxRecTimerId) {
                window.clearTimeout(this.maxRecTimerId);
            }
            this.maxRecTimerRunning = false;
        }
    }
    clearNonRecordingDurationTimer() {
        if (this.nonRecordingDurationTimerRunning) {
            if (this.nonRecordingDurationTimerId) {
                window.clearTimeout(this.nonRecordingDurationTimerId);
            }
            this.nonRecordingDurationTimerRunning = false;
        }
    }
    startItem() {
        this.transportActions.fwdAction.disabled = true;
        this.transportActions.fwdNextAction.disabled = true;
        this.transportActions.bwdAction.disabled = true;
        const isNonrecording = (this.promptItem.type === 'nonrecording');
        if (isNonrecording) {
            this.status = 1 /* Status.IDLE */;
            this.updateDisplayRecFile(null);
            this.displayRecFileVersion = 0;
            this.displayAudioClip = null;
            this.liveLevelDisplay.reset(true);
            // Hide loading hint on livelevel display
            this.liveLevelDisplayState = State.READY;
            this.showRecording();
            if (this.section.mode === 'AUTORECORDING') {
                this.autorecording = true;
            }
            const nrDuration = this.promptItem.duration;
            if (this.autorecording && nrDuration !== undefined) {
                this.nonRecordingDurationTimerId = window.setTimeout(() => {
                    this.nonRecordingDurationTimerRunning = false;
                    this.transportActions.stopNonrecordingAction.disabled = true;
                    this.status = 7 /* Status.STOPPING_STOP */;
                    this.continueSession();
                }, nrDuration);
                this.nonRecordingDurationTimerRunning = true;
            }
            this.status = 9 /* Status.NON_RECORDING_WAIT */;
            this.transportActions.stopNonrecordingAction.disabled = false;
        }
        else {
            this.status = 2 /* Status.STARTING */;
            super.startItem();
            if (this.readonly) {
                this.status = 1 /* Status.IDLE */;
                return;
            }
            this.updateDisplayRecFile(null);
            this.displayRecFileVersion = 0;
            this.displayAudioClip = null;
            this.liveLevelDisplay.reset(true);
            // Hide loading hint on livelevel display
            this.liveLevelDisplayState = State.READY;
            this.showRecording();
            if (this.section.mode === 'AUTORECORDING') {
                this.autorecording = true;
            }
            this.startCapture();
        }
    }
    loadScript() {
        this.promptItemCount = 0;
        this.items = new SprItemsCache();
        let ln = 0;
        //TODO randomize not supported
        for (let si = 0; si < this._script.sections.length; si++) {
            let section = this._script.sections[si];
            let gs = section._shuffledGroups;
            for (let gi = 0; gi < gs.length; gi++) {
                let pis = gs[gi]._shuffledPromptItems;
                let pisLen = pis.length;
                this.promptItemCount += pisLen;
                for (let piSectIdx = 0; piSectIdx < pisLen; piSectIdx++) {
                    let pi = pis[piSectIdx];
                    let promptAsStr = PromptitemUtil.toPlainTextString(pi);
                    let it = new Item(promptAsStr, section.training, (!pi.type || pi.type === 'recording'));
                    this.items.addItem(it);
                    ln++;
                }
            }
        }
    }
    promptIndexByItemcode(itemcode) {
        let pix = 0;
        for (let si = 0; si < this._script.sections.length; si++) {
            let section = this._script.sections[si];
            let gs = section._shuffledGroups;
            for (let gi = 0; gi < gs.length; gi++) {
                let pis = gs[gi]._shuffledPromptItems;
                let pisLen = pis.length;
                for (let piSectIdx = 0; piSectIdx < pisLen; piSectIdx++) {
                    let pi = pis[piSectIdx];
                    let ic = pi.itemcode;
                    if (ic === itemcode) {
                        return pix;
                    }
                    pix++;
                }
            }
        }
        return null;
    }
    clearPrompt() {
        //this.prompting.promptContainer.prompter.promptText='';
        //this.mediaitem = null;
        this.showPrompt = false;
        this.changeDetectorRef.detectChanges();
    }
    applyPrompt() {
        //this.prompting.promptContainer.prompter.promptText=this.promptUnit.mediaitems[0].text;
        //this.promptText = this.promptUnit.mediaitems[0].text;
        //this.mediaitem=this.promptUnit.mediaitems[0];
        this.showPrompt = true;
        this.changeDetectorRef.detectChanges();
    }
    downloadRecording() {
        if (this.displayRecFile) {
            let adh = this.displayRecFile.audioDataHolder;
            let as = null;
            if (adh) {
                as = adh.audioSource;
            }
            const ww = new WavWriter(this._clientMediaStorageFormat?.audioEncoding === AudioStorageFormatEncoding.PCM_FLOAT, this._clientMediaStorageFormat?.audioPCMsampleSizeInBits);
            if (as instanceof AudioBufferSource) {
                ww.writeAsync(as.audioBuffer, (wavFile) => {
                    const blob = new Blob([wavFile], { type: 'audio/wav' });
                    const rfUrl = URL.createObjectURL(blob);
                    const dataDnlLnk = this.renderer.createElement('a');
                    //dataDnlLnk.name = 'Recording';
                    dataDnlLnk.href = rfUrl;
                    this.renderer.appendChild(document.body, dataDnlLnk);
                    // download property not yet in TS def
                    if (this.displayRecFile) {
                        let fn = this.displayRecFile.filenameString();
                        fn += '_' + this.displayRecFileVersion;
                        fn += '.wav';
                        dataDnlLnk.download = fn;
                        dataDnlLnk.click();
                    }
                    this.renderer.removeChild(document.body, dataDnlLnk);
                });
            }
        }
    }
    set displayRecFile(displayRecFile) {
        this._displayRecFile = displayRecFile;
    }
    updateDisplayRecFile(displayRecFile, fetchAndApplyRecordingFile = true) {
        this.displayRecFile = displayRecFile;
        if (this._displayRecFile) {
            if (this.items) {
                this.items.currentRecordingFile = this._displayRecFile;
            }
            let adh = this._displayRecFile.audioDataHolder;
            if (adh) {
                this.displayAudioClip = new AudioClip(adh);
                if (this._controlAudioPlayer) {
                    this._controlAudioPlayer.audioClip = this.displayAudioClip;
                }
                this.showRecording();
            }
            else {
                // clear for now ...
                this.displayAudioClip = null;
                if (this.controlAudioPlayer) {
                    this.controlAudioPlayer.audioClip = null;
                }
                if (fetchAndApplyRecordingFile) {
                    if (this._controlAudioPlayer && this._session) {
                        //... and try to fetch from server
                        this.liveLevelDisplayState = State.LOADING;
                        const rf = this._displayRecFile;
                        let audioDownloadType = this._clientAudioStorageType;
                        if (AudioStorageType.MEM_ENTIRE_AUTO_NET_CHUNKED === this._clientAudioStorageType || AudioStorageType.MEM_CHUNKED_AUTO_NET_CHUNKED === this._clientAudioStorageType) {
                            // Default is network mode
                            audioDownloadType = AudioStorageType.NET_CHUNKED;
                            if (rf.channels && rf.frames) {
                                const samples = rf.channels * rf.frames;
                                if (samples <= this._maxAutoNetMemStoreSamples) {
                                    // But if audio file is small, load in continuous resp. chunked mode
                                    if (AudioStorageType.MEM_ENTIRE_AUTO_NET_CHUNKED === this._clientAudioStorageType) {
                                        audioDownloadType = AudioStorageType.MEM_ENTIRE;
                                    }
                                    else if (AudioStorageType.MEM_CHUNKED_AUTO_NET_CHUNKED === this._clientAudioStorageType) {
                                        audioDownloadType = AudioStorageType.MEM_CHUNKED;
                                    }
                                }
                            }
                        }
                        console.debug("Audio download type: " + audioDownloadType);
                        if (AudioStorageType.DB_CHUNKED === this._clientAudioStorageType) {
                            // Fetch chunked indexed db audio buffer
                            let nextIab = null;
                            if (!this._persistentAudioStorageTarget) {
                                throw Error('Error: Persistent storage target not set.');
                            }
                            else {
                                //console.debug("Fetch audio and store to indexed db...");
                                this.audioFetchSubscription = this.recFileService.fetchSprRecordingFileIndDbAudioBuffer(this._persistentAudioStorageTarget, this._session.project, rf).subscribe({
                                    next: (iab) => {
                                        //console.debug("Sessionmanager: Received inddb audio buffer: "+iab);
                                        nextIab = iab;
                                    },
                                    complete: () => {
                                        this.liveLevelDisplayState = State.READY;
                                        let fabDh = null;
                                        if (nextIab) {
                                            if (rf && this.items) {
                                                fabDh = new AudioDataHolder(nextIab);
                                                this.items.setSprRecFileAudioData(rf, fabDh);
                                            }
                                        }
                                        else {
                                            // Should actually be handled by the error resolver
                                            this.statusMsg = 'Recording file could not be loaded.';
                                            this.statusAlertType = 'error';
                                        }
                                        if (fabDh) {
                                            // this.displayAudioClip could have been changed meanwhile, but the recorder unsubcribes before changing the item, therefore there should be no risk to set to wrong item
                                            this.displayAudioClip = new AudioClip(fabDh);
                                        }
                                        if (this._controlAudioPlayer) {
                                            this._controlAudioPlayer.audioClip = this.displayAudioClip;
                                        }
                                        this.showRecording();
                                    },
                                    error: err => {
                                        console.error("Could not load recording file from server: " + err);
                                        this.liveLevelDisplayState = State.READY;
                                        this.statusMsg = 'Recording file could not be loaded: ' + err;
                                        this.statusAlertType = 'error';
                                        this.changeDetectorRef.detectChanges();
                                    }
                                });
                            }
                        }
                        else if (AudioStorageType.NET_CHUNKED === audioDownloadType) {
                            // Fetch chunked audio buffer from network
                            let nextNetAb = null;
                            //console.debug("Fetch chunked audio from network");
                            this.audioFetchSubscription = this.recFileService.fetchSprRecordingFileNetAudioBuffer(this._session.project, rf).subscribe({
                                next: (netAb) => {
                                    //console.debug("Sessionmanager: Received net audio buffer: "+netAb);
                                    nextNetAb = netAb;
                                },
                                complete: () => {
                                    this.liveLevelDisplayState = State.READY;
                                    let fabDh = null;
                                    if (nextNetAb) {
                                        if (rf && this.items) {
                                            fabDh = new AudioDataHolder(nextNetAb);
                                            this.items.setSprRecFileAudioData(rf, fabDh);
                                        }
                                    }
                                    else {
                                        // Should actually be handled by the error resolver
                                        this.statusMsg = 'Recording file could not be loaded.';
                                        this.statusAlertType = 'error';
                                    }
                                    if (fabDh) {
                                        // this.displayAudioClip could have been changed meanwhile, but the recorder unsubcribes before changing the item, therefore there should be no risk to set to wrong item
                                        //console.debug("set displayRecFile(): fetch net ab complete, set displayAudioClip.")
                                        this.displayAudioClip = new AudioClip(fabDh);
                                    }
                                    if (this._controlAudioPlayer) {
                                        this._controlAudioPlayer.audioClip = this.displayAudioClip;
                                    }
                                    this.showRecording();
                                },
                                error: err => {
                                    console.error("Could not load recording file from server: " + err);
                                    this.liveLevelDisplayState = State.READY;
                                    this.statusMsg = 'Recording file could not be loaded: ' + err;
                                    this.statusAlertType = 'error';
                                    this.changeDetectorRef.detectChanges();
                                }
                            });
                        }
                        else if (AudioStorageType.MEM_CHUNKED === audioDownloadType) {
                            // Fetch chunked array audio buffer
                            let nextAab = null;
                            //console.debug("Fetch audio and store to (chunked) array buffer...");
                            this.audioFetchSubscription = this.recFileService.fetchSprRecordingFileArrayAudioBuffer(this._session.project, rf).subscribe({
                                next: (aab) => {
                                    nextAab = aab;
                                },
                                complete: () => {
                                    this.liveLevelDisplayState = State.READY;
                                    let fabDh = null;
                                    if (nextAab) {
                                        if (rf && this.items) {
                                            fabDh = new AudioDataHolder(nextAab);
                                            this.items.setSprRecFileAudioData(rf, fabDh);
                                        }
                                    }
                                    else {
                                        // Should actually be handled by the error resolver
                                        this.statusMsg = 'Recording file could not be loaded.';
                                        this.statusAlertType = 'error';
                                    }
                                    if (fabDh) {
                                        // this.displayAudioClip could have been changed meanwhile, but the recorder unsubcribes before changing the item, therefore there should be no risk to set to wrong item
                                        this.displayAudioClip = new AudioClip(fabDh);
                                    }
                                    if (this._controlAudioPlayer) {
                                        this._controlAudioPlayer.audioClip = this.displayAudioClip;
                                    }
                                    this.showRecording();
                                },
                                error: err => {
                                    console.error("Could not load recording file from server: " + err);
                                    this.liveLevelDisplayState = State.READY;
                                    this.statusMsg = 'Recording file could not be loaded: ' + err;
                                    this.statusAlertType = 'error';
                                }
                            });
                        }
                        else {
                            // Fetch regular audio buffer
                            //console.debug("Fetch audio and store to audio buffer...");
                            this.audioFetchSubscription = this.recFileService.fetchSprRecordingFileAudioBuffer(this._session.project, rf).subscribe({
                                next: (ab) => {
                                    this.liveLevelDisplayState = State.READY;
                                    let fabDh = null;
                                    if (ab) {
                                        if (rf && this.items) {
                                            if (SessionManager.FORCE_ARRRAY_AUDIO_BUFFER) {
                                                let aab = ArrayAudioBuffer.fromAudioBuffer(ab);
                                                fabDh = new AudioDataHolder(aab);
                                            }
                                            else {
                                                fabDh = new AudioDataHolder(new AudioBufferSource(ab));
                                            }
                                            this.items.setSprRecFileAudioData(rf, fabDh);
                                        }
                                    }
                                    else {
                                        // Should actually be handled by the error resolver
                                        this.statusMsg = 'Recording file could not be loaded.';
                                        this.statusAlertType = 'error';
                                    }
                                    if (fabDh) {
                                        // this.displayAudioClip could have been changed meanwhile, but the recorder unsubcribes before changing the item, therefore there should be no risk to set to wrong item
                                        this.displayAudioClip = new AudioClip(fabDh);
                                    }
                                    if (this._controlAudioPlayer) {
                                        this._controlAudioPlayer.audioClip = this.displayAudioClip;
                                    }
                                    this.showRecording();
                                }, error: err => {
                                    console.error("Could not load recording file from server: " + err);
                                    this.liveLevelDisplayState = State.READY;
                                    this.statusMsg = 'Recording file could not be loaded: ' + err;
                                    this.statusAlertType = 'error';
                                }
                            });
                        }
                    }
                    else {
                        this.statusMsg = 'Recording file could not be decoded. Audio context unavailable.';
                        this.statusAlertType = 'error';
                    }
                }
            }
        }
        else {
            this.displayAudioClip = null;
            if (this.controlAudioPlayer) {
                this.controlAudioPlayer.audioClip = null;
            }
        }
    }
    get displayRecFile() {
        return this._displayRecFile;
    }
    isRecordingItem() {
        return (this.promptItem != null && this.promptItem.type !== 'nonrecording');
    }
    updateStartActionDisableState() {
        this.transportActions.startAction.disabled = !(this.ac && this.isRecordingItem());
    }
    applyItem(temporary = false) {
        this.section = this._script.sections[this.sectIdx];
        this.group = this.section._shuffledGroups[this.groupIdxInSection];
        this.promptItem = this.group._shuffledPromptItems[this.promptItemIdxInGroup];
        //this.selectedItemIdx = this.promptIndex;
        if (this.audioFetchSubscription) {
            //console.debug("Unsubscribe from audio fetch.");
            this.audioFetchSubscription.unsubscribe();
        }
        if (!temporary) {
            this.displayAudioClip = null;
            this.showRecording();
        }
        this.liveLevelDisplayState = State.READY;
        this.clearPrompt();
        const isNonrecording = (this.promptItem.type === 'nonrecording');
        if (isNonrecording || !this.section.promptphase || this.section.promptphase === 'IDLE') {
            this.applyPrompt();
        }
        if (isNonrecording) {
            this.updateDisplayRecFile(null);
            this.displayRecFileVersion = 0;
            this.startStopSignalState = 4 /* StartStopSignalState.OFF */;
        }
        else {
            if (this.items) {
                let it = this.items.getItem(this.promptIndex);
                if (!it.recs) {
                    it.recs = new Array();
                }
                let recentRecFile = null;
                let availRecfiles = it.recs.length;
                if (availRecfiles > 0) {
                    let rfVers = availRecfiles - 1;
                    recentRecFile = it.recs[rfVers];
                    this.updateDisplayRecFile(recentRecFile, !temporary);
                    this.displayRecFileVersion = rfVers;
                }
                else {
                    this.updateDisplayRecFile(null);
                    this.displayRecFileVersion = 0;
                }
            }
            if (!this.readonly) {
                this.startStopSignalState = 0 /* StartStopSignalState.IDLE */;
            }
        }
        // console.debug("applyItem(): temporary: "+temporary);
        //if (!temporary) {
        //   console.debug("applyItem(): Call showRecording(): displayAudioClip: "+this.displayAudioClip);
        //this.showRecording();
        //}
        this.updateStartActionDisableState();
        this.updateNavigationActions();
    }
    start() {
        super.start();
        if (this.promptItemCount > 0) {
            this.promptIndex = 0;
        }
        this.enableNavigation();
    }
    isRecording() {
        return (this.status === 3 /* Status.PRE_RECORDING */ || this.status === 4 /* Status.RECORDING */ || this.status === 5 /* Status.POST_REC_STOP */ || this.status === 6 /* Status.POST_REC_PAUSE */ || this.status === 7 /* Status.STOPPING_STOP */);
    }
    isActive() {
        return (!(this.status === 0 /* Status.BLOCKED */ || this.status === 1 /* Status.IDLE */ || this.status === 10 /* Status.ERROR */) || this.processingRecording || this.sessionService.uploadCount > 0);
    }
    prevItem() {
        let newPrIdx = this._promptIndex;
        newPrIdx--;
        if (newPrIdx < 0) {
            newPrIdx = this.promptItemCount - 1;
        }
        this.promptIndex = newPrIdx;
        //this.updateNavigationActions()
    }
    nextItem() {
        let newPrIdx = this._promptIndex;
        newPrIdx++;
        if (newPrIdx >= this.promptItemCount) {
            newPrIdx = 0;
        }
        this.promptIndex = newPrIdx;
        //this.updateNavigationActions();
    }
    updateNavigationActions() {
        let fwdNxtActionDisabled = true;
        if (this.items) {
            let currRecs = this.items.getItem(this._promptIndex).recs;
            fwdNxtActionDisabled = !(currRecs != null && currRecs.length > 0);
        }
        this.transportActions.fwdNextAction.disabled = this.navigationDisabled || fwdNxtActionDisabled;
        this.transportActions.fwdAction.disabled = this.navigationDisabled;
        this.transportActions.bwdAction.disabled = this.navigationDisabled;
    }
    nextUnrecordedItem() {
        let newPrIdx = this._promptIndex;
        newPrIdx++;
        if (newPrIdx >= this.promptItemCount) {
            newPrIdx = 0;
        }
        if (this.items != null) {
            let it = this.items.getItem(newPrIdx);
            while ((!it.recording || it.itemDone()) && newPrIdx < this.promptItemCount) {
                newPrIdx++;
                it = this.items.getItem(newPrIdx);
            }
            if (!it.itemDone()) {
                this.promptIndex = newPrIdx;
            }
        }
    }
    enableStartUserGesture() {
        super.enableStartUserGesture();
        this.transportActions.startAction.disabled = !(this.ac && this.isRecordingItem());
    }
    enableNavigation() {
        this.navigationDisabled = false;
        this.updateNavigationActions();
    }
    started() {
        let ic = this.promptItem.itemcode;
        let rf = null;
        if (this._session && ic) {
            let sessId = this._session.sessionId;
            let cpIdx = this.promptIndex;
            if (this.items) {
                let it = this.items.getItem(cpIdx);
                if (!it.recs) {
                    it.recs = new Array();
                }
                rf = new SprRecordingFile(sessId, ic, it.recs.length, null);
                rf.uuid = this.rfUuid;
                //it.recs.push(rf);
                this.items.addSprRecFile(it, rf);
                this.items.currentRecordingFile = rf;
            }
        }
        this._recordingFile = rf;
        this.status = 3 /* Status.PRE_RECORDING */;
        super.started();
        this.startStopSignalState = 1 /* StartStopSignalState.PRERECORDING */;
        if (this._session) {
            if (this._session.status === "LOADED") {
                let body = {};
                if (this.section.training) {
                    this._session.status = "STARTED_TRAINING";
                    body.status = this._session.status;
                    if (!this._session.startedTrainingDate) {
                        this._session.startedTrainingDate = new Date();
                        body.startedTrainingDate = this._session.startedTrainingDate;
                    }
                }
                else {
                    this._session.status = "STARTED";
                    body.status = this._session.status;
                    if (!this._session.startedDate) {
                        this._session.startedDate = new Date();
                        body.startedDate = this._session.startedDate;
                    }
                }
                this.sessionService.patchSessionObserver(this._session, body).subscribe();
            }
        }
        if (this.section.promptphase === 'PRERECORDING' || this.section.promptphase === 'PRERECORDINGONLY') {
            this.applyPrompt();
        }
        this.statusAlertType = 'info';
        this.statusMsg = 'Recording...';
        let preDelay = DEFAULT_PRE_REC_DELAY;
        if (this.promptItem.prerecdelay != null) {
            preDelay = this.promptItem.prerecdelay;
        }
        else if (this.promptItem.prerecording != null) {
            preDelay = this.promptItem.prerecording;
        }
        this.postDelay = DEFAULT_POST_REC_DELAY;
        if (this.promptItem.postrecdelay != null) {
            this.postDelay = this.promptItem.postrecdelay;
        }
        else if (this.promptItem.postrecording != null) {
            this.postDelay = this.promptItem.postrecording;
        }
        let maxRecordingTimeMs = MAX_RECORDING_TIME_MS;
        if (this.promptItem.recduration !== null && this.promptItem.recduration !== undefined) {
            maxRecordingTimeMs = preDelay + this.promptItem.recduration + this.postDelay;
        }
        this.maxRecTimerId = window.setTimeout(() => {
            this.stopRecordingMaxRec();
        }, maxRecordingTimeMs);
        this.maxRecTimerRunning = true;
        this.preRecTimerId = window.setTimeout(() => {
            this.preRecTimerRunning = false;
            this.status = 4 /* Status.RECORDING */;
            this.startStopSignalState = 3 /* StartStopSignalState.RECORDING */;
            if (this.section.mode === 'AUTORECORDING') {
                this.transportActions.nextAction.disabled = false;
                this.transportActions.pauseAction.disabled = false;
            }
            else {
                this.transportActions.stopAction.disabled = false;
            }
            if (this.section.promptphase === 'RECORDING') {
                this.applyPrompt();
            }
            if (this.section.promptphase === 'PRERECORDINGONLY') {
                this.clearPrompt();
            }
        }, preDelay);
        this.preRecTimerRunning = true;
    }
    stopItem() {
        this.status = 5 /* Status.POST_REC_STOP */;
        this.startStopSignalState = 2 /* StartStopSignalState.POSTRECORDING */;
        this.transportActions.stopAction.disabled = true;
        this.transportActions.nextAction.disabled = true;
        //this.transportActions.stopNonrecordingAction.disabled=true;
        this.clearPreRecTimer();
        this.postRecTimerId = window.setTimeout(() => {
            this.postRecTimerRunning = false;
            this.status = 7 /* Status.STOPPING_STOP */;
            this.stopRecording();
        }, this.postDelay);
        this.postRecTimerRunning = true;
    }
    stopNonrecording() {
        this.transportActions.stopNonrecordingAction.disabled = true;
        this.clearNonRecordingDurationTimer();
        this.status = 7 /* Status.STOPPING_STOP */;
        this.continueSession();
    }
    pauseItem() {
        this.status = 6 /* Status.POST_REC_PAUSE */;
        this.transportActions.pauseAction.disabled = true;
        this.startStopSignalState = 2 /* StartStopSignalState.POSTRECORDING */;
        this.transportActions.stopAction.disabled = true;
        this.transportActions.nextAction.disabled = true;
        this.transportActions.stopNonrecordingAction.disabled = true;
        this.transportActions.pauseAction.disabled = true;
        this.clearPreRecTimer();
        this.postRecTimerId = window.setTimeout(() => {
            this.postRecTimerRunning = false;
            this.status = 8 /* Status.STOPPING_PAUSE */;
            this.stopRecording();
        }, this.postDelay);
        this.postRecTimerRunning = true;
    }
    stopRecording() {
        this.clearMaxRecTimer();
        if (this.ac) {
            this.ac.stop();
        }
    }
    stopRecordingMaxRec() {
        this.clearPreRecTimer();
        this.clearPostRecTimer();
        this.maxRecTimerRunning = false;
        this.status = 7 /* Status.STOPPING_STOP */;
        if (this.ac) {
            this.ac.stop();
        }
    }
    addRecordingFileByDescriptor(rfd) {
        if (rfd.recording && rfd.recording.itemcode) {
            let prIdx = this.promptIndexByItemcode(rfd.recording.itemcode);
            if (this.items != null && prIdx !== null) {
                let it = this.items.getItem(prIdx);
                if (it && this._session) {
                    // if (!it.recs) {
                    //   it.recs = new Array<SprRecordingFile>();
                    // }
                    let rf = new SprRecordingFile(this._session.sessionId, rfd.recording.itemcode, rfd.version, null);
                    rf.serverPersisted = true;
                    //console.debug("addRecordingFileByDescriptor(): sr: "+rfd.samplerate+", frames: "+rfd.frames);
                    if (rfd.samplerate && rfd.frames) {
                        rf.samplerate = rfd.samplerate;
                        rf.frames = rfd.frames;
                    }
                    if (rfd.channels) {
                        rf.channels = rfd.channels;
                    }
                    this.items.addSprRecFile(it, rf);
                }
                else {
                    //console.debug("WARN: No recording item with code: \"" +rfd.recording.itemcode+ "\" found.");
                }
            }
            else {
                //console.debug("WARN: No recording item with code: \"" +rfd.recording.itemcode+ "\" found.");
            }
        }
    }
    // addRecordingFileByPromptIndex(promptIndex:number, rf:SprRecordingFile){
    //
    // }
    stopped() {
        this.clearPreRecTimer();
        this.clearPostRecTimer();
        this.clearMaxRecTimer();
        this.updateStartActionDisableState();
        this.transportActions.stopAction.disabled = true;
        this.transportActions.nextAction.disabled = true;
        this.transportActions.pauseAction.disabled = true;
        this.statusAlertType = 'info';
        this.statusMsg = 'Recorded.';
        this.startStopSignalState = 0 /* StartStopSignalState.IDLE */;
        let adh = null;
        let as = null;
        let ab = null;
        if (this.ac) {
            if (AudioStorageType.NET_CHUNKED === this.ac.audioStorageType) {
                this.playStartAction.disabled = true;
                this.keepLiveLevel = true;
                let burl = null;
                if (this._session) {
                    if (this._displayRecFile) {
                        // TODO is this branch ever called ?
                        let rf = this._displayRecFile;
                        rf.frames = this.ac.framesRecorded;
                        //console.debug("stopped(): Set frames: "+rf.frames+" on rfId: "+this.displayRecFile?.recordingFileId);
                        burl = this.recFileService.sprAudioFileUrl(this._session?.project, rf);
                    }
                    else if (this.session?.project && this._recordingFile && this._recordingFile instanceof SprRecordingFile) {
                        burl = this.recFileService.sprAudioFileUrlByItemcode(this.session?.project, this.session?.sessionId, this._recordingFile.itemCode, this._recordingFile.version);
                    }
                    else {
                        console.error("Could not create net audio buffer.");
                    }
                    if (burl) {
                        const rUUID = this.ac.recUUID;
                        const sr = this.ac.currentSampleRate;
                        const chFl = sr * RecordingService.DEFAULT_CHUNKED_DOWNLOAD_SECONDS;
                        //console.debug("stopped(): rfID: "+this._recordingFile?.recordingFileId+", net ab url: " + burl+", frames: "+this.ac.framesRecorded+", sample rate: "+sr);
                        let netAb = new NetAudioBuffer(this.recFileService, burl, this.ac.channelCount, sr, chFl, this.ac.framesRecorded, rUUID, chFl);
                        as = netAb;
                        if (this.uploadSet) {
                            //let rp=new ReadyProvider();
                            //netAb.readyProvider=rp;
                            this.uploadSet.onDone = (uploadSet) => {
                                console.debug("upload set on done: Call ready provider.ready");
                                //rp.ready();
                                netAb.ready();
                            };
                        }
                    }
                }
            }
            else if (AudioStorageType.MEM_ENTIRE_AUTO_NET_CHUNKED === this.ac.audioStorageType || AudioStorageType.MEM_CHUNKED_AUTO_NET_CHUNKED === this.ac.audioStorageType) {
                if (AudioStorageType.MEM_ENTIRE_AUTO_NET_CHUNKED === this.ac.audioStorageType) {
                    const acAb = this.ac.audioBuffer();
                    if (acAb) {
                        as = new AudioBufferSource(acAb);
                    }
                }
                if (AudioStorageType.MEM_CHUNKED_AUTO_NET_CHUNKED === this.ac.audioStorageType) {
                    as = this.ac.audioBufferArray();
                }
                if (!as) {
                    this.playStartAction.disabled = true;
                    this.keepLiveLevel = true;
                    let burl = null;
                    if (this._session) {
                        if (this._displayRecFile) {
                            // TODO is this branch ever called ?
                            let rf = this._displayRecFile;
                            rf.frames = this.ac.framesRecorded;
                            //console.debug("stopped(): Set frames: "+rf.frames+" on rfId: "+this.displayRecFile?.recordingFileId);
                            burl = this.recFileService.sprAudioFileUrl(this._session?.project, rf);
                        }
                        else if (this.session?.project && this._recordingFile && this._recordingFile instanceof SprRecordingFile) {
                            burl = this.recFileService.sprAudioFileUrlByItemcode(this.session?.project, this.session?.sessionId, this._recordingFile.itemCode, this._recordingFile.version);
                        }
                        else {
                            console.error("Could not create net audio buffer.");
                        }
                        if (burl) {
                            const rUUID = this.ac.recUUID;
                            const sr = this.ac.currentSampleRate;
                            const chFl = sr * RecordingService.DEFAULT_CHUNKED_DOWNLOAD_SECONDS;
                            //console.debug("stopped(): rfID: "+this._recordingFile?.recordingFileId+", net ab url: " + burl+", frames: "+this.ac.framesRecorded+", sample rate: "+sr);
                            const netAb = new NetAudioBuffer(this.recFileService, burl, this.ac.channelCount, sr, chFl, this.ac.framesRecorded, rUUID, chFl);
                            as = netAb;
                            if (this.uploadSet) {
                                this.uploadSet.onDone = (uploadSet) => {
                                    console.debug("upload set on done: Call ready provider.ready");
                                    netAb.ready();
                                };
                            }
                        }
                    }
                }
            }
            else if (AudioStorageType.DB_CHUNKED === this.ac.audioStorageType) {
                as = this.ac.inddbAudioBufferArray();
            }
            else if (AudioStorageType.MEM_CHUNKED === this.ac.audioStorageType) {
                as = this.ac.audioBufferArray();
            }
            else {
                ab = this.ac.audioBuffer();
                if (ab) {
                    as = new AudioBufferSource(ab);
                }
            }
            if (as) {
                adh = new AudioDataHolder(as);
            }
        }
        // Use an own reference since the writing of the wave file is asynchronous and this._recordingFile might already contain the next recording
        let rf = this._recordingFile;
        if (rf && rf instanceof SprRecordingFile) {
            this.items?.setSprRecFileAudioData(rf, adh);
            if (this.enableUploadRecordings && this._uploadChunkSizeSeconds === null && AudioStorageType.MEM_ENTIRE === this._clientAudioStorageType) {
                // TODO use SpeechRecorderconfig resp. RecfileService
                // convert asynchronously to 16-bit integer PCM
                // TODO could we avoid conversion to save CPU resources and transfer float PCM directly?
                // TODO duplicate conversion for manual download
                //console.log("Build wav writer...");
                if (ab) {
                    this.processingRecording = true;
                    const ww = new WavWriter(this._clientMediaStorageFormat?.audioEncoding === AudioStorageFormatEncoding.PCM_FLOAT, this._clientMediaStorageFormat?.audioPCMsampleSizeInBits);
                    //new REST API URL
                    let apiEndPoint = '';
                    if (this.config && this.config.apiEndPoint) {
                        apiEndPoint = this.config.apiEndPoint;
                    }
                    if (apiEndPoint !== '') {
                        apiEndPoint = apiEndPoint + '/';
                    }
                    let sessionsUrl = apiEndPoint + SessionService.SESSION_API_CTX;
                    let recUrl = sessionsUrl + '/' + rf.session + '/' + RECFILE_API_CTX + '/' + rf.itemCode;
                    ww.writeAsync(ab, (wavFile) => {
                        this.postRecording(wavFile, recUrl, rf);
                        this.processingRecording = false;
                        this.updateWakeLock();
                    });
                }
            }
        }
        this.continueSession();
    }
    continueSession() {
        // check complete session
        let complete = true;
        if (this.items) {
            // search backwards, to gain faster detection of incomplete state
            for (let ri = this.items.length() - 1; ri >= 0; ri--) {
                let it = this.items.getItem(ri);
                if (it.recording && !it.training && !it.itemDone()) {
                    complete = false;
                    break;
                }
            }
        }
        let autoStart = (this.status === 7 /* Status.STOPPING_STOP */);
        this.status = 1 /* Status.IDLE */;
        let startNext = false;
        if (complete) {
            if (this._session != null) {
                if (!this._session.sealed && this._session.status !== "COMPLETED") {
                    let body = {};
                    this._session.status = "COMPLETED";
                    body.status = this._session.status;
                    if (!this._session.completedDate) {
                        this._session.completedDate = new Date();
                        body.completedDate = this._session.completedDate;
                    }
                    this.sessionService.patchSessionObserver(this._session, body).subscribe();
                }
            }
            this.statusMsg = 'Session complete!';
            this.updateWakeLock();
            if (this.showSessionCompleteMessage) {
                this.dialog.open(SessionFinishedDialog, {});
            }
            // enable navigation
            this.transportActions.fwdAction.disabled = false;
            this.transportActions.bwdAction.disabled = false;
        }
        else {
            if (this.section.mode === 'AUTOPROGRESS' || this.section.mode === 'AUTORECORDING') {
                this.nextItem();
            }
            if (this.section.mode === 'AUTORECORDING' && this.autorecording && autoStart) {
                startNext = true;
            }
            else {
                this.navigationDisabled = false;
                this.updateNavigationActions();
                this.updateWakeLock();
            }
        }
        // apply recorded item
        this.applyItem(startNext);
        if (startNext) {
            this.startItem();
        }
        this.changeDetectorRef.detectChanges();
    }
    error(msg = 'An unknown error occured during recording.', advice = 'Please retry.') {
        this.status = 10 /* Status.ERROR */;
        super.error(msg, advice);
        this.updateNavigationActions();
        this.updateStartActionDisableState();
    }
    postChunkAudioBuffer(audioBuffer, chunkIdx) {
        this.processingRecording = true;
        const ww = new WavWriter(this._clientMediaStorageFormat?.audioEncoding === AudioStorageFormatEncoding.PCM_FLOAT, this._clientMediaStorageFormat?.audioPCMsampleSizeInBits);
        let sessionsUrl = this.sessionsBaseUrl();
        let recUrl = sessionsUrl + '/' + this.session?.sessionId + '/' + RECFILE_API_CTX + '/' + this.promptItem.itemcode + '/' + this.rfUuid + '/' + chunkIdx;
        // The upload holder is required to add the upload now to the upload set. The real upload is created async in postrecording and the upload set is already complete at that time.
        let ulh = new UploadHolder();
        if (this.uploadSet) {
            this.uploadSet.add(ulh);
        }
        ww.writeAsync(audioBuffer, (wavFile) => {
            this.postRecording(wavFile, recUrl, null, ulh);
            this.processingRecording = false;
        });
    }
    // postRecording(wavFile: Uint8Array, recUrl: string,rf:RecordingFile|null) {
    //   let wavBlob = new Blob([wavFile], {type: 'audio/wav'});
    //   let ul = new Upload(wavBlob, recUrl,rf);
    //   this.uploader.queueUpload(ul);
    // }
    stop() {
        if (this.ac != null) {
            this.ac.close();
        }
    }
    updateControlPlaybackPosition() {
        if (this._controlAudioPlayer) {
            const ppFrames = this._controlAudioPlayer.playPositionFrames;
            if (ppFrames !== null) {
                if (this.prompting.audioDisplay) {
                    this.prompting.audioDisplay.playFramePosition = ppFrames;
                }
                this.liveLevelDisplay.playFramePosition = ppFrames;
            }
        }
    }
    audioPlayerUpdate(e) {
        if (EventType.READY === e.type) {
        }
        else if (EventType.STARTED === e.type) {
            //this.status = 'Playback...';
            this.updateTimerId = window.setInterval(() => this.updateControlPlaybackPosition(), 50);
        }
        else if (EventType.ENDED === e.type) {
            //.status='Ready.';
            window.clearInterval(this.updateTimerId);
        }
        if (!this.destroyed) {
            this.changeDetectorRef.detectChanges();
        }
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.12", ngImport: i0, type: SessionManager, deps: [{ token: i1$2.BreakpointObserver }, { token: i0.ChangeDetectorRef }, { token: i0.Renderer2 }, { token: i1$3.MatDialog }, { token: SessionService }, { token: RecordingService }, { token: SpeechRecorderUploader }, { token: SPEECHRECORDER_CONFIG }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "18.2.12", type: SessionManager, selector: "app-sprrecordingsession", inputs: { projectName: "projectName", dataSaved: "dataSaved" }, host: { listeners: { "window:keypress": "onKeyPress($event)", "window:keydown": "onKeyDown($event)" } }, providers: [SessionService], viewQueries: [{ propertyName: "prompting", first: true, predicate: Prompting, descendants: true, static: true }, { propertyName: "liveLevelDisplay", first: true, predicate: LevelBar, descendants: true, static: true }], usesInheritance: true, ngImport: i0, template: `
    <app-warningbar [show]="isTestSession()" warningText="Test recording only!"></app-warningbar>
    <app-warningbar [show]="isDefaultAudioTestSession()" warningText="This test uses default audio device! Regular sessions may require a particular audio device (microphone)!"></app-warningbar>
      <app-sprprompting [projectName]="projectName"
                        [startStopSignalState]="startStopSignalState" [promptItem]="promptItem" [showPrompt]="showPrompt"
                        [items]="items?.items"
                        [transportActions]="transportActions"
                        [selectedItemIdx]="promptIndex" (onItemSelect)="itemSelect($event)" (onNextItem)="nextItem()" (onPrevItem)="prevItem()"
                        [audioSignalCollapsed]="audioSignalCollapsed" [displayAudioClip]="displayAudioClip"
                        [playStartAction]="controlAudioPlayer?.startAction"
                        [playSelectionAction]="controlAudioPlayer?.startSelectionAction"
                        [autoPlayOnSelectToggleAction]="controlAudioPlayer?.autoPlayOnSelectToggleAction"
                        [playStopAction]="controlAudioPlayer?.stopAction">

    </app-sprprompting>
    <mat-progress-bar [value]="progressPercentValue()" *ngIf="screenXs" ></mat-progress-bar>


    <div [class]="{audioStatusDisplay:!screenXs,audioStatusDisplayXs:screenXs}">
      <audio-levelbar style="flex:1 0 1%" [streamingMode]="isRecording() || keepLiveLevel" [displayLevelInfos]="displayAudioClip?.levelInfos"  [state]="liveLevelDisplayState"></audio-levelbar>
      <div style="display:flex;flex-direction: row">
        <spr-recordingitemcontrols style="display:flex;flex:10 0 1px"
                                   [audioLoaded]="audioLoaded"
                                   [disableAudioDetails]="disableAudioDetails"
                                   [playStartAction]="controlAudioPlayer?.startAction"
                                   [playStopAction]="controlAudioPlayer?.stopAction"
                                   [peakDbLvl]="peakLevelInDb"
                                   [agc]="this.ac?.agcStatus"
                                   (onShowRecordingDetails)="audioSignalCollapsed=!audioSignalCollapsed">
        </spr-recordingitemcontrols>

        <app-uploadstatus *ngIf="screenXs && enableUploadRecordings" class="ricontrols dark"  style="flex:0 0 0" [value]="uploadProgress"
                          [status]="uploadStatus" [awaitNewUpload]="processingRecording"></app-uploadstatus>
        <app-wakelockindicator *ngIf="screenXs" class="ricontrols dark" style="flex:0 0 0" [screenLocked]="screenLocked"></app-wakelockindicator>
        <app-readystateindicator *ngIf="screenXs" class="ricontrols dark" style="flex:0 0 0" [ready]="dataSaved && !isActive()"></app-readystateindicator>
      </div>
    </div>
    <div #controlpanel class="controlpanel">
      <div style="flex:1 1 30%;justify-content: flex-start;align-items: center; align-content: center">
        <app-sprstatusdisplay *ngIf="!screenXs" [statusMsg]="statusMsg" [statusAlertType]="statusAlertType" [statusWaiting]="statusWaiting"></app-sprstatusdisplay>
      </div>
      <app-sprtransport style="display:flex;flex:10 0 30%;justify-content: center;align-items: center; align-content: center" [readonly]="readonly" [actions]="transportActions" [navigationEnabled]="!items || items.length()>1"></app-sprtransport>
      <div style="display:flex;flex:1 1 30%;flex-direction:row;justify-content: flex-end;align-items: center; align-content: center">
        <app-uploadstatus *ngIf="!screenXs && enableUploadRecordings"  class="ricontrols"  [value]="uploadProgress"
                          [status]="uploadStatus" [awaitNewUpload]="processingRecording"></app-uploadstatus>
        <app-wakelockindicator *ngIf="!screenXs" class="ricontrols" [screenLocked]="screenLocked"></app-wakelockindicator>
        <app-readystateindicator *ngIf="!screenXs" class="ricontrols" [ready]="dataSaved && !isActive()"></app-readystateindicator>
      </div>
    </div>
  `, isInline: true, styles: [":host{flex:2;background:#d3d3d3;display:flex;flex-direction:column;margin:0;padding:0;min-height:0px;overflow:hidden}\n", ".ricontrols{display:flex;padding:4px;box-sizing:border-box;height:100%;flex-direction:row;justify-content:flex-end;align-items:center;align-content:center}\n", ".dark{background:#a9a9a9}\n", ".controlpanel{display:flex;flex-direction:row;align-content:center;align-items:center;margin:0;padding:20px;min-height:min-content}\n", ".audioStatusDisplay{display:flex;flex-direction:row;height:100px;min-height:100px}\n", ".audioStatusDisplayXs{display:flex;flex-direction:column;height:125px;min-height:125px}\n"], dependencies: [{ kind: "directive", type: i1$1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "component", type: i7.MatProgressBar, selector: "mat-progress-bar", inputs: ["color", "value", "bufferValue", "mode"], outputs: ["animationEnd"], exportAs: ["matProgressBar"] }, { kind: "component", type: LevelBar, selector: "audio-levelbar", inputs: ["streamingMode", "displayLevelInfos", "state"] }, { kind: "component", type: Prompting, selector: "app-sprprompting", inputs: ["projectName", "startStopSignalState", "promptItem", "showPrompt", "items", "selectedItemIdx", "transportActions", "enableDownload", "audioSignalCollapsed", "displayAudioClip", "playStartAction", "playSelectionAction", "autoPlayOnSelectToggleAction", "playStopAction"], outputs: ["onItemSelect", "onNextItem", "onPrevItem"] }, { kind: "component", type: StatusDisplay, selector: "app-sprstatusdisplay", inputs: ["statusAlertType", "statusMsg", "statusWaiting"] }, { kind: "component", type: RecordingItemControls, selector: "spr-recordingitemcontrols", inputs: ["audioSignalCollapsed", "enableDownload", "peakDbLvl", "agc", "disableAudioDetails", "audioLoaded", "playStartAction", "playStopAction", "displayLevelInfos"], outputs: ["onShowRecordingDetails", "onDownloadRecording"] }, { kind: "component", type: UploadStatus, selector: "app-uploadstatus", inputs: ["value", "awaitNewUpload", "status"] }, { kind: "component", type: TransportPanel, selector: "app-sprtransport", inputs: ["readonly", "actions", "navigationEnabled", "pausingEnabled"] }, { kind: "component", type: WakeLockIndicator, selector: "app-wakelockindicator", inputs: ["screenLocked"] }, { kind: "component", type: ReadyStateIndicator, selector: "app-readystateindicator", inputs: ["ready"] }, { kind: "component", type: WarningBar, selector: "app-warningbar", inputs: ["warningText", "show"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.12", ngImport: i0, type: SessionManager, decorators: [{
            type: Component,
            args: [{ selector: 'app-sprrecordingsession', providers: [SessionService], template: `
    <app-warningbar [show]="isTestSession()" warningText="Test recording only!"></app-warningbar>
    <app-warningbar [show]="isDefaultAudioTestSession()" warningText="This test uses default audio device! Regular sessions may require a particular audio device (microphone)!"></app-warningbar>
      <app-sprprompting [projectName]="projectName"
                        [startStopSignalState]="startStopSignalState" [promptItem]="promptItem" [showPrompt]="showPrompt"
                        [items]="items?.items"
                        [transportActions]="transportActions"
                        [selectedItemIdx]="promptIndex" (onItemSelect)="itemSelect($event)" (onNextItem)="nextItem()" (onPrevItem)="prevItem()"
                        [audioSignalCollapsed]="audioSignalCollapsed" [displayAudioClip]="displayAudioClip"
                        [playStartAction]="controlAudioPlayer?.startAction"
                        [playSelectionAction]="controlAudioPlayer?.startSelectionAction"
                        [autoPlayOnSelectToggleAction]="controlAudioPlayer?.autoPlayOnSelectToggleAction"
                        [playStopAction]="controlAudioPlayer?.stopAction">

    </app-sprprompting>
    <mat-progress-bar [value]="progressPercentValue()" *ngIf="screenXs" ></mat-progress-bar>


    <div [class]="{audioStatusDisplay:!screenXs,audioStatusDisplayXs:screenXs}">
      <audio-levelbar style="flex:1 0 1%" [streamingMode]="isRecording() || keepLiveLevel" [displayLevelInfos]="displayAudioClip?.levelInfos"  [state]="liveLevelDisplayState"></audio-levelbar>
      <div style="display:flex;flex-direction: row">
        <spr-recordingitemcontrols style="display:flex;flex:10 0 1px"
                                   [audioLoaded]="audioLoaded"
                                   [disableAudioDetails]="disableAudioDetails"
                                   [playStartAction]="controlAudioPlayer?.startAction"
                                   [playStopAction]="controlAudioPlayer?.stopAction"
                                   [peakDbLvl]="peakLevelInDb"
                                   [agc]="this.ac?.agcStatus"
                                   (onShowRecordingDetails)="audioSignalCollapsed=!audioSignalCollapsed">
        </spr-recordingitemcontrols>

        <app-uploadstatus *ngIf="screenXs && enableUploadRecordings" class="ricontrols dark"  style="flex:0 0 0" [value]="uploadProgress"
                          [status]="uploadStatus" [awaitNewUpload]="processingRecording"></app-uploadstatus>
        <app-wakelockindicator *ngIf="screenXs" class="ricontrols dark" style="flex:0 0 0" [screenLocked]="screenLocked"></app-wakelockindicator>
        <app-readystateindicator *ngIf="screenXs" class="ricontrols dark" style="flex:0 0 0" [ready]="dataSaved && !isActive()"></app-readystateindicator>
      </div>
    </div>
    <div #controlpanel class="controlpanel">
      <div style="flex:1 1 30%;justify-content: flex-start;align-items: center; align-content: center">
        <app-sprstatusdisplay *ngIf="!screenXs" [statusMsg]="statusMsg" [statusAlertType]="statusAlertType" [statusWaiting]="statusWaiting"></app-sprstatusdisplay>
      </div>
      <app-sprtransport style="display:flex;flex:10 0 30%;justify-content: center;align-items: center; align-content: center" [readonly]="readonly" [actions]="transportActions" [navigationEnabled]="!items || items.length()>1"></app-sprtransport>
      <div style="display:flex;flex:1 1 30%;flex-direction:row;justify-content: flex-end;align-items: center; align-content: center">
        <app-uploadstatus *ngIf="!screenXs && enableUploadRecordings"  class="ricontrols"  [value]="uploadProgress"
                          [status]="uploadStatus" [awaitNewUpload]="processingRecording"></app-uploadstatus>
        <app-wakelockindicator *ngIf="!screenXs" class="ricontrols" [screenLocked]="screenLocked"></app-wakelockindicator>
        <app-readystateindicator *ngIf="!screenXs" class="ricontrols" [ready]="dataSaved && !isActive()"></app-readystateindicator>
      </div>
    </div>
  `, styles: [":host{flex:2;background:#d3d3d3;display:flex;flex-direction:column;margin:0;padding:0;min-height:0px;overflow:hidden}\n", ".ricontrols{display:flex;padding:4px;box-sizing:border-box;height:100%;flex-direction:row;justify-content:flex-end;align-items:center;align-content:center}\n", ".dark{background:#a9a9a9}\n", ".controlpanel{display:flex;flex-direction:row;align-content:center;align-items:center;margin:0;padding:20px;min-height:min-content}\n", ".audioStatusDisplay{display:flex;flex-direction:row;height:100px;min-height:100px}\n", ".audioStatusDisplayXs{display:flex;flex-direction:column;height:125px;min-height:125px}\n"] }]
        }], ctorParameters: () => [{ type: i1$2.BreakpointObserver }, { type: i0.ChangeDetectorRef }, { type: i0.Renderer2 }, { type: i1$3.MatDialog }, { type: SessionService }, { type: RecordingService }, { type: SpeechRecorderUploader }, { type: SpeechRecorderConfig, decorators: [{
                    type: Inject,
                    args: [SPEECHRECORDER_CONFIG]
                }] }], propDecorators: { projectName: [{
                type: Input
            }], prompting: [{
                type: ViewChild,
                args: [Prompting, { static: true }]
            }], liveLevelDisplay: [{
                type: ViewChild,
                args: [LevelBar, { static: true }]
            }], dataSaved: [{
                type: Input
            }], onKeyPress: [{
                type: HostListener,
                args: ['window:keypress', ['$event']]
            }], onKeyDown: [{
                type: HostListener,
                args: ['window:keydown', ['$event']]
            }] } });

class Sync {
    constructor(objectStoreName, objectId) {
        this._objectStoreName = objectStoreName;
        this._objectId = objectId;
    }
    get objectStoreName() {
        return this._objectStoreName;
    }
    get objectId() {
        return this._objectId;
    }
}
class SprDb {
    static { this.dbName = 'speechrecorder'; }
    static { this.RECORDING_FILE_CACHE_OBJECT_STORE_NAME = '_recording_file_cache'; }
    //public static RECORDING_FILE_CHUNKS_OBJECT_STORE_NAME='rec_file_chunks';
    static { this.dbVersion = 1; }
    constructor() {
        this._store = null;
    }
    static sprDbFactory() {
        let sprDb = new SprDb();
        return sprDb;
    }
    static prepare() {
        let obs = new Observable((subscriber) => {
            console.info("Prepare indexed database...");
            if (indexedDB) {
                let or;
                or = indexedDB.open(SprDb.dbName, SprDb.dbVersion);
                or.onupgradeneeded = (ev) => {
                    let db = or.result;
                    let tr = or.transaction;
                    // if (!db.objectStoreNames.contains(SprDb.RECORDING_FILE_CACHE_OBJECT_STORE_NAME)) {
                    //    db.createObjectStore(SprDb.RECORDING_FILE_CACHE_OBJECT_STORE_NAME);
                    // }
                    // Future work towards a complete PWA which stores all clien data in indexed db and synchronizes to the server: See experimental Git branch "progressive_web_app"
                    // if (!db.objectStoreNames.contains('_sync')) {
                    //     db.createObjectStore('_sync', {keyPath: 'id', autoIncrement:true});
                    // }
                    // if (!db.objectStoreNames.contains('project')) {
                    //     db.createObjectStore('project', {keyPath: 'name'});
                    // }
                    // if (!db.objectStoreNames.contains('session')) {
                    //     let sessStore=db.createObjectStore('session', {keyPath: 'sessionId'});
                    //     sessStore.createIndex('projectIdx', ['project'], {unique:false});
                    // }else if(ev.oldVersion<5){
                    //
                    //     let sessStore=tr.objectStore('session')
                    //    sessStore.createIndex('projectIdx', ['project'], {unique:false});
                    // }
                    //
                    // if (!db.objectStoreNames.contains('script')) {
                    //     let scrStore=db.createObjectStore('script', {keyPath: 'scriptId'});
                    //     scrStore.createIndex('projectIdx', ['project'], {unique:false});
                    // }
                    //
                    // if (!db.objectStoreNames.contains('recfile')) {
                    //     let rfStore=db.createObjectStore('recfile', {keyPath: 'uuid'});
                    //     rfStore.createIndex('sessIdIdx', ['sessionId'], {unique:false});
                    //     rfStore.createIndex('sessIdItemcodeIdx', ['sessionId','itemCode'], {unique:false});
                    // }
                    if (!db.objectStoreNames.contains(SprDb.RECORDING_FILE_CACHE_OBJECT_STORE_NAME)) {
                        let rfStore = db.createObjectStore(SprDb.RECORDING_FILE_CACHE_OBJECT_STORE_NAME);
                    }
                    if (ev.oldVersion) {
                        console.info("Upgraded indexed database " + SprDb.dbName + " schema from version " + ev.oldVersion + " to " + ev.newVersion);
                    }
                    else {
                        console.info("Created indexed database " + SprDb.dbName + " schema version " + ev.newVersion);
                    }
                };
                or.onsuccess = (ev) => {
                    console.info("Opened indexed database");
                    let db = or.result;
                    //   // iPad WEbKit workaround
                    // does not help!
                    //   db.onclose=(ev)=>{
                    //     console.debug("DB closed...");
                    //
                    //   }
                    // console.debug("Close db.");
                    //   db.close();
                    // let opaRq=indexedDB.open(SprDb.dbName, SprDb.dbVersion);
                    // opaRq.onupgradeneeded=(ev)=>{}
                    //
                    // opaRq.onsuccess=(ev)=>{
                    //   console.debug("and opened again");
                    //   subscriber.next(opaRq.result);
                    //   subscriber.complete();
                    // }
                    // opaRq.onerror = (err) => {
                    //   console.error("Could not open indexed database: " + SprDb.dbName + ": " + err)
                    //   subscriber.error(err)
                    // }
                    subscriber.next(db);
                    subscriber.complete();
                };
                or.onerror = (err) => {
                    console.error("Could not open indexed database: " + SprDb.dbName + ": " + err);
                    subscriber.error(err);
                };
            }
            else {
                console.info("Browser does not support indexed databases");
                subscriber.error();
            }
        });
        return obs;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.12", ngImport: i0, type: SprDb, deps: [], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "18.2.12", ngImport: i0, type: SprDb }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.12", ngImport: i0, type: SprDb, decorators: [{
            type: Injectable
        }], ctorParameters: () => [] });

class RecorderComponent {
    constructor(uploader) {
        this.uploader = uploader;
        this.dataSaved = true;
        this._persistentAudioStorageTarget = null;
    }
    printStorageInfos() {
        // Safari seems not to support the estimate function.
        if (navigator.storage && navigator.storage.estimate instanceof Function) {
            navigator.storage.estimate().then((se) => {
                console.info("Estimated storage usage: " + se.usage + ", quota: " + se.quota);
            }).catch((err) => "Could not get get storage infos: " + err.message);
        }
        else {
            console.info("User agent does not support storage manager estimate function.");
        }
    }
    prepare(persistentAudioStorage = false) {
        if (persistentAudioStorage) {
            this.printStorageInfos();
        }
        return new Observable(subscriber => {
            if (persistentAudioStorage) {
                SprDb.prepare().subscribe({
                    next: (db) => {
                        this._persistentAudioStorageTarget = new PersistentAudioStorageTarget(db, SprDb.RECORDING_FILE_CACHE_OBJECT_STORE_NAME);
                        //let delCnt=0;
                        this._persistentAudioStorageTarget.deleteAll().subscribe({
                            next: () => {
                                //delCnt++;
                                subscriber.next();
                            },
                            complete: () => {
                                //console.info('Storage info after deletion of all ('+delCnt+') entries:');
                                console.info('Persistent audio storage object store cleared.');
                                this.printStorageInfos();
                                subscriber.complete();
                            },
                            error: (err) => {
                                subscriber.error(err);
                            }
                        });
                        window.addEventListener('beforeunload', (e) => {
                            if (this._persistentAudioStorageTarget) {
                                // Delete on page leave. Di not register callbacks to prevent page leave blocking
                                this._persistentAudioStorageTarget.deleteAll().subscribe();
                            }
                        });
                    },
                    error: (err) => {
                        subscriber.error(err);
                    }
                });
            }
            else {
                subscriber.next();
                subscriber.complete();
            }
        });
    }
}

/**
 * Created by klausj on 17.06.2017.
 */
const SCRIPT_API_CTX = 'script';
class ScriptService {
    constructor(http, config) {
        this.http = http;
        this.config = config;
        this.withCredentials = false;
        let apiEndPoint = '';
        if (config && config.apiEndPoint) {
            apiEndPoint = config.apiEndPoint;
        }
        if (apiEndPoint !== '') {
            apiEndPoint = apiEndPoint + '/';
        }
        if (config != null && config.withCredentials != null) {
            this.withCredentials = config.withCredentials;
        }
        this.scriptCtxUrl = apiEndPoint + SCRIPT_API_CTX;
    }
    scriptObservable(id) {
        let encScriptId = encodeURIComponent(id);
        let scriptUrl = this.scriptCtxUrl + '/' + encScriptId;
        if (this.config && this.config.apiType === ApiType.FILES) {
            // for development and demo
            // append UUID to make request URL unique to avoid localhost server caching
            scriptUrl = scriptUrl + '.json?requestUUID=' + UUID.generate();
        }
        return this.http.get(scriptUrl, { withCredentials: this.withCredentials });
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.12", ngImport: i0, type: ScriptService, deps: [{ token: i1.HttpClient }, { token: SPEECHRECORDER_CONFIG }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "18.2.12", ngImport: i0, type: ScriptService }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.12", ngImport: i0, type: ScriptService, decorators: [{
            type: Injectable
        }], ctorParameters: () => [{ type: i1.HttpClient }, { type: SpeechRecorderConfig, decorators: [{
                    type: Inject,
                    args: [SPEECHRECORDER_CONFIG]
                }] }] });

var Mode;
(function (Mode) {
    Mode[Mode["SINGLE_SESSION"] = 0] = "SINGLE_SESSION";
    Mode[Mode["DEMO"] = 1] = "DEMO";
})(Mode || (Mode = {}));
class SpeechrecorderngComponent extends RecorderComponent {
    constructor(route, router, changeDetectorRef, sessionsService, projectService, scriptService, recFilesService, uploader) {
        super(uploader);
        this.route = route;
        this.router = router;
        this.changeDetectorRef = changeDetectorRef;
        this.sessionsService = sessionsService;
        this.projectService = projectService;
        this.scriptService = scriptService;
        this.recFilesService = recFilesService;
        this.uploader = uploader;
        this.controlAudioPlayer = null;
        this._project = null;
    }
    handleError(err) {
        let errMsg = 'Unknown error';
        if (err instanceof Error) {
            errMsg = err.message;
        }
        this.sm.statusMsg = errMsg;
        this.sm.statusAlertType = 'error';
        console.error(errMsg);
    }
    ngOnInit() {
        this.controlAudioPlayer = new AudioPlayer(this);
        this.sm.controlAudioPlayer = this.controlAudioPlayer;
        this.sm.statusAlertType = 'info';
        this.sm.statusMsg = 'Player initialized.';
    }
    ngAfterViewInit() {
        // let wakeLockSupp=('wakeLock' in navigator);
        // alert('Wake lock API supported: '+wakeLockSupp);
        if (this.sm.status !== 10 /* SessionManagerStatus.ERROR */) {
            let initSuccess = this.init();
            if (initSuccess) {
                this.route.queryParams.subscribe((params) => {
                    if (params['sessionId']) {
                        this.fetchSession(params['sessionId']);
                    }
                });
                this.route.params.subscribe((params) => {
                    let routeParamsId = params['id'];
                    if (routeParamsId) {
                        this.fetchSession(routeParamsId);
                    }
                });
            }
        }
    }
    fetchSession(sessionId) {
        let sessObs = this.sessionsService.sessionObserver(sessionId);
        if (sessObs) {
            sessObs.subscribe({
                next: sess => {
                    this.setSession(sess);
                    this.sm.statusAlertType = 'info';
                    this.sm.statusMsg = 'Received session info.';
                    this.sm.statusWaiting = false;
                    if (sess.project) {
                        //console.debug("Session associated project: "+sess.project)
                        this.projectService.projectObservable(sess.project).subscribe({
                            next: (project) => {
                                this.project = project;
                                let persistentAudiStorage = (AudioStorageType.DB_CHUNKED === project.clientAudioStorageType);
                                super.prepare(persistentAudiStorage).subscribe({
                                    complete: () => {
                                        this.sm.persistentAudioStorageTarget = this._persistentAudioStorageTarget;
                                        this.fetchScript(sess);
                                    },
                                    error: (err) => {
                                        this.handleError(err);
                                    }
                                });
                            }, error: (reason) => {
                                this.sm.statusMsg = reason;
                                this.sm.statusAlertType = 'error';
                                this.sm.statusWaiting = false;
                                console.error("Error fetching project config: " + reason);
                            }
                        });
                    }
                    else {
                        console.info("Session has no associated project. Using default configuration.");
                        this.fetchScript(sess);
                    }
                },
                error: (reason) => {
                    this.sm.statusMsg = reason;
                    this.sm.statusAlertType = 'error';
                    this.sm.statusWaiting = false;
                    console.error("Error fetching session " + reason);
                }
            });
        }
    }
    fetchScript(sess) {
        if (sess.script) {
            this.sm.statusAlertType = 'info';
            this.sm.statusMsg = 'Fetching recording script...';
            this.sm.statusWaiting = true;
            this.scriptService.scriptObservable(sess.script).subscribe({
                next: (script) => {
                    this.sm.statusAlertType = 'info';
                    this.sm.statusMsg = 'Received recording script.';
                    this.sm.statusWaiting = false;
                    this.setScript(script);
                    this.sm.session = sess;
                    this.fetchRecordings(sess, this.script);
                }, error: (reason) => {
                    let errMsg = "Error fetching recording script: " + reason;
                    console.error(errMsg);
                    this.sm.statusMsg = errMsg;
                    this.sm.statusAlertType = 'error';
                    this.sm.statusWaiting = false;
                }
            });
        }
        else {
            let errMsg = "No recording script is defined for this session with ID " + sess.sessionId;
            console.error(this.sm.statusMsg);
            this.sm.statusMsg = errMsg;
            this.sm.statusAlertType = 'error';
        }
    }
    fetchRecordings(sess, script) {
        this.sm.statusAlertType = 'info';
        this.sm.statusMsg = 'Fetching infos of recordings...';
        this.sm.statusWaiting = true;
        let prNm = null;
        if (this.project) {
            let rfsObs = this.recFilesService.recordingFileDescrList(this.project.name, sess.sessionId);
            rfsObs.subscribe({
                next: (rfs) => {
                    this.sm.statusAlertType = 'info';
                    this.sm.statusMsg = 'Received infos of recordings.';
                    this.sm.statusWaiting = false;
                    if (rfs) {
                        if (rfs instanceof Array) {
                            rfs.forEach((rf) => {
                                //console.debug("Already recorded: " + rf+ " "+rf.recording.itemcode);
                                this.sm.addRecordingFileByDescriptor(rf);
                            });
                        }
                        else {
                            console.error('Expected type array for list of already recorded files ');
                        }
                    }
                    else {
                        //console.debug("Recording file list: " + rfs);
                    }
                }, error: (err) => {
                    // we start the session anyway
                    this.startSession();
                }, complete: () => {
                    this.startSession();
                }
            });
        }
        else {
            // TODO
        }
    }
    get screenLocked() {
        return this.sm.screenLocked;
    }
    startSession() {
        this.sm.statusWaiting = false;
        this.sm.start();
    }
    setSession(session) {
        if (session) {
            // console.debug("Session ID: " + session.sessionId);
        }
        else {
            //console.debug("Session Undefined");
        }
    }
    ready() {
        return this.dataSaved && !this.sm.isActive();
    }
    init() {
        //TODO Duplicate code in AudioRecorderComponent
        this.uploader.listener = (ue) => {
            this.uploadUpdate(ue);
        };
        window.addEventListener('beforeunload', (e) => {
            //console.debug("Before page unload event");
            if (this.ready()) {
                return;
            }
            else {
                // all this attempts to customize the message do not work anymore (for security reasons)!!
                const message = "Please do not leave the page, until all recordings are uploaded!";
                alert(message);
                e = e || window.event;
                if (e) {
                    e.returnValue = message;
                    e.cancelBubble = true;
                    if (e.stopPropagation) {
                        e.stopPropagation();
                    }
                    if (e.preventDefault) {
                        e.preventDefault();
                    }
                }
                return message;
            }
        });
        return true;
    }
    uploadUpdate(ue) {
        let upStatus = ue.status;
        this.dataSaved = (UploaderStatus.DONE === upStatus);
        let percentUpl = ue.percentDone();
        let sizeInQueue = ue.sizeInQueue();
        //console.debug("Uploader: status: "+upStatus+", "+percentUpl+"%, Bytes in queue: "+sizeInQueue+' ('+DataSize.formatBytesToBinaryUnits(sizeInQueue)+')');
        if (UploaderStatus.ERR === upStatus) {
            this.sm.uploadStatus = 'warn';
        }
        else {
            if (percentUpl < 50) {
                this.sm.uploadStatus = 'accent';
            }
            else {
                this.sm.uploadStatus = 'success';
            }
            this.sm.uploadProgress = percentUpl;
        }
        //console.debug("Upload update, update wake lock.")
        this.sm.updateWakeLock(this.dataSaved);
        this.changeDetectorRef.detectChanges();
    }
    configure() {
        this.loadProjectCfg(() => {
            // display project name
            let prName = '[Unknown]';
            if (this.project && this.project.name) {
                prName = this.project.name;
            }
            //this.titleEl.innerText = prName;
        });
    }
    randomize(script) {
        script.sections.forEach((s) => {
            if ('RANDOM' === s.order) {
                s._shuffledGroups = Arrays.shuffleArray(s.groups);
            }
            else {
                s._shuffledGroups = s.groups;
            }
            s._shuffledGroups.forEach((g) => {
                if ('RANDOM' === g.order) {
                    g._shuffledPromptItems = Arrays.shuffleArray(g.promptItems);
                }
                else {
                    g._shuffledPromptItems = g.promptItems;
                }
            });
        });
    }
    setScript(script) {
        this.script = script;
        this.randomize(this.script);
        this.sm.script = this.script;
    }
    set project(project) {
        this._project = project;
        let chCnt = ProjectUtil.DEFAULT_AUDIO_CHANNEL_COUNT;
        if (project) {
            console.info("Project name: " + project.name);
            if (project.recordingDeviceWakeLock === true) {
                this.sm.wakeLock = true;
            }
            console.info("Audio storage type: " + project.clientAudioStorageType);
            if (AudioStorageType.DB_CHUNKED === project.clientAudioStorageType) {
                SprDb.prepare().subscribe();
            }
            if (project.clientAudioStorageType) {
                this.sm.clientAudioStorageType = project.clientAudioStorageType;
            }
            this.sm.clientMediaStorageFormat = project.mediaStorageFormat;
            this.sm.audioDevices = project.audioDevices;
            chCnt = ProjectUtil.audioChannelCount(project);
            console.info("Project requested recording channel count: " + chCnt);
            this.sm.autoGainControlConfigs = project.autoGainControlConfigs;
            if (project.allowEchoCancellation !== undefined) {
                this.sm.allowEchoCancellation = project.allowEchoCancellation;
            }
            if (project.chunkedRecording === true) {
                console.debug("Enable chunked upload: chunkSize: " + BasicRecorder.DEFAULT_CHUNK_SIZE_SECONDS);
                this.sm.uploadChunkSizeSeconds = BasicRecorder.DEFAULT_CHUNK_SIZE_SECONDS;
            }
            else {
                this.sm.uploadChunkSizeSeconds = null;
            }
            if (project.showSessionCompleteMessage != null) {
                this.sm.showSessionCompleteMessage = project.showSessionCompleteMessage;
            }
        }
        else {
            console.error("Empty project configuration!");
        }
        this.sm.channelCount = chCnt;
    }
    get project() {
        return this._project;
    }
    loadProjectCfg(callback) {
        let projUrl = null;
        if (this.sessionId === null) {
            if (window.location.hostname === 'localhost' || this.mode === Mode.DEMO) {
                // debug or demo mode
                projUrl = 'test/Demo1.json?' + new Date().getTime();
            }
        }
        else {
            // load RESTful by sessionId
            projUrl = window.location.protocol + '//' + window.location.hostname + ':' + window.location.port + '/wikispeech/rest/projects/?sessionId=' + this.sessionId;
        }
        if (projUrl) {
            const pLoader = new XMLHttpRequest();
            pLoader.open("GET", projUrl, true);
            pLoader.setRequestHeader('Accept', 'application/json');
            pLoader.responseType = "json";
            pLoader.onload = (e) => {
                this.project = pLoader.response.project;
                callback();
            };
            pLoader.onerror = (e) => {
                console.error("Error downloading project data ...");
            };
            pLoader.send();
        }
    }
    start() {
    }
    audioPlayerUpdate(e) {
        if (EventType.STARTED === e.type) {
            this.sm.statusAlertType = 'info';
            this.sm.statusMsg = 'Playback...';
        }
        else if (EventType.ENDED === e.type) {
            this.sm.statusAlertType = 'info';
            this.sm.statusMsg = 'Ready.';
        }
        else if (EventType.ERROR === e.type) {
            this.sm.statusAlertType = 'error';
            this.sm.statusMsg = 'Playback error.';
        }
    }
    error() {
        this.sm.statusAlertType = 'error';
        this.sm.statusMsg = 'ERROR: Recording.';
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.12", ngImport: i0, type: SpeechrecorderngComponent, deps: [{ token: i4$2.ActivatedRoute }, { token: i4$2.Router }, { token: i0.ChangeDetectorRef }, { token: SessionService }, { token: ProjectService }, { token: ScriptService }, { token: RecordingService }, { token: SpeechRecorderUploader }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "18.2.12", type: SpeechrecorderngComponent, selector: "app-speechrecorder", providers: [SessionService], viewQueries: [{ propertyName: "sm", first: true, predicate: SessionManager, descendants: true, static: true }], usesInheritance: true, ngImport: i0, template: `
    <app-sprrecordingsession [projectName]="project?.name" [dataSaved]="dataSaved"></app-sprrecordingsession>
  `, isInline: true, styles: [":host{flex:2;display:flex;flex-direction:column;min-height:0}\n"], dependencies: [{ kind: "component", type: SessionManager, selector: "app-sprrecordingsession", inputs: ["projectName", "dataSaved"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.12", ngImport: i0, type: SpeechrecorderngComponent, decorators: [{
            type: Component,
            args: [{ selector: 'app-speechrecorder', providers: [SessionService], template: `
    <app-sprrecordingsession [projectName]="project?.name" [dataSaved]="dataSaved"></app-sprrecordingsession>
  `, styles: [":host{flex:2;display:flex;flex-direction:column;min-height:0}\n"] }]
        }], ctorParameters: () => [{ type: i4$2.ActivatedRoute }, { type: i4$2.Router }, { type: i0.ChangeDetectorRef }, { type: SessionService }, { type: ProjectService }, { type: ScriptService }, { type: RecordingService }, { type: SpeechRecorderUploader }], propDecorators: { sm: [{
                type: ViewChild,
                args: [SessionManager, { static: true }]
            }] } });

class ScrollIntoViewDirective {
    constructor(elRef) {
        this.elRef = elRef;
    }
    set scrollIntoViewToBottom(siv) {
        if (siv) {
            this.elRef.nativeElement.scrollIntoView(false);
        }
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.12", ngImport: i0, type: ScrollIntoViewDirective, deps: [{ token: i0.ElementRef }], target: i0.ɵɵFactoryTarget.Directive }); }
    static { this.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "18.2.12", type: ScrollIntoViewDirective, selector: "[scrollIntoViewToBottom]", inputs: { scrollIntoViewToBottom: "scrollIntoViewToBottom" }, ngImport: i0 }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.12", ngImport: i0, type: ScrollIntoViewDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: "[scrollIntoViewToBottom]"
                }]
        }], ctorParameters: () => [{ type: i0.ElementRef }], propDecorators: { scrollIntoViewToBottom: [{
                type: Input
            }] } });

class ScrollPaneHorizontal {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.12", ngImport: i0, type: ScrollPaneHorizontal, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "18.2.12", type: ScrollPaneHorizontal, selector: "scroll-pane-horizontal", ngImport: i0, template: '', isInline: true, styles: [":host{width:100%;background:#a9a9a9;box-sizing:border-box;height:100%;position:relative;overflow-x:scroll;overflow-y:auto}\n"] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.12", ngImport: i0, type: ScrollPaneHorizontal, decorators: [{
            type: Component,
            args: [{ selector: 'scroll-pane-horizontal', template: '', styles: [":host{width:100%;background:#a9a9a9;box-sizing:border-box;height:100%;position:relative;overflow-x:scroll;overflow-y:auto}\n"] }]
        }] });

class AudioDisplayPlayer {
    constructor(route, ref, eRef) {
        this.route = route;
        this.ref = ref;
        this.eRef = eRef;
        this._audioUrl = null;
        this._audioClip = null;
        this.currentLoader = null;
        this.parentE = this.eRef.nativeElement;
        this.playStartAction = new Action("Start");
        this.playSelectionAction = new Action("Play selected");
        this.playStopAction = new Action("Stop");
        this.status = "Player created.";
    }
    ngOnInit() {
        this.zoomSelectedAction = this.audioDisplayScrollPane.zoomSelectedAction;
        this.zoomFitToPanelAction = this.audioDisplayScrollPane.zoomFitToPanelAction;
        this.zoomOutAction = this.audioDisplayScrollPane.zoomOutAction;
        this.zoomInAction = this.audioDisplayScrollPane.zoomInAction;
        this.ap = new AudioPlayer(this);
    }
    ngAfterViewInit() {
        if (this.ap) {
            this.playStartAction.onAction = () => {
                console.debug("Start action, player: " + this.ap);
                this.ap?.start();
            };
            this.playSelectionAction.onAction = () => this.ap?.startSelected();
            this.playStopAction.onAction = () => this.ap?.stop();
        }
        this.layout();
        let heightListener = new MutationObserver((mrs, mo) => {
            mrs.forEach((mr) => {
                if ('attributes' === mr.type && ('class' === mr.attributeName || 'style' === mr.attributeName)) {
                    this.layout();
                }
            });
        });
        heightListener.observe(this.parentE, { attributes: true, childList: true, characterData: true });
        this.route.queryParams.subscribe((params) => {
            if (params['url']) {
                this.audioUrl = params['url'];
            }
        });
    }
    layout() {
        this.audioDisplayScrollPane.layout();
    }
    get audioUrl() {
        return this._audioUrl;
    }
    set audioUrl(value) {
        if (this.ap) {
            this.ap.stop();
        }
        this._audioUrl = value;
        this.load();
    }
    started() {
        //console.debug("Play started");
        this.status = 'Playing...';
    }
    load() {
        if (this.currentLoader) {
            this.currentLoader.abort();
            this.currentLoader = null;
        }
        if (this._audioUrl) {
            //this.statusMsg.innerHTML = 'Connecting...';
            this.currentLoader = new XMLHttpRequest();
            this.currentLoader.open("GET", this._audioUrl, true);
            this.currentLoader.responseType = "arraybuffer";
            this.currentLoader.onload = (e) => {
                if (this.currentLoader) {
                    var data = this.currentLoader.response; // not responseText
                    //console.debug("Received data ", data.byteLength);
                    this.currentLoader = null;
                    this.loaded(data);
                }
            };
            this.currentLoader.onerror = (e) => {
                console.error("Error downloading ...");
                this.currentLoader = null;
            };
            this.currentLoader.send();
        }
    }
    loaded(data) {
        //console.debug("Loaded");
        this.status = 'Audio file loaded.';
        //console.debug("Received data ", data.byteLength);
        AudioContextProvider.decodeAudioData(data).then(audioBuffer => {
            //console.debug("Audio Buffer Samplerate: ", audioBuffer.sampleRate)
            let as = new AudioBufferSource(audioBuffer);
            let adh = new AudioDataHolder(as);
            this.audioClip = new AudioClip(adh);
        });
    }
    set audioData(audioData) {
        this.audioDisplayScrollPane.audioData = audioData;
        if (audioData) {
            let clip = new AudioClip(audioData);
            if (this.ap) {
                this.ap.audioClip = clip;
                this.playStartAction.disabled = false;
            }
        }
        else {
            this.playStartAction.disabled = true;
            if (this.ap) {
                this.ap.audioClip = null;
            }
        }
        this.playSelectionAction.disabled = true;
    }
    startSelectionDisabled() {
        return !(this._audioClip && this.ap != null && !this.playStartAction.disabled && this._audioClip.selection);
    }
    set audioClip(audioClip) {
        this._audioClip = audioClip;
        let audioData = null;
        if (audioClip) {
            audioData = audioClip.audioDataHolder;
            if (this._audioClip) {
                this._audioClip.addSelectionObserver((ac) => {
                    this.playSelectionAction.disabled = this.startSelectionDisabled();
                });
            }
        }
        if (audioData) {
            //console.debug("Play start action (by AudioDisplayPlayer::set audioClip) disabled: "+(!this.ap));
            this.playStartAction.disabled = (!this.ap);
            this.playSelectionAction.disabled = this.startSelectionDisabled();
        }
        else {
            this.playStartAction.disabled = true;
            this.playSelectionAction.disabled = true;
        }
        this.audioDisplayScrollPane.audioClip = audioClip;
        if (this.ap) {
            this.ap.audioClip = audioClip;
        }
    }
    get audioClip() {
        return this._audioClip;
    }
    updatePlayPosition() {
        if (this.ap && this.ap.playPositionFrames) {
            this.audioDisplayScrollPane.playFramePosition = this.ap.playPositionFrames;
        }
    }
    audioPlayerUpdate(e) {
        if (EventType.STARTED === e.type) {
            this.status = 'Playback...';
            this.updateTimerId = window.setInterval(() => this.updatePlayPosition(), 50);
            this.playStartAction.disabled = true;
            this.playSelectionAction.disabled = true;
            this.playStopAction.disabled = false;
        }
        else if (EventType.ENDED === e.type) {
            this.status = 'Ready.';
            window.clearInterval(this.updateTimerId);
            this.playStartAction.disabled = false;
            this.playSelectionAction.disabled = this.startSelectionDisabled();
            this.playStopAction.disabled = true;
        }
        else if (EventType.ERROR === e.type) {
            this.status = 'Error.';
            window.clearInterval(this.updateTimerId);
            this.playStartAction.disabled = false;
            this.playSelectionAction.disabled = this.startSelectionDisabled();
            this.playStopAction.disabled = true;
        }
        this.ref.detectChanges();
    }
    error() {
        this.status = 'ERROR';
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.12", ngImport: i0, type: AudioDisplayPlayer, deps: [{ token: i4$2.ActivatedRoute }, { token: i0.ChangeDetectorRef }, { token: i0.ElementRef }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "18.2.12", type: AudioDisplayPlayer, selector: "app-audiodisplayplayer", inputs: { playStartAction: "playStartAction", playStopAction: "playStopAction", playSelectionAction: "playSelectionAction", autoPlayOnSelectToggleAction: "autoPlayOnSelectToggleAction", audioData: "audioData", audioClip: "audioClip" }, viewQueries: [{ propertyName: "audioDisplayScrollPane", first: true, predicate: AudioDisplayScrollPane, descendants: true, static: true }], ngImport: i0, template: `

    <audio-display-scroll-pane #audioDisplayScrollPane></audio-display-scroll-pane>

    <audio-display-control [audioClip]="audioClip"
                             [playStartAction]="playStartAction"
                             [playSelectionAction]="playSelectionAction"
                             [playStopAction]="playStopAction"
                             [autoPlayOnSelectToggleAction]="ap?.autoPlayOnSelectToggleAction"
                             [zoomInAction]="zoomInAction"
                             [zoomOutAction]="zoomOutAction"
                             [zoomSelectedAction]="zoomSelectedAction"
                             [zoomFitToPanelAction]="zoomFitToPanelAction"></audio-display-control><p>{{status}}
  `, isInline: true, styles: [":host{display:flex;flex-direction:column;position:absolute;bottom:0;height:100%;width:100%;overflow:hidden;padding:20px;z-index:5;box-sizing:border-box;background-color:#000000bf}\n"], dependencies: [{ kind: "component", type: AudioDisplayScrollPane, selector: "audio-display-scroll-pane", inputs: ["audioClip"], outputs: ["zoomInAction", "zoomOutAction", "zoomSelectedAction", "zoomFitToPanelAction"] }, { kind: "component", type: AudioDisplayControl, selector: "audio-display-control", inputs: ["audioClip", "playStartAction", "playSelectionAction", "playStopAction", "zoomInAction", "zoomOutAction", "zoomFitToPanelAction", "zoomSelectedAction", "autoPlayOnSelectToggleAction"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.12", ngImport: i0, type: AudioDisplayPlayer, decorators: [{
            type: Component,
            args: [{ selector: 'app-audiodisplayplayer', template: `

    <audio-display-scroll-pane #audioDisplayScrollPane></audio-display-scroll-pane>

    <audio-display-control [audioClip]="audioClip"
                             [playStartAction]="playStartAction"
                             [playSelectionAction]="playSelectionAction"
                             [playStopAction]="playStopAction"
                             [autoPlayOnSelectToggleAction]="ap?.autoPlayOnSelectToggleAction"
                             [zoomInAction]="zoomInAction"
                             [zoomOutAction]="zoomOutAction"
                             [zoomSelectedAction]="zoomSelectedAction"
                             [zoomFitToPanelAction]="zoomFitToPanelAction"></audio-display-control><p>{{status}}
  `, styles: [":host{display:flex;flex-direction:column;position:absolute;bottom:0;height:100%;width:100%;overflow:hidden;padding:20px;z-index:5;box-sizing:border-box;background-color:#000000bf}\n"] }]
        }], ctorParameters: () => [{ type: i4$2.ActivatedRoute }, { type: i0.ChangeDetectorRef }, { type: i0.ElementRef }], propDecorators: { playStartAction: [{
                type: Input
            }], playStopAction: [{
                type: Input
            }], playSelectionAction: [{
                type: Input
            }], autoPlayOnSelectToggleAction: [{
                type: Input
            }], audioDisplayScrollPane: [{
                type: ViewChild,
                args: [AudioDisplayScrollPane, { static: true }]
            }], audioData: [{
                type: Input
            }], audioClip: [{
                type: Input
            }] } });

// export class RecordingFile {
//
//   get recordingFileId(): string | number {
//     return this._recordingFileId;
//   }
//
//   frames:number=null
//   editStartFrame:number=null
//   editEndFrame:number=null
//
//   recording:PromptItem;
//
//   session:number|string;
//
//   get audioBuffer(): AudioBuffer {
//     return this._audioBuffer;
//   }
//
//   set audioBuffer(value: AudioBuffer) {
//     this._audioBuffer = value;
//   }
//   private _recordingFileId:string | number;
//   private _audioBuffer:AudioBuffer;
//
//   constructor(recordingFileId: string| number, audioBuffer:AudioBuffer){
//     this._recordingFileId=recordingFileId;
//     this._audioBuffer=audioBuffer;
//   }
//
//
// }
class RecordingFileUtil {
    static recordingAsPlainText(recordingFile) {
        if (recordingFile) {
            let r = recordingFile.recording;
            if (r) {
                return PromptitemUtil.toPlainTextString(r);
            }
        }
        return "n/a";
    }
    static framePosForSampleRate(framePosSampleRate, framePos, sampleRate) {
        let fpFSr = null;
        // TODO transitional until editSampleRates are set in the database
        if (framePosSampleRate == null) {
            framePosSampleRate = sampleRate;
        }
        if (framePosSampleRate != null && framePos != null) {
            if (framePosSampleRate === sampleRate) {
                fpFSr = framePos;
            }
            else {
                fpFSr = Math.round((framePos * sampleRate) / framePosSampleRate);
            }
        }
        return fpFSr;
    }
    static editStartFrameForSampleRate(recordingFile, sampleRate) {
        let esffSr = RecordingFileUtil.framePosForSampleRate(recordingFile.editSampleRate, recordingFile.editStartFrame, sampleRate);
        return esffSr;
    }
    static editEndFrameForSampleRate(recordingFile, sampleRate) {
        let eeffSr = RecordingFileUtil.framePosForSampleRate(recordingFile.editSampleRate, recordingFile.editEndFrame, sampleRate);
        return eeffSr;
    }
}

class RecordingFileService extends BasicRecordingService {
    static { this.RECOFILE_API_CTX = 'recordingfile'; }
    constructor(http, config) {
        super(http, config);
        this.http = http;
        this.config = config;
        //private debugDelay:number=10000;
        this.debugDelay = 0;
    }
    recoFileUrl(recordingFileId) {
        let encRecfileId = encodeURIComponent(recordingFileId);
        let recUrl = this.apiEndPoint + RecordingFileService.RECOFILE_API_CTX + '/' + encRecfileId;
        return recUrl;
    }
    fetchAudiofile(recordingFileId) {
        let recUrl = this.recoFileUrl(recordingFileId);
        if (this.config && this.config.apiType === ApiType.FILES) {
            // for development and demo
            // append UUID to make request URL unique to avoid localhost server caching
            recUrl = recUrl + '.wav';
        }
        let headers = new HttpHeaders({
            'Accept': 'audio/wav'
        });
        return this.http.get(recUrl, {
            observe: 'response',
            headers: headers,
            responseType: 'arraybuffer',
            withCredentials: this.withCredentials
        });
    }
    recordingFileDescrObserver(recordingFileId) {
        let recUrl = this.recoFileUrl(recordingFileId);
        if (this.config && this.config.apiType === ApiType.FILES) {
            // for development and demo
            // append UUID to make request URL unique to avoid localhost server caching
            recUrl = recUrl + '.json?requestUUID=' + UUID.generate();
        }
        return this.http.get(recUrl, { withCredentials: this.withCredentials });
    }
    sprRecordingFileDescrObserver(recordingFileId) {
        let recUrl = this.recoFileUrl(recordingFileId);
        if (this.config && this.config.apiType === ApiType.FILES) {
            // for development and demo
            // append UUID to make request URL unique to avoid localhost server caching
            recUrl = recUrl + '.json?requestUUID=' + UUID.generate();
        }
        return this.http.get(recUrl, { withCredentials: this.withCredentials });
    }
    fetchSessionAudiofileById(projectName, sessId, recordingFileId) {
        let recUrl = this.recoFileUrl(recordingFileId);
        // if (this.config && this.config.apiType === ApiType.FILES) {
        //   // for development and demo
        //   // append UUID to make request URL unique to avoid localhost server caching
        //   recUrl = recUrl + '.wav?requestUUID=' + UUID.generate();
        // }
        return this.http.get(recUrl, {
            observe: 'response',
            responseType: 'arraybuffer',
            withCredentials: this.withCredentials
        });
    }
    // TODO test
    fetchAndApplyRecordingFile(recordingFile) {
        let wobs = new Observable(observer => {
            if (recordingFile.recordingFileId) {
                let obs = this.fetchAudiofile(recordingFile.recordingFileId);
                obs.subscribe({ next: resp => {
                        if (resp.body) {
                            AudioContextProvider.decodeAudioData(resp.body).then(ab => {
                                let as = new AudioBufferSource(ab);
                                RecordingFileUtils.setAudioData(recordingFile, new AudioDataHolder(as));
                                if (this.debugDelay > 0) {
                                    window.setTimeout(() => {
                                        observer.next(recordingFile);
                                        observer.complete();
                                    }, this.debugDelay);
                                }
                                else {
                                    observer.next(recordingFile);
                                    observer.complete();
                                }
                            }).catch(reason => { observer.error(reason); });
                        }
                        else {
                            observer.error('Received no audio data!');
                        }
                    },
                    error: (error) => {
                        if (error.status == 404) {
                            // Interpret not as an error, the file ist not recorded yet
                            observer.next(null);
                            observer.complete();
                        }
                        else {
                            // all other states are errors
                            observer.error(error);
                            observer.complete();
                        }
                    }
                });
            }
            else {
                observer.error();
            }
        });
        return wobs;
    }
    fetchRecordingFile(aCtx, recordingFileId) {
        let wobs = new Observable(observer => {
            let rf = null;
            let rfDescrObs = this.recordingFileDescrObserver(recordingFileId);
            rfDescrObs.subscribe({ next: value => {
                    rf = value;
                }, error: (error) => {
                    observer.error(error);
                }, complete: () => {
                    let rfAudioObs = this.fetchAudiofile(recordingFileId);
                    rfAudioObs.subscribe({
                        next: resp => {
                            // Do not use Promise version, which does not work with Safari 13
                            if (resp.body) {
                                AudioContextProvider.decodeAudioData(resp.body).then(ab => {
                                    if (rf) {
                                        let as = new AudioBufferSource(ab);
                                        RecordingFileUtils.setAudioData(rf, new AudioDataHolder(as));
                                    }
                                    else {
                                        observer.error('Recording file object null');
                                    }
                                    if (this.debugDelay > 0) {
                                        window.setTimeout(() => {
                                            observer.next(rf);
                                            observer.complete();
                                        }, this.debugDelay);
                                    }
                                    else {
                                        observer.next(rf);
                                        observer.complete();
                                    }
                                }).catch(reason => { observer.error(reason); });
                            }
                            else {
                                observer.error('Received no audio data');
                            }
                        },
                        error: (error) => {
                            if (error.status == 404) {
                                // Interpret not as an error, the file ist not recorded yet
                                observer.next(null);
                                observer.complete();
                            }
                            else {
                                // all other states are errors
                                observer.error(error);
                                observer.complete();
                            }
                        }
                    });
                }
            });
        });
        return wobs;
    }
    fetchSprRecordingFile(recordingFileId) {
        let wobs = new Observable(observer => {
            let rf = null;
            let rfDescrObs = this.sprRecordingFileDescrObserver(recordingFileId);
            rfDescrObs.subscribe({ next: value => {
                    rf = value;
                },
                error: (error) => {
                    observer.error(error);
                }, complete: () => {
                    let sampleCnt = null;
                    if (rf && rf.channels && rf.frames) {
                        sampleCnt = rf.channels * rf.frames;
                    }
                    // TODO use download storage type depending on sample count of file
                    if (rf && rf.samplerate && sampleCnt != null && sampleCnt > this._maxAutoNetMemStoreSamples) {
                        const baseUrl = this.recoFileUrl(recordingFileId);
                        const obNetAb = this.chunkAudioRequestToNetAudioBuffer(baseUrl, 0, rf?.samplerate, BasicRecordingService.DEFAULT_CHUNKED_DOWNLOAD_SECONDS, rf.frames);
                        obNetAb.subscribe({
                            next: (nab) => {
                                let adh = new AudioDataHolder(nab);
                                if (rf) {
                                    RecordingFileUtils.setAudioData(rf, adh);
                                    observer.next(rf);
                                }
                            },
                            complete: () => {
                                observer.complete();
                            },
                            error: (error) => {
                                if (error.status == 404) {
                                    // Interpret not as an error, the file ist not recorded yet
                                    observer.next(null);
                                    observer.complete();
                                }
                                else {
                                    // all other states are errors
                                    observer.error(error);
                                    observer.complete();
                                }
                            }
                        });
                    }
                    else {
                        let rfAudioObs = this.fetchAudiofile(recordingFileId);
                        rfAudioObs.subscribe({ next: resp => {
                                // Do not use Promise version, which does not work with Safari 13
                                if (resp.body) {
                                    AudioContextProvider.decodeAudioData(resp.body).then(ab => {
                                        if (rf) {
                                            let as = new AudioBufferSource(ab);
                                            let adh = new AudioDataHolder(as);
                                            RecordingFileUtils.setAudioData(rf, adh);
                                        }
                                        else {
                                            observer.error('Recording file object null');
                                        }
                                        if (this.debugDelay > 0) {
                                            window.setTimeout(() => {
                                                observer.next(rf);
                                                observer.complete();
                                            }, this.debugDelay);
                                        }
                                        else {
                                            observer.next(rf);
                                            observer.complete();
                                        }
                                    }).catch(reason => { observer.error(reason); });
                                }
                                else {
                                    observer.error('Received no audio data');
                                }
                            },
                            error: (error) => {
                                if (error.status == 404) {
                                    // Interpret not as an error, the file ist not recorded yet
                                    observer.next(null);
                                    observer.complete();
                                }
                                else {
                                    // all other states are errors
                                    observer.error(error);
                                    observer.complete();
                                }
                            }
                        });
                    }
                }
            });
        });
        return wobs;
    }
    saveEditSelection(recordingFileId, editSampleRate, editStartFrame, editEndFrame) {
        let recUrl = this.apiEndPoint + RecordingFileService.RECOFILE_API_CTX + '/' + recordingFileId;
        if (this.config && this.config.apiType === ApiType.FILES) {
            // for development and demo
            // append UUID to make request URL unique to avoid localhost server caching
            recUrl = recUrl + '.json?requestUUID=' + UUID.generate();
        }
        //console.log("Path request URL: "+recUrl)
        return this.http.patch(recUrl, { editSampleRate: editSampleRate, editStartFrame: editStartFrame, editEndFrame: editEndFrame }, { withCredentials: this.withCredentials });
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.12", ngImport: i0, type: RecordingFileService, deps: [{ token: i1.HttpClient }, { token: SPEECHRECORDER_CONFIG }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "18.2.12", ngImport: i0, type: RecordingFileService }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.12", ngImport: i0, type: RecordingFileService, decorators: [{
            type: Injectable
        }], ctorParameters: () => [{ type: i1.HttpClient }, { type: SpeechRecorderConfig, decorators: [{
                    type: Inject,
                    args: [SPEECHRECORDER_CONFIG]
                }] }] });

class RecordingFileNaviComponent {
    constructor() {
        this.versions = null;
        this.version = null;
        this.naviInfoLoading = false;
    }
    ngOnInit() {
    }
    selectVersionChange(ev) {
        //console.debug("Change event: "+ev.target.value+ ", as Nr: "+versionNr);
        const selEl = ev.target;
        let versionNr = parseInt(selEl.value);
        if (this.selectVersion) {
            this.selectVersion.perform(versionNr);
        }
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.12", ngImport: i0, type: RecordingFileNaviComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "18.2.12", type: RecordingFileNaviComponent, selector: "app-recording-file-navi", inputs: { firstAction: "firstAction", prevAction: "prevAction", nextAction: "nextAction", lastAction: "lastAction", items: "items", itemPos: "itemPos", selectVersion: "selectVersion", versions: "versions", version: "version", naviInfoLoading: "naviInfoLoading" }, ngImport: i0, template: `
        <div #controlPanel style="display:flex;flex-direction: row;">
          <div #navi style="flex: 0;display:flex;flex-direction: row;flex-wrap: nowrap">
            <fieldset>
              <legend>Versions</legend>
              <mat-progress-spinner *ngIf="naviInfoLoading" mode="indeterminate" [diameter]="15"></mat-progress-spinner>
                <select *ngIf="!naviInfoLoading" [disabled]="versions==null || versions.length==1" (change)="selectVersionChange($event)">
                  <option *ngFor="let v of versions; let i = index" [selected]="v===version" value="{{v}}">{{v}}<ng-container *ngIf="i==0"> (latest)</ng-container></option>
                </select>
            </fieldset>
            <fieldset>
              <legend>Navigate</legend>
              <mat-progress-spinner *ngIf="naviInfoLoading" mode="indeterminate" [diameter]="15"></mat-progress-spinner>
              <div *ngIf="!naviInfoLoading"  style="flex: 0;display:flex;flex-direction: row;flex-wrap: nowrap">
                <button (click)="firstAction?.perform()" [disabled]="!firstAction || firstAction.disabled" matTooltip="First recording file">
                  <mat-icon>first_page</mat-icon>
                </button>
                <button (click)="prevAction?.perform()" [disabled]="!prevAction || prevAction.disabled" matTooltip="Previous recording file">
                  <mat-icon>chevron_left</mat-icon>
                </button>
                <button (click)="nextAction?.perform()" [disabled]="!nextAction || nextAction.disabled" matTooltip="Next recording file">
                  <mat-icon>chevron_right</mat-icon>
                </button>
                <button (click)="lastAction?.perform()" [disabled]="!lastAction || lastAction.disabled" matTooltip="Last recording file">
                  <mat-icon>last_page</mat-icon>
                </button>
              </div>
              <p *ngIf="items && itemPos!==null && itemPos!==undefined">Item {{itemPos+1}} of {{items}}</p>
              <p>(List ordered by date)</p>
            </fieldset>
          </div>
        </div>
          `, isInline: true, styles: [":host{flex:0}\n"], dependencies: [{ kind: "directive", type: i1$1.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i1$1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "component", type: i2.MatIcon, selector: "mat-icon", inputs: ["color", "inline", "svgIcon", "fontSet", "fontIcon"], exportAs: ["matIcon"] }, { kind: "component", type: i3$1.MatProgressSpinner, selector: "mat-progress-spinner, mat-spinner", inputs: ["color", "mode", "value", "diameter", "strokeWidth"], exportAs: ["matProgressSpinner"] }, { kind: "directive", type: i4.MatTooltip, selector: "[matTooltip]", inputs: ["matTooltipPosition", "matTooltipPositionAtOrigin", "matTooltipDisabled", "matTooltipShowDelay", "matTooltipHideDelay", "matTooltipTouchGestures", "matTooltip", "matTooltipClass"], exportAs: ["matTooltip"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.12", ngImport: i0, type: RecordingFileNaviComponent, decorators: [{
            type: Component,
            args: [{ selector: 'app-recording-file-navi', template: `
        <div #controlPanel style="display:flex;flex-direction: row;">
          <div #navi style="flex: 0;display:flex;flex-direction: row;flex-wrap: nowrap">
            <fieldset>
              <legend>Versions</legend>
              <mat-progress-spinner *ngIf="naviInfoLoading" mode="indeterminate" [diameter]="15"></mat-progress-spinner>
                <select *ngIf="!naviInfoLoading" [disabled]="versions==null || versions.length==1" (change)="selectVersionChange($event)">
                  <option *ngFor="let v of versions; let i = index" [selected]="v===version" value="{{v}}">{{v}}<ng-container *ngIf="i==0"> (latest)</ng-container></option>
                </select>
            </fieldset>
            <fieldset>
              <legend>Navigate</legend>
              <mat-progress-spinner *ngIf="naviInfoLoading" mode="indeterminate" [diameter]="15"></mat-progress-spinner>
              <div *ngIf="!naviInfoLoading"  style="flex: 0;display:flex;flex-direction: row;flex-wrap: nowrap">
                <button (click)="firstAction?.perform()" [disabled]="!firstAction || firstAction.disabled" matTooltip="First recording file">
                  <mat-icon>first_page</mat-icon>
                </button>
                <button (click)="prevAction?.perform()" [disabled]="!prevAction || prevAction.disabled" matTooltip="Previous recording file">
                  <mat-icon>chevron_left</mat-icon>
                </button>
                <button (click)="nextAction?.perform()" [disabled]="!nextAction || nextAction.disabled" matTooltip="Next recording file">
                  <mat-icon>chevron_right</mat-icon>
                </button>
                <button (click)="lastAction?.perform()" [disabled]="!lastAction || lastAction.disabled" matTooltip="Last recording file">
                  <mat-icon>last_page</mat-icon>
                </button>
              </div>
              <p *ngIf="items && itemPos!==null && itemPos!==undefined">Item {{itemPos+1}} of {{items}}</p>
              <p>(List ordered by date)</p>
            </fieldset>
          </div>
        </div>
          `, styles: [":host{flex:0}\n"] }]
        }], ctorParameters: () => [], propDecorators: { firstAction: [{
                type: Input
            }], prevAction: [{
                type: Input
            }], nextAction: [{
                type: Input
            }], lastAction: [{
                type: Input
            }], items: [{
                type: Input
            }], itemPos: [{
                type: Input
            }], selectVersion: [{
                type: Input
            }], versions: [{
                type: Input
            }], version: [{
                type: Input
            }], naviInfoLoading: [{
                type: Input
            }] } });

class RecordingFileMetaComponent {
    constructor() {
        this.sessionId = null;
        this._recordingFile = null;
        this.itemCode = null;
        this.uuid = null;
        this.stateLoading = false;
    }
    get recordingFile() {
        return this._recordingFile;
    }
    set recordingFile(recordingFile) {
        this._recordingFile = recordingFile;
        if (this._recordingFile) {
            this.itemCode = this._recordingFile.itemCode;
            if (!this.itemCode && this._recordingFile.recording?.itemcode) {
                this.itemCode = this._recordingFile.recording.itemcode;
            }
            if (this.itemCode) {
                this.uuid = null;
                //console.debug("SprRecordingFile: "+this.itemCode+ " UUID: "+this.uuid)
            }
            else {
                this.itemCode = null;
                this.uuid = this._recordingFile?.uuid;
                //console.debug("RecordingFile: "+this.itemCode+ " UUID: "+this.uuid)
            }
        }
        else {
            this.itemCode = null;
            this.uuid = null;
        }
    }
    recordingAsPlainText() {
        let t = null;
        if (this._recordingFile) {
            t = RecordingFileUtil.recordingAsPlainText(this._recordingFile);
        }
        return t;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.12", ngImport: i0, type: RecordingFileMetaComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "18.2.12", type: RecordingFileMetaComponent, selector: "app-recording-file-meta", inputs: { sessionId: "sessionId", stateLoading: "stateLoading", recordingFile: "recordingFile" }, ngImport: i0, template: `
    <mat-card appearance="outlined">
      <mat-card-title>Recording file ID: {{recordingFile?.recordingFileId}}</mat-card-title>
      <mat-card-content>
        <mat-progress-spinner *ngIf="stateLoading" mode="indeterminate" [diameter]="20"></mat-progress-spinner>
        <table>
          <tr *ngIf="itemCode">
            <td>Itemcode:</td>
            <td>{{itemCode}}</td>
          </tr>
          <tr *ngIf="uuid && !itemCode">
            <td>UUID:</td>
            <td>{{uuid}}</td>
          </tr>
          <tr *ngIf="recordingFile?.startedDate">
            <td>Started:</td>
            <td>{{recordingFile?.startedDate}}</td>
          </tr>
          <tr *ngIf="!recordingFile?.startedDate && recordingFile?.date">
            <td>Date:</td>
            <td>{{recordingFile?.date}}</td>
          </tr>
          <tr *ngIf="itemCode">
            <td>Prompt:</td>
            <td>{{recordingAsPlainText()}}</td>
          </tr>

          <tr *ngIf="sessionId">
            <td>Session:</td>
            <td>{{sessionId}}</td>
          </tr>
        </table>
      </mat-card-content>
    </mat-card>
  `, isInline: true, dependencies: [{ kind: "directive", type: i1$1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "component", type: i3$1.MatProgressSpinner, selector: "mat-progress-spinner, mat-spinner", inputs: ["color", "mode", "value", "diameter", "strokeWidth"], exportAs: ["matProgressSpinner"] }, { kind: "component", type: i3$2.MatCard, selector: "mat-card", inputs: ["appearance"], exportAs: ["matCard"] }, { kind: "directive", type: i3$2.MatCardContent, selector: "mat-card-content" }, { kind: "directive", type: i3$2.MatCardTitle, selector: "mat-card-title, [mat-card-title], [matCardTitle]" }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.12", ngImport: i0, type: RecordingFileMetaComponent, decorators: [{
            type: Component,
            args: [{ selector: 'app-recording-file-meta', template: `
    <mat-card appearance="outlined">
      <mat-card-title>Recording file ID: {{recordingFile?.recordingFileId}}</mat-card-title>
      <mat-card-content>
        <mat-progress-spinner *ngIf="stateLoading" mode="indeterminate" [diameter]="20"></mat-progress-spinner>
        <table>
          <tr *ngIf="itemCode">
            <td>Itemcode:</td>
            <td>{{itemCode}}</td>
          </tr>
          <tr *ngIf="uuid && !itemCode">
            <td>UUID:</td>
            <td>{{uuid}}</td>
          </tr>
          <tr *ngIf="recordingFile?.startedDate">
            <td>Started:</td>
            <td>{{recordingFile?.startedDate}}</td>
          </tr>
          <tr *ngIf="!recordingFile?.startedDate && recordingFile?.date">
            <td>Date:</td>
            <td>{{recordingFile?.date}}</td>
          </tr>
          <tr *ngIf="itemCode">
            <td>Prompt:</td>
            <td>{{recordingAsPlainText()}}</td>
          </tr>

          <tr *ngIf="sessionId">
            <td>Session:</td>
            <td>{{sessionId}}</td>
          </tr>
        </table>
      </mat-card-content>
    </mat-card>
  ` }]
        }], ctorParameters: () => [], propDecorators: { sessionId: [{
                type: Input
            }], stateLoading: [{
                type: Input
            }], recordingFile: [{
                type: Input
            }] } });

class ItemcodeIndex {
}
class RecordingFileViewComponent extends AudioDisplayPlayer {
    constructor(recordingFileService, recordingService, sessionService, router, route, ref, eRef, dialog) {
        super(route, ref, eRef);
        this.recordingFileService = recordingFileService;
        this.recordingService = recordingService;
        this.sessionService = sessionService;
        this.router = router;
        this.route = route;
        this.ref = ref;
        this.eRef = eRef;
        this.dialog = dialog;
        this.sessionId = null;
        this.sessionIdFromRoute = null;
        this.availRecFiles = null;
        this.versions = null;
        this.recordingFile = null;
        this.recordingFileVersion = null;
        this.routedByQueryParam = false;
        this.posInList = null;
        this.parentE = this.eRef.nativeElement;
        // TODO Should be initialized with false, but this causes in debug mode:
        // ERROR Error: NG0100: ExpressionChangedAfterItHasBeenCheckedError: Expression has changed after it was checked. Previous value: 'false'. Current value: 'true'. Find more at https://angular.io/errors/NG0100
        this.audioFetching = true;
        this.naviInfoLoading = false;
        this.firstAction = new Action('First');
        this.firstAction.onAction = () => {
            this.posInList = 0;
            this.navigateToRecordingFile();
        };
        this.prevAction = new Action('Previous');
        this.prevAction.onAction = () => this.prevFile();
        this.nextAction = new Action('Next');
        this.nextAction.onAction = () => this.nextFile();
        this.lastAction = new Action('Last');
        this.lastAction.onAction = () => {
            if (this.availRecFiles) {
                this.posInList = this.availRecFiles.length - 1;
                this.navigateToRecordingFile();
            }
        };
        this.toVersionAction = new Action('To version');
        this.toVersionAction.onAction = (ae) => this.toVersion(ae);
    }
    ngOnInit() {
        super.ngOnInit();
    }
    ngAfterViewInit() {
        super.ngAfterViewInit();
        this.route.queryParams.subscribe((params) => {
            let rfIdP = params['recordingFileId'];
            let sIdP = params['sessionId'];
            if (sIdP) {
                this.sessionIdFromRoute = sIdP;
            }
            if (rfIdP) {
                this.routedByQueryParam = true;
                this.loadRecFile(rfIdP);
            }
        });
        this.route.params.subscribe((params) => {
            let rfIdP = params['recordingFileId'];
            let sIdP = params['sessionId'];
            if (sIdP) {
                this.sessionIdFromRoute = sIdP;
            }
            if (rfIdP) {
                this.routedByQueryParam = false;
                this.loadRecFile(rfIdP);
            }
        });
        // if(this.sessionId){
        //     this.loadSession(this.sessionId);
        // }
    }
    navigateToId(rfId) {
        if (this.routedByQueryParam) {
            this.router.navigate([], { relativeTo: this.route, queryParams: { 'recordingFileId': rfId } });
        }
        else {
            this.router.navigate(['../' + rfId], { relativeTo: this.route });
        }
    }
    navigateToRecordingFile() {
        if (this.posInList != null && this.availRecFiles) {
            let latestNextRf = this.availRecFiles[this.posInList][0];
            let lnRfId = latestNextRf.recordingFileId;
            if (lnRfId) {
                this.navigateToId(lnRfId);
            }
        }
    }
    toVersion(ae) {
        let toRfId = null;
        const version = ae.value;
        if (this.posInList != null && this.availRecFiles) {
            let cRfs = this.availRecFiles[this.posInList];
            //let availVersionCnt = cRfs.length;
            for (let cRf of cRfs) {
                if (cRf.version != null) {
                    if (cRf.version === version) {
                        toRfId = cRf.recordingFileId;
                        break;
                    }
                }
            }
        }
        if (toRfId != null) {
            this.navigateToId(toRfId);
        }
    }
    prevFile() {
        if (this.posInList != null) {
            this.posInList--;
        }
        this.navigateToRecordingFile();
    }
    nextFile() {
        if (this.posInList != null) {
            this.posInList++;
        }
        this.navigateToRecordingFile();
    }
    positionInList() {
        if (this.availRecFiles && this.recordingFile) {
            let cic = this.recordingFile.itemCode;
            if (!cic && this.recordingFile.recording && this.recordingFile.recording.itemcode) {
                cic = this.recordingFile.recording.itemcode;
            }
            if (cic) {
                let itemCnt = this.availRecFiles.length;
                for (let rfdi = 0; rfdi < itemCnt; rfdi++) {
                    let arRf = this.availRecFiles[rfdi][0];
                    if (arRf.recording) {
                        let ar = arRf.recording;
                        if (cic === ar.itemcode) {
                            return rfdi;
                        }
                    }
                }
            }
            else {
                let itemCnt = this.availRecFiles.length;
                for (let rfdi = 0; rfdi < itemCnt; rfdi++) {
                    let arRf = this.availRecFiles[rfdi][0];
                    if (this.recordingFile.uuid === arRf.uuid) {
                        return rfdi;
                    }
                }
            }
        }
        return null;
    }
    updatePos() {
        this.posInList = this.positionInList();
        this.toVersionAction.disabled = true;
        if (this.availRecFiles) {
            let avRfsLen = this.availRecFiles.length;
            if (this.posInList != null && avRfsLen > this.posInList) {
                let arfs = this.availRecFiles[this.posInList];
                if (arfs) {
                    this.versions = new Array();
                    for (let arf of arfs) {
                        if (arf.recording?.itemcode) {
                            this.versions.push(arf.version);
                        }
                    }
                    this.toVersionAction.disabled = (this.versions.length < 2);
                }
            }
        }
        if (this.recordingFile) {
            if (this.recordingFile.version) {
                this.recordingFileVersion = this.recordingFile.version;
            }
            else {
                this.recordingFileVersion = 0;
            }
        }
        else {
            this.recordingFileVersion = null;
        }
        this.updateActions();
    }
    loadRecFile(rfId) {
        this.ap?.stop();
        this.audioClip = null;
        this.recordingFile = null;
        this.posInList = null;
        this.updateActions();
        this.audioFetching = true;
        this.recordingFileService.fetchSprRecordingFile(rfId).subscribe({
            next: value => {
                this.audioFetching = false;
                this.status = 'Audio file loaded.';
                let clip = null;
                this.recordingFile = value;
                if (this.recordingFile) {
                    let ab = this.recordingFile.audioDataHolder;
                    if (ab) {
                        clip = new AudioClip(ab);
                        let esffsr = null;
                        let eeffsr = null;
                        let esr = null;
                        if (clip.audioDataHolder != null) {
                            esr = ab.sampleRate;
                            if (esr != null) {
                                esffsr = RecordingFileUtil.editStartFrameForSampleRate(this.recordingFile, esr);
                                eeffsr = RecordingFileUtil.editEndFrameForSampleRate(this.recordingFile, esr);
                            }
                            let sel = null;
                            if (esffsr != null) {
                                if (eeffsr != null) {
                                    sel = new Selection(ab.sampleRate, esffsr, eeffsr);
                                }
                                else {
                                    //let ch0 = ab.getChannelData(0);
                                    let frameLength = ab.frameLen;
                                    sel = new Selection(esr, esffsr, frameLength);
                                }
                            }
                            else if (eeffsr != null) {
                                sel = new Selection(esr, 0, eeffsr);
                            }
                            clip.selection = sel;
                        }
                    }
                }
                this.audioClip = clip;
                this.loadedRecfile();
            }, error: (err) => {
                this.audioFetching = false;
                this.status = 'Error loading audio file';
                const errMsg = ErrorHelper.message('Could not load audio file', err);
                this.dialog.open(MessageDialog, {
                    data: {
                        type: 'error',
                        title: this.status,
                        msg: errMsg,
                        advice: "Please check network connection and server state or contact application administrator."
                    }
                });
            }
        });
    }
    loadedRecfile() {
        if (this.recordingFile && !this.sessionId) {
            let sId = this.recordingFile.session;
            if (!sId) {
                sId = this.sessionIdFromRoute;
            }
            if (sId) {
                this.loadSession(sId);
            }
        }
        this.updatePos();
        this.ref.detectChanges();
    }
    updateActions() {
        let itemCnt = null;
        if (this.availRecFiles) {
            itemCnt = this.availRecFiles.length;
        }
        this.firstAction.disabled = (this.posInList == null || this.posInList == 0);
        this.prevAction.disabled = (this.posInList == null || this.posInList == 0);
        this.nextAction.disabled = (this.posInList == null || itemCnt == null || this.posInList >= itemCnt - 1);
        this.lastAction.disabled = (this.posInList == null || itemCnt == null || this.posInList >= itemCnt - 1);
    }
    loadSession(sessionId) {
        // load session and recording file metadata only when on init and when session changes
        if (sessionId != this.sessionId) {
            // tell UI that we are working...
            this.naviInfoLoading = true;
            this.sessionService.sessionObserver(sessionId).subscribe((s) => {
                // received session data
                this.sessionId = s.sessionId;
                // fetch recording file meta data list
                this.recordingService.sprRecordingFileList(s.project, s.sessionId).subscribe((rfds) => {
                    this.availRecFiles = new Array();
                    // build structure indexed by itemcode
                    let icIdx = new ItemcodeIndex();
                    for (let rfdi = 0; rfdi < rfds.length; rfdi++) {
                        let rfd = rfds[rfdi];
                        if (rfd.date) {
                            // convert date string for faster sorting later
                            rfd._dateAsDateObj = new Date(rfd.date);
                        }
                        let ic = rfd.itemCode;
                        if (!ic) {
                            let r = rfd.recording;
                            if (r && r.itemcode) {
                                ic = r.itemcode;
                            }
                        }
                        if (ic) {
                            let exRfsForIc = icIdx[ic];
                            if (exRfsForIc == null) {
                                // itemcode not yet stored
                                let arfd = new Array();
                                arfd.push(rfd);
                                icIdx[ic] = arfd;
                                this.availRecFiles.push(arfd);
                            }
                            else {
                                // rec file with itemcode already exists, add (push) this version ...
                                exRfsForIc.push(rfd);
                                // ... and sort latest version (highest version number) to lowest index
                                exRfsForIc.sort((rfd1, rfd2) => {
                                    return rfd2.version - rfd1.version;
                                });
                            }
                        }
                        else {
                            let arfd = new Array();
                            arfd.push(rfd);
                            this.availRecFiles.push(arfd);
                        }
                    }
                    // have unsorted itemcode indexed recording files here
                    // sort them ordered by date of latest version ascending
                    this.availRecFiles.sort((rfs1, rfs2) => {
                        let d1 = rfs2[0]._dateAsDateObj;
                        let d2 = rfs1[0]._dateAsDateObj;
                        if (d1 == null) {
                            if (d2 == null) {
                                return 0;
                            }
                            else {
                                // Sort entries whose dates are not set to the end
                                return -1;
                            }
                        }
                        else {
                            if (d2 == null) {
                                // Sort entries whose dates are not set to the end
                                return 1;
                            }
                            else {
                                // Compare date by time in milliseconds value
                                return d2.getTime() - d1.getTime();
                            }
                        }
                    });
                    for (let avRf of this.availRecFiles) {
                        if (avRf[0] && avRf[0].recording) {
                            let os = avRf[0].recording.itemcode + ': versions: ';
                            for (let avRfV of avRf) {
                                os += avRfV.version + '/';
                            }
                            //console.debug(os);
                        }
                    }
                    this.updatePos();
                    this.naviInfoLoading = false;
                    this.ref.detectChanges();
                });
            });
        }
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.12", ngImport: i0, type: RecordingFileViewComponent, deps: [{ token: RecordingFileService }, { token: RecordingService }, { token: SessionService }, { token: i4$2.Router }, { token: i4$2.ActivatedRoute }, { token: i0.ChangeDetectorRef }, { token: i0.ElementRef }, { token: i1$3.MatDialog }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "18.2.12", type: RecordingFileViewComponent, selector: "app-audiodisplayplayer", viewQueries: [{ propertyName: "ac", first: true, predicate: AudioDisplayScrollPane, descendants: true }], usesInheritance: true, ngImport: i0, template: `

    <audio-display-scroll-pane #audioDisplayScrollPane></audio-display-scroll-pane>
    <div class="ctrlview">
      <app-recording-file-meta [sessionId]="sessionId" [recordingFile]="recordingFile" [stateLoading]="audioFetching"></app-recording-file-meta>

    <audio-display-control [audioClip]="audioClip"
                             [playStartAction]="playStartAction"
                             [playSelectionAction]="playSelectionAction"
                             [playStopAction]="playStopAction"
                             [autoPlayOnSelectToggleAction]="ap?.autoPlayOnSelectToggleAction"
                             [zoomInAction]="zoomInAction"
                             [zoomOutAction]="zoomOutAction"
                             [zoomSelectedAction]="zoomSelectedAction"
                           [zoomFitToPanelAction]="zoomFitToPanelAction"></audio-display-control>
      <app-recording-file-navi [items]="availRecFiles?.length" [itemPos]="posInList" [version]="recordingFileVersion" [versions]="versions" [firstAction]="firstAction" [prevAction]="prevAction" [nextAction]="nextAction" [lastAction]="lastAction" [selectVersion]="toVersionAction" [naviInfoLoading]="naviInfoLoading"></app-recording-file-navi>
      </div>
  `, isInline: true, styles: [":host{flex:2;display:flex;flex-direction:column;min-height:0;overflow:hidden;padding:20px;z-index:5;box-sizing:border-box;background-color:#fff}\n", ".ctrlview{display:flex;flex-direction:row}\n", "audio-display-control{flex:3}\n"], dependencies: [{ kind: "component", type: AudioDisplayScrollPane, selector: "audio-display-scroll-pane", inputs: ["audioClip"], outputs: ["zoomInAction", "zoomOutAction", "zoomSelectedAction", "zoomFitToPanelAction"] }, { kind: "component", type: AudioDisplayControl, selector: "audio-display-control", inputs: ["audioClip", "playStartAction", "playSelectionAction", "playStopAction", "zoomInAction", "zoomOutAction", "zoomFitToPanelAction", "zoomSelectedAction", "autoPlayOnSelectToggleAction"] }, { kind: "component", type: RecordingFileNaviComponent, selector: "app-recording-file-navi", inputs: ["firstAction", "prevAction", "nextAction", "lastAction", "items", "itemPos", "selectVersion", "versions", "version", "naviInfoLoading"] }, { kind: "component", type: RecordingFileMetaComponent, selector: "app-recording-file-meta", inputs: ["sessionId", "stateLoading", "recordingFile"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.12", ngImport: i0, type: RecordingFileViewComponent, decorators: [{
            type: Component,
            args: [{ selector: 'app-audiodisplayplayer', template: `

    <audio-display-scroll-pane #audioDisplayScrollPane></audio-display-scroll-pane>
    <div class="ctrlview">
      <app-recording-file-meta [sessionId]="sessionId" [recordingFile]="recordingFile" [stateLoading]="audioFetching"></app-recording-file-meta>

    <audio-display-control [audioClip]="audioClip"
                             [playStartAction]="playStartAction"
                             [playSelectionAction]="playSelectionAction"
                             [playStopAction]="playStopAction"
                             [autoPlayOnSelectToggleAction]="ap?.autoPlayOnSelectToggleAction"
                             [zoomInAction]="zoomInAction"
                             [zoomOutAction]="zoomOutAction"
                             [zoomSelectedAction]="zoomSelectedAction"
                           [zoomFitToPanelAction]="zoomFitToPanelAction"></audio-display-control>
      <app-recording-file-navi [items]="availRecFiles?.length" [itemPos]="posInList" [version]="recordingFileVersion" [versions]="versions" [firstAction]="firstAction" [prevAction]="prevAction" [nextAction]="nextAction" [lastAction]="lastAction" [selectVersion]="toVersionAction" [naviInfoLoading]="naviInfoLoading"></app-recording-file-navi>
      </div>
  `, styles: [":host{flex:2;display:flex;flex-direction:column;min-height:0;overflow:hidden;padding:20px;z-index:5;box-sizing:border-box;background-color:#fff}\n", ".ctrlview{display:flex;flex-direction:row}\n", "audio-display-control{flex:3}\n"] }]
        }], ctorParameters: () => [{ type: RecordingFileService }, { type: RecordingService }, { type: SessionService }, { type: i4$2.Router }, { type: i4$2.ActivatedRoute }, { type: i0.ChangeDetectorRef }, { type: i0.ElementRef }, { type: i1$3.MatDialog }], propDecorators: { ac: [{
                type: ViewChild,
                args: [AudioDisplayScrollPane]
            }] } });

class RecordingFileUI extends RecordingFileViewComponent {
    constructor(recordingFileService, recordingService, sessionService, router, route, ref, eRef, dialog, snackBar) {
        super(recordingFileService, recordingService, sessionService, router, route, ref, eRef, dialog);
        this.recordingFileService = recordingFileService;
        this.recordingService = recordingService;
        this.sessionService = sessionService;
        this.router = router;
        this.route = route;
        this.ref = ref;
        this.eRef = eRef;
        this.dialog = dialog;
        this.snackBar = snackBar;
        this.savedEditSelection = null;
        this.editSaved = true;
        this.parentE = this.eRef.nativeElement;
    }
    ngAfterViewInit() {
        super.ngAfterViewInit();
    }
    applyButtonText() {
        if (this.audioClip) {
            let s = this.audioClip.selection;
            if (s) {
                return "Apply current selection as editing selection";
            }
            else {
                return "Cancel out editing selection";
            }
        }
        // just as fallback
        return "Apply selection";
    }
    loadRecFile(rfId) {
        this.editSaved = true;
        super.loadRecFile(rfId);
    }
    loadedRecfile() {
        super.loadedRecfile();
        if (this.audioClip) {
            this.audioClip.addSelectionObserver((clip) => {
                let s = clip.selection;
                this.editSaved = ((this.savedEditSelection == null && s == null) || this.savedEditSelection != null && this.savedEditSelection.equals(s));
            });
        }
        this.savedEditSelection = this.audioClip ? this.audioClip.selection : null;
        this.editSaved = true;
    }
    applySelection() {
        if (this.audioClip) {
            let ab = this.audioClip.audioDataHolder;
            let s = this.audioClip.selection;
            if (ab && this.recordingFile?.recordingFileId) {
                let sr = null;
                let sf = null;
                let ef = null;
                if (s) {
                    sr = ab.sampleRate;
                    sf = s.startFrame;
                    ef = s.endFrame;
                }
                this.recordingFileService.saveEditSelection(this.recordingFile.recordingFileId, sr, sf, ef).subscribe({
                    next: () => { },
                    error: (err) => {
                        const errMsg = ErrorHelper.message('Could not save edit selection to server', err);
                        this.dialog.open(MessageDialog, {
                            data: {
                                type: 'error',
                                title: 'Save selection edit error',
                                msg: errMsg,
                                advice: "Please check network connection and server state."
                            }
                        });
                    }, complete: () => {
                        // Or use returned selection value from server?
                        this.savedEditSelection = s;
                        this.editSaved = true;
                        this.snackBar.open('Selection edit saved successfully.', 'OK', { duration: 1500 });
                    }
                });
            }
        }
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.12", ngImport: i0, type: RecordingFileUI, deps: [{ token: RecordingFileService }, { token: RecordingService }, { token: SessionService }, { token: i4$2.Router }, { token: i4$2.ActivatedRoute }, { token: i0.ChangeDetectorRef }, { token: i0.ElementRef }, { token: i1$3.MatDialog }, { token: i6.MatSnackBar }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "18.2.12", type: RecordingFileUI, selector: "app-audiodisplayplayer", usesInheritance: true, ngImport: i0, template: `
      <h1>Recording file editing</h1>
      <p>On export or delivery the editing selection of the recording file is cut out. If no editing selection is applied the original file is exported.</p>

    <audio-display-scroll-pane #audioDisplayScrollPane></audio-display-scroll-pane>
      <div class="ctrlview">
        <app-recording-file-meta [sessionId]="sessionId"  [recordingFile]="recordingFile" [stateLoading]="audioFetching"></app-recording-file-meta>
    <audio-display-control [audioClip]="audioClip"
                             [playStartAction]="playStartAction"
                             [playSelectionAction]="playSelectionAction"
                             [playStopAction]="playStopAction"
                             [autoPlayOnSelectToggleAction]="ap?.autoPlayOnSelectToggleAction"
                             [zoomInAction]="zoomInAction"
                             [zoomOutAction]="zoomOutAction"
                             [zoomSelectedAction]="zoomSelectedAction"
                           [zoomFitToPanelAction]="zoomFitToPanelAction"></audio-display-control>
        <app-recording-file-navi [items]="availRecFiles?.length" [itemPos]="posInList" [version]="recordingFileVersion" [versions]="versions" [firstAction]="firstAction" [prevAction]="prevAction" [nextAction]="nextAction" [lastAction]="lastAction" [selectVersion]="toVersionAction" [naviInfoLoading]="naviInfoLoading"></app-recording-file-navi>
      </div>

      <button mat-raised-button color="accent" (click)="applySelection()" [disabled]="editSaved">{{this.applyButtonText()}}</button>
  `, isInline: true, styles: [":host{flex:2;display:flex;flex-direction:column;min-height:0;overflow:hidden;padding:20px;z-index:5;box-sizing:border-box;background-color:#fff}\n", ".ctrlview{display:flex;flex-direction:row}\n", "audio-display-control{flex:3}\n"], dependencies: [{ kind: "component", type: i3.MatButton, selector: "    button[mat-button], button[mat-raised-button], button[mat-flat-button],    button[mat-stroked-button]  ", exportAs: ["matButton"] }, { kind: "component", type: AudioDisplayScrollPane, selector: "audio-display-scroll-pane", inputs: ["audioClip"], outputs: ["zoomInAction", "zoomOutAction", "zoomSelectedAction", "zoomFitToPanelAction"] }, { kind: "component", type: AudioDisplayControl, selector: "audio-display-control", inputs: ["audioClip", "playStartAction", "playSelectionAction", "playStopAction", "zoomInAction", "zoomOutAction", "zoomFitToPanelAction", "zoomSelectedAction", "autoPlayOnSelectToggleAction"] }, { kind: "component", type: RecordingFileNaviComponent, selector: "app-recording-file-navi", inputs: ["firstAction", "prevAction", "nextAction", "lastAction", "items", "itemPos", "selectVersion", "versions", "version", "naviInfoLoading"] }, { kind: "component", type: RecordingFileMetaComponent, selector: "app-recording-file-meta", inputs: ["sessionId", "stateLoading", "recordingFile"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.12", ngImport: i0, type: RecordingFileUI, decorators: [{
            type: Component,
            args: [{ selector: 'app-audiodisplayplayer', template: `
      <h1>Recording file editing</h1>
      <p>On export or delivery the editing selection of the recording file is cut out. If no editing selection is applied the original file is exported.</p>

    <audio-display-scroll-pane #audioDisplayScrollPane></audio-display-scroll-pane>
      <div class="ctrlview">
        <app-recording-file-meta [sessionId]="sessionId"  [recordingFile]="recordingFile" [stateLoading]="audioFetching"></app-recording-file-meta>
    <audio-display-control [audioClip]="audioClip"
                             [playStartAction]="playStartAction"
                             [playSelectionAction]="playSelectionAction"
                             [playStopAction]="playStopAction"
                             [autoPlayOnSelectToggleAction]="ap?.autoPlayOnSelectToggleAction"
                             [zoomInAction]="zoomInAction"
                             [zoomOutAction]="zoomOutAction"
                             [zoomSelectedAction]="zoomSelectedAction"
                           [zoomFitToPanelAction]="zoomFitToPanelAction"></audio-display-control>
        <app-recording-file-navi [items]="availRecFiles?.length" [itemPos]="posInList" [version]="recordingFileVersion" [versions]="versions" [firstAction]="firstAction" [prevAction]="prevAction" [nextAction]="nextAction" [lastAction]="lastAction" [selectVersion]="toVersionAction" [naviInfoLoading]="naviInfoLoading"></app-recording-file-navi>
      </div>

      <button mat-raised-button color="accent" (click)="applySelection()" [disabled]="editSaved">{{this.applyButtonText()}}</button>
  `, styles: [":host{flex:2;display:flex;flex-direction:column;min-height:0;overflow:hidden;padding:20px;z-index:5;box-sizing:border-box;background-color:#fff}\n", ".ctrlview{display:flex;flex-direction:row}\n", "audio-display-control{flex:3}\n"] }]
        }], ctorParameters: () => [{ type: RecordingFileService }, { type: RecordingService }, { type: SessionService }, { type: i4$2.Router }, { type: i4$2.ActivatedRoute }, { type: i0.ChangeDetectorRef }, { type: i0.ElementRef }, { type: i1$3.MatDialog }, { type: i6.MatSnackBar }] });

class MediaUtils {
    static toMediaTime(timeInSeconds) {
        let rest = timeInSeconds;
        let hours = Math.floor(timeInSeconds / 3600);
        rest -= hours * 3600;
        let minutes = Math.floor(rest / 60);
        rest -= minutes * 60;
        let seconds = Math.floor(rest);
        rest -= seconds;
        let millis = Math.round(rest * 1000);
        return hours.toString().padStart(2, '0') + ':' + minutes.toString().padStart(2, '0') + ':' + seconds.toString().padStart(2, '0') + '.' + millis.toString().padStart(3, '0');
    }
}

class RecordingList {
    constructor() {
        //private recordingList:Array<RecordingFile>=new Array<RecordingFile>();
        this.recordingList = new RecFilesCache();
        //cols=['index','length','samples','samplerate','action'];
        this.cols = ['index', 'startedDate', 'length', 'action'];
        this.selectDisabled = false;
        this.selectedRecordingFileChanged = new EventEmitter();
        this.selectedRecordingFile = null;
        this.recordingListDataSource = new MatTableDataSource();
    }
    ngAfterViewInit() {
        this.buildDataSource();
    }
    buildDataSource() {
        this.recordingList.recFiles.sort((a, b) => {
            let cmp = 0;
            let aD = null;
            let bD = null;
            if (a._startedAsDateObj && b._startedAsDateObj) {
                aD = a._startedAsDateObj;
                bD = b._startedAsDateObj;
            }
            else if (a.startedDate && b.startedDate) {
                aD = new Date(a.startedDate);
                bD = new Date(b.startedDate);
            }
            else if (a.date && b.date) {
                aD = new Date(a.date);
                bD = new Date(b.date);
            }
            if (aD !== null && bD !== null) {
                cmp = bD.getTime() - aD.getTime();
            }
            return cmp;
        });
        this.recordingListDataSource.data = this.recordingList.recFiles;
    }
    addRecFile(rf) {
        this.recordingList.addRecFile(rf);
        this.buildDataSource();
    }
    setRecFileAudioData(recFile, adh) {
        this.recordingList.setRecFileAudioData(recFile, adh);
    }
    selectRecordingFile(rf) {
        this.recordingList.currentRecordingFile = rf;
        this.selectedRecordingFileChanged.emit(rf);
    }
    selectTop() {
        if (this.recordingList.recFiles.length > 0) {
            this.selectRecordingFile(this.recordingList.recFiles[0]);
        }
    }
    lengthTimeFormatted(rf) {
        let str = '--:--:--';
        let tl = null;
        if (rf.timeLength) {
            tl = rf.timeLength;
        }
        else if (rf.frames && rf.audioDataHolder) {
            tl = rf.frames / rf.audioDataHolder?.sampleRate;
        }
        if (tl) {
            str = MediaUtils.toMediaTime(tl);
        }
        return str;
    }
    recordingFileCached(rf) {
        let cached = null;
        if (rf && rf.serverPersisted) {
            cached = (rf.audioDataHolder != null);
        }
        return cached;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.12", ngImport: i0, type: RecordingList, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "18.2.12", type: RecordingList, selector: "app-recordinglist", inputs: { selectDisabled: "selectDisabled", selectedRecordingFile: "selectedRecordingFile" }, outputs: { selectedRecordingFileChanged: "selectedRecordingFileChanged" }, ngImport: i0, template: `
    <mat-card appearance="outlined">
      <mat-card-header>
        <h2>Recording list</h2>
      </mat-card-header>
      <mat-card-content>
        <table mat-table [dataSource]="recordingListDataSource" class="mat-elevation-z0">
          <tr mat-header-row *matHeaderRowDef="cols;sticky:true"></tr>
          <tr mat-row *matRowDef="let element; columns: cols;"
              [scrollIntoViewToBottom]="element.uuid===selectedRecordingFile?.uuid" [class.selected]="element.uuid===selectedRecordingFile?.uuid"></tr>
          <ng-container matColumnDef="index">
            <th mat-header-cell *matHeaderCellDef mat-header>#</th>
            <td mat-cell class="monospaced"
                *matCellDef="let element;let i = index">{{recordingListDataSource.data.length - i}}</td>
          </ng-container>
          <ng-container matColumnDef="startedDate">
            <th mat-header-cell *matHeaderCellDef mat-header>Started</th>
            <td mat-cell class="monospaced"
                *matCellDef="let element">{{element.startedDate | date:'YYYY-MM-dd HH:mm:ss'}}</td>
          </ng-container>
          <ng-container matColumnDef="length">
            <th mat-header-cell *matHeaderCellDef mat-header>Length</th>
            <td mat-cell class="monospaced" *matCellDef="let element">{{lengthTimeFormatted(element)}}</td>
          </ng-container>
          <ng-container matColumnDef="action">
            <th mat-header-cell *matHeaderCellDef>Action</th>
            <td mat-cell *matCellDef="let element">
              <!--
              <mat-icon *ngIf="recordingFileCached(element)===false" style="font-size:0.8em;width:0.8em;height:0.8em">
                cloud_download
              </mat-icon>
              -->
              <button mat-stroked-button color="primary" (click)="selectRecordingFile(element)"
                      [disabled]="selectDisabled || element.uuid===selectedRecordingFile?.uuid">
                <mat-icon>edit_attributes</mat-icon>
                Select
              </button>

            </td>
          </ng-container>
        </table>
      </mat-card-content>
    </mat-card>

  `, isInline: true, styles: [".monospaced{font-family:monospace}.mat-mdc-cell,.mat-mdc-header-cell{padding-left:5px;padding-right:5px}.mat-mdc-card,.mat-mdc-card-header,.mat-mdc-card-content{width:auto}.flexForm{display:flex;flex-direction:column;width:auto}.flexFill{margin:0;width:100%;height:100%;min-width:100%;min-height:100%}.spr-button-icon{font-size:24px;vertical-align:middle;overflow:hidden;text-overflow:clip;white-space:nowrap}\n", ":host{position:relative;margin:0;padding:0;background:#d3d3d3;width:100%;flex:1;overflow-y:auto;min-height:0px}\n", ".selected{font-weight:700}\n"], dependencies: [{ kind: "component", type: i2.MatIcon, selector: "mat-icon", inputs: ["color", "inline", "svgIcon", "fontSet", "fontIcon"], exportAs: ["matIcon"] }, { kind: "component", type: i3.MatButton, selector: "    button[mat-button], button[mat-raised-button], button[mat-flat-button],    button[mat-stroked-button]  ", exportAs: ["matButton"] }, { kind: "component", type: i3$2.MatCard, selector: "mat-card", inputs: ["appearance"], exportAs: ["matCard"] }, { kind: "directive", type: i3$2.MatCardContent, selector: "mat-card-content" }, { kind: "component", type: i3$2.MatCardHeader, selector: "mat-card-header" }, { kind: "component", type: i4$3.MatTable, selector: "mat-table, table[mat-table]", exportAs: ["matTable"] }, { kind: "directive", type: i4$3.MatHeaderCellDef, selector: "[matHeaderCellDef]" }, { kind: "directive", type: i4$3.MatHeaderRowDef, selector: "[matHeaderRowDef]", inputs: ["matHeaderRowDef", "matHeaderRowDefSticky"] }, { kind: "directive", type: i4$3.MatColumnDef, selector: "[matColumnDef]", inputs: ["matColumnDef"] }, { kind: "directive", type: i4$3.MatCellDef, selector: "[matCellDef]" }, { kind: "directive", type: i4$3.MatRowDef, selector: "[matRowDef]", inputs: ["matRowDefColumns", "matRowDefWhen"] }, { kind: "directive", type: i4$3.MatHeaderCell, selector: "mat-header-cell, th[mat-header-cell]" }, { kind: "directive", type: i4$3.MatCell, selector: "mat-cell, td[mat-cell]" }, { kind: "component", type: i4$3.MatHeaderRow, selector: "mat-header-row, tr[mat-header-row]", exportAs: ["matHeaderRow"] }, { kind: "component", type: i4$3.MatRow, selector: "mat-row, tr[mat-row]", exportAs: ["matRow"] }, { kind: "directive", type: ScrollIntoViewDirective, selector: "[scrollIntoViewToBottom]", inputs: ["scrollIntoViewToBottom"] }, { kind: "pipe", type: i1$1.DatePipe, name: "date" }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.12", ngImport: i0, type: RecordingList, decorators: [{
            type: Component,
            args: [{ selector: 'app-recordinglist', template: `
    <mat-card appearance="outlined">
      <mat-card-header>
        <h2>Recording list</h2>
      </mat-card-header>
      <mat-card-content>
        <table mat-table [dataSource]="recordingListDataSource" class="mat-elevation-z0">
          <tr mat-header-row *matHeaderRowDef="cols;sticky:true"></tr>
          <tr mat-row *matRowDef="let element; columns: cols;"
              [scrollIntoViewToBottom]="element.uuid===selectedRecordingFile?.uuid" [class.selected]="element.uuid===selectedRecordingFile?.uuid"></tr>
          <ng-container matColumnDef="index">
            <th mat-header-cell *matHeaderCellDef mat-header>#</th>
            <td mat-cell class="monospaced"
                *matCellDef="let element;let i = index">{{recordingListDataSource.data.length - i}}</td>
          </ng-container>
          <ng-container matColumnDef="startedDate">
            <th mat-header-cell *matHeaderCellDef mat-header>Started</th>
            <td mat-cell class="monospaced"
                *matCellDef="let element">{{element.startedDate | date:'YYYY-MM-dd HH:mm:ss'}}</td>
          </ng-container>
          <ng-container matColumnDef="length">
            <th mat-header-cell *matHeaderCellDef mat-header>Length</th>
            <td mat-cell class="monospaced" *matCellDef="let element">{{lengthTimeFormatted(element)}}</td>
          </ng-container>
          <ng-container matColumnDef="action">
            <th mat-header-cell *matHeaderCellDef>Action</th>
            <td mat-cell *matCellDef="let element">
              <!--
              <mat-icon *ngIf="recordingFileCached(element)===false" style="font-size:0.8em;width:0.8em;height:0.8em">
                cloud_download
              </mat-icon>
              -->
              <button mat-stroked-button color="primary" (click)="selectRecordingFile(element)"
                      [disabled]="selectDisabled || element.uuid===selectedRecordingFile?.uuid">
                <mat-icon>edit_attributes</mat-icon>
                Select
              </button>

            </td>
          </ng-container>
        </table>
      </mat-card-content>
    </mat-card>

  `, styles: [".monospaced{font-family:monospace}.mat-mdc-cell,.mat-mdc-header-cell{padding-left:5px;padding-right:5px}.mat-mdc-card,.mat-mdc-card-header,.mat-mdc-card-content{width:auto}.flexForm{display:flex;flex-direction:column;width:auto}.flexFill{margin:0;width:100%;height:100%;min-width:100%;min-height:100%}.spr-button-icon{font-size:24px;vertical-align:middle;overflow:hidden;text-overflow:clip;white-space:nowrap}\n", ":host{position:relative;margin:0;padding:0;background:#d3d3d3;width:100%;flex:1;overflow-y:auto;min-height:0px}\n", ".selected{font-weight:700}\n"] }]
        }], ctorParameters: () => [], propDecorators: { selectDisabled: [{
                type: Input
            }], selectedRecordingFileChanged: [{
                type: Output
            }], selectedRecordingFile: [{
                type: Input
            }] } });

class RecorderCombiPane extends ResponsiveComponent {
    constructor(bpo) {
        super(bpo);
        this.bpo = bpo;
        this.selectDisabled = false;
        this.selectedRecordingFileChanged = new EventEmitter();
        this.selectedRecordingFile = null;
        this.audioSignalCollapsed = true;
        this.displayAudioClip = null;
    }
    ngAfterViewInit() {
    }
    addRecFile(rf) {
        this.recordingListComp.addRecFile(rf);
    }
    setRecFileAudioData(recFile, adh) {
        this.recordingListComp.setRecFileAudioData(recFile, adh);
    }
    selectRecordingFile(rf) {
        this.selectedRecordingFileChanged.emit(rf);
    }
    selectTop() {
        this.recordingListComp.selectTop();
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.12", ngImport: i0, type: RecorderCombiPane, deps: [{ token: i1$2.BreakpointObserver }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "18.2.12", type: RecorderCombiPane, selector: "app-recordercombipane", inputs: { selectDisabled: "selectDisabled", selectedRecordingFile: "selectedRecordingFile", audioSignalCollapsed: "audioSignalCollapsed", displayAudioClip: "displayAudioClip", playStartAction: "playStartAction", playSelectionAction: "playSelectionAction", autoPlayOnSelectToggleAction: "autoPlayOnSelectToggleAction", playStopAction: "playStopAction" }, outputs: { selectedRecordingFileChanged: "selectedRecordingFileChanged" }, viewQueries: [{ propertyName: "recordingListComp", first: true, predicate: RecordingList, descendants: true }, { propertyName: "audioDisplay", first: true, predicate: AudioDisplay, descendants: true, static: true }], usesInheritance: true, ngImport: i0, template: `
    <div class="scrollList">
        <app-recordinglist [selectedRecordingFile]="selectedRecordingFile" [selectDisabled]="selectDisabled" (selectedRecordingFileChanged)="selectRecordingFile($event)"></app-recordinglist>
    </div>
    <div class="collapsable"  #asCt [class.active]="!audioSignalCollapsed && !screenXs">
      <app-audiodisplay #audioSignalContainer [class.active]="!audioSignalCollapsed"
                        [audioClip]="displayAudioClip"
                        [playStartAction]="playStartAction"
                        [playSelectionAction]="playSelectionAction"
                        [autoPlayOnSelectToggleAction]="autoPlayOnSelectToggleAction"
                        [playStopAction]="playStopAction"></app-audiodisplay>
    </div>
  `, isInline: true, styles: [".monospaced{font-family:monospace}.mat-mdc-cell,.mat-mdc-header-cell{padding-left:5px;padding-right:5px}.mat-mdc-card,.mat-mdc-card-header,.mat-mdc-card-content{width:auto}.flexForm{display:flex;flex-direction:column;width:auto}.flexFill{margin:0;width:100%;height:100%;min-width:100%;min-height:100%}.spr-button-icon{font-size:24px;vertical-align:middle;overflow:hidden;text-overflow:clip;white-space:nowrap}\n", ":host{background-color:#ff0;position:relative;margin:0;padding:0;background:#d3d3d3;width:100%;flex:1;min-height:0px}\n", ".scrollList{margin:0;padding:0;background:#d3d3d3;width:100%;height:100%;overflow-y:auto}\n", ".collapsable{display:none;position:absolute;z-index:5}\n", ".collapsable.active{display:flex;position:absolute;bottom:0;height:90%;width:100%;overflow:hidden;padding:0;z-index:200;box-sizing:border-box;background-color:#0000}\n"], dependencies: [{ kind: "component", type: AudioDisplay, selector: "app-audiodisplay", inputs: ["playStartAction", "playStopAction", "playSelectionAction", "autoPlayOnSelectToggleAction", "audioData", "audioClip"] }, { kind: "component", type: RecordingList, selector: "app-recordinglist", inputs: ["selectDisabled", "selectedRecordingFile"], outputs: ["selectedRecordingFileChanged"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.12", ngImport: i0, type: RecorderCombiPane, decorators: [{
            type: Component,
            args: [{ selector: 'app-recordercombipane', template: `
    <div class="scrollList">
        <app-recordinglist [selectedRecordingFile]="selectedRecordingFile" [selectDisabled]="selectDisabled" (selectedRecordingFileChanged)="selectRecordingFile($event)"></app-recordinglist>
    </div>
    <div class="collapsable"  #asCt [class.active]="!audioSignalCollapsed && !screenXs">
      <app-audiodisplay #audioSignalContainer [class.active]="!audioSignalCollapsed"
                        [audioClip]="displayAudioClip"
                        [playStartAction]="playStartAction"
                        [playSelectionAction]="playSelectionAction"
                        [autoPlayOnSelectToggleAction]="autoPlayOnSelectToggleAction"
                        [playStopAction]="playStopAction"></app-audiodisplay>
    </div>
  `, styles: [".monospaced{font-family:monospace}.mat-mdc-cell,.mat-mdc-header-cell{padding-left:5px;padding-right:5px}.mat-mdc-card,.mat-mdc-card-header,.mat-mdc-card-content{width:auto}.flexForm{display:flex;flex-direction:column;width:auto}.flexFill{margin:0;width:100%;height:100%;min-width:100%;min-height:100%}.spr-button-icon{font-size:24px;vertical-align:middle;overflow:hidden;text-overflow:clip;white-space:nowrap}\n", ":host{background-color:#ff0;position:relative;margin:0;padding:0;background:#d3d3d3;width:100%;flex:1;min-height:0px}\n", ".scrollList{margin:0;padding:0;background:#d3d3d3;width:100%;height:100%;overflow-y:auto}\n", ".collapsable{display:none;position:absolute;z-index:5}\n", ".collapsable.active{display:flex;position:absolute;bottom:0;height:90%;width:100%;overflow:hidden;padding:0;z-index:200;box-sizing:border-box;background-color:#0000}\n"] }]
        }], ctorParameters: () => [{ type: i1$2.BreakpointObserver }], propDecorators: { recordingListComp: [{
                type: ViewChild,
                args: [RecordingList]
            }], selectDisabled: [{
                type: Input
            }], selectedRecordingFileChanged: [{
                type: Output
            }], selectedRecordingFile: [{
                type: Input
            }], audioDisplay: [{
                type: ViewChild,
                args: [AudioDisplay, { static: true }]
            }], audioSignalCollapsed: [{
                type: Input
            }], displayAudioClip: [{
                type: Input
            }], playStartAction: [{
                type: Input
            }], playSelectionAction: [{
                type: Input
            }], autoPlayOnSelectToggleAction: [{
                type: Input
            }], playStopAction: [{
                type: Input
            }] } });

class AudioRecorder extends BasicRecorder {
    constructor(bpo, changeDetectorRef, renderer, dialog, sessionService, recFileService, uploader, config) {
        super(bpo, changeDetectorRef, dialog, sessionService, uploader, config);
        this.bpo = bpo;
        this.renderer = renderer;
        this.recFileService = recFileService;
        this.uploader = uploader;
        this._project = null;
        this.projectName = null;
        this.enableUploadRecordings = true;
        this.enableDownloadRecordings = false;
        this.status = 0 /* Status.BLOCKED */;
        this.dataSaved = true;
        this._displayRecFile = null;
        this.displayRecFileVersion = 0;
        //super(injector);
        this.status = 1 /* Status.IDLE */;
        this.audio = document.getElementById('audio');
        if (this.config && this.config.enableUploadRecordings != null) {
            this.enableUploadRecordings = this.config.enableUploadRecordings;
        }
        if (this.config && this.config.enableDownloadRecordings != null) {
            this.enableDownloadRecordings = this.config.enableDownloadRecordings;
        }
        //this.init();
    }
    ngAfterViewInit() {
        this.streamLevelMeasure.levelListener = this.liveLevelDisplay;
        this.streamLevelMeasure.peakLevelListener = (peakLvlInDb) => {
            this.peakLevelInDb = peakLvlInDb;
            this.changeDetectorRef.detectChanges();
        };
        //let wakeLockSupp=('wakeLock' in navigator);
        //alert('Wake lock API supported: '+wakeLockSupp);
    }
    ready() {
        return this.dataSaved && !this.isActive();
    }
    ngOnDestroy() {
        this.disableWakeLockCond();
        this.destroyed = true;
        // TODO stop capture /playback
    }
    ngOnInit() {
        this.transportActions.startAction.disabled = true;
        this.transportActions.stopAction.disabled = true;
        this.transportActions.nextAction.disabled = true;
        this.transportActions.pauseAction.disabled = true;
        this.playStartAction.disabled = true;
        this.ac = new AudioCapture();
        if (this.ac) {
            this.transportActions.startAction.onAction = () => this.startItem();
            this.ac.listener = this;
            this.configureStreamCaptureStream();
            // Don't list the devices here. If we do not have audio permissions we only get anonymized devices without labels.
            //this.ac.listDevices();
        }
        else {
            this.transportActions.startAction.disabled = true;
            let errMsg = 'Browser does not support Media/Audio API!';
            this.statusMsg = 'ERROR: ' + errMsg;
            this.statusAlertType = 'error';
            this.dialog.open(MessageDialog, {
                data: {
                    type: 'error',
                    title: 'Error',
                    msg: errMsg,
                    advice: 'Please use a supported browser.',
                }
            });
            return;
        }
        this.transportActions.stopAction.onAction = () => this.stopItem();
        this.transportActions.nextAction.onAction = () => this.stopItem();
        //this.transportActions.pauseAction.onAction = () => this.pauseItem();
        this.playStartAction.onAction = () => this.controlAudioPlayer?.start();
        this.uploader.listener = (ue) => {
            this.uploadUpdate(ue);
        };
    }
    onKeyPress(ke) {
        if (ke.key == ' ') {
            //this.transportActions.startAction.perform();
            //this.transportActions.nextAction.perform();
        }
    }
    onKeyDown(ke) {
        if (ke.key == ' ') {
            if (!this.transportActions.startAction.disabled) {
                this.transportActions.startAction.perform();
            }
            else if (!this.transportActions.stopAction.disabled) {
                this.transportActions.stopAction.perform();
            }
        }
        if (ke.key == 'p') {
            this.transportActions.pauseAction.perform();
        }
        if (ke.key == 'Escape') {
            if (!this.audioSignalCollapsed) {
                this.audioSignalCollapsed = true;
            }
            this.transportActions.stopAction.perform();
            this.transportActions.pauseAction.perform();
        }
        if (ke.key == 'MediaPlayPause') {
            this.playStartAction.perform();
        }
        if (ke.key === 'ArrowRight') {
            this.transportActions.fwdAction.perform();
        }
        if (ke.key === 'ArrowLeft') {
            this.transportActions.bwdAction.perform();
        }
    }
    isTestSession() {
        return ((this._session != null) && (this._session.type === 'TEST' || this._session.type === 'TEST_DEF_A' || this._session.type === 'SINUS_TEST'));
    }
    isDefaultAudioTestSession() {
        return ((this._session != null) && (this._session.type === 'TEST_DEF_A'));
    }
    isDefaultAudioTestSessionOverwriteingProjectRequirements() {
        return ((this._session != null) && (this._session.type === 'TEST_DEF_A') && (this.audioDevices != null) && this.audioDevices.length > 0);
    }
    fetchRecordings(sess) {
        this.statusAlertType = 'info';
        this.statusMsg = 'Fetching infos of recordings...';
        this.statusWaiting = true;
        //let prNm:string|null=null;
        if (this.project) {
            let rfsObs = this.recFileService.recordingFileList(this.project.name, sess.sessionId);
            rfsObs.subscribe({ next: (rfs) => {
                    this.statusAlertType = 'info';
                    this.statusMsg = 'Received infos of recordings.';
                    this.statusWaiting = false;
                    if (rfs) {
                        if (rfs instanceof Array) {
                            rfs.forEach((rf) => {
                                // the list comes from the server, asssuem all recording files as server persisted
                                rf.serverPersisted = true;
                                if (rf.startedDate) {
                                    rf._startedAsDateObj = new Date(rf.startedDate);
                                }
                                if (rf.date) {
                                    rf._dateAsDateObj = new Date(rf.date);
                                }
                                this.recorderCombiPane.addRecFile(rf);
                            });
                        }
                        else {
                            console.error('Expected type array for list of already recorded files ');
                        }
                    }
                    else {
                        //console.debug("Recording file list: " + rfs);
                    }
                }, error: (err) => {
                    // Failed fetching existing, but we start the session anyway
                    this.start();
                }, complete: () => {
                    // Normal start
                    this.start();
                } });
        }
        else {
            // No project def -> error
            this.statusAlertType = 'error';
            this.statusMsg = 'No project definiton.';
            this.statusWaiting = false;
            console.error(this.statusMsg);
        }
    }
    set project(project) {
        this._project = project;
        let chCnt = ProjectUtil.DEFAULT_AUDIO_CHANNEL_COUNT;
        if (project) {
            console.info("Project name: " + project.name);
            if (project.recordingDeviceWakeLock === true) {
                this.wakeLock = true;
            }
            this.audioDevices = project.audioDevices;
            chCnt = ProjectUtil.audioChannelCount(project);
            console.info("Project requested recording channel count: " + chCnt);
            this.autoGainControlConfigs = project.autoGainControlConfigs;
            if (project.allowEchoCancellation !== undefined) {
                this.allowEchoCancellation = project.allowEchoCancellation;
            }
            if (project.chunkedRecording === true) {
                this.uploadChunkSizeSeconds = BasicRecorder.DEFAULT_CHUNK_SIZE_SECONDS;
            }
            else {
                this.uploadChunkSizeSeconds = null;
            }
            if (project.clientAudioStorageType) {
                this.clientAudioStorageType = project.clientAudioStorageType;
            }
        }
        else {
            console.error("Empty project configuration!");
        }
        this.channelCount = chCnt;
    }
    get project() {
        return this._project;
    }
    selectRecordingFile(rf) {
        this.liveLevelDisplayState = State.READY;
        this.keepLiveLevel = false;
        this.displayRecFile = rf;
    }
    uploadUpdate(ue) {
        let upStatus = ue.status;
        this.dataSaved = (UploaderStatus.DONE === upStatus);
        let percentUpl = ue.percentDone();
        if (UploaderStatus.ERR === upStatus) {
            this.uploadStatus = 'warn';
        }
        else {
            if (percentUpl < 50) {
                this.uploadStatus = 'accent';
            }
            else {
                this.uploadStatus = 'success';
            }
            this.uploadProgress = percentUpl;
        }
        this.changeDetectorRef.detectChanges();
    }
    set controlAudioPlayer(controlAudioPlayer) {
        this._controlAudioPlayer = controlAudioPlayer;
        if (this._controlAudioPlayer) {
            this._controlAudioPlayer.listener = this;
        }
    }
    get controlAudioPlayer() {
        return this._controlAudioPlayer;
    }
    update(e) {
        if (e.type == EventType.STARTED) {
            this.playStartAction.disabled = true;
            this.updateTimerId = window.setInterval(() => {
                //this.audioSignal.playFramePosition = this.ap.playPositionFrames;
            }, 50);
        }
        else if (e.type == EventType.STOPPED || e.type == EventType.ENDED) {
            window.clearInterval(this.updateTimerId);
            //console.debug("Enable play start action (by player events stopped or ended): "+(!(this.displayRecFile)));
            this.playStartAction.disabled = (!(this.displayRecFile));
        }
    }
    startDisabled() {
        return !this.transportActions || this.readonly || this.transportActions.startAction.disabled;
    }
    stopDisabled() {
        return !this.transportActions || this.transportActions.stopAction.disabled;
    }
    startStopNextName() {
        if (!this.startDisabled()) {
            this.startStopNextButtonName = "Start";
        }
        else if (!this.stopDisabled()) {
            this.startStopNextButtonName = "Stop";
        }
        return this.startStopNextButtonName;
    }
    startStopNextIconName() {
        if (!this.startDisabled()) {
            this.startStopNextButtonIconName = "fiber_manual_record";
        }
        else if (!this.stopDisabled()) {
            this.startStopNextButtonIconName = "stop";
        }
        return this.startStopNextButtonIconName;
    }
    startStopNextIconColor() {
        if (!this.startDisabled()) {
            return "red";
        }
        else if (!this.stopDisabled()) {
            return "yellow";
        }
        else {
            return "grey";
        }
    }
    startStopPerform() {
        if (!this.startDisabled()) {
            this.transportActions.startAction.perform();
        }
        else if (!this.stopDisabled()) {
            this.transportActions.stopAction.perform();
        }
    }
    startItem() {
        this.status = 2 /* Status.STARTING */;
        super.startItem();
        if (this.readonly) {
            this.status = 1 /* Status.IDLE */;
            return;
        }
        this.transportActions.fwdAction.disabled = true;
        this.transportActions.fwdNextAction.disabled = true;
        this.transportActions.bwdAction.disabled = true;
        this.displayRecFile = null;
        this.displayRecFileVersion = 0;
        this.displayAudioClip = null;
        this.liveLevelDisplay.reset(true);
        this.liveLevelDisplayState = State.READY;
        this.showRecording();
        this.startCapture();
    }
    downloadRecording() {
        if (this.displayRecFile) {
            let ab = this.displayRecFile.audioDataHolder;
            const ww = new WavWriter(this.project?.mediaStorageFormat?.audioEncoding === AudioStorageFormatEncoding.PCM_FLOAT, this.project?.mediaStorageFormat?.audioPCMsampleSizeInBits);
            let as = ab?.audioSource;
            if (as instanceof AudioBufferSource) {
                ww.writeAsync(as.audioBuffer, (wavFile) => {
                    let blob = new Blob([wavFile], { type: 'audio/wav' });
                    let rfUrl = URL.createObjectURL(blob);
                    let dataDnlLnk = this.renderer.createElement('a');
                    //dataDnlLnk.name = 'Recording';
                    dataDnlLnk.href = rfUrl;
                    this.renderer.appendChild(document.body, dataDnlLnk);
                    // download property not yet in TS def
                    if (this.displayRecFile) {
                        let fn = this.displayRecFile.filenameString();
                        fn += '_' + this.displayRecFileVersion;
                        fn += '.wav';
                        dataDnlLnk.download = fn;
                        dataDnlLnk.click();
                    }
                    this.renderer.removeChild(document.body, dataDnlLnk);
                });
            }
        }
    }
    set displayRecFile(displayRecFile) {
        //this.audioLoaded=false;
        this._displayRecFile = displayRecFile;
        if (this._displayRecFile) {
            let adh = this._displayRecFile.audioDataHolder;
            if (adh) {
                this.displayAudioClip = new AudioClip(adh);
                //this.audioLoaded=true;
                //console.debug(" set recording file: display audio clip set");
                if (this._controlAudioPlayer) {
                    this._controlAudioPlayer.audioClip = this.displayAudioClip;
                }
                this.showRecording();
            }
            else {
                // clear for now ...
                this.displayAudioClip = null;
                //console.debug("set recording file: display audio clip null");
                if (this._controlAudioPlayer) {
                    this._controlAudioPlayer.audioClip = null;
                }
                if (this._controlAudioPlayer && this._session) {
                    //... and try to fetch from server
                    this.liveLevelDisplayState = State.LOADING;
                    const rf = this._displayRecFile;
                    let audioDownloadType = this._clientAudioStorageType;
                    if (AudioStorageType.MEM_ENTIRE_AUTO_NET_CHUNKED === this._clientAudioStorageType || AudioStorageType.MEM_CHUNKED_AUTO_NET_CHUNKED === this._clientAudioStorageType) {
                        // Default is network mode
                        audioDownloadType = AudioStorageType.NET_CHUNKED;
                        if (rf.channels && rf.frames) {
                            const samples = rf.channels * rf.frames;
                            if (samples <= this._maxAutoNetMemStoreSamples) {
                                // But if audio file is small, load in continuous resp. chunked mode
                                if (AudioStorageType.MEM_ENTIRE_AUTO_NET_CHUNKED === this._clientAudioStorageType) {
                                    audioDownloadType = AudioStorageType.MEM_ENTIRE;
                                }
                                else if (AudioStorageType.MEM_CHUNKED_AUTO_NET_CHUNKED === this._clientAudioStorageType) {
                                    audioDownloadType = AudioStorageType.MEM_CHUNKED;
                                }
                            }
                        }
                    }
                    if (AudioStorageType.DB_CHUNKED === this._clientAudioStorageType) {
                        // Fetch chunked indexed db audio buffer
                        let nextIab = null;
                        if (!this._persistentAudioStorageTarget) {
                            throw Error('Error: Persistent storage target not set.');
                        }
                        else {
                            //console.debug("Fetch audio and store to indexed db...");
                            this.audioFetchSubscription = this.recFileService.fetchRecordingFileIndDbAudioBuffer(this._persistentAudioStorageTarget, this._session.project, rf).subscribe({
                                next: (iab) => {
                                    //console.debug("Sessionmanager: Received inddb audio buffer: "+iab);
                                    nextIab = iab;
                                },
                                complete: () => {
                                    this.liveLevelDisplayState = State.READY;
                                    let fabDh = null;
                                    if (nextIab) {
                                        if (rf) {
                                            fabDh = new AudioDataHolder(nextIab);
                                            //this.audioLoaded=true;
                                            this.recorderCombiPane.setRecFileAudioData(rf, fabDh);
                                        }
                                    }
                                    else {
                                        // Should actually be handled by the error resolver
                                        this.statusMsg = 'Recording file could not be loaded.';
                                        this.statusAlertType = 'error';
                                    }
                                    if (fabDh) {
                                        // this.displayAudioClip could have been changed meanwhile, but the recorder unsubcribes before changing the item. Therefore, there should be no risk to set to wrong item
                                        this.displayAudioClip = new AudioClip(fabDh);
                                    }
                                    if (this._controlAudioPlayer) {
                                        this._controlAudioPlayer.audioClip = this.displayAudioClip;
                                    }
                                    this.showRecording();
                                },
                                error: err => {
                                    console.error("Could not load recording file from server: " + err);
                                    this.liveLevelDisplayState = State.READY;
                                    this.statusMsg = 'Recording file could not be loaded: ' + err;
                                    this.statusAlertType = 'error';
                                    this.changeDetectorRef.detectChanges();
                                }
                            });
                        }
                    }
                    else if (AudioStorageType.NET_CHUNKED === audioDownloadType) {
                        // Fetch chunked audio buffer from network
                        let nextNetAb = null;
                        //console.debug("Fetch chunked audio from network");
                        this.audioFetchSubscription = this.recFileService.fetchRecordingFileNetAudioBuffer(this._session.project, rf).subscribe({
                            next: (netAb) => {
                                //console.debug("Sessionmanager: Received net audio buffer: "+netAb);
                                nextNetAb = netAb;
                            },
                            complete: () => {
                                this.liveLevelDisplayState = State.READY;
                                let fabDh = null;
                                if (nextNetAb) {
                                    if (rf) {
                                        fabDh = new AudioDataHolder(nextNetAb);
                                        this.recorderCombiPane.setRecFileAudioData(rf, fabDh);
                                    }
                                }
                                else {
                                    // Should actually be handled by the error resolver
                                    this.statusMsg = 'Recording file could not be loaded.';
                                    this.statusAlertType = 'error';
                                }
                                if (fabDh) {
                                    // this.displayAudioClip could have been changed meanwhile, but the recorder unsubcribes before changing the item. Therefore, there should be no risk to set to wrong item
                                    //console.debug("set displayRecFile(): fetch net ab complete, set displayAudioClip.")
                                    this.displayAudioClip = new AudioClip(fabDh);
                                    // fabDh.onReady=()=>{
                                    //   this.audioLoaded=true;
                                    // }
                                }
                                if (this._controlAudioPlayer) {
                                    this._controlAudioPlayer.audioClip = this.displayAudioClip;
                                }
                                this.showRecording();
                            },
                            error: err => {
                                console.error("Could not load recording file from server: " + err);
                                this.liveLevelDisplayState = State.READY;
                                this.statusMsg = 'Recording file could not be loaded: ' + err;
                                this.statusAlertType = 'error';
                                this.changeDetectorRef.detectChanges();
                            }
                        });
                    }
                    else if (AudioStorageType.MEM_CHUNKED === audioDownloadType) {
                        // Fetch chunked array audio buffer
                        let nextAab = null;
                        //console.debug("Fetch audio and store to (chunked) array buffer...");
                        this.audioFetchSubscription = this.recFileService.fetchRecordingFileArrayAudioBuffer(this._session.project, rf).subscribe({
                            next: (aab) => {
                                nextAab = aab;
                            },
                            complete: () => {
                                this.liveLevelDisplayState = State.READY;
                                let fabDh = null;
                                if (nextAab) {
                                    if (rf) {
                                        fabDh = new AudioDataHolder(nextAab);
                                        this.recorderCombiPane.setRecFileAudioData(rf, fabDh);
                                    }
                                }
                                else {
                                    // Should actually be handled by the error resolver
                                    this.statusMsg = 'Recording file could not be loaded.';
                                    this.statusAlertType = 'error';
                                }
                                if (fabDh) {
                                    // this.displayAudioClip could have been changed meanwhile, but the recorder unsubcribes before changing the item. Therefore, there should be no risk to set to wrong item
                                    this.displayAudioClip = new AudioClip(fabDh);
                                    //this.audioLoaded=true;
                                }
                                if (this._controlAudioPlayer) {
                                    this._controlAudioPlayer.audioClip = this.displayAudioClip;
                                }
                                this.showRecording();
                            },
                            error: err => {
                                console.error("Could not load recording file from server: " + err);
                                this.liveLevelDisplayState = State.READY;
                                this.statusMsg = 'Recording file could not be loaded: ' + err;
                                this.statusAlertType = 'error';
                            }
                        });
                    }
                    else {
                        this.audioFetchSubscription = this.recFileService.fetchRecordingFileAudioBuffer(this._session.project, rf).subscribe({
                            next: ab => {
                                this.liveLevelDisplayState = State.READY;
                                let fabDh = null;
                                if (ab) {
                                    let abSrc = new AudioBufferSource(ab);
                                    if (rf) {
                                        fabDh = new AudioDataHolder(abSrc);
                                        this.recorderCombiPane.setRecFileAudioData(rf, fabDh);
                                    }
                                }
                                else {
                                    console.error('Recording file could not be loaded.');
                                    this.statusMsg = 'Recording file could not be loaded.';
                                    this.statusAlertType = 'error';
                                }
                                if (fabDh) {
                                    // this.displayAudioClip could have been changed meanwhile, but the recorder unsubcribes before changing the item. Therefore, there should be no risk to set to wrong item
                                    this.displayAudioClip = new AudioClip(fabDh);
                                    //this.audioLoaded=true;
                                    //console.debug("set recording file: display audio clip from fetched audio buffer");
                                }
                                if (this._controlAudioPlayer) {
                                    this._controlAudioPlayer.audioClip = this.displayAudioClip;
                                }
                                this.showRecording();
                            }, error: err => {
                                console.error("Could not load recording file from server: " + err);
                                this.liveLevelDisplayState = State.READY;
                                this.statusMsg = 'Recording file could not be loaded: ' + err;
                                this.statusAlertType = 'error';
                            }
                        });
                    }
                }
                else {
                    this.statusMsg = 'Recording file could not be decoded. Audio context unavailable.';
                    this.statusAlertType = 'error';
                }
            }
        }
        else {
            //console.debug("recording file null");
            this.displayAudioClip = null;
            if (this._controlAudioPlayer) {
                this._controlAudioPlayer.audioClip = null;
            }
        }
        this.showRecording();
    }
    get displayRecFile() {
        return this._displayRecFile;
    }
    updateStartActionDisableState() {
        this.transportActions.startAction.disabled = !(this.ac);
    }
    start() {
        super.start();
        this.recorderCombiPane.selectTop();
        this.enableNavigation();
        this.updateStartActionDisableState();
    }
    isRecording() {
        return (this.status === 3 /* Status.RECORDING */ || this.status === 4 /* Status.STOPPING_STOP */);
    }
    isActive() {
        return (!(this.status === 0 /* Status.BLOCKED */ || this.status === 1 /* Status.IDLE */ || this.status === 5 /* Status.ERROR */) || this.processingRecording || this.sessionService.uploadCount > 0);
    }
    updateWakeLock(dataSaved = this.dataSaved) {
        //console.debug("Update wake lock: dataSaved: "+dataSaved+", not active: "+! this.isActive())
        if (dataSaved && !this.isActive()) {
            this.disableWakeLockCond();
        }
    }
    updateNavigationActions() {
        this.transportActions.fwdAction.disabled = this.navigationDisabled;
        this.transportActions.bwdAction.disabled = this.navigationDisabled;
    }
    enableStartUserGesture() {
        super.enableStartUserGesture();
        this.transportActions.startAction.disabled = !(this.ac);
    }
    enableNavigation() {
        this.navigationDisabled = false;
        this.updateNavigationActions();
    }
    started() {
        this.status = 3 /* Status.RECORDING */;
        super.started();
        this.statusAlertType = 'info';
        this.statusMsg = 'Recording...';
        let sessId = 0;
        if (this._session) {
            sessId = this._session.sessionId;
        }
        if (this.rfUuid) {
            let rf = new RecordingFile(this.rfUuid, sessId, null);
            rf._startedAsDateObj = this.startedDate;
            if (rf._startedAsDateObj) {
                rf.startedDate = rf._startedAsDateObj.toString();
            }
            this._recordingFile = rf;
        }
        let maxRecordingTimeMs = MAX_RECORDING_TIME_MS;
        this.maxRecTimerId = window.setTimeout(() => {
            this.stopRecordingMaxRec();
        }, maxRecordingTimeMs);
        this.maxRecTimerRunning = true;
        this.transportActions.stopAction.disabled = false;
    }
    stopItem() {
        this.transportActions.stopAction.disabled = true;
        this.transportActions.nextAction.disabled = true;
        this.status = 4 /* Status.STOPPING_STOP */;
        this.stopRecording();
    }
    stopRecording() {
        if (this.maxRecTimerRunning && this.maxRecTimerId != null) {
            window.clearTimeout(this.maxRecTimerId);
            this.maxRecTimerRunning = false;
        }
        if (this.ac) {
            this.ac.stop();
        }
    }
    stopRecordingMaxRec() {
        this.maxRecTimerRunning = false;
        this.status = 4 /* Status.STOPPING_STOP */;
        if (this.ac) {
            this.ac.stop();
        }
    }
    stopped() {
        this.updateStartActionDisableState();
        this.transportActions.stopAction.disabled = true;
        this.transportActions.nextAction.disabled = true;
        this.transportActions.pauseAction.disabled = true;
        this.statusAlertType = 'info';
        this.statusMsg = 'Recorded.';
        let ab = null;
        if (this.ac) {
            let adh = null;
            let as = null;
            if (this.ac) {
                if (AudioStorageType.NET_CHUNKED === this.ac.audioStorageType) {
                    this.playStartAction.disabled = true;
                    //this.audioLoaded=false;
                    this.keepLiveLevel = true;
                    let rUUID = null;
                    let burl = null;
                    if (this._session) {
                        if (this._recordingFile) {
                            let rf = this._recordingFile;
                            rf.frames = this.ac.framesRecorded;
                            rUUID = rf.uuid;
                            //console.debug("stopped(): Set frames: "+rf.frames+" on rfId: "+this.displayRecFile?.recordingFileId);
                            burl = this.recFileService.audioFileUrl(this._session?.project, rf);
                        }
                        else if (this.session?.project) {
                            if (this.ac.recUUID) {
                                rUUID = this.ac.recUUID;
                                burl = this.recFileService.audioFileUrlByUUID(this.session.project, this.session.sessionId, rUUID);
                            }
                        }
                        else {
                            console.error("Could not create net audio buffer.");
                        }
                        if (burl) {
                            const sr = this.ac.currentSampleRate;
                            const chFl = sr * RecordingService.DEFAULT_CHUNKED_DOWNLOAD_SECONDS;
                            //console.debug("stopped(): rfID: "+this._recordingFile?.recordingFileId+", net ab url: " + burl+", frames: "+this.ac.framesRecorded+", sample rate: "+sr);
                            let netAs = new NetAudioBuffer(this.recFileService, burl, this.ac.channelCount, sr, chFl, this.ac.framesRecorded, rUUID, chFl);
                            as = netAs;
                            if (this.uploadSet) {
                                this.uploadSet.onDone = (uploadSet) => {
                                    //console.debug("upload set on done: Call ready provider.ready");
                                    netAs.ready();
                                };
                            }
                        }
                    }
                }
                else if (AudioStorageType.MEM_ENTIRE_AUTO_NET_CHUNKED === this.ac.audioStorageType || AudioStorageType.MEM_CHUNKED_AUTO_NET_CHUNKED === this.ac.audioStorageType) {
                    if (AudioStorageType.MEM_ENTIRE_AUTO_NET_CHUNKED === this.ac.audioStorageType) {
                        const acAb = this.ac.audioBuffer();
                        if (acAb) {
                            as = new AudioBufferSource(acAb);
                        }
                    }
                    if (AudioStorageType.MEM_CHUNKED_AUTO_NET_CHUNKED === this.ac.audioStorageType) {
                        as = this.ac.audioBufferArray();
                    }
                    if (!as) {
                        this.playStartAction.disabled = true;
                        this.keepLiveLevel = true;
                        let rUUID = null;
                        let burl = null;
                        if (this._session) {
                            if (this._recordingFile) {
                                let rf = this._recordingFile;
                                rf.frames = this.ac.framesRecorded;
                                rUUID = rf.uuid;
                                //console.debug("stopped(): Set frames: "+rf.frames+" on rfId: "+this.displayRecFile?.recordingFileId);
                                burl = this.recFileService.audioFileUrl(this._session?.project, rf);
                            }
                            else if (this.session?.project) {
                                if (this.ac.recUUID) {
                                    rUUID = this.ac.recUUID;
                                    burl = this.recFileService.audioFileUrlByUUID(this.session.project, this.session.sessionId, rUUID);
                                }
                            }
                            else {
                                console.error("Could not create net audio buffer.");
                            }
                            if (burl) {
                                const sr = this.ac.currentSampleRate;
                                const chFl = sr * RecordingService.DEFAULT_CHUNKED_DOWNLOAD_SECONDS;
                                //console.debug("stopped(): rfID: "+this._recordingFile?.recordingFileId+", net ab url: " + burl+", frames: "+this.ac.framesRecorded+", sample rate: "+sr);
                                let netAs = new NetAudioBuffer(this.recFileService, burl, this.ac.channelCount, sr, chFl, this.ac.framesRecorded, rUUID, chFl);
                                as = netAs;
                                if (this.uploadSet) {
                                    this.uploadSet.onDone = (uploadSet) => {
                                        //console.debug("upload set on done: Call ready provider.ready");
                                        netAs.ready();
                                    };
                                }
                            }
                        }
                    }
                }
                else if (AudioStorageType.DB_CHUNKED === this.ac.audioStorageType) {
                    as = this.ac.inddbAudioBufferArray();
                }
                else if (AudioStorageType.MEM_CHUNKED === this.ac.audioStorageType) {
                    as = this.ac.audioBufferArray();
                }
                else {
                    ab = this.ac.audioBuffer();
                    if (ab) {
                        as = new AudioBufferSource(ab);
                    }
                }
                if (as) {
                    adh = new AudioDataHolder(as);
                }
            }
            let sessId = 0;
            if (this._session) {
                sessId = this._session.sessionId;
            }
            if (this._recordingFile) {
                //this._recordingFile.samplerate=this.ac.currentSampleRate;
                // Use an own reference since the writing of the wave file is asynchronous and this._recordingFile might already contain the next recording
                let rf = this._recordingFile;
                RecordingFileUtils.setAudioData(rf, adh);
                this.recorderCombiPane.addRecFile(rf);
                // Upload if upload enabled and not in chunked upload mode
                if (this.enableUploadRecordings && this._uploadChunkSizeSeconds === null && AudioStorageType.MEM_ENTIRE === this._clientAudioStorageType && rf != null && ab != null) {
                    let apiEndPoint = '';
                    if (this.config && this.config.apiEndPoint) {
                        apiEndPoint = this.config.apiEndPoint;
                    }
                    if (apiEndPoint !== '') {
                        apiEndPoint = apiEndPoint + '/';
                    }
                    let sessionsUrl = apiEndPoint + SessionService.SESSION_API_CTX;
                    let recUrl = sessionsUrl + '/' + rf.session + '/' + RECFILE_API_CTX + '/' + rf.uuid;
                    // convert asynchronously to 16-bit integer PCM
                    // TODO could we avoid conversion to save CPU resources and transfer float PCM directly?
                    // TODO duplicate conversion for manual download
                    this.processingRecording = true;
                    const ww = new WavWriter(this.project?.mediaStorageFormat?.audioEncoding === AudioStorageFormatEncoding.PCM_FLOAT, this.project?.mediaStorageFormat?.audioPCMsampleSizeInBits);
                    ww.writeAsync(ab, (wavFile) => {
                        this.postRecordingMultipart(wavFile, recUrl, rf);
                        this.processingRecording = false;
                        this.updateWakeLock();
                        this.changeDetectorRef.detectChanges();
                    });
                }
            }
        }
        this.displayRecFile = this._recordingFile;
        this.status = 1 /* Status.IDLE */;
        this.navigationDisabled = false;
        this.updateNavigationActions();
        this.updateWakeLock();
        this.changeDetectorRef.detectChanges();
    }
    error(msg = 'An unknown error occured during recording.', advice = 'Please retry.') {
        this.status = 5 /* Status.ERROR */;
        super.error(msg, advice);
        this.updateNavigationActions();
        this.updateStartActionDisableState();
    }
    postRecordingMultipart(wavFile, recUrl, rf) {
        let wavBlob = new Blob([wavFile], { type: 'audio/wav' });
        let fd = new FormData();
        if (rf.uuid) {
            fd.set('uuid', rf.uuid);
        }
        if (rf.session !== null) {
            fd.set('sessionId', rf.session.toString());
        }
        if (rf._startedAsDateObj) {
            fd.set('startedDate', rf._startedAsDateObj.toJSON());
        }
        fd.set('audio', wavBlob);
        let ul = new Upload(fd, recUrl, rf);
        this.uploader.queueUpload(ul);
    }
    postChunkAudioBuffer(audioBuffer, chunkIdx) {
        this.processingRecording = true;
        const ww = new WavWriter(this.project?.mediaStorageFormat?.audioEncoding === AudioStorageFormatEncoding.PCM_FLOAT, this.project?.mediaStorageFormat?.audioPCMsampleSizeInBits);
        let sessionsUrl = this.sessionsBaseUrl();
        let recUrl = sessionsUrl + '/' + this.session?.sessionId + '/' + RECFILE_API_CTX + '/' + this.rfUuid + '/' + chunkIdx;
        let rf = this._recordingFile;
        // The upload holder is required to add the upload now to the upload set. The real upload is created async in postrecording and the upload set is already complete at that time.
        let ulh = new UploadHolder();
        if (this.uploadSet) {
            this.uploadSet.add(ulh);
        }
        ww.writeAsync(audioBuffer, (wavFile) => {
            this.postRecording(wavFile, recUrl, rf, ulh);
            this.processingRecording = false;
        });
    }
    stop() {
        if (this.ac) {
            this.ac.close();
        }
    }
    updateControlPlaybackPosition() {
        if (this._controlAudioPlayer) {
            const ppFrames = this._controlAudioPlayer.playPositionFrames;
            if (ppFrames !== null) {
                this.recorderCombiPane.audioDisplay.playFramePosition = ppFrames;
                this.liveLevelDisplay.playFramePosition = ppFrames;
            }
        }
    }
    audioPlayerUpdate(e) {
        if (EventType.READY === e.type) {
        }
        else if (EventType.STARTED === e.type) {
            //this.status = 'Playback...';
            this.updateTimerId = window.setInterval(() => this.updateControlPlaybackPosition(), 50);
        }
        else if (EventType.ENDED === e.type) {
            //.status='Ready.';
            window.clearInterval(this.updateTimerId);
        }
        if (!this.destroyed) {
            this.changeDetectorRef.detectChanges();
        }
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.12", ngImport: i0, type: AudioRecorder, deps: [{ token: i1$2.BreakpointObserver }, { token: i0.ChangeDetectorRef }, { token: i0.Renderer2 }, { token: i1$3.MatDialog }, { token: SessionService }, { token: RecordingService }, { token: SpeechRecorderUploader }, { token: SPEECHRECORDER_CONFIG }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "18.2.12", type: AudioRecorder, selector: "app-audiorecorder", inputs: { projectName: "projectName", dataSaved: "dataSaved" }, host: { listeners: { "window:keypress": "onKeyPress($event)", "window:keydown": "onKeyDown($event)" } }, providers: [SessionService], viewQueries: [{ propertyName: "recorderCombiPane", first: true, predicate: RecorderCombiPane, descendants: true, static: true }, { propertyName: "liveLevelDisplay", first: true, predicate: LevelBar, descendants: true, static: true }], usesInheritance: true, ngImport: i0, template: `
    <app-warningbar [show]="isTestSession()" warningText="Test recording only!"></app-warningbar>
    <app-warningbar [show]="isDefaultAudioTestSession()"
                    warningText="This test uses default audio device! Regular sessions may require a particular audio device (microphone)!"></app-warningbar>
    <app-recordercombipane (selectedRecordingFileChanged)="selectRecordingFile($event)"
                           [audioSignalCollapsed]="audioSignalCollapsed"
                           [selectedRecordingFile]="displayRecFile"
                           [selectDisabled]="isActive()"
                           [displayAudioClip]="displayAudioClip"
                           [playStartAction]="controlAudioPlayer?.startAction"
                           [playStopAction]="controlAudioPlayer?.stopAction"
                           [playSelectionAction]="controlAudioPlayer?.startSelectionAction"
                           [autoPlayOnSelectToggleAction]="controlAudioPlayer?.autoPlayOnSelectToggleAction"
    ></app-recordercombipane>

    <div [class]="{audioStatusDisplay:!screenXs,audioStatusDisplayXs:screenXs}">
      <audio-levelbar style="flex:1 0 1%" [streamingMode]="isRecording() || keepLiveLevel" [state]="liveLevelDisplayState"
                      [displayLevelInfos]="displayAudioClip?.levelInfos"></audio-levelbar>
      <div style="display:flex;flex-direction: row">
        <spr-recordingitemcontrols style="flex:10 0 1px"
                                   [disableAudioDetails]="disableAudioDetails"
                                   [audioLoaded]="audioLoaded"
                                   [playStartAction]="controlAudioPlayer?.startAction"
                                   [playStopAction]="controlAudioPlayer?.stopAction"
                                   [peakDbLvl]="peakLevelInDb"
                                   [agc]="this.ac?.agcStatus"
                                   (onShowRecordingDetails)="audioSignalCollapsed=!audioSignalCollapsed">
        </spr-recordingitemcontrols>

        <app-uploadstatus *ngIf="screenXs && enableUploadRecordings" class="ricontrols dark" style="flex:0 0 0"
                          [value]="uploadProgress"
                          [status]="uploadStatus" [awaitNewUpload]="processingRecording"></app-uploadstatus>
        <app-wakelockindicator *ngIf="screenXs" class="ricontrols dark" style="flex:0 0 0" [screenLocked]="screenLocked"></app-wakelockindicator>
        <app-readystateindicator *ngIf="screenXs" class="ricontrols dark" style="flex:0 0 0"
                                 [ready]="dataSaved && !isActive()"></app-readystateindicator>
      </div>
    </div>
    <div #controlpanel class="controlpanel">
      <app-sprstatusdisplay *ngIf="!screenXs" style="flex:0 1 30%;" [statusMsg]="statusMsg" [statusAlertType]="statusAlertType"
                            [statusWaiting]="statusWaiting"
                            class="hidden-xs"></app-sprstatusdisplay>
      <div [class.startstop]="!screenXs" [class.startstopscreenxs]="screenXs">
        <div style="align-content: center">
          <button (click)="startStopPerform()" [disabled]="startDisabled() && stopDisabled()" mat-raised-button class="bigbutton">
            <mat-icon class="bigbuttonicon" [style.color]="startStopNextIconColor()">{{startStopNextIconName()}}</mat-icon>
            <span class="bigbuttontext">{{startStopNextName()}}</span>
          </button>
        </div>
      </div>
      <div style="flex:0 1 30%;display:flex;justify-items: flex-end;justify-content:flex-end" >
        <app-uploadstatus *ngIf="!screenXs && enableUploadRecordings" class="ricontrols"
                          [value]="uploadProgress"
                          [status]="uploadStatus" [awaitNewUpload]="processingRecording"></app-uploadstatus>
        <app-wakelockindicator  *ngIf="!screenXs" class="ricontrols" [screenLocked]="screenLocked"></app-wakelockindicator>
        <app-readystateindicator *ngIf="!screenXs" class="ricontrols"
                                 [ready]="dataSaved && !isActive()"></app-readystateindicator>
      </div>
    </div>
  `, isInline: true, styles: [":host{flex:2;background:#d3d3d3;display:flex;flex-direction:column;margin:0;padding:0;height:100%;min-height:0px;overflow:hidden}\n", ".ricontrols{padding:4px;box-sizing:border-box;height:100%}\n", ".dark{background:#a9a9a9}\n", ".controlpanel{display:flex;flex-direction:row;align-content:center;align-items:center;margin:0;padding:20px;min-height:min-content}\n", ".startstop{width:100%;flex:1 0 30%;align-items:center;text-align:center;align-content:center}\n", ".startstopscreenxs{width:100%;flex:1 0 100%;align-items:center;text-align:center;align-content:center}\n", ".bigbutton{vertical-align:middle;overflow:hidden;text-overflow:clip;white-space:nowrap;letter-spacing:normal;min-width:70px;min-height:50px;border-radius:20px}\n", ".bigbuttonicon{min-width:50px;min-height:50px;font-size:50px}\n", ".bigbuttontext{font-weight:bolder;font-size:14px;vertical-align:middle}\n", ".audioStatusDisplay{display:flex;flex-direction:row;height:100px;min-height:100px}\n", ".audioStatusDisplayXs{display:flex;flex-direction:column;height:125px;min-height:125px}\n"], dependencies: [{ kind: "directive", type: i1$1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "component", type: i2.MatIcon, selector: "mat-icon", inputs: ["color", "inline", "svgIcon", "fontSet", "fontIcon"], exportAs: ["matIcon"] }, { kind: "component", type: i3.MatButton, selector: "    button[mat-button], button[mat-raised-button], button[mat-flat-button],    button[mat-stroked-button]  ", exportAs: ["matButton"] }, { kind: "component", type: LevelBar, selector: "audio-levelbar", inputs: ["streamingMode", "displayLevelInfos", "state"] }, { kind: "component", type: StatusDisplay, selector: "app-sprstatusdisplay", inputs: ["statusAlertType", "statusMsg", "statusWaiting"] }, { kind: "component", type: RecordingItemControls, selector: "spr-recordingitemcontrols", inputs: ["audioSignalCollapsed", "enableDownload", "peakDbLvl", "agc", "disableAudioDetails", "audioLoaded", "playStartAction", "playStopAction", "displayLevelInfos"], outputs: ["onShowRecordingDetails", "onDownloadRecording"] }, { kind: "component", type: UploadStatus, selector: "app-uploadstatus", inputs: ["value", "awaitNewUpload", "status"] }, { kind: "component", type: WakeLockIndicator, selector: "app-wakelockindicator", inputs: ["screenLocked"] }, { kind: "component", type: ReadyStateIndicator, selector: "app-readystateindicator", inputs: ["ready"] }, { kind: "component", type: WarningBar, selector: "app-warningbar", inputs: ["warningText", "show"] }, { kind: "component", type: RecorderCombiPane, selector: "app-recordercombipane", inputs: ["selectDisabled", "selectedRecordingFile", "audioSignalCollapsed", "displayAudioClip", "playStartAction", "playSelectionAction", "autoPlayOnSelectToggleAction", "playStopAction"], outputs: ["selectedRecordingFileChanged"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.12", ngImport: i0, type: AudioRecorder, decorators: [{
            type: Component,
            args: [{ selector: 'app-audiorecorder', providers: [SessionService], template: `
    <app-warningbar [show]="isTestSession()" warningText="Test recording only!"></app-warningbar>
    <app-warningbar [show]="isDefaultAudioTestSession()"
                    warningText="This test uses default audio device! Regular sessions may require a particular audio device (microphone)!"></app-warningbar>
    <app-recordercombipane (selectedRecordingFileChanged)="selectRecordingFile($event)"
                           [audioSignalCollapsed]="audioSignalCollapsed"
                           [selectedRecordingFile]="displayRecFile"
                           [selectDisabled]="isActive()"
                           [displayAudioClip]="displayAudioClip"
                           [playStartAction]="controlAudioPlayer?.startAction"
                           [playStopAction]="controlAudioPlayer?.stopAction"
                           [playSelectionAction]="controlAudioPlayer?.startSelectionAction"
                           [autoPlayOnSelectToggleAction]="controlAudioPlayer?.autoPlayOnSelectToggleAction"
    ></app-recordercombipane>

    <div [class]="{audioStatusDisplay:!screenXs,audioStatusDisplayXs:screenXs}">
      <audio-levelbar style="flex:1 0 1%" [streamingMode]="isRecording() || keepLiveLevel" [state]="liveLevelDisplayState"
                      [displayLevelInfos]="displayAudioClip?.levelInfos"></audio-levelbar>
      <div style="display:flex;flex-direction: row">
        <spr-recordingitemcontrols style="flex:10 0 1px"
                                   [disableAudioDetails]="disableAudioDetails"
                                   [audioLoaded]="audioLoaded"
                                   [playStartAction]="controlAudioPlayer?.startAction"
                                   [playStopAction]="controlAudioPlayer?.stopAction"
                                   [peakDbLvl]="peakLevelInDb"
                                   [agc]="this.ac?.agcStatus"
                                   (onShowRecordingDetails)="audioSignalCollapsed=!audioSignalCollapsed">
        </spr-recordingitemcontrols>

        <app-uploadstatus *ngIf="screenXs && enableUploadRecordings" class="ricontrols dark" style="flex:0 0 0"
                          [value]="uploadProgress"
                          [status]="uploadStatus" [awaitNewUpload]="processingRecording"></app-uploadstatus>
        <app-wakelockindicator *ngIf="screenXs" class="ricontrols dark" style="flex:0 0 0" [screenLocked]="screenLocked"></app-wakelockindicator>
        <app-readystateindicator *ngIf="screenXs" class="ricontrols dark" style="flex:0 0 0"
                                 [ready]="dataSaved && !isActive()"></app-readystateindicator>
      </div>
    </div>
    <div #controlpanel class="controlpanel">
      <app-sprstatusdisplay *ngIf="!screenXs" style="flex:0 1 30%;" [statusMsg]="statusMsg" [statusAlertType]="statusAlertType"
                            [statusWaiting]="statusWaiting"
                            class="hidden-xs"></app-sprstatusdisplay>
      <div [class.startstop]="!screenXs" [class.startstopscreenxs]="screenXs">
        <div style="align-content: center">
          <button (click)="startStopPerform()" [disabled]="startDisabled() && stopDisabled()" mat-raised-button class="bigbutton">
            <mat-icon class="bigbuttonicon" [style.color]="startStopNextIconColor()">{{startStopNextIconName()}}</mat-icon>
            <span class="bigbuttontext">{{startStopNextName()}}</span>
          </button>
        </div>
      </div>
      <div style="flex:0 1 30%;display:flex;justify-items: flex-end;justify-content:flex-end" >
        <app-uploadstatus *ngIf="!screenXs && enableUploadRecordings" class="ricontrols"
                          [value]="uploadProgress"
                          [status]="uploadStatus" [awaitNewUpload]="processingRecording"></app-uploadstatus>
        <app-wakelockindicator  *ngIf="!screenXs" class="ricontrols" [screenLocked]="screenLocked"></app-wakelockindicator>
        <app-readystateindicator *ngIf="!screenXs" class="ricontrols"
                                 [ready]="dataSaved && !isActive()"></app-readystateindicator>
      </div>
    </div>
  `, styles: [":host{flex:2;background:#d3d3d3;display:flex;flex-direction:column;margin:0;padding:0;height:100%;min-height:0px;overflow:hidden}\n", ".ricontrols{padding:4px;box-sizing:border-box;height:100%}\n", ".dark{background:#a9a9a9}\n", ".controlpanel{display:flex;flex-direction:row;align-content:center;align-items:center;margin:0;padding:20px;min-height:min-content}\n", ".startstop{width:100%;flex:1 0 30%;align-items:center;text-align:center;align-content:center}\n", ".startstopscreenxs{width:100%;flex:1 0 100%;align-items:center;text-align:center;align-content:center}\n", ".bigbutton{vertical-align:middle;overflow:hidden;text-overflow:clip;white-space:nowrap;letter-spacing:normal;min-width:70px;min-height:50px;border-radius:20px}\n", ".bigbuttonicon{min-width:50px;min-height:50px;font-size:50px}\n", ".bigbuttontext{font-weight:bolder;font-size:14px;vertical-align:middle}\n", ".audioStatusDisplay{display:flex;flex-direction:row;height:100px;min-height:100px}\n", ".audioStatusDisplayXs{display:flex;flex-direction:column;height:125px;min-height:125px}\n"] }]
        }], ctorParameters: () => [{ type: i1$2.BreakpointObserver }, { type: i0.ChangeDetectorRef }, { type: i0.Renderer2 }, { type: i1$3.MatDialog }, { type: SessionService }, { type: RecordingService }, { type: SpeechRecorderUploader }, { type: SpeechRecorderConfig, decorators: [{
                    type: Inject,
                    args: [SPEECHRECORDER_CONFIG]
                }] }], propDecorators: { projectName: [{
                type: Input
            }], recorderCombiPane: [{
                type: ViewChild,
                args: [RecorderCombiPane, { static: true }]
            }], liveLevelDisplay: [{
                type: ViewChild,
                args: [LevelBar, { static: true }]
            }], dataSaved: [{
                type: Input
            }], onKeyPress: [{
                type: HostListener,
                args: ['window:keypress', ['$event']]
            }], onKeyDown: [{
                type: HostListener,
                args: ['window:keydown', ['$event']]
            }] } });
class AudioRecorderComponent extends RecorderComponent {
    constructor(route, router, changeDetectorRef, sessionService, projectService, uploader) {
        super(uploader);
        this.route = route;
        this.router = router;
        this.changeDetectorRef = changeDetectorRef;
        this.sessionService = sessionService;
        this.projectService = projectService;
        this.uploader = uploader;
    }
    ngOnInit() {
        this.controlAudioPlayer = new AudioPlayer(this.ar);
        this.ar.controlAudioPlayer = this.controlAudioPlayer;
        //TODO Duplicate code in SpeechRecorderComponent
        window.addEventListener('beforeunload', (e) => {
            console.debug("Before page unload event");
            if (this.ready()) {
                return;
            }
            else {
                // all this attempts to customize the message do not work anymore (for security reasons)!!
                const message = "Please do not leave the page, until all recordings are uploaded!";
                alert(message);
                e = e || window.event;
                if (e) {
                    e.returnValue = message;
                    e.cancelBubble = true;
                    if (e.stopPropagation) {
                        e.stopPropagation();
                    }
                    if (e.preventDefault) {
                        e.preventDefault();
                    }
                }
                return message;
            }
        });
    }
    ngAfterViewInit() {
        // TODO call prepare !!
        this.uploader.listener = (ue) => {
            this.uploadUpdate(ue);
        };
        this.route.queryParams.subscribe((params) => {
            if (params['sessionId']) {
                this.fetchSession(params['sessionId']);
            }
        });
        this.route.params.subscribe((params) => {
            let routeParamsId = params['id'];
            if (routeParamsId) {
                this.fetchSession(routeParamsId);
            }
        });
    }
    ngOnDestroy() {
        //super.ngOnDestroy();
    }
    get screenLocked() {
        return this.ar.screenLocked;
    }
    fetchSession(sessionId) {
        let sessObs = this.sessionService.sessionObserver(sessionId);
        if (sessObs) {
            sessObs.subscribe({
                next: (sess) => {
                    this.ar.statusAlertType = 'info';
                    this.ar.statusMsg = 'Received session info.';
                    this.ar.statusWaiting = false;
                    this.session = sess;
                    this.ar.session = sess;
                    if (sess.project) {
                        //console.debug("Session associated project: "+sess.project)
                        this.projectService.projectObservable(sess.project).subscribe({
                            next: (project) => {
                                this.ar.project = project;
                                this.ar.fetchRecordings(sess);
                            }, error: (reason) => {
                                this.ar.statusMsg = reason;
                                this.ar.statusAlertType = 'error';
                                this.ar.statusWaiting = false;
                                console.error("Error fetching project config: " + reason);
                            }
                        });
                    }
                    else {
                        console.info("Session has no associated project. Using default configuration.");
                    }
                },
                error: (reason) => {
                    this.ar.statusMsg = reason;
                    this.ar.statusAlertType = 'error';
                    this.ar.statusWaiting = false;
                    console.error("Error fetching session " + reason);
                }
            });
        }
    }
    uploadUpdate(ue) {
        let upStatus = ue.status;
        this.dataSaved = (UploaderStatus.DONE === upStatus);
        let percentUpl = ue.percentDone();
        if (UploaderStatus.ERR === upStatus) {
            this.ar.uploadStatus = 'warn';
        }
        else {
            if (percentUpl < 50) {
                this.ar.uploadStatus = 'accent';
            }
            else {
                this.ar.uploadStatus = 'success';
            }
            this.ar.uploadProgress = percentUpl;
        }
        this.ar.updateWakeLock(this.dataSaved);
        this.changeDetectorRef.detectChanges();
    }
    ready() {
        return this.dataSaved && !this.ar.isActive();
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.12", ngImport: i0, type: AudioRecorderComponent, deps: [{ token: i4$2.ActivatedRoute }, { token: i4$2.Router }, { token: i0.ChangeDetectorRef }, { token: SessionService }, { token: ProjectService }, { token: SpeechRecorderUploader }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "18.2.12", type: AudioRecorderComponent, selector: "app-audiorecorder-comp", providers: [SessionService], viewQueries: [{ propertyName: "ar", first: true, predicate: AudioRecorder, descendants: true, static: true }], usesInheritance: true, ngImport: i0, template: `
    <app-audiorecorder [projectName]="_project?.name" [dataSaved]="dataSaved"></app-audiorecorder>
  `, isInline: true, styles: [":host{flex:2;display:flex;height:100%;flex-direction:column;min-height:0}\n"], dependencies: [{ kind: "component", type: AudioRecorder, selector: "app-audiorecorder", inputs: ["projectName", "dataSaved"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.12", ngImport: i0, type: AudioRecorderComponent, decorators: [{
            type: Component,
            args: [{ selector: 'app-audiorecorder-comp', providers: [SessionService], template: `
    <app-audiorecorder [projectName]="_project?.name" [dataSaved]="dataSaved"></app-audiorecorder>
  `, styles: [":host{flex:2;display:flex;height:100%;flex-direction:column;min-height:0}\n"] }]
        }], ctorParameters: () => [{ type: i4$2.ActivatedRoute }, { type: i4$2.Router }, { type: i0.ChangeDetectorRef }, { type: SessionService }, { type: ProjectService }, { type: SpeechRecorderUploader }], propDecorators: { ar: [{
                type: ViewChild,
                args: [AudioRecorder, { static: true }]
            }] } });

const SPR_ROUTES = [
    { path: 'spr/session/:id', component: SpeechrecorderngComponent },
    { path: 'recorder/session/:id', component: AudioRecorderComponent },
    { path: 'recorder', component: AudioRecorderComponent },
    { path: 'spr/db/project/:project/session/:sessionId/recordingfile/_view/:recordingFileId', component: RecordingFileViewComponent },
    { path: 'spr/db/project/:project/session/:sessionId/recordingfile/_edit/:recordingFileId', component: RecordingFileUI },
    { path: 'spr/db/project/:project/session/:sessionId/recordingfile/_view', component: RecordingFileViewComponent },
    { path: 'spr/db/project/:project/session/:sessionId/recordingfile/_edit', component: RecordingFileUI },
    { path: 'spr/db/project/:project/session/:sessionId/recordingfile/:recordingFileId', component: RecordingFileUI },
    { path: 'spr/db/project/:project/session/:sessionId/recordingfile', component: RecordingFileUI },
    { path: 'spr/db/recordingfile/_view/:recordingFileId', component: RecordingFileViewComponent },
    { path: 'spr/db/recordingfile/_edit/:recordingFileId', component: RecordingFileUI },
    { path: 'spr/db/recordingfile/_view/', component: RecordingFileViewComponent },
    { path: 'spr/db/recordingfile/_view', component: RecordingFileViewComponent },
    { path: 'spr/db/recordingfile/_edit', component: RecordingFileUI },
    { path: 'spr/db/recordingfile/:recordingFileId', component: RecordingFileUI },
    { path: 'spr/db/recordingfile', component: RecordingFileUI },
    { path: 'spr', component: SpeechrecorderngComponent }
];
class SpeechrecorderngModule {
    static forRoot(config) {
        return {
            ngModule: SpeechrecorderngModule,
            providers: [
                { provide: SPEECHRECORDER_CONFIG, useValue: config }
            ]
        };
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.12", ngImport: i0, type: SpeechrecorderngModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "18.2.12", ngImport: i0, type: SpeechrecorderngModule, declarations: [AudioSignal, Sonagram, ScrollPaneHorizontal, AudioClipUIContainer, AudioDisplayScrollPane, AudioDisplay, AudioDisplayPlayer, AudioDisplayControl, LevelBar, Progress, SimpleTrafficLight, Recinstructions, Prompter, PromptContainer, PromptingContainer, Prompting, StatusDisplay,
            ProgressDisplay, RecordingItemDisplay, RecordingItemControls, UploadStatus, TransportPanel, WakeLockIndicator, ReadyStateIndicator, ControlPanel, WarningBar, AudioRecorder, SessionManager, MessageDialog, SessionFinishedDialog, SpeechrecorderngComponent, AudioRecorderComponent, RecordingFileViewComponent, RecordingFileUI, ScrollIntoViewDirective, RecordingFileNaviComponent, RecordingFileMetaComponent, RecordingList, RecorderCombiPane, AudioRecorder], imports: [i4$2.RouterModule, CommonModule, MatIconModule, MatButtonModule, MatDialogModule, MatProgressBarModule, MatProgressSpinnerModule, MatTooltipModule, MatCheckboxModule, MatCardModule, MatDividerModule, MatGridListModule, MatTableModule, MatInputModule, MatSelectModule, MatSnackBarModule, MatMenuModule, IntersectionObserverDirective], exports: [MessageDialog, SpeechrecorderngComponent, ScrollPaneHorizontal, AudioClipUIContainer, AudioDisplayScrollPane, AudioDisplay, AudioDisplayPlayer, AudioDisplayControl, LevelBar, AudioRecorder] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "18.2.12", ngImport: i0, type: SpeechrecorderngModule, providers: [SessionService, ProjectService, ScriptService, RecordingService, RecordingFileService, SpeechRecorderUploader, provideHttpClient(withInterceptorsFromDi())], imports: [RouterModule.forChild(SPR_ROUTES), CommonModule, MatIconModule, MatButtonModule, MatDialogModule, MatProgressBarModule, MatProgressSpinnerModule, MatTooltipModule, MatCheckboxModule, MatCardModule, MatDividerModule, MatGridListModule, MatTableModule, MatInputModule, MatSelectModule, MatSnackBarModule, MatMenuModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.12", ngImport: i0, type: SpeechrecorderngModule, decorators: [{
            type: NgModule,
            args: [{ declarations: [AudioSignal, Sonagram, ScrollPaneHorizontal, AudioClipUIContainer, AudioDisplayScrollPane, AudioDisplay, AudioDisplayPlayer, AudioDisplayControl, LevelBar, Progress, SimpleTrafficLight, Recinstructions, Prompter, PromptContainer, PromptingContainer, Prompting, StatusDisplay,
                        ProgressDisplay, RecordingItemDisplay, RecordingItemControls, UploadStatus, TransportPanel, WakeLockIndicator, ReadyStateIndicator, ControlPanel, WarningBar, AudioRecorder, SessionManager, MessageDialog, SessionFinishedDialog, SpeechrecorderngComponent, AudioRecorderComponent, RecordingFileViewComponent, RecordingFileUI, ScrollIntoViewDirective, RecordingFileNaviComponent, RecordingFileMetaComponent, RecordingList, RecorderCombiPane, AudioRecorder],
                    exports: [MessageDialog, SpeechrecorderngComponent, ScrollPaneHorizontal, AudioClipUIContainer, AudioDisplayScrollPane, AudioDisplay, AudioDisplayPlayer, AudioDisplayControl, LevelBar, AudioRecorder], imports: [RouterModule.forChild(SPR_ROUTES), CommonModule, MatIconModule, MatButtonModule, MatDialogModule, MatProgressBarModule, MatProgressSpinnerModule, MatTooltipModule, MatCheckboxModule, MatCardModule, MatDividerModule, MatGridListModule, MatTableModule, MatInputModule, MatSelectModule, MatSnackBarModule, MatMenuModule, IntersectionObserverDirective], providers: [SessionService, ProjectService, ScriptService, RecordingService, RecordingFileService, SpeechRecorderUploader, provideHttpClient(withInterceptorsFromDi())] }]
        }] });

const VERSION = '3.10.13';

const SPEECHRECORDER_ENVIRONMENT_DEFAULTS = {
    production: false,
    apiType: 'files',
    apiEndPoint: 'test',
    apiVersion: 1,
    enableDownloadRecordings: true,
    enableUploadRecordings: false
};

/*
 * Public API Surface of speechrecorderng
 */

/**
 * Generated bundle index. Do not edit.
 */

export { Action, ApiType, AudioClip, AudioClipUIContainer, AudioContextProvider, AudioDisplay, AudioDisplayControl, AudioDisplayPlayer, AudioDisplayScrollPane, AudioPlayer, AudioPlayerEvent, AudioRecorder, AudioRecorderComponent, EventType, LevelBar, MessageDialog, ProjectService, RecorderComponent, RecordingFileService, RecordingFileUI, RecordingFileViewComponent, RecordingService, ResponsiveComponent, SPEECHRECORDER_CONFIG, SPEECHRECORDER_ENVIRONMENT_DEFAULTS, ScriptService, ScrollPaneHorizontal, Selection, SessionService, SpeechRecorderConfig, SpeechrecorderngComponent, SpeechrecorderngModule, SprRecordingFile, UUID, VERSION, WavWriter };
